import type { GraphQLClient, RequestOptions } from "graphql-request";
import gql from "graphql-tag";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
type GraphQLClientRequestHeaders = RequestOptions["requestHeaders"];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
  Decimal: { input: any; output: any };
  GenericScalar: { input: any; output: any };
  JSONString: { input: any; output: any };
  UUID: { input: any; output: any };
  Upload: { input: any; output: any };
};

/**
 * User: Advisor
 * Cancel an in-progress succession transition from Step 1 (before freeze is confirmed).
 * Reverses all automatic actions taken at initiation:
 *   1. Unfreezes the DAF account
 *   2. Marks the SuccessionTransition record as 'aborted'
 * Campaigns paused by the transition must be manually re-activated if applicable.
 * Family member invites are untouched -- step 1 never cancels them.
 */
export type AbortTransition = {
  __typename?: "AbortTransition";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  restoredInviteCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Accept Advisor Agreement Fee details  */
export type AcceptAdvisorFeeAgreement = {
  __typename?: "AcceptAdvisorFeeAgreement";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type AcceptEmail = {
  __typename?: "AcceptEmail";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * A successor accepts being named in a family's succession plan, from the
 * accept/decline screen shown at the start of successor onboarding.
 *
 * Post-login: the successor is identified by the Successor row's
 * family_member link, so a caller can only accept an invite that is their
 * own. Sets accepted_at and nothing else -- deliberately not the linked
 * User's invite_status, which is account-level and already flips to
 * 'accepted' merely on login (see Successor.accepted_at help_text), and no
 * percentage math, which is decline-only.
 *
 * accepted_at/declined_at are mutually exclusive; both null means invited but
 * undecided, which is exactly when the screen is shown (see the
 * mySuccessorInvite query in portfolio.schema).
 */
export type AcceptSuccessorInvite = {
  __typename?: "AcceptSuccessorInvite";
  message?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Update terms & conditions of User  */
export type Accept_Tnc = {
  __typename?: "Accept_Tnc";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Account input field type  */
export type AccountInputType = {
  custodian?: InputMaybe<Scalars["Int"]["input"]>;
  family?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  number?: InputMaybe<Scalars["String"]["input"]>;
};

/** Account response field type  */
export type AccountType = {
  __typename?: "AccountType";
  custodian?: Maybe<Scalars["String"]["output"]>;
  family: FamilyType;
  holdingsSummary: Array<HoldingSummaryType>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  number?: Maybe<Scalars["String"]["output"]>;
  taxable?: Maybe<Scalars["Boolean"]["output"]>;
};

export enum ActionableCategory {
  /** Campaign */
  Campaign = "CAMPAIGN",
  /** Contribution */
  Contribution = "CONTRIBUTION",
  /** Fund */
  Fund = "FUND",
  /** Giving */
  Giving = "GIVING",
  /** Investment */
  Investment = "INVESTMENT",
  /** Invitation */
  Invitation = "INVITATION",
}

export type ActionableFilterInput = {
  /** Filter by activity category */
  category?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by activity type */
  type?: InputMaybe<Scalars["String"]["input"]>;
};

/** Connection type for paginated actionable results */
export type ActionablePaginatedType = {
  __typename?: "ActionablePaginatedType";
  count?: Maybe<Scalars["Int"]["output"]>;
  objects?: Maybe<Array<Maybe<ActionableTypeSchema>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export enum ActionableType {
  /** Allocation Attention */
  AllocationAttention = "ALLOCATION_ATTENTION",
  /** Disconnected Bank */
  DisconnectedBank = "DISCONNECTED_BANK",
  /** Insufficient Funds */
  InsufficientFunds = "INSUFFICIENT_FUNDS",
  /** Investment Drift */
  InvestmentDrift = "INVESTMENT_DRIFT",
  /** Investment Payout */
  InvestmentPayout = "INVESTMENT_PAYOUT",
  /** Low Balance */
  LowBalance = "LOW_BALANCE",
  /** Low Cash */
  LowCash = "LOW_CASH",
  /** No Member Invited */
  NoMemberInvited = "NO_MEMBER_INVITED",
  /** Client Invite Pending */
  PendingClientInvite = "PENDING_CLIENT_INVITE",
  /** Pending Investment Strategy */
  PendingInvestmentStrategy = "PENDING_INVESTMENT_STRATEGY",
  /** Member Invite Pending */
  PendingMemberInvite = "PENDING_MEMBER_INVITE",
  /** Unfunded DAF */
  UnfundedDaf = "UNFUNDED_DAF",
  /** Voided Check */
  VoidedCheck = "VOIDED_CHECK",
}

export type ActionableTypeSchema = {
  __typename?: "ActionableTypeSchema";
  /** Text for the action button */
  actionText: Scalars["String"]["output"];
  /** URL for the action button */
  actionUrl: Scalars["String"]["output"];
  category: ActionableCategory;
  id: Scalars["ID"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  /** Additional metadata for the actionable item */
  metaData: Scalars["JSONString"]["output"];
  type: ActionableType;
};

export enum ActivityCategory {
  /** Campaign */
  Campaign = "CAMPAIGN",
  /** Contribution */
  Contribution = "CONTRIBUTION",
  /** Fund */
  Fund = "FUND",
  /** Giving */
  Giving = "GIVING",
  /** Investment */
  Investment = "INVESTMENT",
  /** Invitation */
  Invitation = "INVITATION",
}

export type ActivityFilterInput = {
  /** Filter by activity category */
  category?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter activities created before this date */
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Filter activities created after this date */
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Filter by activity type */
  type?: InputMaybe<Scalars["String"]["input"]>;
};

/** Connection type for paginated activity results */
export type ActivityPaginatedType = {
  __typename?: "ActivityPaginatedType";
  count?: Maybe<Scalars["Int"]["output"]>;
  objects?: Maybe<Array<Maybe<ActivityTypeSchema>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export enum ActivityType {
  /** Campaign Cancelled */
  CampaignCancelled = "CAMPAIGN_CANCELLED",
  /** Campaign Completed */
  CampaignCompleted = "CAMPAIGN_COMPLETED",
  /** Campaign Ended */
  CampaignEnded = "CAMPAIGN_ENDED",
  /** Campaign Paused */
  CampaignPaused = "CAMPAIGN_PAUSED",
  /** Campaign Resumed */
  CampaignResumed = "CAMPAIGN_RESUMED",
  /** Campaign Started */
  CampaignStarted = "CAMPAIGN_STARTED",
  /** Contribution Completed */
  ContributionCompleted = "CONTRIBUTION_COMPLETED",
  /** Contribution Confirmed */
  ContributionConfirmed = "CONTRIBUTION_CONFIRMED",
  /** Contribution Failed */
  ContributionFailed = "CONTRIBUTION_FAILED",
  /** Contribution Rejected */
  ContributionRejected = "CONTRIBUTION_REJECTED",
  /** Contribution Submitted */
  ContributionSubmitted = "CONTRIBUTION_SUBMITTED",
  /** Grant Cancelled */
  GrantCancelled = "GRANT_CANCELLED",
  /** Grant Completed */
  GrantCompleted = "GRANT_COMPLETED",
  /** Grant Confirmed */
  GrantConfirmed = "GRANT_CONFIRMED",
  /** Grant Failed */
  GrantFailed = "GRANT_FAILED",
  /** Grant Paused */
  GrantPaused = "GRANT_PAUSED",
  /** Grant Rejected */
  GrantRejected = "GRANT_REJECTED",
  /** Grant Resumed */
  GrantResumed = "GRANT_RESUMED",
  /** Grant Submitted */
  GrantSubmitted = "GRANT_SUBMITTED",
  /** Investment Cancelled */
  InvestmentCancelled = "INVESTMENT_CANCELLED",
  /** Investment Completed */
  InvestmentCompleted = "INVESTMENT_COMPLETED",
  /** Investment Confirmed */
  InvestmentConfirmed = "INVESTMENT_CONFIRMED",
  /** Investment Failed */
  InvestmentFailed = "INVESTMENT_FAILED",
  /** Investment Paused */
  InvestmentPaused = "INVESTMENT_PAUSED",
  /** Investment Rejected */
  InvestmentRejected = "INVESTMENT_REJECTED",
  /** Investment Resumed */
  InvestmentResumed = "INVESTMENT_RESUMED",
  /** Investment Submitted */
  InvestmentSubmitted = "INVESTMENT_SUBMITTED",
  /** Invitation Accepted */
  InvitationAccepted = "INVITATION_ACCEPTED",
  /** Invitation Cancelled */
  InvitationCancelled = "INVITATION_CANCELLED",
  /** Invitation Completed */
  InvitationCompleted = "INVITATION_COMPLETED",
  /** Invitation Failed */
  InvitationFailed = "INVITATION_FAILED",
  /** Invitation Rejected */
  InvitationRejected = "INVITATION_REJECTED",
  /** Invitation Sent */
  InvitationSent = "INVITATION_SENT",
}

export type ActivityTypeSchema = {
  __typename?: "ActivityTypeSchema";
  /** Text for the action button */
  actionText: Scalars["String"]["output"];
  /** URL for the action button */
  actionUrl: Scalars["String"]["output"];
  category: ActivityCategory;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  objectId?: Maybe<Scalars["Int"]["output"]>;
  type: ActivityType;
};

/** API to add multiple admin users to an existing family */
export type AddAdminUsersToFamily = {
  __typename?: "AddAdminUsersToFamily";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type AddAdventIntegration = {
  __typename?: "AddAdventIntegration";
  adventIntegration?: Maybe<AdventIntegrationType>;
};

/** Add Beneficiary contributions in Amicus  */
export type AddBeneficiary = {
  __typename?: "AddBeneficiary";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** API to add to funds table  */
export type AddCharity = {
  __typename?: "AddCharity";
  charity?: Maybe<CharityType>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Add family members to existing family  */
export type AddFamilyMember = {
  __typename?: "AddFamilyMember";
  status?: Maybe<StatusSummaryType>;
};

/** Add existing family member as a successor  */
export type AddFamilyMemberSuccessor = {
  __typename?: "AddFamilyMemberSuccessor";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** API to add a family to an existing corporate firm */
export type AddFamilyToExistingFirm = {
  __typename?: "AddFamilyToExistingFirm";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type AddFeaturedCharities = {
  __typename?: "AddFeaturedCharities";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * Create DAF Account with Louise.
 * Requires contact details of the Head of the Family,
 * fund name and optional successor information.
 */
export type AddLouiseDafAccount = {
  __typename?: "AddLouiseDafAccount";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Create new advisor user group  */
export type AddMembersToAdvisorUserGroup = {
  __typename?: "AddMembersToAdvisorUserGroup";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  status?: Maybe<StatusSummaryType>;
};

/** Add a model to a family  */
export type AddModel = {
  __typename?: "AddModel";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type AddParticipantFromFile = {
  __typename?: "AddParticipantFromFile";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Add or remove TagCategory from firm */
export type AddRemoveTagCategory = {
  __typename?: "AddRemoveTagCategory";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Add Successor contributions in Amicus  */
export type AddSuccessor = {
  __typename?: "AddSuccessor";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type AddressInputType = {
  city?: InputMaybe<Scalars["String"]["input"]>;
  postalCode?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<Scalars["String"]["input"]>;
  streetAddress?: InputMaybe<Scalars["String"]["input"]>;
};

export type AddressType = {
  __typename?: "AddressType";
  postalCode?: Maybe<Scalars["String"]["output"]>;
};

/** Input type for admin user details */
export type AdminUserInputType = {
  /** Email address of the admin user */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** First name of the admin user */
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  /** Last name of the admin user */
  lastName?: InputMaybe<Scalars["String"]["input"]>;
};

export type AdoptionBannerStatsType = {
  __typename?: "AdoptionBannerStatsType";
  /** First 12 weeks stats from launch date */
  period?: Maybe<PeriodStatsType>;
};

/**
 * User: ops_admin
 * Run the daily step job for ONE family, right now -- the "Complete Step N"
 * button on the ops pipeline.
 *
 * Deliberately the job itself (run_succession_steps), not a hand-written
 * advance. The step's exit conditions, its emails, its transfers and its
 * beneficiary distributions all live in _advance_one, and a second way to move
 * a transition would be a second set of rules about when money may move. This
 * only changes WHEN the job runs, never what it does.
 *
 * So the side effects are real and intended: pressing this can send the freeze
 * confirmation, invite successors, or create beneficiary distributions. That is
 * the difference between this and the read-only pipeline view, which must never
 * do any of it.
 *
 * At most one step advances per call, because the job advances at most one per
 * run -- "Complete Step 4" moves the transition to step 5 and stops there.
 *
 * `expected_step` guards against a stale page: the button was labelled from
 * what the queue showed, and if the nightly job has moved the transition since,
 * completing "step 4" would silently complete step 5 instead.
 *
 * Refuses, with the reason, on the two states the job will not touch: a death
 * event whose certificate is still under review (ops approves that first, and
 * the transition begins there), and a voluntary transition scheduled for a
 * future date (process_scheduled_transitions activates it on the day -- a
 * different job from this one).
 */
export type AdvanceSuccessionStep = {
  __typename?: "AdvanceSuccessionStep";
  /** True when the step's conditions were met and the transition moved on. */
  advanced?: Maybe<Scalars["Boolean"]["output"]>;
  /** Where the transition stands now. */
  currentStep?: Maybe<Scalars["Int"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  /** Why it did not advance, in the step's own words. Null when it did. */
  reason?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  /** The step the job ran against. */
  step?: Maybe<Scalars["Int"]["output"]>;
};

/**
 * Stamp one of the successor-only onboarding steps as done.
 *
 * Covers the four steps that leave no other trace:
 *   founder_message  step 2 -- founder's voice shown (or skipped as empty)
 *   mission          step 4 -- originating family's mission reviewed
 *   acknowledgment   step 5 -- Successor Acknowledgment Form signed
 *   giving_history   step 6 -- founder's pinned giving history shown (or
 *                    skipped when nothing was pinned)
 *
 * Steps 1, 3 and 7 are not settable here: they already have real markers
 * (accepted_at/declined_at, curation rows, the destination DAF itself).
 *
 * Scoped by destination family, like every other successor-only step -- the
 * caller can only advance their own claim on that family. Idempotent: a repeat
 * call keeps the first timestamp, so a back-and-forward through the wizard does
 * not rewrite history.
 *
 * Ordering is enforced, not assumed: acknowledgment cannot be signed before the
 * invite is accepted. Without that, a client bug could create the destination
 * DAF with no consent on record -- and the transition's step 2/3 'resolved' test
 * reads DAF-exists as proof of consent.
 */
export type AdvanceSuccessorOnboarding = {
  __typename?: "AdvanceSuccessorOnboarding";
  message?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export enum AdventIntegratedMasterAccountLinkStatus {
  /** ACTIVE */
  Active = "ACTIVE",
  /** PENDING */
  Pending = "PENDING",
}

export type AdventIntegratedMasterAccountType = {
  __typename?: "AdventIntegratedMasterAccountType";
  accountNumber: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  linkStatus: AdventIntegratedMasterAccountLinkStatus;
  portfolios?: Maybe<Array<Maybe<AdventIntegratedPortfolioType>>>;
};

export type AdventIntegratedPortfolioSodEntryType = {
  __typename?: "AdventIntegratedPortfolioSODEntryType";
  costBasis?: Maybe<Scalars["Float"]["output"]>;
  cusip?: Maybe<Scalars["String"]["output"]>;
  gains?: Maybe<Scalars["Float"]["output"]>;
  generatedLotId?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isLongTerm?: Maybe<Scalars["Boolean"]["output"]>;
  lotNumber?: Maybe<Scalars["Int"]["output"]>;
  marketValue?: Maybe<Scalars["Float"]["output"]>;
  portfolioCode?: Maybe<Scalars["String"]["output"]>;
  portfolioId?: Maybe<Scalars["String"]["output"]>;
  price?: Maybe<Scalars["Float"]["output"]>;
  quantity?: Maybe<Scalars["Float"]["output"]>;
  securityTypeCode?: Maybe<Scalars["String"]["output"]>;
  sodDate?: Maybe<Scalars["DateTime"]["output"]>;
  ticker?: Maybe<Scalars["String"]["output"]>;
};

export type AdventIntegratedPortfolioType = {
  __typename?: "AdventIntegratedPortfolioType";
  accountName: Scalars["String"]["output"];
  acctType?: Maybe<Scalars["String"]["output"]>;
  agi?: Maybe<Scalars["Float"]["output"]>;
  appreciatedSecuritiesCount?: Maybe<Scalars["Int"]["output"]>;
  appreciatedSecuritiesValue?: Maybe<Scalars["Float"]["output"]>;
  capitalGainsTaxSavings?: Maybe<Scalars["Float"]["output"]>;
  cashAndEquiv?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  custodianId?: Maybe<Scalars["String"]["output"]>;
  donationLimit?: Maybe<Scalars["String"]["output"]>;
  equity?: Maybe<Scalars["Float"]["output"]>;
  errorInput?: Maybe<Scalars["String"]["output"]>;
  excludeTicker?: Maybe<Scalars["String"]["output"]>;
  filingStatus?: Maybe<Scalars["String"]["output"]>;
  fixedIncome?: Maybe<Scalars["Float"]["output"]>;
  id: Scalars["ID"]["output"];
  incomeTaxSavings?: Maybe<Scalars["Float"]["output"]>;
  lastSyncTime?: Maybe<Scalars["DateTime"]["output"]>;
  newTotalValue?: Maybe<Scalars["Float"]["output"]>;
  numTickerAllowed?: Maybe<Scalars["String"]["output"]>;
  numberOfRecommendations?: Maybe<Scalars["Int"]["output"]>;
  optimizationMethod?: Maybe<Scalars["String"]["output"]>;
  optimizerError?: Maybe<Scalars["String"]["output"]>;
  originalTotalValue?: Maybe<Scalars["Float"]["output"]>;
  other?: Maybe<Scalars["Float"]["output"]>;
  portfolioAllocationAfter?: Maybe<Scalars["String"]["output"]>;
  portfolioAllocationBefore?: Maybe<Scalars["String"]["output"]>;
  portfolioCode: Scalars["String"]["output"];
  portfolioNameTwo?: Maybe<Scalars["String"]["output"]>;
  recommendations?: Maybe<Scalars["String"]["output"]>;
  shareLimit?: Maybe<Scalars["String"]["output"]>;
  sodEntries?: Maybe<Array<Maybe<AdventIntegratedPortfolioSodEntryType>>>;
  targetTaxSavings?: Maybe<Scalars["String"]["output"]>;
  taxOpportunityScore?: Maybe<Scalars["Float"]["output"]>;
  taxSavedDifference?: Maybe<Scalars["Float"]["output"]>;
  taxSavedItemizedDeduction?: Maybe<Scalars["Float"]["output"]>;
  taxSavedStandardDeduction?: Maybe<Scalars["Float"]["output"]>;
  taxStatus?: Maybe<Scalars["String"]["output"]>;
  teLimit?: Maybe<Scalars["String"]["output"]>;
  totalBalance: Scalars["Float"]["output"];
  totalCostForDonation?: Maybe<Scalars["Float"]["output"]>;
  totalDafDeduction?: Maybe<Scalars["Float"]["output"]>;
  totalTaxSavings?: Maybe<Scalars["Float"]["output"]>;
  totalUnrealizedGain?: Maybe<Scalars["Float"]["output"]>;
  trackingError?: Maybe<Scalars["Float"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  valueChange?: Maybe<Scalars["Float"]["output"]>;
};

export enum AdventIntegrationStatus {
  /** CANCELED */
  Canceled = "CANCELED",
  /** COMPLETE */
  Complete = "COMPLETE",
  /** DECLINED */
  Declined = "DECLINED",
  /** FAILED */
  Failed = "FAILED",
  /** IN PROGRESS */
  InProgress = "IN_PROGRESS",
  /** PENDING */
  Pending = "PENDING",
  /** REQUIRES_SIGNATURE */
  RequiresSignature = "REQUIRES_SIGNATURE",
}

export type AdventIntegrationType = {
  __typename?: "AdventIntegrationType";
  advisor?: Maybe<UserType>;
  completedAt?: Maybe<Scalars["DateTime"]["output"]>;
  connectedOn?: Maybe<Scalars["DateTime"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  custodian?: Maybe<DafCustodianType>;
  docusignEnvelopeId: Scalars["String"]["output"];
  docusignUrl?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  lastSyncedAt?: Maybe<Array<Maybe<Scalars["DateTime"]["output"]>>>;
  masterAccount?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  masterAccounts: Array<AdventIntegratedMasterAccountType>;
  requestedAt?: Maybe<Scalars["DateTime"]["output"]>;
  signedAt?: Maybe<Scalars["DateTime"]["output"]>;
  status: AdventIntegrationStatus;
  totalAccounts?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type AdventPortfolioUserAccountType = {
  __typename?: "AdventPortfolioUserAccountType";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  portfolio: AdventIntegratedPortfolioType;
  user: UserType;
};

export type AdvisorCustodianMetadataType = {
  __typename?: "AdvisorCustodianMetadataType";
  firmName?: Maybe<Scalars["String"]["output"]>;
  gNumbers?: Maybe<Scalars["String"]["output"]>;
};

export type AdvisorDafType = {
  __typename?: "AdvisorDAFType";
  accountNumber?: Maybe<Scalars["String"]["output"]>;
  benchmark?: Maybe<Scalars["String"]["output"]>;
  bps: Scalars["Int"]["output"];
  custodian?: Maybe<DafCustodianType>;
  /** Determine if the DAF account is AMA or not */
  disableAllocations: Scalars["Boolean"]["output"];
  family: FamilyType;
  fundName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  isSingleCharityFund: Scalars["Boolean"]["output"];
  managementFees?: Maybe<Scalars["Decimal"]["output"]>;
  metaData?: Maybe<Scalars["JSONString"]["output"]>;
  restrictedCharityEin?: Maybe<Scalars["String"]["output"]>;
  restrictedCharityId?: Maybe<Scalars["String"]["output"]>;
  restrictedCharityName?: Maybe<Scalars["String"]["output"]>;
};

export type AdvisorDafClientsFilterType = {
  engageFamily?: InputMaybe<Scalars["Boolean"]["input"]>;
  fundType?: InputMaybe<FundTypeEnum>;
  isIndividualDaf?: InputMaybe<Scalars["Boolean"]["input"]>;
  status?: InputMaybe<FundStatusEnum>;
};

/** Input type to create DAF when advisor creates family/HOH */
export type AdvisorDafInputType = {
  accountNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** Annual income of the DAF holder in dollars. */
  annualIncome?: InputMaybe<Scalars["Int"]["input"]>;
  benchmark?: InputMaybe<Scalars["String"]["input"]>;
  /** Getting Advisor Fees. */
  bps?: InputMaybe<Scalars["Int"]["input"]>;
  /** Goldman Sachs branch code for this DAF. */
  branchCode?: InputMaybe<Scalars["String"]["input"]>;
  dafCustodianId: Scalars["Int"]["input"];
  disableAllocations?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Employer line of business (GS API enum, e.g. FINANCE, TECHNOLOGY). */
  employerLineOfBusiness?: InputMaybe<Scalars["String"]["input"]>;
  /** Employment status. One of: FULL_TIME_EMPLOYED, SELF_EMPLOYED, RETIRED, PART_TIME_EMPLOYED, NOT_EMPLOYED. */
  employmentStatus?: InputMaybe<Scalars["String"]["input"]>;
  /** Name of the fund to be reflected in DAF. Eg: <Your Family Name>'s Family Fund. */
  fundName: Scalars["String"]["input"];
  /** Whether the fund is single charity fund or not. */
  isSingleCharityFund?: InputMaybe<Scalars["Boolean"]["input"]>;
  managementFees?: InputMaybe<Scalars["Decimal"]["input"]>;
  primaryFidelityFirmName?: InputMaybe<Scalars["String"]["input"]>;
  /** Comma-separated list of G numbers. */
  primaryFidelityGNumbers?: InputMaybe<Scalars["String"]["input"]>;
  primarySchwabFirmName?: InputMaybe<Scalars["String"]["input"]>;
  primarySchwabMasterAccountNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** Goldman Sachs rep code for this DAF. */
  repCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Charity EIN to restrict the single charity fund to */
  restrictedCharityEin?: InputMaybe<Scalars["String"]["input"]>;
  /** Charity ID to restrict the the single charity fund to. */
  restrictedCharityId?: InputMaybe<Scalars["String"]["input"]>;
  /** Charity Name to restrict the the single charity fund to. */
  restrictedCharityName?: InputMaybe<Scalars["String"]["input"]>;
  /** Source(s) of wealth for the DAF holder. */
  sourceOfWealth?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type AdvisorDashboardType = {
  __typename?: "AdvisorDashboardType";
  assets?: Maybe<Scalars["Int"]["output"]>;
  clients?: Maybe<Scalars["Int"]["output"]>;
  portfolios?: Maybe<Scalars["Int"]["output"]>;
};

export type AdvisorDetailsType = {
  __typename?: "AdvisorDetailsType";
  aum?: Maybe<Scalars["String"]["output"]>;
  clientsManaged?: Maybe<Scalars["Int"]["output"]>;
  clientsSupported?: Maybe<Scalars["Int"]["output"]>;
  dafsCount?: Maybe<Scalars["Int"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  profileUrl?: Maybe<Scalars["String"]["output"]>;
  tncAcceptedTime?: Maybe<Scalars["DateTime"]["output"]>;
  ytd?: Maybe<Scalars["String"]["output"]>;
};

export type AdvisorFamilyDashboardType = {
  __typename?: "AdvisorFamilyDashboardType";
  acceptedCount?: Maybe<Scalars["Int"]["output"]>;
  invitedCount?: Maybe<Scalars["Int"]["output"]>;
  membersCount?: Maybe<Scalars["Int"]["output"]>;
  pendingCount?: Maybe<Scalars["Int"]["output"]>;
};

export type AdvisorFeeRowType = {
  __typename?: "AdvisorFeeRowType";
  adminFees?: Maybe<Scalars["Float"]["output"]>;
  aum?: Maybe<Scalars["String"]["output"]>;
  avgBps?: Maybe<Scalars["String"]["output"]>;
  dafGiveReferenceId?: Maybe<Scalars["String"]["output"]>;
  dafId?: Maybe<Scalars["String"]["output"]>;
  dafName?: Maybe<Scalars["String"]["output"]>;
  enterpriseFeePct?: Maybe<Scalars["Float"]["output"]>;
  enterpriseShare?: Maybe<Scalars["Float"]["output"]>;
  platformFeePct?: Maybe<Scalars["Float"]["output"]>;
  platformShare?: Maybe<Scalars["Float"]["output"]>;
  subAdvisorFees?: Maybe<Scalars["Float"]["output"]>;
};

export type AdvisorGroupClientsDetailsType = {
  __typename?: "AdvisorGroupClientsDetailsType";
  aum?: Maybe<Scalars["Float"]["output"]>;
  fundName?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  primaryAdvisor?: Maybe<Scalars["String"]["output"]>;
  subAdvisorFee?: Maybe<Scalars["Float"]["output"]>;
  ytd?: Maybe<Scalars["Float"]["output"]>;
};

/** Response fields to have pagination for advisor group's details clients list  */
export type AdvisorGroupClientsPaginatedType = {
  __typename?: "AdvisorGroupClientsPaginatedType";
  objects?: Maybe<Array<Maybe<AdvisorGroupClientsDetailsType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

/** Response fields to have pagination for advisor groups list  */
export type AdvisorGroupPaginatedType = {
  __typename?: "AdvisorGroupPaginatedType";
  objects?: Maybe<Array<Maybe<AdvisorGroupType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Response fields to provide advisor group brief details  */
export type AdvisorGroupType = {
  __typename?: "AdvisorGroupType";
  advisors?: Maybe<Array<Maybe<UserType>>>;
  externalId?: Maybe<Scalars["String"]["output"]>;
  familyCount?: Maybe<Scalars["Int"]["output"]>;
  groupType?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type AdvisorOnboardType = {
  __typename?: "AdvisorOnboardType";
  allContributionCount?: Maybe<Scalars["Int"]["output"]>;
  contributionCount?: Maybe<Scalars["Int"]["output"]>;
  familyCount?: Maybe<Scalars["Int"]["output"]>;
  memberCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Response fields to have pagination for advisor's detail list  */
export type AdvisorPaginatedType = {
  __typename?: "AdvisorPaginatedType";
  objects?: Maybe<Array<Maybe<ClientDetailsType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export type AdvisorSummaryDashboardType = {
  __typename?: "AdvisorSummaryDashboardType";
  campaigns?: Maybe<Scalars["Int"]["output"]>;
  clientCount?: Maybe<Scalars["Int"]["output"]>;
  dafInvestmentPercent?: Maybe<Scalars["Int"]["output"]>;
  donorActivity?: Maybe<Array<Maybe<DonorActivityLogsType>>>;
  totalDafAum?: Maybe<Scalars["String"]["output"]>;
  totalGifted?: Maybe<Scalars["Int"]["output"]>;
  ytdContribution?: Maybe<Scalars["Float"]["output"]>;
  ytdSubadvisoryFee?: Maybe<Scalars["Float"]["output"]>;
};

/** advisor's detail list */
export type AdvisorSummaryType = {
  __typename?: "AdvisorSummaryType";
  clientsManaged?: Maybe<Scalars["Int"]["output"]>;
  clientsSupported?: Maybe<Scalars["Int"]["output"]>;
  totalAum?: Maybe<Scalars["String"]["output"]>;
  totalYtdFees?: Maybe<Scalars["String"]["output"]>;
};

export type AdvisorWeeklySummaryType = {
  __typename?: "AdvisorWeeklySummaryType";
  contributions?: Maybe<Scalars["Int"]["output"]>;
  grants?: Maybe<Scalars["Int"]["output"]>;
  pendingContributions?: Maybe<Scalars["Int"]["output"]>;
  pendingGrants?: Maybe<Scalars["Int"]["output"]>;
};

/** advisor's detail list */
export type AdvisoryopsDetailsType = {
  __typename?: "AdvisoryopsDetailsType";
  aum?: Maybe<Scalars["String"]["output"]>;
  clientsCount?: Maybe<Scalars["Int"]["output"]>;
  dafsCount?: Maybe<Scalars["Int"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  profileUrl?: Maybe<Scalars["String"]["output"]>;
  ytd?: Maybe<Scalars["String"]["output"]>;
};

/** Response fields to have pagination for advisory op's  detail list  */
export type AdvisoryopsPaginatedType = {
  __typename?: "AdvisoryopsPaginatedType";
  objects?: Maybe<Array<Maybe<AdvisoryopsDetailsType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export type AlertsType = {
  __typename?: "AlertsType";
  allocate?: Maybe<Scalars["Boolean"]["output"]>;
  contribution?: Maybe<Scalars["Boolean"]["output"]>;
  daf?: Maybe<Scalars["Boolean"]["output"]>;
  organize?: Maybe<Scalars["Boolean"]["output"]>;
  plaid?: Maybe<Scalars["Boolean"]["output"]>;
};

export type AlignModuleType = {
  __typename?: "AlignModuleType";
  cashModel?: Maybe<AssetPoolType>;
  /** Lists the models/pool details of the current portfolio */
  currentPortfolio?: Maybe<Array<Maybe<CurrentPortfolioType>>>;
  lastSubmitted?: Maybe<Scalars["Date"]["output"]>;
  /** Overall portfolio alignment score */
  portfolioAlignment?: Maybe<Scalars["Float"]["output"]>;
  /** Provides analytics report including gains chart, risk analysis, etc., */
  portfolioAnalytics?: Maybe<Scalars["GenericScalar"]["output"]>;
  selectedCores?: Maybe<Array<Maybe<AssetPoolType>>>;
  /** List of holdings and its target weight of a portfolio */
  targetPortfolio?: Maybe<Array<Maybe<Scalars["GenericScalar"]["output"]>>>;
  /** Gets the investment weightage pattern for each theme and the alignment with the correspondin giving pattern */
  thematicPortfolio?: Maybe<Array<Maybe<Scalars["GenericScalar"]["output"]>>>;
  /** Provides thematic portfolio analytics report including gains chart, risk analysis, etc., */
  thematicPortfolioAnalytics?: Maybe<
    Array<Maybe<Scalars["GenericScalar"]["output"]>>
  >;
};

export type AllTransactionsType = {
  __typename?: "AllTransactionsType";
  amount?: Maybe<Scalars["Float"]["output"]>;
  contributor: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  displayStatus: Scalars["String"]["output"];
  familyId: Scalars["Int"]["output"];
  id: Scalars["UUID"]["output"];
  initiatedOn: Scalars["DateTime"]["output"];
  lastUpdatedOn?: Maybe<Scalars["DateTime"]["output"]>;
  metaData: Scalars["JSONString"]["output"];
  /** Composite key combining object_id and identifier for SECURITIES batches */
  objectId?: Maybe<Scalars["String"]["output"]>;
  searchDescription: Scalars["String"]["output"];
  source: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  transactionId: Scalars["String"]["output"];
  userId: Scalars["Int"]["output"];
};

export type AllocationType = {
  assetId: Scalars["String"]["input"];
  ratio: Scalars["String"]["input"];
};

export type AllowedCustodianType = {
  allowedFundTypes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type AppreciatedSecuritiesType = {
  __typename?: "AppreciatedSecuritiesType";
  count?: Maybe<Scalars["Int"]["output"]>;
  tickers?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  value?: Maybe<Scalars["Float"]["output"]>;
};

/** Aprove company grant  */
export type ApproveClientGrant = {
  __typename?: "ApproveClientGrant";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Aprove company grant  */
export type ApproveCompanyGrant = {
  __typename?: "ApproveCompanyGrant";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * User: ops_admin
 * Approve a pending death event transition after verifying the death certificate.
 * Moves the transition from under_review → initiated so the advisor can confirm Step 1.
 */
export type ApproveDeathTransition = {
  __typename?: "ApproveDeathTransition";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Response fields to have pagination for users list  */
export type ArchivedUsersPaginatedType = {
  __typename?: "ArchivedUsersPaginatedType";
  objects?: Maybe<Array<Maybe<UserType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export type ArticlePaginatedType = {
  __typename?: "ArticlePaginatedType";
  objects?: Maybe<Array<Maybe<ArticleType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export type ArticleType = {
  __typename?: "ArticleType";
  dataId: Scalars["Int"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  image?: Maybe<Scalars["String"]["output"]>;
  publicationDate?: Maybe<Scalars["Date"]["output"]>;
  score?: Maybe<Scalars["Float"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  url?: Maybe<Scalars["String"]["output"]>;
};

export enum AssetPoolPoolType {
  /** Cash */
  Cash = "CASH",
  /** Core */
  Core = "CORE",
  /** Thematic */
  Thematic = "THEMATIC",
}

export type AssetPoolType = {
  __typename?: "AssetPoolType";
  assetId: Scalars["String"]["output"];
  assetName: Scalars["String"]["output"];
  poolType?: Maybe<AssetPoolPoolType>;
};

export type AssetType = {
  __typename?: "AssetType";
  Class?: Maybe<Scalars["String"]["output"]>;
  Type?: Maybe<Scalars["String"]["output"]>;
  category?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  ticker?: Maybe<Scalars["String"]["output"]>;
  tickerName?: Maybe<Scalars["String"]["output"]>;
  weight?: Maybe<Scalars["Float"]["output"]>;
};

export type AttachPaymentMethod = {
  __typename?: "AttachPaymentMethod";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** attest transactions API  */
export type AttestTransactions = {
  __typename?: "AttestTransactions";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type AuthType = {
  __typename?: "AuthType";
  error?: Maybe<Scalars["String"]["output"]>;
  token?: Maybe<Scalars["String"]["output"]>;
  user?: Maybe<UserType>;
};

/**
 * ItemAccount projection for scheduled-contribution APIs only.
 *
 * Must not register on the global model→type map: Graphene-Django keeps one
 * type per model, and the last registrant wins for every relation. Without
 * skip_registry this type silently replaces bank.ItemAccountType (which owns
 * balance / verificationStatus resolvers), so plaidItems.itemAccounts loses
 * those fields.
 */
export type BankItemAccountType = {
  __typename?: "BankItemAccountType";
  accountHolder?: Maybe<Scalars["String"]["output"]>;
  accountId?: Maybe<Scalars["String"]["output"]>;
  accountName?: Maybe<Scalars["String"]["output"]>;
  connected: Scalars["Boolean"]["output"];
  createdBy?: Maybe<UserType>;
  default: Scalars["Boolean"]["output"];
  family?: Maybe<FamilyType>;
  id: Scalars["ID"]["output"];
  institutionName?: Maybe<Scalars["String"]["output"]>;
  locked: Scalars["Boolean"]["output"];
  mask?: Maybe<Scalars["String"]["output"]>;
  plaidItem?: Maybe<PlaidItemType>;
  processorToken?: Maybe<Scalars["String"]["output"]>;
  scheduledContributions: Array<ScheduledContributionType>;
  verificationStatus?: Maybe<Scalars["String"]["output"]>;
};

export type BarChartDataType = {
  __typename?: "BarChartDataType";
  donationQuantity?: Maybe<Scalars["Float"]["output"]>;
  marketValue?: Maybe<Scalars["Float"]["output"]>;
  marketValuePercent?: Maybe<Scalars["Float"]["output"]>;
  securityName?: Maybe<Scalars["String"]["output"]>;
  taxSavingPercent?: Maybe<Scalars["Float"]["output"]>;
  ticker?: Maybe<Scalars["String"]["output"]>;
  totalTaxSaving?: Maybe<Scalars["Float"]["output"]>;
};

export enum BeneficiaryFrequency {
  /** Annually */
  Annually = "ANNUALLY",
  /** Monthly */
  Monthly = "MONTHLY",
  /** One Time */
  OneTime = "ONE_TIME",
  /** Quarterly */
  Quarterly = "QUARTERLY",
}

/** Beneficiary input field type  */
export type BeneficiaryInputType = {
  address: Scalars["String"]["input"];
  charityName: Scalars["String"]["input"];
  city: Scalars["String"]["input"];
  duration?: InputMaybe<Scalars["Int"]["input"]>;
  ein?: InputMaybe<Scalars["String"]["input"]>;
  /** Enum options for frequency types. */
  frequency?: InputMaybe<FrequencyChoices>;
  percentage: Scalars["Float"]["input"];
  phoneNumber: Scalars["String"]["input"];
  state: Scalars["String"]["input"];
  website?: InputMaybe<Scalars["String"]["input"]>;
  zipCode: Scalars["String"]["input"];
};

/** Beneficiary response field type  */
export type BeneficiaryType = {
  __typename?: "BeneficiaryType";
  address: Scalars["String"]["output"];
  charityName?: Maybe<Scalars["String"]["output"]>;
  city: Scalars["String"]["output"];
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** Set the moment a succession-transition step-5 distribution was attempted for this beneficiary, whether or not it resulted in a Contribution (e.g. skipped for an invalid EIN or an amount below the $50 minimum). Distinguishes 'skipped, nothing to wait for' from 'not processed yet'. */
  distributionAttemptedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** The real Contribution created for this beneficiary when the family's succession transition entered step 5 and distributed its remaining DAF balance (see give.utils.create_succession_beneficiary_contributions). Null if a distribution was never attempted, or if attempted but skipped -- see distribution_attempted_at to tell those two cases apart. */
  distributionContribution?: Maybe<GiftActivityType>;
  duration?: Maybe<Scalars["Int"]["output"]>;
  ein?: Maybe<Scalars["String"]["output"]>;
  family: FamilyType;
  frequency: BeneficiaryFrequency;
  id: Scalars["ID"]["output"];
  percentage?: Maybe<Scalars["Float"]["output"]>;
  phoneNumber: Scalars["String"]["output"];
  state: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  website: Scalars["String"]["output"];
  zipCode: Scalars["String"]["output"];
};

export type BillingDetailsType = {
  __typename?: "BillingDetailsType";
  address?: Maybe<AddressType>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type BookLevelSettingsType = {
  __typename?: "BookLevelSettingsType";
  coreUser: UserType;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  maxContribution?: Maybe<Scalars["Float"]["output"]>;
  teError?: Maybe<Scalars["Float"]["output"]>;
  tickerLimit?: Maybe<Scalars["Int"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export enum BookOfBusinessImportJobStatus {
  /** COMPLETED */
  Completed = "COMPLETED",
  /** FAILED */
  Failed = "FAILED",
  /** IN_PROGRESS */
  InProgress = "IN_PROGRESS",
  /** PENDING */
  Pending = "PENDING",
}

export type BookOfBusinessImportJobType = {
  __typename?: "BookOfBusinessImportJobType";
  createdAt: Scalars["DateTime"]["output"];
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  failedCount: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  matchedCount: Scalars["Int"]["output"];
  queuedCount: Scalars["Int"]["output"];
  status: BookOfBusinessImportJobStatus;
  totalAccounts: Scalars["Int"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export enum BookOfBusinessImportRecordStatus {
  /** FAILED */
  Failed = "FAILED",
  /** MATCHED */
  Matched = "MATCHED",
  /** QUEUED */
  Queued = "QUEUED",
  /** SKIPPED */
  Skipped = "SKIPPED",
}

export type BookOfBusinessImportRecordType = {
  __typename?: "BookOfBusinessImportRecordType";
  accountName: Scalars["String"]["output"];
  accountNumber: Scalars["String"]["output"];
  accountType?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  matchedFamily?: Maybe<FamilyType>;
  rawData?: Maybe<Scalars["JSONString"]["output"]>;
  status: BookOfBusinessImportRecordStatus;
  updatedAt: Scalars["DateTime"]["output"];
};

/** Cancel all cancelable securities in a batch. */
export type BulkCancelSecurityTransactions = {
  __typename?: "BulkCancelSecurityTransactions";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type BunchingAnalysisResultType = {
  __typename?: "BunchingAnalysisResultType";
  bunched?: Maybe<BunchingScenarioType>;
  bunchedContributionAmount?: Maybe<Scalars["Float"]["output"]>;
  bunchingWindowYears?: Maybe<Scalars["Int"]["output"]>;
  filingStatus?: Maybe<Scalars["String"]["output"]>;
  fundingContributionDetails?: Maybe<Array<Maybe<ContributionDetailType>>>;
  fundingOptimizationSummary?: Maybe<OptimizationSummaryType>;
  itemizedDeductionExcludingCharity?: Maybe<Scalars["Float"]["output"]>;
  plannedAnnualGiving?: Maybe<Scalars["Float"]["output"]>;
  saltDeduction?: Maybe<Scalars["Float"]["output"]>;
  standardDeduction?: Maybe<Scalars["Float"]["output"]>;
  statusQuo?: Maybe<BunchingScenarioType>;
  taxYear?: Maybe<Scalars["Int"]["output"]>;
  totalTaxSavings?: Maybe<Scalars["Float"]["output"]>;
};

export type BunchingGivingPatternInputType = {
  bunchingWindowYears?: InputMaybe<Scalars["Int"]["input"]>;
  plannedAnnualGiving?: InputMaybe<Scalars["Float"]["input"]>;
};

export enum BunchingPlanDraftStatus {
  /** DRAFT */
  Draft = "DRAFT",
  /** SAVED */
  Saved = "SAVED",
}

export type BunchingPlanDraftType = {
  __typename?: "BunchingPlanDraftType";
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  planData?: Maybe<Scalars["JSONString"]["output"]>;
  status: BunchingPlanDraftStatus;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type BunchingScenarioType = {
  __typename?: "BunchingScenarioType";
  label?: Maybe<Scalars["String"]["output"]>;
  totalTax?: Maybe<Scalars["Float"]["output"]>;
  years?: Maybe<Array<Maybe<BunchingScenarioYearType>>>;
};

export type BunchingScenarioYearType = {
  __typename?: "BunchingScenarioYearType";
  charitableGiving?: Maybe<Scalars["Float"]["output"]>;
  deductionUsed?: Maybe<Scalars["Float"]["output"]>;
  itemizedDeduction?: Maybe<Scalars["Float"]["output"]>;
  taxOwed?: Maybe<Scalars["Float"]["output"]>;
  taxableIncome?: Maybe<Scalars["Float"]["output"]>;
  yearIndex?: Maybe<Scalars["Int"]["output"]>;
};

export type BunchingTaxProfileInputType = {
  estimatedAnnualIncome?: InputMaybe<Scalars["Float"]["input"]>;
  filingStatus?: InputMaybe<Scalars["String"]["input"]>;
  mortgageInterest?: InputMaybe<Scalars["Float"]["input"]>;
  otherItemizedDeductions?: InputMaybe<Scalars["Float"]["input"]>;
  saltPaid?: InputMaybe<Scalars["Float"]["input"]>;
  taxYear?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum CTypeEnumType {
  All = "ALL",
  Family = "FAMILY",
  Tag = "TAG",
  User = "USER",
}

export enum CampaignCampaignType {
  /** MEMORIAL */
  Memorial = "MEMORIAL",
  /** MILESTONE */
  Milestone = "MILESTONE",
  /** STANDARD */
  Standard = "STANDARD",
  /** TRIBUTE */
  Tribute = "TRIBUTE",
}

export type CampaignDashboardMetricsType = {
  __typename?: "CampaignDashboardMetricsType";
  activeCampaigns?: Maybe<Scalars["Int"]["output"]>;
  completedCampaigns?: Maybe<Scalars["Int"]["output"]>;
  pendingCampaigns?: Maybe<Scalars["Int"]["output"]>;
  totalDonations?: Maybe<Scalars["Decimal"]["output"]>;
  totalDonors?: Maybe<Scalars["Int"]["output"]>;
};

/** Response fields to have pagination for advisor's detail list  */
export type CampaignDonationPaginatedType = {
  __typename?: "CampaignDonationPaginatedType";
  objects?: Maybe<Array<Maybe<CampaignDonationType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export enum CampaignDonationStatus {
  /** APPROVED */
  Approved = "APPROVED",
  /** APPROVED PENDING REDEMPTION */
  ApprovedPendingRedemption = "APPROVED_PENDING_REDEMPTION",
  /** AWAITING VERIFICATION */
  AwaitingVerification = "AWAITING_VERIFICATION",
  /** CANCELED */
  Canceled = "CANCELED",
  /** CHARGE_EXCEPTION */
  ChargeException = "CHARGE_EXCEPTION",
  /** CLEARED */
  Cleared = "CLEARED",
  /** FUNDING COMPLETE */
  FundingComplete = "FUNDING_COMPLETE",
  /** FUNDING IN PROCESS */
  FundingInProcess = "FUNDING_IN_PROCESS",
  /** FUNDING RESERVED */
  FundingReserved = "FUNDING_RESERVED",
  /** IN PROGRESS */
  InProgress = "IN_PROGRESS",
  /** NEW_REQUEST */
  NewRequest = "NEW_REQUEST",
  /** NOT_CHARGED */
  NotCharged = "NOT_CHARGED",
  /** PAYMENT PENDING */
  PaymentPending = "PAYMENT_PENDING",
  /** PAYMENT PROCESSING */
  PaymentProcessing = "PAYMENT_PROCESSING",
  /** PAYMENT SENT */
  PaymentSent = "PAYMENT_SENT",
  /** PENDING */
  Pending = "PENDING",
  /** PROCESSING */
  Processing = "PROCESSING",
  /** RECEIVED BY CHARITY */
  ReceivedByCharity = "RECEIVED_BY_CHARITY",
  /** RECONCILED */
  Reconciled = "RECONCILED",
  /** REJECTED */
  Rejected = "REJECTED",
}

export type CampaignDonationType = {
  __typename?: "CampaignDonationType";
  amount: Scalars["Decimal"]["output"];
  brand?: Maybe<Scalars["String"]["output"]>;
  campaign: CampaignPublicType;
  chargeAmount: Scalars["Decimal"]["output"];
  contribution?: Maybe<GiftActivityType>;
  contributor?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  createdBy?: Maybe<UserType>;
  email?: Maybe<Scalars["String"]["output"]>;
  funding?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isAnonymous: Scalars["Boolean"]["output"];
  isExternal: Scalars["Boolean"]["output"];
  /** True for ACH micro-deposit verification, False for instant ACH */
  isMicroDeposit: Scalars["Boolean"]["output"];
  last4?: Maybe<Scalars["String"]["output"]>;
  note?: Maybe<Scalars["String"]["output"]>;
  oneTimeFee: Scalars["Decimal"]["output"];
  processingFee: Scalars["Decimal"]["output"];
  receiptDate?: Maybe<Scalars["DateTime"]["output"]>;
  status?: Maybe<CampaignDonationStatus>;
  transferReference?: Maybe<Scalars["String"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export enum CampaignDraftCampaignType {
  /** MEMORIAL */
  Memorial = "MEMORIAL",
  /** MILESTONE */
  Milestone = "MILESTONE",
  /** STANDARD */
  Standard = "STANDARD",
  /** TRIBUTE */
  Tribute = "TRIBUTE",
}

/** An unfinished campaign draft. Family-scoped — never public. */
export type CampaignDraftType = {
  __typename?: "CampaignDraftType";
  bannerImage?: Maybe<Scalars["String"]["output"]>;
  campaignImage?: Maybe<Scalars["String"]["output"]>;
  campaignType: CampaignDraftCampaignType;
  createdAt: Scalars["DateTime"]["output"];
  createdBy: UserType;
  family: FamilyType;
  formData?: Maybe<Scalars["GenericScalar"]["output"]>;
  id: Scalars["ID"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

/** Transaction filter input type */
export type CampaignFilterInputType = {
  /** Filter by campaign states */
  states?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** Campaign filters type */
export type CampaignFiltersType = {
  __typename?: "CampaignFiltersType";
  charities?: Maybe<Array<Maybe<CharityFilterType>>>;
  statuses?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type CampaignPaginatedType = {
  __typename?: "CampaignPaginatedType";
  count?: Maybe<Scalars["Int"]["output"]>;
  objects?: Maybe<Array<Maybe<CampaignType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export type CampaignPublicType = {
  __typename?: "CampaignPublicType";
  achieved?: Maybe<Scalars["Decimal"]["output"]>;
  bannerImage?: Maybe<Scalars["String"]["output"]>;
  campaignImage?: Maybe<Scalars["String"]["output"]>;
  /** Template this campaign was created from. */
  campaignType: CampaignCampaignType;
  charity?: Maybe<CharityType>;
  charityId?: Maybe<Scalars["String"]["output"]>;
  charityMetadata?: Maybe<Scalars["JSONString"]["output"]>;
  donation: Array<CampaignDonationType>;
  elevateCampaignRef?: Maybe<Scalars["String"]["output"]>;
  endDate?: Maybe<Scalars["DateTime"]["output"]>;
  endIfGoalCompleted?: Maybe<Scalars["Boolean"]["output"]>;
  endOnFinalDay?: Maybe<Scalars["Boolean"]["output"]>;
  /** Timestamp when campaign was ended due to 90-day inactivity */
  endedDueToInactivityAt?: Maybe<Scalars["DateTime"]["output"]>;
  goal?: Maybe<Scalars["Decimal"]["output"]>;
  id: Scalars["ID"]["output"];
  /** Timestamp when 60-day inactivity alert was sent */
  inactivityAlertSentAt?: Maybe<Scalars["DateTime"]["output"]>;
  isActive: Scalars["Boolean"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  publicId: Scalars["UUID"]["output"];
  startDate?: Maybe<Scalars["DateTime"]["output"]>;
  startedBy?: Maybe<UserType>;
  startedByFirstName?: Maybe<Scalars["String"]["output"]>;
  state?: Maybe<CampaignState>;
  templateData?: Maybe<Scalars["GenericScalar"]["output"]>;
  thirdImage?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export enum CampaignState {
  /** ACTIVE */
  Active = "ACTIVE",
  /** ARCHIVED */
  Archived = "ARCHIVED",
  /** CLOSED */
  Closed = "CLOSED",
  /** COMPLETED */
  Completed = "COMPLETED",
  /** CREATED */
  Created = "CREATED",
  /** FUNDING_COMPLETE */
  FundingComplete = "FUNDING_COMPLETE",
  /** FUNDING_IN_PROCESS */
  FundingInProcess = "FUNDING_IN_PROCESS",
  /** FUNDING_RESERVED */
  FundingReserved = "FUNDING_RESERVED",
  /** PAYMENT SENT */
  PaymentSent = "PAYMENT_SENT",
  /** PENDING */
  Pending = "PENDING",
  /** PENDING_CONSENT */
  PendingConsent = "PENDING_CONSENT",
  /** PROCESSING */
  Processing = "PROCESSING",
  /** RETIRED */
  Retired = "RETIRED",
  /** SUSPENDED */
  Suspended = "SUSPENDED",
}

/** The campaign details page's three stat cards. */
export type CampaignStatsType = {
  __typename?: "CampaignStatsType";
  /** Null when there is no goal. Never negative. */
  amountRemaining?: Maybe<Scalars["Decimal"]["output"]>;
  /** Distinct people who have given, not number of donations. */
  contributors: Scalars["Int"]["output"];
  /** Null for open-ended campaigns (memorial, tribute). */
  goal?: Maybe<Scalars["Decimal"]["output"]>;
  /** Null when there is no goal. Not capped at 100. */
  goalProgressPercent?: Maybe<Scalars["Int"]["output"]>;
  /** People whose first gift to this campaign was in the last 7 days. */
  newContributorsThisWeek: Scalars["Int"]["output"];
  /** Of that, what arrived in the last 7 days. */
  raisedThisWeek: Scalars["Decimal"]["output"];
  /** All donations that have not failed. */
  totalRaised: Scalars["Decimal"]["output"];
};

/**
 * The template rules the campaign form offers as choices. One source for
 * both sides: the frontend renders these, the validators enforce them.
 */
export type CampaignTemplateSettingsType = {
  __typename?: "CampaignTemplateSettingsType";
  /** Days a tribute honoree has to answer a review request. */
  consentWindowDays: Scalars["Int"]["output"];
  /** Days after the event a milestone campaign may stay open. */
  milestoneAutoCloseDays: Array<Scalars["Int"]["output"]>;
  /** Accepted milestone event_type values. */
  milestoneEventTypes: Array<Scalars["String"]["output"]>;
};

export type CampaignType = {
  __typename?: "CampaignType";
  achieved?: Maybe<Scalars["Decimal"]["output"]>;
  bannerImage?: Maybe<Scalars["String"]["output"]>;
  campaignImage?: Maybe<Scalars["String"]["output"]>;
  /** Template this campaign was created from. */
  campaignType: CampaignCampaignType;
  charity?: Maybe<CharityType>;
  charityId?: Maybe<Scalars["String"]["output"]>;
  charityMetadata?: Maybe<Scalars["JSONString"]["output"]>;
  donation?: Maybe<Array<Maybe<CampaignDonationType>>>;
  elevateCampaignRef?: Maybe<Scalars["String"]["output"]>;
  endDate?: Maybe<Scalars["DateTime"]["output"]>;
  endIfGoalCompleted: Scalars["Boolean"]["output"];
  endOnFinalDay: Scalars["Boolean"]["output"];
  /** Timestamp when campaign was ended due to 90-day inactivity */
  endedDueToInactivityAt?: Maybe<Scalars["DateTime"]["output"]>;
  family: FamilyType;
  goal?: Maybe<Scalars["Decimal"]["output"]>;
  grantReference: Scalars["UUID"]["output"];
  id: Scalars["ID"]["output"];
  /** Timestamp when 60-day inactivity alert was sent */
  inactivityAlertSentAt?: Maybe<Scalars["DateTime"]["output"]>;
  isActive: Scalars["Boolean"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  numberOfDonations?: Maybe<Scalars["Int"]["output"]>;
  publicId: Scalars["UUID"]["output"];
  startDate?: Maybe<Scalars["DateTime"]["output"]>;
  startedBy: UserType;
  state?: Maybe<CampaignState>;
  templateData?: Maybe<Scalars["GenericScalar"]["output"]>;
  thirdImage?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  unreconciledExternalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type CampaignTypeDonationArgs = {
  isExternal?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CampaignTypeNumberOfDonationsArgs = {
  isExternal?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CancelCashMovement = {
  __typename?: "CancelCashMovement";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Cancel a Grant request if it is still in pending status. */
export type CancelGifts = {
  __typename?: "CancelGifts";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type CancelReallocationRebalance = {
  __typename?: "CancelReallocationRebalance";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Cancel a scheduled contribution  */
export type CancelScheduledContribution = {
  __typename?: "CancelScheduledContribution";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** cancel the transactions  */
export type CancelTransactions = {
  __typename?: "CancelTransactions";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * Cancel a single active grant or contribution during the Step 1 transition checklist.
 * Routes to the correct action based on item_type:
 *   - recurring_gift: deactivates the recurring gift
 *   - company_grant: rejects the pending advisor-created grant
 *   - contribution: cancels the pending one-time contribution
 */
export type CancelTransitionItem = {
  __typename?: "CancelTransitionItem";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type CardType = {
  __typename?: "CardType";
  brand?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  expMonth?: Maybe<Scalars["Int"]["output"]>;
  expYear?: Maybe<Scalars["Int"]["output"]>;
  funding?: Maybe<Scalars["String"]["output"]>;
  last4?: Maybe<Scalars["String"]["output"]>;
};

export type CartInputType = {
  /** Amount to be donated to mentioned charity. */
  amount: Scalars["Decimal"]["input"];
  /** Flag to check if user wants to disclose their identity to the charity. */
  anonymous: Scalars["Boolean"]["input"];
  /** Unique Identifier of the charity in CharityId database. */
  charityId: Scalars["String"]["input"];
  /** Company Grant ID if it's a company grant */
  companyGrant?: InputMaybe<Scalars["Int"]["input"]>;
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Enum options for frequency types. */
  frequency: FrequencyChoices;
  /** Flag to indicate if this contribution uses the full balance */
  isFullBalance?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Purpose of Giving Grant. */
  note?: InputMaybe<Scalars["String"]["input"]>;
  /** Granular donor field sharing flags: share_name, share_email, share_address, share_phone, share_employer. */
  privacyFields?: InputMaybe<Scalars["JSONString"]["input"]>;
  /** Donor privacy preset: anonymous, name_only, full, or custom. */
  privacyPreset?: InputMaybe<Scalars["String"]["input"]>;
  startDate: Scalars["DateTime"]["input"];
};

export type CashContributionDetailType = {
  __typename?: "CashContributionDetailType";
  cashContributionDetails?: Maybe<CashTransactionIntegeratedType>;
  statusTimeline?: Maybe<Array<Maybe<ContributionStatusTimelineType>>>;
};

export enum CashTransactionAccountEnumType {
  BankAccount = "bank_account",
  CreditCard = "credit_card",
  ThirdParty = "third_party",
  ThirdPartyIra = "third_party_ira",
  WireTransfer = "wire_transfer",
}

/** Cash Transaction Details with Contributor, Source, Amount etc. */
export type CashTransactionIntegeratedType = {
  __typename?: "CashTransactionIntegeratedType";
  amount?: Maybe<Scalars["Float"]["output"]>;
  contributor?: Maybe<Scalars["String"]["output"]>;
  contributorMetadata?: Maybe<Scalars["JSONString"]["output"]>;
  impersonatedBy?: Maybe<Scalars["String"]["output"]>;
  impersonatedById?: Maybe<Scalars["Int"]["output"]>;
  initiatedOn?: Maybe<Scalars["DateTime"]["output"]>;
  quantity?: Maybe<Scalars["String"]["output"]>;
  receiptDate?: Maybe<Scalars["DateTime"]["output"]>;
  security?: Maybe<Scalars["String"]["output"]>;
  securityName?: Maybe<Scalars["String"]["output"]>;
  source?: Maybe<Scalars["String"]["output"]>;
  transactionId?: Maybe<Scalars["Int"]["output"]>;
  transactionReference?: Maybe<Scalars["String"]["output"]>;
  transactionStatus?: Maybe<Scalars["String"]["output"]>;
  transactionType?: Maybe<Scalars["String"]["output"]>;
  updatedOn?: Maybe<Scalars["DateTime"]["output"]>;
};

export type CauseType = {
  __typename?: "CauseType";
  id?: Maybe<Scalars["String"]["output"]>;
  images?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  key?: Maybe<Scalars["String"]["output"]>;
  value?: Maybe<Scalars["String"]["output"]>;
};

/** Internal API used to set routine for nudge emails */
export type ChangeNudgeRoutine = {
  __typename?: "ChangeNudgeRoutine";
  status?: Maybe<Scalars["String"]["output"]>;
};

/** Change password for Profile information of User  */
export type ChangePassword = {
  __typename?: "ChangePassword";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ChannelPerformanceMetricsType = {
  __typename?: "ChannelPerformanceMetricsType";
  chat?: Maybe<GeneralPerformanceMetricsType>;
  email?: Maybe<GeneralPerformanceMetricsType>;
};

export type CharityAddressType = {
  __typename?: "CharityAddressType";
  /** City, state, zip */
  cityStateZip?: Maybe<Scalars["String"]["output"]>;
  /** Country */
  country?: Maybe<Scalars["String"]["output"]>;
  /** Street address */
  streetAddress?: Maybe<Scalars["String"]["output"]>;
};

export type CharityEligibilityType = {
  __typename?: "CharityEligibilityType";
  validEin?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Charity filter type for grants and campaigns */
export type CharityFilterType = {
  __typename?: "CharityFilterType";
  id?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

/** Response fields to have pagination for charities list  */
export type CharityPaginatedType = {
  __typename?: "CharityPaginatedType";
  objects?: Maybe<Array<Maybe<CharityType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export type CharityPaymentType = {
  __typename?: "CharityPaymentType";
  billCustomerId?: Maybe<Scalars["String"]["output"]>;
  charity?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["String"]["output"]>;
  grantLetterEmail?: Maybe<Scalars["String"]["output"]>;
  grantLetterMethod?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  isAch?: Maybe<Scalars["Boolean"]["output"]>;
  msBillCustomerId?: Maybe<Scalars["String"]["output"]>;
  notes?: Maybe<Scalars["String"]["output"]>;
  paymentMethod?: Maybe<Scalars["String"]["output"]>;
  paypalId?: Maybe<Scalars["String"]["output"]>;
};

export type CharityTotalContributionType = {
  __typename?: "CharityTotalContributionType";
  charityName?: Maybe<Scalars["String"]["output"]>;
  numOfGrants?: Maybe<Scalars["Int"]["output"]>;
  totalContribution?: Maybe<Scalars["Float"]["output"]>;
};

export type CharityType = {
  __typename?: "CharityType";
  address?: Maybe<Scalars["String"]["output"]>;
  campaignedBy?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  categories?: Maybe<Array<Maybe<CauseType>>>;
  causes?: Maybe<Array<Maybe<CauseType>>>;
  charityNavRatings?: Maybe<Scalars["GenericScalar"]["output"]>;
  contributors?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  ein?: Maybe<Scalars["String"]["output"]>;
  fundUrl?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  international?: Maybe<Scalars["Boolean"]["output"]>;
  isAch?: Maybe<Scalars["Boolean"]["output"]>;
  isBlacklisted?: Maybe<Scalars["Boolean"]["output"]>;
  isUserFavourite?: Maybe<Scalars["Boolean"]["output"]>;
  mediumImg?: Maybe<Scalars["String"]["output"]>;
  membersLiked?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  mission?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  nteeCode?: Maybe<Scalars["String"]["output"]>;
  nteeDesc?: Maybe<Scalars["String"]["output"]>;
  orgSecondName?: Maybe<Scalars["String"]["output"]>;
  parentCategories?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  parentCauses?: Maybe<Array<Maybe<CauseType>>>;
  payment?: Maybe<CharityPaymentType>;
  pcsSubject?: Maybe<Scalars["String"]["output"]>;
  restricted?: Maybe<Scalars["Boolean"]["output"]>;
  rotate?: Maybe<Scalars["Boolean"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  totalGrantsAmount?: Maybe<Scalars["Float"]["output"]>;
  totalGrantsCount?: Maybe<Scalars["Int"]["output"]>;
  value?: Maybe<Scalars["String"]["output"]>;
  ytdGrantsAmount?: Maybe<Scalars["Float"]["output"]>;
  ytdGrantsCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Response field to display active and pending DAFs of clients of an advisor */
export type ClientDafDetailsType = {
  __typename?: "ClientDAFDetailsType";
  activeDafCount?: Maybe<Scalars["Int"]["output"]>;
  pendingDafCount?: Maybe<Scalars["Int"]["output"]>;
};

export type ClientDetailsType = {
  __typename?: "ClientDetailsType";
  aum?: Maybe<Scalars["Float"]["output"]>;
  fundName?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  role?: Maybe<Scalars["String"]["output"]>;
  subAdvisorFee?: Maybe<Scalars["Float"]["output"]>;
  ytd?: Maybe<Scalars["Float"]["output"]>;
};

export type ClientInputType = {
  clientRole?: InputMaybe<InviteRoleTypeEnum>;
  clientType?: InputMaybe<ClientTypesChoices>;
  dob?: InputMaybe<Scalars["Date"]["input"]>;
  email: Scalars["String"]["input"];
  /** Differentiates Individual vs Family Subscription. */
  engageFamily?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Optional GS loginId (or other external identity) to persist on the HoF User. */
  externalId?: InputMaybe<Scalars["String"]["input"]>;
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  /** Optional middle name */
  middleName?: InputMaybe<Scalars["String"]["input"]>;
  participantId?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** Title/prefix: MR, MRS, MS, MISS, DR, PROF */
  prefix?: InputMaybe<Scalars["String"]["input"]>;
  /** ID of the primary advisor for this client. Defaults to logged-in user if not provided. */
  primaryAdvisor?: InputMaybe<Scalars["Int"]["input"]>;
  /** Optional suffix: II, III, IV, JR, SR */
  suffix?: InputMaybe<Scalars["String"]["input"]>;
};

export enum ClientLevelSettingsFilingStatus {
  /** head_of_household */
  HeadOfHousehold = "HEAD_OF_HOUSEHOLD",
  /** married_filing_jointly */
  MarriedFilingJointly = "MARRIED_FILING_JOINTLY",
  /** married_filing_separately */
  MarriedFilingSeparately = "MARRIED_FILING_SEPARATELY",
  /** single */
  Single = "SINGLE",
}

export enum ClientLevelSettingsTaxProposalScenario {
  /** donate_charity */
  DonateCharity = "DONATE_CHARITY",
  /** save_taxes */
  SaveTaxes = "SAVE_TAXES",
}

export type ClientLevelSettingsType = {
  __typename?: "ClientLevelSettingsType";
  adventIntegratedPortfolio: AdventIntegratedPortfolioType;
  agi?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  donationLimit?: Maybe<Scalars["Float"]["output"]>;
  filingStatus?: Maybe<ClientLevelSettingsFilingStatus>;
  id: Scalars["ID"]["output"];
  restrictedSecurities: Array<Scalars["String"]["output"]>;
  targetTaxSavings?: Maybe<Scalars["Float"]["output"]>;
  taxProposalScenario?: Maybe<ClientLevelSettingsTaxProposalScenario>;
  teError?: Maybe<Scalars["Float"]["output"]>;
  tickerLimit?: Maybe<Scalars["Int"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export enum ClientTypesChoices {
  BlueGiveOnly = "BlueGive_Only",
  RonaldBlueTrust = "Ronald_Blue_Trust",
}

export type ClientsEligibleForDafType = {
  __typename?: "ClientsEligibleForDAFType";
  accountNumber?: Maybe<Scalars["String"]["output"]>;
  appreciatedSecuritiesCount?: Maybe<Scalars["Int"]["output"]>;
  assets?: Maybe<Scalars["Float"]["output"]>;
  clientName?: Maybe<Scalars["String"]["output"]>;
  costBasis?: Maybe<Scalars["Float"]["output"]>;
  familyId?: Maybe<Scalars["String"]["output"]>;
  hofUserId?: Maybe<Scalars["String"]["output"]>;
  portfolioCode?: Maybe<Scalars["String"]["output"]>;
  portfolioValue?: Maybe<Scalars["Float"]["output"]>;
  unrealizedGain?: Maybe<Scalars["Float"]["output"]>;
};

export type ClientsWithThirdPartyDafPaginatedType = {
  __typename?: "ClientsWithThirdPartyDAFPaginatedType";
  objects?: Maybe<Array<Maybe<ClientsWithThirdPartyDafType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type ClientsWithThirdPartyDafType = {
  __typename?: "ClientsWithThirdPartyDAFType";
  accountId?: Maybe<Scalars["String"]["output"]>;
  assets?: Maybe<Scalars["Float"]["output"]>;
  clientName?: Maybe<Scalars["String"]["output"]>;
  custodianName?: Maybe<Scalars["String"]["output"]>;
};

export type CloseCampaign = {
  __typename?: "CloseCampaign";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * User: Advisor
 * Close a succession transition whose DAF has no balance to distribute.
 *
 * A succession moves the fund's balance to the named successors. With nothing
 * in the fund there is nothing to transfer, so the transition would run to
 * step 4 and wait there indefinitely for transfers that cannot arrive. Step 1
 * emails the advisor when it finds this; this is the way out.
 *
 * Marked COMPLETED rather than aborted. The transition ran its course -- there
 * simply was nothing to distribute -- and aborting would unfreeze the fund and
 * reverse the invites, implying it never happened. The account stays archived,
 * which is the correct end state for a fund that has been succeeded.
 *
 * Refuses while there is any balance. That is the whole premise, and closing a
 * funded transition here would strand the money with the account archived.
 */
export type CloseEmptyTransition = {
  __typename?: "CloseEmptyTransition";
  message?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export enum CompanyGrantFrequency {
  /** Annually */
  Annually = "ANNUALLY",
  /** Monthly */
  Monthly = "MONTHLY",
  /** One Time */
  OneTime = "ONE_TIME",
  /** Quarterly */
  Quarterly = "QUARTERLY",
}

export type CompanyGrantInputType = {
  /** Amount to be donated to mentioned charity. */
  amount: Scalars["Decimal"]["input"];
  /** Flag to check if user wants to disclose their identity to the charity. */
  anonymous: Scalars["Boolean"]["input"];
  /** Unique Identifier of the charity in CharityId database. */
  charityId: Scalars["String"]["input"];
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Enum options for frequency types. */
  frequency: FrequencyChoices;
  /** Purpose of Giving Grant. */
  note?: InputMaybe<Scalars["String"]["input"]>;
  /** Granular donor field sharing flags: share_name, share_email, share_address, share_phone, share_employer. */
  privacyFields?: InputMaybe<Scalars["JSONString"]["input"]>;
  /** Donor privacy preset: anonymous, name_only, full, or custom. */
  privacyPreset?: InputMaybe<Scalars["String"]["input"]>;
  startDate: Scalars["DateTime"]["input"];
};

/** Response fields to have pagination for advisory op's  detail list  */
export type CompanyGrantPaginatedType = {
  __typename?: "CompanyGrantPaginatedType";
  count?: Maybe<Scalars["Int"]["output"]>;
  objects?: Maybe<Array<Maybe<CompanyGrantType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export enum CompanyGrantStatus {
  /** Accepted */
  Accepted = "ACCEPTED",
  /** Pending */
  Pending = "PENDING",
  /** Rejected */
  Rejected = "REJECTED",
}

export enum CompanyGrantStatusChoices {
  Accepted = "ACCEPTED",
  Pending = "PENDING",
  Rejected = "REJECTED",
}

export type CompanyGrantType = {
  __typename?: "CompanyGrantType";
  amount: Scalars["Float"]["output"];
  anonymous: Scalars["Boolean"]["output"];
  charity?: Maybe<CharityType>;
  charityId?: Maybe<Scalars["String"]["output"]>;
  contributions: Array<GiftActivityType>;
  createdAt: Scalars["DateTime"]["output"];
  createdBy: UserType;
  endDate?: Maybe<Scalars["DateTime"]["output"]>;
  endorsedAt?: Maybe<Scalars["DateTime"]["output"]>;
  endorsedBy?: Maybe<UserType>;
  family: FamilyType;
  frequency: CompanyGrantFrequency;
  grantor?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  newStartDate?: Maybe<Scalars["DateTime"]["output"]>;
  note?: Maybe<Scalars["String"]["output"]>;
  privacyFields?: Maybe<Scalars["JSONString"]["output"]>;
  privacyPreset?: Maybe<Scalars["String"]["output"]>;
  recurringGifts: Array<RecurringGiftType>;
  startDate?: Maybe<Scalars["DateTime"]["output"]>;
  status?: Maybe<CompanyGrantStatus>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type CompanyMemberType = {
  __typename?: "CompanyMemberType";
  email?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  inviteStatus?: Maybe<Scalars["String"]["output"]>;
  lastLogin?: Maybe<Scalars["DateTime"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  phoneNumber?: Maybe<Scalars["GenericScalar"]["output"]>;
};

/**
 * Mutation to confirm AMA account opening by advisor.
 * Sets confirm_ama_account = True and optionally updates account_number.
 */
export type ConfirmAmaAccount = {
  __typename?: "ConfirmAmaAccount";
  message?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * User: Advisor
 * Confirm the freeze after the advisor has reviewed and actioned all active items
 * (grants, contributions, invites). Sets freeze_confirmed_at timestamp.
 */
export type ConfirmDafFreeze = {
  __typename?: "ConfirmDAFFreeze";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * User: ops_admin
 * Accept that a succession transfer moved a different amount than expected.
 *
 * Step 4 requires the contributions landing in a successor's fund to total
 * exactly their share of the frozen balance. The custodian legitimately moves a
 * different figure -- fees, timing, a rounded wire -- so rather than absorbing
 * the difference with a tolerance nobody chose, the transfer waits here for an
 * admin to accept it explicitly.
 *
 * Deliberately narrow. It only unblocks an AMOUNT mismatch: a transfer that has
 * not arrived, or has not been received, is not something ops can confirm away
 * -- that money genuinely has not moved yet, and offering a button would invite
 * approving a payout that never happened.
 *
 * The confirmation is pinned to the amount accepted. If more money lands
 * afterwards the total changes and the transfer returns to this queue, rather
 * than passing on a stale approval.
 */
export type ConfirmTransferVariance = {
  __typename?: "ConfirmTransferVariance";
  message?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ConnectAchAccounts = {
  __typename?: "ConnectAchAccounts";
  itemAccounts?: Maybe<Array<Maybe<ItemAccountType>>>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  plaidItem?: Maybe<PlaidItemType>;
};

export type ConnectCustodian = {
  __typename?: "ConnectCustodian";
  status?: Maybe<StatusSummaryType>;
};

/** Connect Manual ACH Account  */
export type ConnectManualAch = {
  __typename?: "ConnectManualAch";
  accountId?: Maybe<Scalars["Int"]["output"]>;
};

/** Account Details with Institution, Account Name, Account Number, Balance etc. */
export type ConnectedAccountType = {
  __typename?: "ConnectedAccountType";
  accessibility?: Maybe<Scalars["Boolean"]["output"]>;
  accountName?: Maybe<Scalars["String"]["output"]>;
  connected?: Maybe<Scalars["Boolean"]["output"]>;
  default?: Maybe<Scalars["Boolean"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  institutionName?: Maybe<Scalars["String"]["output"]>;
  locked?: Maybe<Scalars["Boolean"]["output"]>;
  mask?: Maybe<Scalars["String"]["output"]>;
  recentTransaction?: Maybe<Scalars["GenericScalar"]["output"]>;
  /** Specifies if the account linking is complete or pending approval from the Institution(Custodian). */
  status?: Maybe<Scalars["String"]["output"]>;
  /** Specifies if the account is Savings or Securities. */
  type?: Maybe<Scalars["String"]["output"]>;
};

export enum ContributionAccountType {
  /** DAF */
  A_1 = "A_1",
  /** TAXABLE */
  A_2 = "A_2",
  /** SAVING */
  A_3 = "A_3",
}

export type ContributionDetailType = {
  __typename?: "ContributionDetailType";
  capitalTaxSaving?: Maybe<Scalars["Float"]["output"]>;
  costBasis?: Maybe<Scalars["Float"]["output"]>;
  currentPrice?: Maybe<Scalars["Float"]["output"]>;
  date?: Maybe<Scalars["String"]["output"]>;
  donationQuantity?: Maybe<Scalars["Float"]["output"]>;
  donationValue?: Maybe<Scalars["Float"]["output"]>;
  incomeTaxSaving?: Maybe<Scalars["Float"]["output"]>;
  lot?: Maybe<Scalars["Int"]["output"]>;
  marketValue?: Maybe<Scalars["Float"]["output"]>;
  periodType?: Maybe<Scalars["String"]["output"]>;
  quantityAfter?: Maybe<Scalars["Float"]["output"]>;
  quantityBefore?: Maybe<Scalars["Float"]["output"]>;
  secType?: Maybe<Scalars["String"]["output"]>;
  securityName?: Maybe<Scalars["String"]["output"]>;
  ticker?: Maybe<Scalars["String"]["output"]>;
  totalTaxSaving?: Maybe<Scalars["Float"]["output"]>;
  unrealizedGainLoss?: Maybe<Scalars["Float"]["output"]>;
};

/** Contribution filters type */
export type ContributionFiltersType = {
  __typename?: "ContributionFiltersType";
  displayStatuses?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  statuses?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  types?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export enum ContributionFrequencyChoices {
  Annually = "ANNUALLY",
  Monthly = "MONTHLY",
  OneTime = "ONE_TIME",
  Quarterly = "QUARTERLY",
}

/** A custom dictionary containing user-friendly statuses for the corresponding elevate statuses.  */
export type ContributionStatusTimelineType = {
  __typename?: "ContributionStatusTimelineType";
  completedOn?: Maybe<Scalars["String"]["output"]>;
  elevateStatus?: Maybe<Scalars["String"]["output"]>;
  orderOfAppearance?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  statusSubtext?: Maybe<Scalars["String"]["output"]>;
};

export type ContributionTimelineStatsType = {
  __typename?: "ContributionTimelineStatsType";
  /** State */
  state?: Maybe<Scalars["String"]["output"]>;
  /** Date */
  value?: Maybe<Scalars["String"]["output"]>;
};

export type ContributionTimelineType = {
  __typename?: "ContributionTimelineType";
  /** State */
  state?: Maybe<Scalars["String"]["output"]>;
  /** Date */
  value?: Maybe<Scalars["String"]["output"]>;
};

/** Contribution Request/Gift record. */
export type ContributionType = {
  __typename?: "ContributionType";
  accountType?: Maybe<ContributionAccountType>;
  activeCampaigns?: Maybe<Array<Maybe<CampaignType>>>;
  anonymous: Scalars["Boolean"]["output"];
  campaignDonation?: Maybe<CampaignDonationType>;
  causes?: Maybe<Array<Scalars["String"]["output"]>>;
  charity?: Maybe<CharityType>;
  charityId?: Maybe<Scalars["String"]["output"]>;
  charityName?: Maybe<Scalars["String"]["output"]>;
  companyGrant?: Maybe<CompanyGrantType>;
  contributedAt?: Maybe<Scalars["DateTime"]["output"]>;
  contribution: Scalars["Float"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  donors?: Maybe<Array<Maybe<UserType>>>;
  ein?: Maybe<Scalars["String"]["output"]>;
  elevateStatus?: Maybe<Scalars["String"]["output"]>;
  elevateStatusDates: Scalars["JSONString"]["output"];
  faConfirm: Scalars["Boolean"]["output"];
  family: FamilyType;
  grantClearedAt?: Maybe<Scalars["DateTime"]["output"]>;
  grantReference?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  impersonatedBy?: Maybe<UserType>;
  isActive: Scalars["Boolean"]["output"];
  isCart: Scalars["Boolean"]["output"];
  /** Flag to indicate if this contribution uses the full balance */
  isFullBalance: Scalars["Boolean"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  privacyFields?: Maybe<Scalars["JSONString"]["output"]>;
  privacyPreset?: Maybe<Scalars["String"]["output"]>;
  /** Advisor-authored rationale for why this grant was made (max 500 chars). */
  rationale?: Maybe<Scalars["String"]["output"]>;
  recurringGift?: Maybe<RecurringGiftType>;
  retryContributionId?: Maybe<Scalars["Int"]["output"]>;
  saveLater: Scalars["Boolean"]["output"];
  status?: Maybe<Scalars["String"]["output"]>;
  /** The real Contribution created for this beneficiary when the family's succession transition entered step 5 and distributed its remaining DAF balance (see give.utils.create_succession_beneficiary_contributions). Null if a distribution was never attempted, or if attempted but skipped -- see distribution_attempted_at to tell those two cases apart. */
  successionBeneficiary: Array<BeneficiaryType>;
  user: UserType;
};

/** Contributions summary  */
export type ContributionsSummaryType = {
  __typename?: "ContributionsSummaryType";
  creditCardTransactionsCount?: Maybe<Scalars["Int"]["output"]>;
  externalDafSecurityTransactionsCount?: Maybe<Scalars["Int"]["output"]>;
  iraTransactionsCount?: Maybe<Scalars["Int"]["output"]>;
  manualSecurityTransactionsCount?: Maybe<Scalars["Int"]["output"]>;
  plaidTransactionsCount?: Maybe<Scalars["Int"]["output"]>;
  thirdpartyTransactionsCount?: Maybe<Scalars["Int"]["output"]>;
  wireTransactionsCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Contributor metadata input field type for OTHERS detail capture  */
export type ContributorMetadataInputType = {
  /** City */
  city: Scalars["String"]["input"];
  /** Name of the designated contributor */
  designateName: Scalars["String"]["input"];
  /** State */
  state: Scalars["String"]["input"];
  /** Physical street address */
  streetAddress: Scalars["String"]["input"];
  /** Zip code */
  zipCode: Scalars["String"]["input"];
};

/** Type for DAF contributor information */
export type ContributorType = {
  __typename?: "ContributorType";
  /** Whether the contributor is Corporate Admin for this company */
  isCorporateAdmin?: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether the contributor is Head of Household for this family */
  isHoh?: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether the contributor is Self Directed user */
  isSelfDirected?: Maybe<Scalars["Boolean"]["output"]>;
  /** Name of the contributor */
  name?: Maybe<Scalars["String"]["output"]>;
};

export type ContributorsType = {
  __typename?: "ContributorsType";
  contributions?: Maybe<Array<Maybe<UserContributionType>>>;
  userId?: Maybe<Scalars["Int"]["output"]>;
  userName?: Maybe<Scalars["String"]["output"]>;
};

export type ConversationTopIssueThemeType = {
  __typename?: "ConversationTopIssueThemeType";
  topIssues?: Maybe<Array<Maybe<ConversationTopIssueTypeObject>>>;
};

export type ConversationTopIssueTypeObject = {
  __typename?: "ConversationTopIssueTypeObject";
  /** Number of conversations */
  count?: Maybe<Scalars["Int"]["output"]>;
  /** Issue type */
  issueType?: Maybe<Scalars["String"]["output"]>;
};

export type CopySettingsType = {
  __typename?: "CopySettingsType";
  agi?: Maybe<Scalars["Float"]["output"]>;
  donationLimit?: Maybe<Scalars["Float"]["output"]>;
  excludedTickers?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  filingStatus?: Maybe<Scalars["String"]["output"]>;
  maxContributionTrackingError?: Maybe<Scalars["Float"]["output"]>;
  numTickerAllowed?: Maybe<Scalars["Int"]["output"]>;
  shareLimit?: Maybe<Scalars["Float"]["output"]>;
  targetTaxSavings?: Maybe<Scalars["Float"]["output"]>;
  totalCostBasis?: Maybe<Scalars["Float"]["output"]>;
  totalUnrealizedGain?: Maybe<Scalars["Float"]["output"]>;
};

/** Paginated corporate admins results using UserType with FirmType support */
export type CorporateAdminsPaginatedType = {
  __typename?: "CorporateAdminsPaginatedType";
  count?: Maybe<Scalars["Int"]["output"]>;
  objects?: Maybe<Array<Maybe<UserType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export type CorporateDafFilterOptionType = {
  __typename?: "CorporateDafFilterOptionType";
  count?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  isSubType?: Maybe<Scalars["Boolean"]["output"]>;
  subTypeOptions?: Maybe<Array<Maybe<CorporateDafFilterSubOptionType>>>;
  subTypeTitle?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type CorporateDafFilterSubOptionType = {
  __typename?: "CorporateDafFilterSubOptionType";
  count?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type CorporateDafFilterType = {
  __typename?: "CorporateDafFilterType";
  options?: Maybe<Array<Maybe<CorporateDafFilterOptionType>>>;
  type?: Maybe<Scalars["String"]["output"]>;
};

export type CorporateDafFiltersType = {
  __typename?: "CorporateDafFiltersType";
  companyDafFilters?: Maybe<Array<Maybe<CorporateDafFilterType>>>;
  individualDafFilters?: Maybe<Array<Maybe<CorporateDafFilterType>>>;
};

export enum CorporateDafUserTypeFilterType {
  Admins = "ADMINS",
  Employees = "EMPLOYEES",
}

export type CorporateUserSummaryType = {
  __typename?: "CorporateUserSummaryType";
  companySummary?: Maybe<EmployeeSummaryType>;
  participantSummary?: Maybe<ParticipantSummaryType>;
};

export type CorrespondenceItemType = {
  __typename?: "CorrespondenceItemType";
  /** Date */
  date?: Maybe<Scalars["DateTime"]["output"]>;
  /** Message */
  message?: Maybe<Scalars["String"]["output"]>;
  /** Name */
  name?: Maybe<Scalars["String"]["output"]>;
};

export type CreateAchPaymentIntent = {
  __typename?: "CreateACHPaymentIntent";
  intentId?: Maybe<Scalars["String"]["output"]>;
  intentSecret?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type CreateAdvisorInputType = {
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  phone?: InputMaybe<Scalars["String"]["input"]>;
};

/** Create new advisor user group  */
export type CreateAdvisorUserGroup = {
  __typename?: "CreateAdvisorUserGroup";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  status?: Maybe<StatusSummaryType>;
};

/** Create advisors from .csv or .xlsx file  */
export type CreateAdvisors = {
  __typename?: "CreateAdvisors";
  status?: Maybe<StatusSummaryType>;
};

/** Initiate a Cash transfer request from Savings account to DAF.  */
export type CreateAmicusContribution = {
  __typename?: "CreateAmicusContribution";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type CreateCashMovement = {
  __typename?: "CreateCashMovement";
  advisorId?: Maybe<Scalars["ID"]["output"]>;
  dateRequested?: Maybe<Scalars["String"]["output"]>;
  fromPool?: Maybe<Scalars["JSONString"]["output"]>;
  fundId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  requestValue?: Maybe<Scalars["Float"]["output"]>;
  toPool?: Maybe<Scalars["JSONString"]["output"]>;
};

/** Add gifts by Reviewer or RIA */
export type CreateClientGrant = {
  __typename?: "CreateClientGrant";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Add grant on behalf of Company */
export type CreateCompanyGrant = {
  __typename?: "CreateCompanyGrant";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Initiate a Credit Card contribution.  */
export type CreateCreditCardContribution = {
  __typename?: "CreateCreditCardContribution";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Onboard a client, and their family.  */
export type CreateFamily = {
  __typename?: "CreateFamily";
  status?: Maybe<StatusSummaryType>;
};

/** Onboard a client, their family and family members  */
export type CreateFamilyAndMembers = {
  __typename?: "CreateFamilyAndMembers";
  status?: Maybe<StatusSummaryType>;
};

/** API to create Firm with or without RIA  */
export type CreateFirm = {
  __typename?: "CreateFirm";
  firmId?: Maybe<Scalars["Int"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** API to create Firm Users  */
export type CreateFirmUsers = {
  __typename?: "CreateFirmUsers";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Create a new inheritance registry entry for a family. */
export type CreateInheritanceRegistry = {
  __typename?: "CreateInheritanceRegistry";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  registry?: Maybe<InheritanceRegistryType>;
};

export type CreatePaymentIntent = {
  __typename?: "CreatePaymentIntent";
  ccType?: Maybe<Scalars["String"]["output"]>;
  intentId?: Maybe<Scalars["String"]["output"]>;
  intentSecret?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * Create or verify a primary advisor exists on Elevate platform and Okta.
 * Takes a family_id, retrieves the associated advisor, and ensures they exist
 * in both Okta and Elevate platforms. Creates them in Okta and/or Elevate if they don't exist.
 */
export type CreatePrimaryAdvisorOnElevate = {
  __typename?: "CreatePrimaryAdvisorOnElevate";
  message?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type CreateSelfDirectedUser = {
  __typename?: "CreateSelfDirectedUser";
  status?: Maybe<StatusType>;
};

export type CreateSetupIntent = {
  __typename?: "CreateSetupIntent";
  intentSecret?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Create tags to each category  */
export type CreateTag = {
  __typename?: "CreateTag";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Create tag categories to enterprise  */
export type CreateTagCategories = {
  __typename?: "CreateTagCategories";
  status?: Maybe<StatusSummaryType>;
};

/** To create ThirdPartyAccountDetail. */
export type CreateThirdPartyAccountDetail = {
  __typename?: "CreateThirdPartyAccountDetail";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type CreateUserPortfolioMapping = {
  __typename?: "CreateUserPortfolioMapping";
  adventPortfolioUserAccounts?: Maybe<
    Array<Maybe<AdventPortfolioUserAccountType>>
  >;
  errorMessages?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  successCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Initiate a wire transfer request to DAF.  */
export type CreateWireContribution = {
  __typename?: "CreateWireContribution";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type CreditCardTransactionAmounts = {
  __typename?: "CreditCardTransactionAmounts";
  contributionAmount?: Maybe<Scalars["Decimal"]["output"]>;
  processingFee?: Maybe<Scalars["Decimal"]["output"]>;
  totalAmount?: Maybe<Scalars["Decimal"]["output"]>;
};

/** Curates category record. */
export type CuratesType = {
  __typename?: "CuratesType";
  /** Defines if the category is enabled for the family. */
  curate?: Maybe<Scalars["Boolean"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  images?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  key?: Maybe<Scalars["String"]["output"]>;
  value?: Maybe<Scalars["String"]["output"]>;
};

export type CurrentPortfolioType = {
  __typename?: "CurrentPortfolioType";
  poolId?: Maybe<Scalars["String"]["output"]>;
  poolName?: Maybe<Scalars["String"]["output"]>;
  poolType?: Maybe<Scalars["String"]["output"]>;
  poolValue?: Maybe<Scalars["Float"]["output"]>;
  poolWeight?: Maybe<Scalars["Float"]["output"]>;
};

export type CustodianType = {
  __typename?: "CustodianType";
  connected: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  shortName: Scalars["String"]["output"];
};

export type CustomFeeType = {
  __typename?: "CustomFeeType";
  enableFee?: Maybe<Scalars["Boolean"]["output"]>;
  enableFeeTier?: Maybe<Scalars["Boolean"]["output"]>;
  feeCoefficient?: Maybe<Scalars["Float"]["output"]>;
  feeTier?: Maybe<Scalars["String"]["output"]>;
};

/** Response type to custom fees  */
export type CustomFees = {
  __typename?: "CustomFees";
  advisorFeeTier?: Maybe<Scalars["GenericScalar"]["output"]>;
  enableAdvisorFeeTier?: Maybe<Scalars["Boolean"]["output"]>;
  enableFee?: Maybe<Scalars["Boolean"]["output"]>;
  enableFeeTier?: Maybe<Scalars["Boolean"]["output"]>;
  feeCoefficient?: Maybe<Scalars["Float"]["output"]>;
  feeTier?: Maybe<Scalars["GenericScalar"]["output"]>;
  lockAdvisorFeeTier?: Maybe<Scalars["Boolean"]["output"]>;
};

export type CustomerSuccessStatsType = {
  __typename?: "CustomerSuccessStatsType";
  /** Average first response time */
  avgFirstResponse?: Maybe<Scalars["Float"]["output"]>;
  /** Average resolution time */
  avgResolutionTime?: Maybe<Scalars["Float"]["output"]>;
  /** Number of outstanding requests */
  outstandingRequests?: Maybe<Scalars["Int"]["output"]>;
  /** Number of service requests */
  totalServiceRequests?: Maybe<Scalars["Int"]["output"]>;
};

/** Daf Account Holder input field type  */
export type DafAccountHolderInputType = {
  address?: InputMaybe<Scalars["String"]["input"]>;
  /** GS branch code selected by the advisor */
  branchCode?: InputMaybe<Scalars["String"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  /** Optional middle name */
  middleName?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** Title/prefix: MR, MRS, MS, MISS, DR, PROF */
  prefix?: InputMaybe<Scalars["String"]["input"]>;
  /** GS rep code selected by the advisor */
  repCode?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<Scalars["String"]["input"]>;
  /** Optional suffix: II, III, IV, JR, SR */
  suffix?: InputMaybe<Scalars["String"]["input"]>;
  /** Donor SSN or Tax ID Number, 9 digits (dashes accepted and stripped). Required to open a NEW Goldman Sachs client; ignored when the donor already exists on GSCS. Passed straight through to the GSCS payload and never persisted. */
  tid?: InputMaybe<Scalars["String"]["input"]>;
  zipCode?: InputMaybe<Scalars["String"]["input"]>;
};

export enum DafCustodianIntegrationEligible {
  /** ELIGIBLE */
  Eligible = "ELIGIBLE",
  /** INELIGIBLE */
  Ineligible = "INELIGIBLE",
  /** PENDING */
  Pending = "PENDING",
}

export type DafCustodianType = {
  __typename?: "DafCustodianType";
  advisordafSet: Array<AdvisorDafType>;
  allowDafs: Scalars["Boolean"]["output"];
  allowedFundTypes?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  amaAccountOpeningFormTemplateId: Scalars["String"]["output"];
  assetpoolSet: Array<AssetPoolType>;
  contributionDetails?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  elevateRef?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  integrationEligible?: Maybe<DafCustodianIntegrationEligible>;
  integrationFormTemplateId: Scalars["String"]["output"];
  linkRequests: Array<AdventIntegrationType>;
  logo?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  /** Up to 3 signers: [{"first_name": "", "last_name": "", "email": ""}] */
  signatureContacts?: Maybe<Scalars["JSONString"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** n8n webhook URL for this custodian */
  webhookUrl?: Maybe<Scalars["String"]["output"]>;
};

export type DafImpactReportType = {
  __typename?: "DafImpactReportType";
  lifetimeContributions?: Maybe<LifetimeContributionType>;
  lifetimeGifting?: Maybe<LifetimeContributionType>;
  topGiftedCharities?: Maybe<Array<Maybe<CharityTotalContributionType>>>;
};

export type DailyEmailStatsType = {
  __typename?: "DailyEmailStatsType";
  /** Click rate percentage */
  clickRate?: Maybe<Scalars["Float"]["output"]>;
  /** Date in ISO format */
  date?: Maybe<Scalars["String"]["output"]>;
  /** Number of emails bounced */
  emailsBounced?: Maybe<Scalars["Int"]["output"]>;
  /** Number of emails clicked */
  emailsClicked?: Maybe<Scalars["Int"]["output"]>;
  /** Number of emails delivered */
  emailsDelivered?: Maybe<Scalars["Int"]["output"]>;
  /** Number of emails opened */
  emailsOpened?: Maybe<Scalars["Int"]["output"]>;
  /** Number of emails sent */
  emailsSent?: Maybe<Scalars["Int"]["output"]>;
  /** Open rate percentage */
  openRate?: Maybe<Scalars["Float"]["output"]>;
};

export type DashboardGraphsDataType = {
  __typename?: "DashboardGraphsDataType";
  topCauses?: Maybe<Array<Maybe<TopCauseType>>>;
  topCharities?: Maybe<Array<Maybe<TopCharityType>>>;
  totalGrantsCount?: Maybe<Scalars["Int"]["output"]>;
};

/**
 * A successor declines being named in a family's succession plan, from the
 * same accept/decline screen as AcceptSuccessorInvite.
 *
 * Post-login: the successor is identified by the Successor row's
 * family_member link, so a caller can only decline an invite that is their
 * own. (This was previously a token-authorized pre-login URL; the flow is
 * now entirely post-login, so the token was dropped.)
 *
 * Marks THIS Successor row as declined and zeroes its percentage --
 * deliberately not the linked User's invite_status, since for an existing
 * user (SendSuccessionInvites cases 1/2) that field also reflects their own
 * unrelated account status elsewhere. The declined percentage is
 * redistributed to the remaining successors in the same tier -- see
 * portfolio.utils.redistribute_declined_successor_percentage. When a whole
 * tier declines, the cascade to the next one (primaries → contingents →
 * beneficiaries) is handled at step 3 of the batch job instead, not here. The
 * originating family's advisor is notified.
 *
 * Step 2 of the succession batch job (core.tasks._advance_one) treats a
 * declined successor as resolved rather than waiting on their acceptance.
 */
export type DeclineSuccessorInvite = {
  __typename?: "DeclineSuccessorInvite";
  message?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DefaultAllocationsType = {
  __typename?: "DefaultAllocationsType";
  defaultAllocations?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
};

/** Delete Beneficiary  Details  */
export type DeleteBeneficiary = {
  __typename?: "DeleteBeneficiary";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DeleteBunchingPlanDraft = {
  __typename?: "DeleteBunchingPlanDraft";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DeleteCampaign = {
  __typename?: "DeleteCampaign";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * Delete an unfinished campaign draft (also called after a
 * successful publish, so the draft doesn't linger next to the real campaign).
 */
export type DeleteCampaignDraft = {
  __typename?: "DeleteCampaignDraft";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Remove Family if don't have daf accout requested from advisor */
export type DeleteFamily = {
  __typename?: "DeleteFamily";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Reset a firm's document override back to its enterprise/platform default. */
export type DeleteFirmDocument = {
  __typename?: "DeleteFirmDocument";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Delete Uploaded firm Logo  */
export type DeleteFirmLogo = {
  __typename?: "DeleteFirmLogo";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Delete a fund from the cart */
export type DeleteFromCart = {
  __typename?: "DeleteFromCart";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Soft-delete a supporting document. */
export type DeleteInheritanceDocument = {
  __typename?: "DeleteInheritanceDocument";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Soft-delete an inheritance registry entry. */
export type DeleteInheritanceRegistry = {
  __typename?: "DeleteInheritanceRegistry";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** API to delete delete a client invitation */
export type DeleteInvite = {
  __typename?: "DeleteInvite";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Soft-delete a legacy document (shared InheritanceDocument model). */
export type DeleteLegacyDocument = {
  __typename?: "DeleteLegacyDocument";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Cancel Recurring Gift */
export type DeleteRecurringGift = {
  __typename?: "DeleteRecurringGift";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DeleteRestrictedCharity = {
  __typename?: "DeleteRestrictedCharity";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Delete Successor  Details  */
export type DeleteSuccessor = {
  __typename?: "DeleteSuccessor";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Delete a tag from tagcategory */
export type DeleteTag = {
  __typename?: "DeleteTag";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** To Delete ThirdPartyAccountDetail. */
export type DeleteThirdPartyAccountDetail = {
  __typename?: "DeleteThirdPartyAccountDetail";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DelinkUserFromPortfolios = {
  __typename?: "DelinkUserFromPortfolios";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DetachPaymentMethod = {
  __typename?: "DetachPaymentMethod";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Disconnect the ClientCustodianPortfolio account  */
export type DisConnectCustodian = {
  __typename?: "DisConnectCustodian";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** API to disable a user */
export type DisableUser = {
  __typename?: "DisableUser";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Unlink the Savings Account from DAF. */
export type DisconnectSavingsAccount = {
  __typename?: "DisconnectSavingsAccount";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DistributionStatsDataType = {
  __typename?: "DistributionStatsDataType";
  /** Count */
  count?: Maybe<Scalars["Int"]["output"]>;
  /** End date */
  endDate?: Maybe<Scalars["String"]["output"]>;
  /** Segment key */
  segmentKey?: Maybe<Scalars["String"]["output"]>;
  /** Segment name */
  segmentName?: Maybe<Scalars["String"]["output"]>;
  /** Start date */
  startDate?: Maybe<Scalars["String"]["output"]>;
  /** Total balance */
  totalBalance?: Maybe<Scalars["Float"]["output"]>;
};

export enum DonorActivityLogsActivity {
  /** ALLOCATION */
  Allocation = "ALLOCATION_",
  /** CAMPAIGN */
  Campaign = "CAMPAIGN",
  /** CONTRIBUTION */
  Contribution = "CONTRIBUTION",
  /** FAVORITE */
  Favorite = "FAVORITE",
  /** GIFT */
  Gift = "GIFT",
  /** ON_BOARD_STATUS */
  OnBoardStatus = "ON_BOARD_STATUS",
  /** SCHEDULED_CONTRIBUTION */
  ScheduledContribution = "SCHEDULED_CONTRIBUTION",
  /** SCHEDULED_GIFT */
  ScheduledGift = "SCHEDULED_GIFT",
}

export type DonorActivityLogsType = {
  __typename?: "DonorActivityLogsType";
  action?: Maybe<Scalars["String"]["output"]>;
  activity?: Maybe<DonorActivityLogsActivity>;
  activityId: Scalars["Int"]["output"];
  advisor?: Maybe<UserType>;
  createdAt: Scalars["DateTime"]["output"];
  family: FamilyType;
  firm: FirmType;
  id: Scalars["ID"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  user: UserType;
};

/** Generate a presigned S3 download URL for a completed N8N envelope doc and mark it as downloaded. */
export type DownloadN8NLogDocument = {
  __typename?: "DownloadN8NLogDocument";
  downloadUrl?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Edit  DAF Details  */
export type EditAdvisorDaf = {
  __typename?: "EditAdvisorDAF";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Edit Beneficiary  Details  */
export type EditBeneficiary = {
  __typename?: "EditBeneficiary";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Edit the campaign with the given input id */
export type EditCampaign = {
  __typename?: "EditCampaign";
  campaign?: Maybe<CampaignType>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Edit Campaign Details */
export type EditCampaignDetails = {
  __typename?: "EditCampaignDetails";
  status?: Maybe<StatusType>;
};

export type EditCampaignInputType = {
  bannerImage?: InputMaybe<Scalars["Upload"]["input"]>;
  campaignImage?: InputMaybe<Scalars["Upload"]["input"]>;
  /** End Date of the Campaign. */
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** True if we should end the campaign if we reach the goal amount */
  endIfGoalCompleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** True if we should be ending the campaign on end date */
  endOnFinalDay?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Desired amount of fund to be raised for the charity. */
  goal?: InputMaybe<Scalars["Decimal"]["input"]>;
  /** message of the Campaign. */
  message?: InputMaybe<Scalars["String"]["input"]>;
  /** Start Date of the Campaign. */
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Template-specific fields. Merged into the existing value, not replaced. */
  templateData?: InputMaybe<Scalars["GenericScalar"]["input"]>;
  thirdImage?: InputMaybe<Scalars["Upload"]["input"]>;
  /** Title of the Campaign. */
  title?: InputMaybe<Scalars["String"]["input"]>;
};

/** Edit client details */
export type EditClientDetails = {
  __typename?: "EditClientDetails";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Aprove company grant  */
export type EditClientGrant = {
  __typename?: "EditClientGrant";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Edit Donor details and client_type */
export type EditDonorDetails = {
  __typename?: "EditDonorDetails";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Edit Family Details */
export type EditFamilyDetails = {
  __typename?: "EditFamilyDetails";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** To update the Grant note */
export type EditGrantNote = {
  __typename?: "EditGrantNote";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Edit Profile information of User  */
export type EditNotificationPreferences = {
  __typename?: "EditNotificationPreferences";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Edit Profile information of User  */
export type EditProfile = {
  __typename?: "EditProfile";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Mutation that updates the email of pending self directed user, and resend an invite for the latest email. */
export type EditSelfDirectedEmail = {
  __typename?: "EditSelfDirectedEmail";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Edit Successor  Details  */
export type EditSuccessor = {
  __typename?: "EditSuccessor";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type EmailPreferencesInputType = {
  emailPreferences: Scalars["GenericScalar"]["input"];
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type EmailRequestType = {
  __typename?: "EmailRequestType";
  newMail?: Maybe<Scalars["String"]["output"]>;
  oldMail?: Maybe<Scalars["String"]["output"]>;
  valid?: Maybe<Scalars["Boolean"]["output"]>;
};

/** GraphQL response for email validation checks when adding family members/HOHs. */
export type EmailValidationType = {
  __typename?: "EmailValidationType";
  isValidEmail: Scalars["Boolean"]["output"];
  /** Reason the email is not valid; null when the email is valid. */
  message?: Maybe<Scalars["String"]["output"]>;
};

/** Update Employee allocation for unattached employee and invite */
export type EmployeeAllocationAndInvite = {
  __typename?: "EmployeeAllocationAndInvite";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type EmployeeDafDetailsType = {
  __typename?: "EmployeeDafDetailsType";
  dafFundedDate?: Maybe<Scalars["Date"]["output"]>;
  dafOpenedDate?: Maybe<Scalars["Date"]["output"]>;
};

/** Response fields to have pagination for advisory op's  detail list  */
export type EmployeePaginatedType = {
  __typename?: "EmployeePaginatedType";
  count?: Maybe<Scalars["Int"]["output"]>;
  objects?: Maybe<Array<Maybe<UserType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export enum EmployeeSortingKeysEnum {
  AddedOnTs = "ADDED_ON_TS",
  AllocatedAmount = "ALLOCATED_AMOUNT",
  ContributionAmount = "CONTRIBUTION_AMOUNT",
  FirstName = "FIRST_NAME",
  LastName = "LAST_NAME",
}

export type EmployeeSummaryType = {
  __typename?: "EmployeeSummaryType";
  acceptedCount?: Maybe<Scalars["Int"]["output"]>;
  companyGiftsUnderApproval?: Maybe<Scalars["Float"]["output"]>;
  inactiveCount?: Maybe<Scalars["Int"]["output"]>;
  ineligibleCount?: Maybe<Scalars["Int"]["output"]>;
  pendingCount?: Maybe<Scalars["Int"]["output"]>;
  reservedCredits?: Maybe<Scalars["Float"]["output"]>;
  unallocatedCount?: Maybe<Scalars["Int"]["output"]>;
};

export enum EmployeeTypeEnum {
  Accepted = "ACCEPTED",
  Active = "ACTIVE",
  Inactive = "INACTIVE",
  Ineligible = "INELIGIBLE",
  Pending = "PENDING",
  Unallocated = "UNALLOCATED",
}

/** Paginated employees results using UserType with FirmType support */
export type EmployeesPaginatedType = {
  __typename?: "EmployeesPaginatedType";
  count?: Maybe<Scalars["Int"]["output"]>;
  objects?: Maybe<Array<Maybe<UserType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export type EngageCategoriesType = {
  __typename?: "EngageCategoriesType";
  categories?: Maybe<Array<Maybe<EngageCategoryType>>>;
};

export type EngageCategoryType = {
  __typename?: "EngageCategoryType";
  funds?: Maybe<Array<Maybe<CharityType>>>;
  id?: Maybe<Scalars["String"]["output"]>;
  images?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  name?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type EngageDistributionType = {
  __typename?: "EngageDistributionType";
  gift?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  images?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  key?: Maybe<Scalars["String"]["output"]>;
  value?: Maybe<Scalars["String"]["output"]>;
  weight?: Maybe<Scalars["Float"]["output"]>;
};

export type EngageType = {
  __typename?: "EngageType";
  distribution?: Maybe<Array<Maybe<EngageDistributionType>>>;
  totalGift?: Maybe<Scalars["Float"]["output"]>;
};

export type EngagementFunnelType = {
  __typename?: "EngagementFunnelType";
  /** Number of DAFs opened */
  dafsOpened?: Maybe<Scalars["Int"]["output"]>;
  /** Total number of emails bounced */
  emailsBounced?: Maybe<Scalars["Int"]["output"]>;
  /** Total number of emails opened */
  emailsOpened?: Maybe<Scalars["Int"]["output"]>;
  /** Total number of emails sent */
  emailsSent?: Maybe<Scalars["Int"]["output"]>;
  /** End date in ISO format */
  endDate?: Maybe<Scalars["String"]["output"]>;
  /** Number of first contributions */
  firstContribution?: Maybe<Scalars["Int"]["output"]>;
  /** Number of first grants */
  firstGrant?: Maybe<Scalars["Int"]["output"]>;
  /** Number of sign ups */
  signUps?: Maybe<Scalars["Int"]["output"]>;
  /** Start date in ISO format */
  startDate?: Maybe<Scalars["String"]["output"]>;
};

export type EngagementOverTimeType = {
  __typename?: "EngagementOverTimeType";
  /** List of weekly engagement data */
  weeks?: Maybe<Array<Maybe<WeekEngagementType>>>;
};

/** Start Okta Verify push factor enrollment. Returns QR code + enrollment ID. */
export type EnrollOktaVerify = {
  __typename?: "EnrollOktaVerify";
  enrollmentId?: Maybe<Scalars["String"]["output"]>;
  error?: Maybe<Scalars["String"]["output"]>;
  qrCodeDataUrl?: Maybe<Scalars["String"]["output"]>;
};

/** Create Okta-hosted TOTP factor. Returns shared secret + QR code data URL. */
export type EnrollTotp = {
  __typename?: "EnrollTotp";
  error?: Maybe<Scalars["String"]["output"]>;
  qrCodeDataUrl?: Maybe<Scalars["String"]["output"]>;
  secret?: Maybe<Scalars["String"]["output"]>;
};

/** Paginated enterprise admins results using UserType with FirmType support */
export type EnterpriseAdminsPaginatedType = {
  __typename?: "EnterpriseAdminsPaginatedType";
  count?: Maybe<Scalars["Int"]["output"]>;
  objects?: Maybe<Array<Maybe<UserType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export type EnterpriseFeeRowType = {
  __typename?: "EnterpriseFeeRowType";
  adminFees?: Maybe<Scalars["Float"]["output"]>;
  aum?: Maybe<Scalars["String"]["output"]>;
  avgBps?: Maybe<Scalars["String"]["output"]>;
  enterpriseFeePct?: Maybe<Scalars["Float"]["output"]>;
  enterpriseShare?: Maybe<Scalars["Float"]["output"]>;
  firmGiveReferenceId?: Maybe<Scalars["String"]["output"]>;
  firmId?: Maybe<Scalars["String"]["output"]>;
  firmName?: Maybe<Scalars["String"]["output"]>;
  platformFeePct?: Maybe<Scalars["Float"]["output"]>;
  platformShare?: Maybe<Scalars["Float"]["output"]>;
  subAdvisorFees?: Maybe<Scalars["Float"]["output"]>;
};

export type ExternalGivingHistoryType = {
  __typename?: "ExternalGivingHistoryType";
  causes?: Maybe<Array<Scalars["Int"]["output"]>>;
  charity?: Maybe<Scalars["String"]["output"]>;
  date?: Maybe<Scalars["Date"]["output"]>;
  ein: Scalars["Int"]["output"];
  family: FamilyType;
  giftAmount: Scalars["Decimal"]["output"];
  id: Scalars["ID"]["output"];
};

export enum FamilyClientType {
  /** Bluegive Only */
  BluegiveOnly = "BLUEGIVE_ONLY",
  /** Ronald Blue Trust */
  RonaldBlueTrust = "RONALD_BLUE_TRUST",
}

export type FamilyInputType = {
  engageFamily?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type FamilyListType = {
  __typename?: "FamilyListType";
  id?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  uploaded?: Maybe<Scalars["Boolean"]["output"]>;
};

export type FamilyMemberBasicType = {
  __typename?: "FamilyMemberBasicType";
  email?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  tncAcceptedTime?: Maybe<Scalars["DateTime"]["output"]>;
  userId?: Maybe<Scalars["Int"]["output"]>;
};

/** Paginated family members (household) results using UserType */
export type FamilyMembersPaginatedType = {
  __typename?: "FamilyMembersPaginatedType";
  count?: Maybe<Scalars["Int"]["output"]>;
  objects?: Maybe<Array<Maybe<UserType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export type FamilyPaginatedType = {
  __typename?: "FamilyPaginatedType";
  count?: Maybe<Scalars["Int"]["output"]>;
  objects?: Maybe<Array<Maybe<FamilyType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export type FamilyReturnJsonType = {
  __typename?: "FamilyReturnJsonType";
  jsonData?: Maybe<Scalars["GenericScalar"]["output"]>;
};

export type FamilyTreeType = {
  __typename?: "FamilyTreeType";
  children?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  level?: Maybe<Scalars["Int"]["output"]>;
  parent: Scalars["Int"]["output"];
  user?: Maybe<UserType>;
};

/** Family details. */
export type FamilyType = {
  __typename?: "FamilyType";
  accounts: Array<AccountType>;
  actionables: Array<ActionableTypeSchema>;
  advisor?: Maybe<UserType>;
  advisorDaf?: Maybe<AdvisorDafType>;
  advisorDafDetails?: Maybe<AdvisorDafType>;
  advisorOps: Array<UserType>;
  advisors: Array<UserType>;
  alignStatus?: Maybe<Scalars["Boolean"]["output"]>;
  allocatedAmount?: Maybe<Scalars["Decimal"]["output"]>;
  annualGivingGoal?: Maybe<Scalars["Decimal"]["output"]>;
  annualGivingGoalAchieved?: Maybe<Scalars["Decimal"]["output"]>;
  beneficiary: Array<BeneficiaryType>;
  campaignDrafts: Array<CampaignDraftType>;
  campaigns: Array<CampaignPublicType>;
  causes?: Maybe<Array<Scalars["String"]["output"]>>;
  charityImages?: Maybe<Array<Maybe<Scalars["JSONString"]["output"]>>>;
  clientType?: Maybe<FamilyClientType>;
  companyGrants: Array<CompanyGrantType>;
  contributions: Array<GiftActivityType>;
  createdAt: Scalars["DateTime"]["output"];
  curateSearch?: Maybe<Scalars["Boolean"]["output"]>;
  customMission?: Maybe<Scalars["Boolean"]["output"]>;
  /** When the fund was locked -- LouiseDafAccount.freeze_initiated_at. The console shows this as 'fund access locked', distinct from the fund-activity-frozen date, which is when the confirmation email went out at the end of step 1. */
  dafFreezeInitiatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  defaultAllocation?: Maybe<Scalars["Int"]["output"]>;
  donorActivityLogs: Array<DonorActivityLogsType>;
  ein?: Maybe<Array<Scalars["String"]["output"]>>;
  engageFamily: Scalars["Boolean"]["output"];
  externalGivingFamily: Array<ExternalGivingHistoryType>;
  externalId?: Maybe<Scalars["String"]["output"]>;
  familyContributions?: Maybe<Scalars["JSONString"]["output"]>;
  familyFavourites?: Maybe<Scalars["JSONString"]["output"]>;
  familyMembers?: Maybe<Array<Maybe<UserType>>>;
  familyTree?: Maybe<Scalars["JSONString"]["output"]>;
  familyUserGroupAllocatedAmount?: Maybe<Scalars["Decimal"]["output"]>;
  familyUserGroupTotalContribution?: Maybe<Scalars["Decimal"]["output"]>;
  familyView?: Maybe<Scalars["Boolean"]["output"]>;
  favourites: Array<FavouritesType>;
  firm?: Maybe<FirmType>;
  foundersMessage?: Maybe<Scalars["String"]["output"]>;
  fundAssetPool: Array<FundAssetPoolType>;
  grantHistoryBatches: Array<GrantHistoryBatchType>;
  grantHistoryRecords: Array<GrantHistoryRecordType>;
  gsDafApplication?: Maybe<GsDafAccountApplicationType>;
  gsImportRecords: Array<BookOfBusinessImportRecordType>;
  hof?: Maybe<UserType>;
  holdingsSummary: Array<HoldingSummaryType>;
  id: Scalars["ID"]["output"];
  includeInternationalCharity: Scalars["Boolean"]["output"];
  /** LouiseDafAccount.is_frozen for this family. Distinct from 'is there an active SuccessionTransition for this family', which is what the frontend's useIsDAFFrozen asks: a successor's destination fund is born frozen while the transition it belongs to is recorded against the ORIGINATING family, so the transition question answers no for a fund that is plainly frozen. Read this to decide whether to tell the user the account is frozen. */
  isDafFrozen?: Maybe<Scalars["Boolean"]["output"]>;
  isFunded?: Maybe<Scalars["Boolean"]["output"]>;
  isIndividualDaf?: Maybe<Scalars["Boolean"]["output"]>;
  isLinkedPortfolio?: Maybe<Scalars["Boolean"]["output"]>;
  /** This fund was created to receive a succession transfer. It can never accept contributions -- see portfolio.utils.check_daf_accepts_contributions -- so Add Funds must stay disabled for it, permanently and independently of any freeze. */
  isSuccessorFund?: Maybe<Scalars["Boolean"]["output"]>;
  itemAccounts: Array<ItemAccountType>;
  legacyDocuments: Array<InheritanceDocumentType>;
  linkedAssets?: Maybe<Scalars["Float"]["output"]>;
  longTermTax: Scalars["Decimal"]["output"];
  louiseDaf?: Maybe<LouiseDafSummary>;
  members?: Maybe<Array<Maybe<UserType>>>;
  mission?: Maybe<Scalars["String"]["output"]>;
  n8nLog?: Maybe<N8NIntegrationLogType>;
  name: Scalars["String"]["output"];
  optimiseConfig: Array<OptimiseConfigType>;
  pendingGifts?: Maybe<Scalars["Int"]["output"]>;
  plaidItems: Array<PlaidItemType>;
  portfolioMappings?: Maybe<Array<Maybe<PortfolioMappingType>>>;
  recurringGifts: Array<RecurringGiftType>;
  scheduledCcContributions: Array<ScheduledCcContributionDto>;
  scheduledContributions: Array<ScheduledContributionType>;
  shortTermTax: Scalars["Decimal"]["output"];
  successionIntegration?: Maybe<SuccessionIntegrationType>;
  /** Name of the donor this fund was inherited from, for a successor fund. Null for every other fund. Used by the frozen banner, which names the original donor. */
  successionSourceDonorName?: Maybe<Scalars["String"]["output"]>;
  successionTransitions: Array<SuccessionTransitionType>;
  successor: Array<SuccessorType>;
  /** The new family/DAF created for this successor when their invite was sent (distinct from `family`, the original/source family being succeeded). */
  successorDestination: Array<SuccessorType>;
  taxOptimisationSessionIds?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  thirdpartyaccount: Array<ThirdPartyAccountInputType>;
  totalContribution?: Maybe<Scalars["Decimal"]["output"]>;
  unattestedContributions?: Maybe<IntegratedContributionType>;
  yearlyFamilyUserGroupData?: Maybe<YearlyFamilyUserGroupDataType>;
  yellowRef?: Maybe<Scalars["String"]["output"]>;
  ytdContribution?: Maybe<Scalars["Float"]["output"]>;
};

/** API to create favourites  */
export type Favourite = {
  __typename?: "Favourite";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type FavouritesType = {
  __typename?: "FavouritesType";
  user: UserType;
};

/** Response type for feature locks */
export type FeatureLocksType = {
  __typename?: "FeatureLocksType";
  branding?: Maybe<Scalars["GenericScalar"]["output"]>;
  custodians?: Maybe<Scalars["GenericScalar"]["output"]>;
  featureFlags?: Maybe<Scalars["GenericScalar"]["output"]>;
};

export type FeaturedGrantType = {
  __typename?: "FeaturedGrantType";
  causes?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  charityName?: Maybe<Scalars["String"]["output"]>;
  contribution?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  rationale?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  submittedOn?: Maybe<Scalars["String"]["output"]>;
};

export type FeeTierType = {
  __typename?: "FeeTierType";
  feeTier?: Maybe<Scalars["GenericScalar"]["output"]>;
};

export type FeesByAdvisorIdType = {
  __typename?: "FeesByAdvisorIdType";
  isCustomFeeSplit?: Maybe<Scalars["Boolean"]["output"]>;
  isLastPage?: Maybe<Scalars["Boolean"]["output"]>;
  isPaginated?: Maybe<Scalars["Boolean"]["output"]>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pageSize?: Maybe<Scalars["Int"]["output"]>;
  results?: Maybe<Array<Maybe<AdvisorFeeRowType>>>;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type FeesByEnterpriseType = {
  __typename?: "FeesByEnterpriseType";
  isCustomFeeSplit?: Maybe<Scalars["Boolean"]["output"]>;
  isLastPage?: Maybe<Scalars["Boolean"]["output"]>;
  isPaginated?: Maybe<Scalars["Boolean"]["output"]>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pageSize?: Maybe<Scalars["Int"]["output"]>;
  results?: Maybe<Array<Maybe<EnterpriseFeeRowType>>>;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type FeesByFirmType = {
  __typename?: "FeesByFirmType";
  isCustomFeeSplit?: Maybe<Scalars["Boolean"]["output"]>;
  isLastPage?: Maybe<Scalars["Boolean"]["output"]>;
  isPaginated?: Maybe<Scalars["Boolean"]["output"]>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pageSize?: Maybe<Scalars["Int"]["output"]>;
  results?: Maybe<Array<Maybe<FirmFeeRowType>>>;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type FeesByProgramType = {
  __typename?: "FeesByProgramType";
  isCustomFeeSplit?: Maybe<Scalars["Boolean"]["output"]>;
  isLastPage?: Maybe<Scalars["Boolean"]["output"]>;
  isPaginated?: Maybe<Scalars["Boolean"]["output"]>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pageSize?: Maybe<Scalars["Int"]["output"]>;
  results?: Maybe<Array<Maybe<ProgramFeeRowType>>>;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type FeesStatsType = {
  __typename?: "FeesStatsType";
  adminFees?: Maybe<Scalars["Float"]["output"]>;
  aum?: Maybe<Scalars["Float"]["output"]>;
  avgBps?: Maybe<Scalars["Float"]["output"]>;
  enterpriseFeePct?: Maybe<Scalars["Float"]["output"]>;
  enterpriseShare?: Maybe<Scalars["Float"]["output"]>;
  platformFeePct?: Maybe<Scalars["Float"]["output"]>;
  platformShare?: Maybe<Scalars["Float"]["output"]>;
  subAdvisorFees?: Maybe<Scalars["Float"]["output"]>;
};

/** Card Processing Fees Type */
export type FeesType = {
  __typename?: "FeesType";
  oneTimeFee?: Maybe<Scalars["Float"]["output"]>;
  processingFee?: Maybe<Scalars["Float"]["output"]>;
};

export type FilterKeyType = {
  city?: InputMaybe<Scalars["String"]["input"]>;
  international?: InputMaybe<Scalars["Boolean"]["input"]>;
  state?: InputMaybe<Scalars["String"]["input"]>;
  zipCode?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * Manual trigger for closing a succession transition's step 5: verifies the DAF
 * balance is $0 and every beneficiary distribution has cleared, then marks the
 * transition completed and unfreezes the DAF. Does NOT create distributions
 * itself -- those are created once by the daily batch job
 * (core.tasks._advance_one) as soon as the transition enters step 5. This is a
 * manual check of the exact same close condition the batch job verifies daily,
 * for an advisor who doesn't want to wait for the next run.
 */
export type FinalizeSuccessionTransition = {
  __typename?: "FinalizeSuccessionTransition";
  grantsCreated?: Maybe<Scalars["Int"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Paginated firm admins results using UserType with FirmType support */
export type FirmAdminsPaginatedType = {
  __typename?: "FirmAdminsPaginatedType";
  count?: Maybe<Scalars["Int"]["output"]>;
  objects?: Maybe<Array<Maybe<UserType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

/** Paginated advisors results using UserType with FirmType support */
export type FirmAdvisorsPaginatedType = {
  __typename?: "FirmAdvisorsPaginatedType";
  count?: Maybe<Scalars["Int"]["output"]>;
  objects?: Maybe<Array<Maybe<UserType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export type FirmAdvisorsType = {
  __typename?: "FirmAdvisorsType";
  allClients?: Maybe<Scalars["Int"]["output"]>;
  archivedCount?: Maybe<Scalars["Int"]["output"]>;
  pendingCount?: Maybe<Scalars["Int"]["output"]>;
  totalAum?: Maybe<Scalars["Float"]["output"]>;
  totalDafs?: Maybe<Scalars["Int"]["output"]>;
  totalUsers?: Maybe<Scalars["Int"]["output"]>;
  ytdFees?: Maybe<Scalars["Float"]["output"]>;
};

export type FirmClientDetailType = {
  __typename?: "FirmClientDetailType";
  advisor?: Maybe<RiaMemberType>;
  advisorOps?: Maybe<Array<Maybe<RiaMemberType>>>;
  aum?: Maybe<Scalars["Float"]["output"]>;
  clientId?: Maybe<Scalars["Int"]["output"]>;
  clientName?: Maybe<Scalars["String"]["output"]>;
  dafName?: Maybe<Scalars["String"]["output"]>;
  pendingContributions?: Maybe<Scalars["Float"]["output"]>;
  totalAllocations?: Maybe<Scalars["Float"]["output"]>;
  ytdAdminFees?: Maybe<Scalars["Float"]["output"]>;
};

/** Paginated clients results using UserType with FirmType support */
export type FirmClientsPaginatedType = {
  __typename?: "FirmClientsPaginatedType";
  count?: Maybe<Scalars["Int"]["output"]>;
  objects?: Maybe<Array<Maybe<UserType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

/**
 * A firm/enterprise-level override of a static legal document.
 *
 * `source` tells the admin UI whether this row belongs to the firm being
 * viewed or was inherited from its enterprise parent (see
 * resolve_firm_documents) — an inherited row can only be reset from the
 * enterprise itself, not from the child firm.
 */
export type FirmDocumentType = {
  __typename?: "FirmDocumentType";
  documentType?: Maybe<Scalars["String"]["output"]>;
  documentUrl?: Maybe<Scalars["String"]["output"]>;
  firm: FirmType;
  id: Scalars["ID"]["output"];
  originalFilename?: Maybe<Scalars["String"]["output"]>;
  source?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
  uploadedAt: Scalars["DateTime"]["output"];
  uploadedBy?: Maybe<UserType>;
};

/** List email preferences of a firm */
export type FirmEmailPreferencesType = {
  __typename?: "FirmEmailPreferencesType";
  emailList?: Maybe<Scalars["GenericScalar"]["output"]>;
};

export type FirmEmailStatisticsType = {
  __typename?: "FirmEmailStatisticsType";
  /** Overall click rate percentage */
  clickRate?: Maybe<Scalars["Float"]["output"]>;
  /** Daily statistics breakdown */
  dailyBreakdown?: Maybe<Array<Maybe<DailyEmailStatsType>>>;
  /** End date in ISO format */
  endDate?: Maybe<Scalars["String"]["output"]>;
  /** Firm ID */
  firmId?: Maybe<Scalars["Int"]["output"]>;
  /** Overall open rate percentage */
  openRate?: Maybe<Scalars["Float"]["output"]>;
  /** Start date in ISO format */
  startDate?: Maybe<Scalars["String"]["output"]>;
  /** Total emails bounced */
  totalEmailsBounced?: Maybe<Scalars["Int"]["output"]>;
  /** Total emails clicked */
  totalEmailsClicked?: Maybe<Scalars["Int"]["output"]>;
  /** Total emails delivered */
  totalEmailsDelivered?: Maybe<Scalars["Int"]["output"]>;
  /** Total emails opened */
  totalEmailsOpened?: Maybe<Scalars["Int"]["output"]>;
  /** Total emails sent */
  totalEmailsSent?: Maybe<Scalars["Int"]["output"]>;
};

export type FirmFeeRowType = {
  __typename?: "FirmFeeRowType";
  adminFees?: Maybe<Scalars["Float"]["output"]>;
  advisorGiveReferenceId?: Maybe<Scalars["String"]["output"]>;
  advisorId?: Maybe<Scalars["String"]["output"]>;
  advisorName?: Maybe<Scalars["String"]["output"]>;
  aum?: Maybe<Scalars["String"]["output"]>;
  avgBps?: Maybe<Scalars["String"]["output"]>;
  enterpriseFeePct?: Maybe<Scalars["Float"]["output"]>;
  enterpriseShare?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  platformFeePct?: Maybe<Scalars["Float"]["output"]>;
  platformShare?: Maybe<Scalars["Float"]["output"]>;
  subAdvisorFees?: Maybe<Scalars["Float"]["output"]>;
};

/** Input fields for firm  */
export type FirmInputType = {
  address?: InputMaybe<Scalars["GenericScalar"]["input"]>;
  firmName?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["GenericScalar"]["input"]>;
  website?: InputMaybe<Scalars["String"]["input"]>;
};

export type FirmPaginatedType = {
  __typename?: "FirmPaginatedType";
  count?: Maybe<Scalars["Int"]["output"]>;
  objects?: Maybe<Array<Maybe<FirmType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export type FirmPaginationType = {
  __typename?: "FirmPaginationType";
  objects?: Maybe<Array<Maybe<AdvisorDetailsType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export type FirmPoolSetsType = {
  __typename?: "FirmPoolSetsType";
  custodianName?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  isSmaPooledSets?: Maybe<Scalars["Boolean"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  pools?: Maybe<Array<Maybe<PoolSetPools>>>;
};

export type FirmSummaryType = {
  __typename?: "FirmSummaryType";
  totalAdvisors?: Maybe<Scalars["Int"]["output"]>;
  totalAum?: Maybe<Scalars["Float"]["output"]>;
  totalClients?: Maybe<Scalars["Int"]["output"]>;
  totalDafs?: Maybe<Scalars["Int"]["output"]>;
  totalFirms?: Maybe<Scalars["Int"]["output"]>;
  totalUsers?: Maybe<Scalars["Int"]["output"]>;
  ytdFees?: Maybe<Scalars["Float"]["output"]>;
};

export type FirmType = {
  __typename?: "FirmType";
  address?: Maybe<Scalars["JSONString"]["output"]>;
  companyDafLaunchDate?: Maybe<Scalars["DateTime"]["output"]>;
  customDomain?: Maybe<Scalars["String"]["output"]>;
  eligibilityEmails?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  featureLocks?: Maybe<FeatureLocksType>;
  firmName?: Maybe<Scalars["String"]["output"]>;
  firmSummary?: Maybe<FirmSummaryType>;
  hasMinimumOneDaf?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  individualDafLaunchDate?: Maybe<Scalars["DateTime"]["output"]>;
  isEnterprise?: Maybe<Scalars["Boolean"]["output"]>;
  isSetupDone: Scalars["Boolean"]["output"];
  logo?: Maybe<Scalars["String"]["output"]>;
  logoUrl?: Maybe<Scalars["String"]["output"]>;
  members: Scalars["Int"]["output"];
  metaData?: Maybe<Scalars["JSONString"]["output"]>;
  parentFirm?: Maybe<FirmType>;
  phoneNumber?: Maybe<Scalars["JSONString"]["output"]>;
  primaryColor?: Maybe<Scalars["String"]["output"]>;
  secondaryColor?: Maybe<Scalars["String"]["output"]>;
  taxId?: Maybe<Scalars["String"]["output"]>;
  website?: Maybe<Scalars["String"]["output"]>;
};

export type FirmUserDetailsType = {
  __typename?: "FirmUserDetailsType";
  aum?: Maybe<Scalars["String"]["output"]>;
  clientsManaged?: Maybe<Scalars["Int"]["output"]>;
  clientsSupported?: Maybe<Scalars["Int"]["output"]>;
  dafsCount?: Maybe<Scalars["Int"]["output"]>;
  elevateUserRef?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  profileUrl?: Maybe<Scalars["String"]["output"]>;
  role?: Maybe<Scalars["String"]["output"]>;
  tncAcceptedTime?: Maybe<Scalars["DateTime"]["output"]>;
  ytd?: Maybe<Scalars["String"]["output"]>;
};

export type FirmUsersPaginationType = {
  __typename?: "FirmUsersPaginationType";
  objects?: Maybe<Array<Maybe<FirmUserDetailsType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export type FocusAreaInput = {
  label: Scalars["String"]["input"];
  weight?: InputMaybe<Scalars["Float"]["input"]>;
};

export type FocusAreaType = {
  __typename?: "FocusAreaType";
  id: Scalars["ID"]["output"];
  label: Scalars["String"]["output"];
  weight?: Maybe<Scalars["Float"]["output"]>;
};

/**
 * User: Advisor
 * Freeze a family's Louise DAF account at the start of a succession transition.
 * Blocks new grants, contributions, and family member invites.
 */
export type FreezeDafAccount = {
  __typename?: "FreezeDAFAccount";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export enum FrequencyChoices {
  Annually = "ANNUALLY",
  Monthly = "MONTHLY",
  OneTime = "ONE_TIME",
  Quarterly = "QUARTERLY",
}

export type FundAssetPoolType = {
  __typename?: "FundAssetPoolType";
  assetId: Scalars["String"]["output"];
  assetName: Scalars["String"]["output"];
  assetNetValue?: Maybe<Scalars["Decimal"]["output"]>;
  assetPool: AssetPoolType;
  assetSharesOutstanding?: Maybe<Scalars["Float"]["output"]>;
  assetValuePerShare?: Maybe<Scalars["Float"]["output"]>;
  currentPortfolioRatio?: Maybe<Scalars["Float"]["output"]>;
  family: FamilyType;
  holderAssetValue?: Maybe<Scalars["Decimal"]["output"]>;
  holderNumSharesHeld?: Maybe<Scalars["Float"]["output"]>;
  holderTargetRatio?: Maybe<Scalars["Float"]["output"]>;
  holderTargetValue?: Maybe<Scalars["Decimal"]["output"]>;
  id: Scalars["ID"]["output"];
};

export type FundCumulativeType = {
  __typename?: "FundCumulativeType";
  contribution?: Maybe<Scalars["Int"]["output"]>;
  fundId?: Maybe<Scalars["Int"]["output"]>;
  fundTitle?: Maybe<Scalars["String"]["output"]>;
};

export type FundReallocationsRebalancePaginatedType = {
  __typename?: "FundReallocationsRebalancePaginatedType";
  objects?: Maybe<Array<Maybe<FundReallocationsRebalanceType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type FundReallocationsRebalanceType = {
  __typename?: "FundReallocationsRebalanceType";
  daf?: Maybe<Scalars["ID"]["output"]>;
  dateRequested?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  targets?: Maybe<Array<Maybe<TargetType>>>;
};

export enum FundStatusEnum {
  Active = "active",
  Pending = "pending",
}

export type FundTransferRequestsPaginatedType = {
  __typename?: "FundTransferRequestsPaginatedType";
  objects?: Maybe<Array<Maybe<FundTransferRequestsType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export type FundTransferRequestsPoolType = {
  __typename?: "FundTransferRequestsPoolType";
  id?: Maybe<Scalars["ID"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type FundTransferRequestsType = {
  __typename?: "FundTransferRequestsType";
  createdBy?: Maybe<Scalars["String"]["output"]>;
  daf?: Maybe<Scalars["ID"]["output"]>;
  dateInvested?: Maybe<Scalars["String"]["output"]>;
  dateRedeemed?: Maybe<Scalars["String"]["output"]>;
  dateRequested?: Maybe<Scalars["String"]["output"]>;
  fromPool?: Maybe<FundTransferRequestsPoolType>;
  id?: Maybe<Scalars["ID"]["output"]>;
  investedValue?: Maybe<Scalars["String"]["output"]>;
  redeemedValue?: Maybe<Scalars["String"]["output"]>;
  requestedValue?: Maybe<Scalars["Float"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  toPool?: Maybe<FundTransferRequestsPoolType>;
  transferReference?: Maybe<Scalars["ID"]["output"]>;
};

export enum FundTypeEnum {
  Daf = "daf",
  Scf = "scf",
}

export type GeneralPerformanceMetricsType = {
  __typename?: "GeneralPerformanceMetricsType";
  /** Average satisfaction score */
  avgSatisfaction?: Maybe<Scalars["Float"]["output"]>;
  /** Number of requests */
  requests?: Maybe<Scalars["Int"]["output"]>;
};

export type GenerateClientBunchingAnalysis = {
  __typename?: "GenerateClientBunchingAnalysis";
  error?: Maybe<Scalars["String"]["output"]>;
  result?: Maybe<BunchingAnalysisResultType>;
};

export type GenerateClientTaxOptimisationResult = {
  __typename?: "GenerateClientTaxOptimisationResult";
  accountName?: Maybe<Scalars["String"]["output"]>;
  appreciatedSecuritiesCount?: Maybe<Scalars["Int"]["output"]>;
  error?: Maybe<Scalars["String"]["output"]>;
  portfolioValue?: Maybe<Scalars["Float"]["output"]>;
  result?: Maybe<TaxOptimisationResultType>;
  totalUnrealizedGain?: Maybe<Scalars["Float"]["output"]>;
};

/** A generic mutation that takes in html and css and returns a base64 encoded pdf. */
export type GeneratePdf = {
  __typename?: "GeneratePDF";
  byteData?: Maybe<Scalars["String"]["output"]>;
};

/** Endpoint to generate downloadable base64 PDF content of user's signed Sub Advisory Agreement. */
export type GenerateSubAdvisoryAgreement = {
  __typename?: "GenerateSubAdvisoryAgreement";
  byteData?: Maybe<Scalars["String"]["output"]>;
};

export type GenerateTaxOptimiserPdf = {
  __typename?: "GenerateTaxOptimiserPDF";
  byteData?: Maybe<Scalars["String"]["output"]>;
};

/** Fetch a fees report PDF from Elevate/Amicus and return it as a base64-encoded string for client-side download. */
export type GetFeeStatement = {
  __typename?: "GetFeeStatement";
  /** Fees report PDF from Amicus, base64-encoded. */
  feeStatement?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Fetch Individual Tax Receipt from Amicus(if available) and returns a base64 encoded string. This can be converted and downloaded as PDF. */
export type GetIndividualTaxReceipt = {
  __typename?: "GetIndividualTaxReceipt";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  /** Individual Tax Receipt PDF file from Amicus converted into base64 encoded string. */
  taxReceipt?: Maybe<Scalars["String"]["output"]>;
};

/** Fetch Tax Receipt from Amicus(if available) and returns a base64 encoded string. This can be converted and downloaded as PDF. */
export type GetTaxReceipt = {
  __typename?: "GetTaxReceipt";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  /** Tax Receipt PDF file from Amicus converted into base64 encoded string. */
  taxReceipt?: Maybe<Scalars["String"]["output"]>;
};

export type GiftActivityFilterInputType = {
  charityIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** Case-insensitive partial match on charity name. */
  charityName?: InputMaybe<Scalars["String"]["input"]>;
  companyGrant?: InputMaybe<Scalars["Boolean"]["input"]>;
  giftType?: InputMaybe<GiftFilterTypeEnum>;
  statuses?: InputMaybe<Array<InputMaybe<GiftStatusEnum>>>;
  userGroup?: InputMaybe<UserGroupTypeEnum>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

/** Response fields to have pagination for grant history  */
export type GiftActivityPaginatedType = {
  __typename?: "GiftActivityPaginatedType";
  objects?: Maybe<Array<Maybe<GiftActivityType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

/** Contribution Request/Gift record. */
export type GiftActivityType = {
  __typename?: "GiftActivityType";
  accountType?: Maybe<ContributionAccountType>;
  amount?: Maybe<Scalars["Decimal"]["output"]>;
  anonymous: Scalars["Boolean"]["output"];
  campaignDonation?: Maybe<CampaignDonationType>;
  causes?: Maybe<Array<Scalars["String"]["output"]>>;
  charity?: Maybe<CharityType>;
  charityId?: Maybe<Scalars["String"]["output"]>;
  charityName?: Maybe<Scalars["String"]["output"]>;
  companyGrant?: Maybe<CompanyGrantType>;
  contributedAt?: Maybe<Scalars["DateTime"]["output"]>;
  contribution: Scalars["Float"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  donor?: Maybe<Scalars["String"]["output"]>;
  ein?: Maybe<Scalars["String"]["output"]>;
  elevateStatus?: Maybe<Scalars["String"]["output"]>;
  elevateStatusDates: Scalars["JSONString"]["output"];
  faConfirm: Scalars["Boolean"]["output"];
  family: FamilyType;
  frequency?: Maybe<Scalars["String"]["output"]>;
  grantClearedAt?: Maybe<Scalars["DateTime"]["output"]>;
  grantReference?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  impersonatedBy?: Maybe<UserType>;
  isActive: Scalars["Boolean"]["output"];
  isCart: Scalars["Boolean"]["output"];
  /** Flag to indicate if this contribution uses the full balance */
  isFullBalance: Scalars["Boolean"]["output"];
  nextScheduled?: Maybe<Scalars["String"]["output"]>;
  note?: Maybe<Scalars["String"]["output"]>;
  notes?: Maybe<Scalars["String"]["output"]>;
  privacyFields?: Maybe<Scalars["JSONString"]["output"]>;
  privacyPreset?: Maybe<Scalars["String"]["output"]>;
  /** Advisor-authored rationale for why this grant was made (max 500 chars). */
  rationale?: Maybe<Scalars["String"]["output"]>;
  recurringGift?: Maybe<RecurringGiftType>;
  retryContributionId?: Maybe<Scalars["Int"]["output"]>;
  saveLater: Scalars["Boolean"]["output"];
  status?: Maybe<Scalars["String"]["output"]>;
  submittedOn?: Maybe<Scalars["String"]["output"]>;
  /** The real Contribution created for this beneficiary when the family's succession transition entered step 5 and distributed its remaining DAF balance (see give.utils.create_succession_beneficiary_contributions). Null if a distribution was never attempted, or if attempted but skipped -- see distribution_attempted_at to tell those two cases apart. */
  successionBeneficiary: Array<BeneficiaryType>;
  user: UserType;
};

export enum GiftDeleteTypeEnum {
  All = "ALL",
  OneTime = "ONE_TIME",
}

export enum GiftFilterTypeEnum {
  OneTime = "ONE_TIME",
  Recurring = "RECURRING",
}

/** Response fields for Gift Activity  */
export type GiftHistory = {
  __typename?: "GiftHistory";
  /** Historical Grants Total till date, excluding the cancelled and future grants. */
  accumulatedGrants?: Maybe<Scalars["Float"]["output"]>;
  /** Response fields to have pagination for grant history */
  giftActivity?: Maybe<GiftActivityPaginatedType>;
};

/** Details of completed contribution request/gift. */
export type GiftHistoryType = {
  __typename?: "GiftHistoryType";
  charityId?: Maybe<Scalars["String"]["output"]>;
  charityMediumImg?: Maybe<Scalars["String"]["output"]>;
  charityTitle?: Maybe<Scalars["String"]["output"]>;
  contributors?: Maybe<Array<Maybe<ContributorsType>>>;
  saveLater?: Maybe<Scalars["Boolean"]["output"]>;
  totalContribution?: Maybe<Scalars["Int"]["output"]>;
};

export enum GiftStatusEnum {
  Approved = "APPROVED",
  Canceled = "CANCELED",
  CheckExpired = "CHECK_EXPIRED",
  CheckReissued = "CHECK_REISSUED",
  InProgress = "IN_PROGRESS",
  NewRequest = "NEW_REQUEST",
  PaymentVoided = "PAYMENT_VOIDED",
  Pending = "PENDING",
  ReceivedByCharity = "RECEIVED_BY_CHARITY",
  Rejected = "REJECTED",
  SentToCharity = "SENT_TO_CHARITY",
}

/** Add a specific charity to user(family member)'s cart, edit the amount to be donated or send the donation request to advisor. */
export type Give = {
  __typename?: "Give";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type GivingChartDataType = {
  __typename?: "GivingChartDataType";
  contribution?: Maybe<Scalars["Int"]["output"]>;
  fund?: Maybe<Scalars["String"]["output"]>;
  monthName?: Maybe<Scalars["String"]["output"]>;
};

export type GivingPlanType = {
  __typename?: "GivingPlanType";
  chartData?: Maybe<Array<Maybe<GivingChartDataType>>>;
  fundCumulative?: Maybe<Array<Maybe<FundCumulativeType>>>;
};

/** Details of a grant along with the timeline of events  */
export type GrantDetailType = {
  __typename?: "GrantDetailType";
  currentOccurrence?: Maybe<Scalars["Int"]["output"]>;
  endDate?: Maybe<Scalars["DateTime"]["output"]>;
  grantDetails?: Maybe<GiftActivityType>;
  startDate?: Maybe<Scalars["DateTime"]["output"]>;
  statusTimeline?: Maybe<Array<Maybe<GrantStatusTimelineType>>>;
  totalOccurrences?: Maybe<Scalars["Int"]["output"]>;
};

/** Grant filters type */
export type GrantFiltersType = {
  __typename?: "GrantFiltersType";
  charities?: Maybe<Array<Maybe<CharityFilterType>>>;
  statuses?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export enum GrantHistoryBatchSource {
  /** AI_AGENT_UPLOAD */
  AiAgentUpload = "AI_AGENT_UPLOAD",
}

export enum GrantHistoryBatchStatus {
  /** COMPLETED */
  Completed = "COMPLETED",
  /** FAILED */
  Failed = "FAILED",
  /** PROCESSING */
  Processing = "PROCESSING",
}

export type GrantHistoryBatchType = {
  __typename?: "GrantHistoryBatchType";
  createdAt: Scalars["DateTime"]["output"];
  dateRangeEnd?: Maybe<Scalars["Date"]["output"]>;
  dateRangeStart?: Maybe<Scalars["Date"]["output"]>;
  /** Original filename (display only) */
  filename: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  importedRecords: Scalars["Int"]["output"];
  skippedRecords: Scalars["Int"]["output"];
  source: GrantHistoryBatchSource;
  status: GrantHistoryBatchStatus;
  totalAmount: Scalars["Decimal"]["output"];
  totalRecords: Scalars["Int"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  uploadSessionId: Scalars["String"]["output"];
  uploadedByName?: Maybe<Scalars["String"]["output"]>;
};

export type GrantHistoryRecordType = {
  __typename?: "GrantHistoryRecordType";
  amount: Scalars["Decimal"]["output"];
  charityEin: Scalars["String"]["output"];
  /** Platform charity ID */
  charityId: Scalars["String"]["output"];
  charityName: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  grantDate: Scalars["Date"]["output"];
  id: Scalars["ID"]["output"];
  note: Scalars["String"]["output"];
  /** Original row index in the uploaded file (1-based) */
  sourceRowNumber: Scalars["Int"]["output"];
};

/** A custom dictionary containing user-friendly statuses for the corresponding elevate statuses.  */
export type GrantStatusTimelineType = {
  __typename?: "GrantStatusTimelineType";
  activeTimelineStatus?: Maybe<Scalars["String"]["output"]>;
  activeTimelineStatusSubtext?: Maybe<Scalars["String"]["output"]>;
  completedOn?: Maybe<Scalars["String"]["output"]>;
  elevateStatus?: Maybe<Scalars["String"]["output"]>;
  inactiveTimelineStatus?: Maybe<Scalars["String"]["output"]>;
  inactiveTimelineStatusSubtext?: Maybe<Scalars["String"]["output"]>;
  orderOfAppearance?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  tooltipText?: Maybe<Scalars["String"]["output"]>;
};

export type GranteeAddressType = {
  __typename?: "GranteeAddressType";
  /** City, state, zip */
  cityStateZip?: Maybe<Scalars["String"]["output"]>;
  /** Country */
  country?: Maybe<Scalars["String"]["output"]>;
  /** Street address */
  streetAddress?: Maybe<Scalars["String"]["output"]>;
};

export enum GrowthActivityActionActionType {
  /** Disable */
  Disable = "DISABLE",
  /** Snooze */
  Snooze = "SNOOZE",
}

/** Input type for growth activity actions */
export type GrowthActivityActionInput = {
  /** Type of action to perform */
  actionType: Scalars["String"]["input"];
  /** ID of the growth activity */
  id: Scalars["ID"]["input"];
};

/** Response type for growth activity actions */
export type GrowthActivityActionPayload = {
  __typename?: "GrowthActivityActionPayload";
  action?: Maybe<GrowthActivityActionType>;
  errors?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type GrowthActivityActionType = {
  __typename?: "GrowthActivityActionType";
  actionAt: Scalars["DateTime"]["output"];
  /** User who performed the action */
  actionBy: UserType;
  actionByUser?: Maybe<UserType>;
  /** Type of action performed */
  actionType: GrowthActivityActionActionType;
  growthActivity: GrowthActivityTypeSchema;
  id: Scalars["ID"]["output"];
};

export enum GrowthActivityCategory {
  /** Grow DAF Assets */
  GrowDafAssets = "GROW_DAF_ASSETS",
  /** Increase Wallet Share + KYC */
  IncreaseWalletShareAndKyc = "INCREASE_WALLET_SHARE_AND_KYC",
  /** Increase Wallet Share + Service */
  IncreaseWalletShareAndService = "INCREASE_WALLET_SHARE_AND_SERVICE",
  /** NextGen Engagement */
  NextgenEngagement = "NEXTGEN_ENGAGEMENT",
}

/** Filter input for growth activities */
export type GrowthActivityFilterInput = {
  /** Include normal activities (not snoozed/disabled) */
  showNormal?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Include snoozed activities */
  showSnoozed?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Connection type for paginated growth activity results */
export type GrowthActivityPaginatedType = {
  __typename?: "GrowthActivityPaginatedType";
  /** Count of activities matching the current filter */
  count?: Maybe<Scalars["Int"]["output"]>;
  /** Count of normal activities (not snoozed or disabled) */
  normalCount?: Maybe<Scalars["Int"]["output"]>;
  objects?: Maybe<Array<Maybe<GrowthActivityTypeSchema>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
  /** Count of snoozed activities (snoozed within last 2 weeks) */
  snoozedCount?: Maybe<Scalars["Int"]["output"]>;
};

export type GrowthActivityTypeSchema = {
  __typename?: "GrowthActivityTypeSchema";
  /** Text for the action button */
  actionText: Scalars["String"]["output"];
  /** URL for the action button */
  actionUrl: Scalars["String"]["output"];
  actions?: Maybe<Array<Maybe<GrowthActivityActionType>>>;
  /** Category of growth activity */
  category: GrowthActivityCategory;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  objectId?: Maybe<Scalars["Int"]["output"]>;
  /** Description of how this activity leads to revenue generation */
  pathToRevenue: Scalars["String"]["output"];
  /** Recommended action to take for this growth opportunity */
  recommendedAction: Scalars["String"]["output"];
  type?: Maybe<Scalars["String"]["output"]>;
};

/** One owner (GSCS client) of an imported GS account. */
export type GsAccountOwnerType = {
  __typename?: "GsAccountOwnerType";
  annualIncome?: Maybe<Scalars["Float"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  employerLineOfBusiness?: Maybe<Scalars["String"]["output"]>;
  employmentStatus?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  inviteStatus?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  loginId?: Maybe<Scalars["String"]["output"]>;
  matchedUserId?: Maybe<Scalars["Int"]["output"]>;
  middleName?: Maybe<Scalars["String"]["output"]>;
  phone?: Maybe<Scalars["String"]["output"]>;
  prefix?: Maybe<Scalars["String"]["output"]>;
  repCode?: Maybe<Scalars["String"]["output"]>;
  sourceOfWealth?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  suffix?: Maybe<Scalars["String"]["output"]>;
};

/** Branch and rep codes available to the logged-in advisor at GSCS. */
export type GsBranchRepCodesType = {
  __typename?: "GsBranchRepCodesType";
  branchCodes?: Maybe<Array<Scalars["String"]["output"]>>;
  repCodes?: Maybe<Array<Scalars["String"]["output"]>>;
};

export enum GsDafAccountApplicationStatus {
  /** AWAITING_SIGNATURE */
  AwaitingSignature = "AWAITING_SIGNATURE",
  /** COMPLETED */
  Completed = "COMPLETED",
  /** FAILED */
  Failed = "FAILED",
  /** HOUSEHOLD_READY */
  HouseholdReady = "HOUSEHOLD_READY",
  /** PENDING */
  Pending = "PENDING",
  /** TASKS_CREATED */
  TasksCreated = "TASKS_CREATED",
}

export type GsDafAccountApplicationType = {
  __typename?: "GsDafAccountApplicationType";
  cipRestricted?: Maybe<Scalars["Boolean"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  fundName: Scalars["String"]["output"];
  gsAccountNumber: Scalars["String"]["output"];
  gsAccountTaskId: Scalars["String"]["output"];
  gsFirmTaskId: Scalars["String"]["output"];
  gsHouseholdId: Scalars["String"]["output"];
  gsInvitationId: Scalars["String"]["output"];
  hohFirstName: Scalars["String"]["output"];
  hohLastName: Scalars["String"]["output"];
  hohLoginId: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  status: GsDafAccountApplicationStatus;
  updatedAt: Scalars["DateTime"]["output"];
};

export type GsImportRecordsPaginatedType = {
  __typename?: "GsImportRecordsPaginatedType";
  count?: Maybe<Scalars["Int"]["output"]>;
  objects?: Maybe<Array<Maybe<BookOfBusinessImportRecordType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

/**
 * Owner-resolution result for the Link-to-DAF flow.
 *
 * status drives the FE branch:
 *   matched          — single owner, Louise user with invite_status=accepted
 *                      → connect portfolio to that user
 *   invite_pending   — single owner, Louise user exists but invitation not
 *                      accepted yet → do not re-invite / do not map yet
 *   invite_required  — single owner, no Louise user → open Invite Client
 *                      prefilled from the owner fields
 *   multiple_owners  — advisor must pick an owner first (each entry carries
 *                      its own matched_user_id + invite_status)
 *   firm_owned       — the only owner(s) are firm entities (isFirm=true,
 *                      e.g. GiveClear-owned DAF accounts) — no donor to link
 *   no_owner_data    — GS sent no owner info for this account
 */
export type GsPortfolioOwnersType = {
  __typename?: "GsPortfolioOwnersType";
  matchedUserId?: Maybe<Scalars["Int"]["output"]>;
  owners?: Maybe<Array<Maybe<GsAccountOwnerType>>>;
  portfolioCode?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
};

/** HoldingSummary input field type  */
export type HoldingSummaryInputType = {
  price: Scalars["Float"]["input"];
  shares: Scalars["Float"]["input"];
  ticker: Scalars["String"]["input"];
  value: Scalars["Float"]["input"];
  weight: Scalars["Float"]["input"];
};

/** HoldingSummary response field type  */
export type HoldingSummaryType = {
  __typename?: "HoldingSummaryType";
  account: AccountType;
  currentPrice: Scalars["Decimal"]["output"];
  family: FamilyType;
  id: Scalars["ID"]["output"];
  tickerId?: Maybe<Scalars["String"]["output"]>;
  values: Scalars["Decimal"]["output"];
  weight: Scalars["Decimal"]["output"];
};

export type ImpactGoalInput = {
  causeArea?: InputMaybe<Scalars["String"]["input"]>;
  label: Scalars["String"]["input"];
  metricType?: InputMaybe<Scalars["String"]["input"]>;
  period?: InputMaybe<Scalars["String"]["input"]>;
  targetValue?: InputMaybe<Scalars["Float"]["input"]>;
};

export type ImpactGoalType = {
  __typename?: "ImpactGoalType";
  causeArea?: Maybe<Scalars["String"]["output"]>;
  currentValue?: Maybe<Scalars["Float"]["output"]>;
  id: Scalars["ID"]["output"];
  label: Scalars["String"]["output"];
  metricType?: Maybe<Scalars["String"]["output"]>;
  order: Scalars["Int"]["output"];
  period?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  targetValue?: Maybe<Scalars["Float"]["output"]>;
};

export type IndividualClientDetailType = {
  __typename?: "IndividualClientDetailType";
  aum?: Maybe<Scalars["Float"]["output"]>;
  clientId?: Maybe<Scalars["Int"]["output"]>;
  clientName?: Maybe<Scalars["String"]["output"]>;
  dafName?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  isDafCreated?: Maybe<Scalars["Boolean"]["output"]>;
  subAdvisorFee?: Maybe<Scalars["Float"]["output"]>;
  userId?: Maybe<Scalars["Int"]["output"]>;
  ytdAdminFees?: Maybe<Scalars["Float"]["output"]>;
};

/** Response fields to have pagination for individual client's detail list  */
export type IndividualClientPaginatedType = {
  __typename?: "IndividualClientPaginatedType";
  objects?: Maybe<Array<Maybe<IndividualClientDetailType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export enum IndividualDafStatusFilterType {
  Active = "ACTIVE",
  DafFunded = "DAF_FUNDED",
  DafOpened = "DAF_OPENED",
  Pending = "PENDING",
}

/**
 * Shared document type for both inheritance-registry docs and family
 * legacy documents (same underlying model).
 */
export type InheritanceDocumentType = {
  __typename?: "InheritanceDocumentType";
  documentType?: Maybe<Scalars["String"]["output"]>;
  documentUrl?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isDeleted: Scalars["Boolean"]["output"];
  originalFilename: Scalars["String"]["output"];
  status?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
  uploadedAt: Scalars["DateTime"]["output"];
  uploadedBy?: Maybe<UserType>;
  visibility?: Maybe<Scalars["String"]["output"]>;
};

export type InheritanceRegistryInput = {
  accountFundName?: InputMaybe<Scalars["String"]["input"]>;
  allocationPercentage?: InputMaybe<Scalars["Decimal"]["input"]>;
  currentAdvisorGrantor?: InputMaybe<Scalars["String"]["input"]>;
  dafSponsor?: InputMaybe<Scalars["String"]["input"]>;
  ein?: InputMaybe<Scalars["String"]["input"]>;
  estimatedValue?: InputMaybe<Scalars["Decimal"]["input"]>;
  foundationType?: InputMaybe<Scalars["String"]["input"]>;
  fundEntityName: Scalars["String"]["input"];
  relation?: InputMaybe<Scalars["String"]["input"]>;
  restrictions?: InputMaybe<Array<InputMaybe<InheritanceRestrictionInput>>>;
  sourceType: Scalars["String"]["input"];
  trustType?: InputMaybe<Scalars["String"]["input"]>;
  trusteeCustodian?: InputMaybe<Scalars["String"]["input"]>;
};

export type InheritanceRegistryType = {
  __typename?: "InheritanceRegistryType";
  accountFundName: Scalars["String"]["output"];
  allocationPercentage?: Maybe<Scalars["Decimal"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  currentAdvisorGrantor: Scalars["String"]["output"];
  dafSponsor: Scalars["String"]["output"];
  documents?: Maybe<Array<Maybe<InheritanceDocumentType>>>;
  ein: Scalars["String"]["output"];
  estimatedValue?: Maybe<Scalars["Decimal"]["output"]>;
  foundationType: Scalars["String"]["output"];
  fundEntityName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  isDeleted: Scalars["Boolean"]["output"];
  lastConfirmed?: Maybe<Scalars["Date"]["output"]>;
  relation: Scalars["String"]["output"];
  restrictions?: Maybe<Array<Maybe<InheritanceRestrictionType>>>;
  sourceType?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  trustType: Scalars["String"]["output"];
  trusteeCustodian: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type InheritanceRestrictionInput = {
  causeAreaAllocation?: InputMaybe<Scalars["GenericScalar"]["input"]>;
  restriction: Scalars["String"]["input"];
};

export type InheritanceRestrictionType = {
  __typename?: "InheritanceRestrictionType";
  causeAreaAllocation?: Maybe<Scalars["GenericScalar"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  restriction: Scalars["String"]["output"];
};

/** Step 1 (email path): validate bot signals, create user, send OTP, return temp JWT. */
export type InitiateEmailSignup = {
  __typename?: "InitiateEmailSignup";
  failureReason?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  redactedEmail?: Maybe<Scalars["String"]["output"]>;
  tempToken?: Maybe<Scalars["String"]["output"]>;
};

/**
 * Kick off a Goldman Sachs book-of-business import using service-level credentials
 * stored in Django settings (GS_CLIENT_ID / GS_CLIENT_SECRET).
 * The advisor's GS loginId is collected from the UI and stored per-advisor.
 * The firm must have the 'gs_book_of_business_enabled' feature flag set to True.
 */
export type InitiateGoldmanSachsIntegration = {
  __typename?: "InitiateGoldmanSachsIntegration";
  jobId?: Maybe<Scalars["Int"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * Initiate a GS custodial DAF account opening for a given family.
 *
 * Gating requirements (enforced server-side):
 *   - The advisor's firm must have the 'gs_book_of_business_enabled' feature flag.
 *   - The advisor must have GS credentials stored on the server.
 *   - The family's advisorDaf custodian must be Goldman Sachs.
 *
 * Creates a GsDafAccountApplication record and enqueues the `open_gs_daf_account`
 * Celery task which drives the multi-step GS onboarding workflow.
 */
export type InitiateGsDafAccountOpening = {
  __typename?: "InitiateGsDafAccountOpening";
  applicationId?: Maybe<Scalars["Int"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Send Okta Verify push notification for login verification. */
export type InitiateOktaVerifyLogin = {
  __typename?: "InitiateOktaVerifyLogin";
  error?: Maybe<Scalars["String"]["output"]>;
  pollUrl?: Maybe<Scalars["String"]["output"]>;
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Step 1 (social path): verify Okta ID token (Google/Apple via Okta IdP), create/upsert user, return session JWT + prefill. */
export type InitiateSocialSignup = {
  __typename?: "InitiateSocialSignup";
  error?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  prefillEmail?: Maybe<Scalars["String"]["output"]>;
  prefillFirstName?: Maybe<Scalars["String"]["output"]>;
  prefillLastName?: Maybe<Scalars["String"]["output"]>;
  sessionToken?: Maybe<Scalars["String"]["output"]>;
};

/**
 * User: Advisor
 * Atomically initiates a succession transition for a family:
 *   1. Freezes the Louise DAF account (blocks new grants/contributions)
 *   2. Cancels all non-accepted family member invites (invite + pending statuses)
 *   3. Creates a SuccessionTransition record as the persistent lifecycle anchor
 * Returns the count of cancelled invites and the freeze timestamp.
 */
export type InitiateTransition = {
  __typename?: "InitiateTransition";
  cancelledCount?: Maybe<Scalars["Int"]["output"]>;
  freezeInitiatedAt?: Maybe<Scalars["String"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** For listing ach, wire and security transactions */
export type IntegratedContributionType = {
  __typename?: "IntegratedContributionType";
  achContributions?: Maybe<Array<Maybe<CashTransactionIntegeratedType>>>;
  securityTransactions?: Maybe<Array<Maybe<SecurityTransactionType>>>;
  thirdPartyTransactions?: Maybe<Array<Maybe<CashTransactionIntegeratedType>>>;
  wireTransactions?: Maybe<Array<Maybe<CashTransactionIntegeratedType>>>;
};

export type InternalCampaignDonation = {
  __typename?: "InternalCampaignDonation";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type InvestmentChangeRequestPaginatedType = {
  __typename?: "InvestmentChangeRequestPaginatedType";
  objects?: Maybe<Array<Maybe<InvestmentChangeRequestType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export type InvestmentChangeRequestType = {
  __typename?: "InvestmentChangeRequestType";
  id?: Maybe<Scalars["ID"]["output"]>;
  initiatedOn?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  targets?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
};

export enum InviteRoleTypeEnum {
  CorporateAdmin = "corporate_admin",
  FamilyMember = "family_member",
  HeadOfTheFamily = "head_of_the_family",
  SelfDirected = "self_directed",
}

export type ItemAccountType = {
  __typename?: "ItemAccountType";
  accountId?: Maybe<Scalars["String"]["output"]>;
  accountName?: Maybe<Scalars["String"]["output"]>;
  balance?: Maybe<Scalars["Decimal"]["output"]>;
  default: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  institutionName?: Maybe<Scalars["String"]["output"]>;
  mask?: Maybe<Scalars["String"]["output"]>;
  plaidItem?: Maybe<PlaidItemType>;
  verificationStatus?: Maybe<Scalars["String"]["output"]>;
};

/** Launch a new campaign for a specific charity.  */
export type LaunchCampaign = {
  __typename?: "LaunchCampaign";
  campaign?: Maybe<CampaignType>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type LegacyBlueprintType = {
  __typename?: "LegacyBlueprintType";
  coreValues?: Maybe<Scalars["GenericScalar"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  focusAreas?: Maybe<Array<Maybe<FocusAreaType>>>;
  geographicFocus?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  impactGoals?: Maybe<Array<Maybe<ImpactGoalType>>>;
  motivation: Scalars["String"]["output"];
  motivationTags?: Maybe<Scalars["GenericScalar"]["output"]>;
  personalConnection: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type LifetimeContributionType = {
  __typename?: "LifetimeContributionType";
  numberOfTransactions?: Maybe<Scalars["Int"]["output"]>;
  totalAmount?: Maybe<Scalars["Float"]["output"]>;
};

export type LinkTokenType = {
  __typename?: "LinkTokenType";
  expiration?: Maybe<Scalars["String"]["output"]>;
  linkToken?: Maybe<Scalars["String"]["output"]>;
};

export type LinkUserToPortfolios = {
  __typename?: "LinkUserToPortfolios";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type LinkedAccountPaginatedType = {
  __typename?: "LinkedAccountPaginatedType";
  objects?: Maybe<Array<Maybe<LinkedAccountType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type LinkedAccountType = {
  __typename?: "LinkedAccountType";
  accountId?: Maybe<Scalars["String"]["output"]>;
  accountNumber?: Maybe<Scalars["String"]["output"]>;
  appreciatedSecuritiesCount?: Maybe<Scalars["Int"]["output"]>;
  assets?: Maybe<Scalars["Float"]["output"]>;
  clientName?: Maybe<Scalars["String"]["output"]>;
  costBasis?: Maybe<Scalars["Float"]["output"]>;
  custodianName?: Maybe<Scalars["String"]["output"]>;
  hasGsOwners?: Maybe<Scalars["Boolean"]["output"]>;
  unrealizedGain?: Maybe<Scalars["Float"]["output"]>;
};

/** Response fields to have pagination for users list  */
export type ListAdvisorAssignType = {
  __typename?: "ListAdvisorAssignType";
  clientsManaged?: Maybe<Scalars["Int"]["output"]>;
  clientsSupported?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

/** Response fields to have pagination for cash contributions list  */
export type ListCashContributionsPaginatedType = {
  __typename?: "ListCashContributionsPaginatedType";
  count?: Maybe<Scalars["Int"]["output"]>;
  objects?: Maybe<Array<Maybe<CashTransactionIntegeratedType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

/** Response fields to have pagination for users list  */
export type ListClientAssignType = {
  __typename?: "ListClientAssignType";
  advisorName?: Maybe<Scalars["String"]["output"]>;
  fundName?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type ListStatusType = {
  __typename?: "ListStatusType";
  statuses?: Maybe<Array<Maybe<StatusType>>>;
  total?: Maybe<Scalars["Int"]["output"]>;
};

/** Response type for paginated transactions list */
export type ListTransactionsPaginatedType = {
  __typename?: "ListTransactionsPaginatedType";
  count?: Maybe<Scalars["Int"]["output"]>;
  objects?: Maybe<Array<Maybe<AllTransactionsType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

/**
 * The plan-derived figures for the advisor's Living Legacy dashboard.
 *
 * Clients Managed and Total Value are deliberately absent: those come from
 * advisorNewSummary so they reconcile with the "My Clients" view, and
 * duplicating them here would invite the two screens to drift apart again.
 *
 * These counts DO NOT partition `all_dafs`, and deliberately so -- they are
 * four independent answers to "how many of my DAFs are at this point", not
 * slices of one pie. A family whose plan is defined and is now mid-transition
 * is counted in both `legacy_plan_defined` and `in_transition`, because both
 * statements are true of it. The previous strip did partition (active_plans =
 * complete + in_progress + needs_review); anything relying on the cards summing
 * to the total no longer holds.
 *
 * `in_transition` and `transition_completed` are the only mutually exclusive
 * pair, and follow the same precedence as LivingLegacyPlanType.transition_state:
 * a family that has succeeded once and is mid-way through another counts as in
 * transition, not completed. That keeps a card consistent with the badge on the
 * row underneath it.
 */
export type LivingLegacyKpisType = {
  __typename?: "LivingLegacyKpisType";
  /** Every client DAF this advisor manages that is eligible for a Living Legacy plan: an active head of family, a created DAF account, and not a single-charity fund (an SCF is locked to one charity, so it has no succession plan). Same eligibility as livingLegacyPlans, so this is exactly the number of rows in the list beneath it. */
  allDafs?: Maybe<Scalars["Int"]["output"]>;
  /** DAFs with a succession transition currently scheduled, under review, initiated or in progress. Counts FAMILIES, not transitions: two active transitions on one family (not prevented at the DB level) is one DAF in transition. */
  inTransition?: Maybe<Scalars["Int"]["output"]>;
  /** DAFs where the legacy plan is defined: successors and/or beneficiaries are named AND their shares total exactly 100. A partly-allocated plan does not count -- the unallocated share has nowhere to go, and validate_succession_plan_ready would refuse to initiate a transition on it. Mirrors LivingLegacyPlanType.legacyPlanDefined, so this count and the per-row flag always agree. */
  legacyPlanDefined?: Maybe<Scalars["Int"]["output"]>;
  successors?: Maybe<Scalars["Int"]["output"]>;
  /** DAFs whose succession transition has finished. Aborted does not count -- that family can start again. Excludes families that have since begun another transition; those are counted in `in_transition`. */
  transitionCompleted?: Maybe<Scalars["Int"]["output"]>;
};

/** A DAF succession plan as surfaced on the advisor Living Legacy dashboard. */
export type LivingLegacyPlanType = {
  __typename?: "LivingLegacyPlanType";
  beneficiaryCount?: Maybe<Scalars["Int"]["output"]>;
  documentCount?: Maybe<Scalars["Int"]["output"]>;
  familyId?: Maybe<Scalars["Int"]["output"]>;
  founderName?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  /** A payout policy is set: an annual target, or a sunset timeframe. */
  impactVelocityDefined?: Maybe<Scalars["Boolean"]["output"]>;
  lastActivity?: Maybe<Scalars["String"]["output"]>;
  /** Successors and/or beneficiaries are named and their shares total 100%. */
  legacyPlanDefined?: Maybe<Scalars["Boolean"]["output"]>;
  /** Allocations exist under My Family. */
  myFamilyCompleted?: Maybe<Scalars["Boolean"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  progress?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  successorCount?: Maybe<Scalars["Int"]["output"]>;
  totalValue?: Maybe<Scalars["Float"]["output"]>;
  /** Where this family stands on succession: "active" while a transition is scheduled, under review, initiated or in progress; "completed" once one has finished; null if none has ever run. Aborted counts as null -- that family can start again. */
  transitionState?: Maybe<Scalars["String"]["output"]>;
};

/** Mutation to load portfolio  */
export type LoadPortfolio = {
  __typename?: "LoadPortfolio";
  ccPortfolioSummary?: Maybe<Scalars["GenericScalar"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** lock or unlock the connected accounts by owner  */
export type LockConnectedAccount = {
  __typename?: "LockConnectedAccount";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Blocklist the current social access token so it is immediately invalidated on logout. */
export type LogoutSocialUser = {
  __typename?: "LogoutSocialUser";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Portfolio type for the response  */
export type LouiseDafSummary = {
  __typename?: "LouiseDAFSummary";
  accountNumber?: Maybe<Scalars["String"]["output"]>;
  accumulatedContributions?: Maybe<Scalars["Decimal"]["output"]>;
  accumulatedGrants?: Maybe<Scalars["Decimal"]["output"]>;
  accumulatedYearlyContributions?: Maybe<Scalars["Decimal"]["output"]>;
  accumulatedYearlyGrants?: Maybe<Scalars["Decimal"]["output"]>;
  availableBalance?: Maybe<Scalars["Decimal"]["output"]>;
  availableBalanceToSpend?: Maybe<Scalars["Float"]["output"]>;
  benchmark?: Maybe<Scalars["String"]["output"]>;
  bps?: Maybe<Scalars["Int"]["output"]>;
  bpsAudit?: Maybe<Scalars["GenericScalar"]["output"]>;
  cashAvailableBalance?: Maybe<Scalars["String"]["output"]>;
  cashBalance?: Maybe<Scalars["String"]["output"]>;
  cashModel?: Maybe<Scalars["String"]["output"]>;
  confirmAmaAccount?: Maybe<Scalars["Boolean"]["output"]>;
  custodialVerified?: Maybe<Scalars["Boolean"]["output"]>;
  custodialVerifiedAt?: Maybe<Scalars["DateTime"]["output"]>;
  custodian?: Maybe<Scalars["String"]["output"]>;
  custodianContributionDetails?: Maybe<Scalars["GenericScalar"]["output"]>;
  custodianId?: Maybe<Scalars["Int"]["output"]>;
  dafId?: Maybe<Scalars["Int"]["output"]>;
  disableAllocations?: Maybe<Scalars["Boolean"]["output"]>;
  expectedReturns?: Maybe<Scalars["Decimal"]["output"]>;
  fundId?: Maybe<Scalars["String"]["output"]>;
  fundName?: Maybe<Scalars["String"]["output"]>;
  grossBalance?: Maybe<Scalars["Decimal"]["output"]>;
  investmentBalance?: Maybe<Scalars["String"]["output"]>;
  isCashOnly?: Maybe<Scalars["Boolean"]["output"]>;
  isSingleCharityFund?: Maybe<Scalars["Boolean"]["output"]>;
  managementFees?: Maybe<Scalars["Decimal"]["output"]>;
  metaData?: Maybe<Scalars["GenericScalar"]["output"]>;
  pendingContributions?: Maybe<Scalars["Decimal"]["output"]>;
  pendingGrants?: Maybe<Scalars["Decimal"]["output"]>;
  pendingTotalContributions?: Maybe<Scalars["Decimal"]["output"]>;
  pendingTotalGrants?: Maybe<Scalars["Decimal"]["output"]>;
  pendingYearlyGrants?: Maybe<Scalars["Decimal"]["output"]>;
  pendingYtdAdminFees?: Maybe<Scalars["Float"]["output"]>;
  pendingYtdAdvisorFees?: Maybe<Scalars["Float"]["output"]>;
  pendingYtdAumFees?: Maybe<Scalars["Float"]["output"]>;
  restrictedCharityEin?: Maybe<Scalars["String"]["output"]>;
  restrictedCharityId?: Maybe<Scalars["String"]["output"]>;
  restrictedCharityName?: Maybe<Scalars["String"]["output"]>;
  riskScore?: Maybe<Scalars["Int"]["output"]>;
  taxYears?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  totalAvailableBalance?: Maybe<Scalars["String"]["output"]>;
  totalBalance?: Maybe<Scalars["String"]["output"]>;
  totalGrantsCount?: Maybe<Scalars["Int"]["output"]>;
  volatility?: Maybe<Scalars["Decimal"]["output"]>;
  ytdAdminFees?: Maybe<Scalars["Float"]["output"]>;
  ytdAdvisorFees?: Maybe<Scalars["Float"]["output"]>;
  ytdAumFees?: Maybe<Scalars["Float"]["output"]>;
};

/** Louise Daf account input type */
export type LouiseDafAccountInputType = {
  dafCustodianId: Scalars["Int"]["input"];
  /** GS: donor is a director / 10% shareholder / policy executive at a public company. */
  directorOrTenPercentShareholder?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** GS: ticker list (e.g. AAPL) for public companies when directorOrTenPercentShareholder is true. */
  directorOrTenPercentShareholderCompany?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >;
  /** Unique identifier of the family in Louise database. */
  family?: InputMaybe<Scalars["Int"]["input"]>;
  /** GS: donor or immediate family is FINRA / securities-industry affiliated. */
  finraAffiliated?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Name of the fund to be reflected in DAF. Eg: <Your Family Name>'s Family Fund. */
  fundName: Scalars["String"]["input"];
  /** Whether the fund is single charity fund or not. */
  isSingleCharityFund?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** GS: donor or immediate family is a politically exposed person. */
  politicallyExposed?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Charity EIN to restrict the single charity fund to */
  restrictedCharityEin?: InputMaybe<Scalars["String"]["input"]>;
  /** Charity ID to restrict the the single charity fund to. */
  restrictedCharityId?: InputMaybe<Scalars["String"]["input"]>;
  /** Charity Name to restrict the the single charity fund to. */
  restrictedCharityName?: InputMaybe<Scalars["String"]["input"]>;
  successorContact: Scalars["String"]["input"];
  successorName: Scalars["String"]["input"];
};

/** Account Details with Institution, Account Name, Account Number, Balance etc. */
export type ManualAchInputType = {
  accountHolder: Scalars["String"]["input"];
  accountNum: Scalars["String"]["input"];
  institutionName: Scalars["String"]["input"];
  routing: Scalars["String"]["input"];
};

/** Create Security contributions in Amicus  */
export type ManualSecurityContribution = {
  __typename?: "ManualSecurityContribution";
  id?: Maybe<Scalars["Int"]["output"]>;
};

/** HoldingSummary input field type  */
export type ManualSecurityType = {
  costBasis?: InputMaybe<Scalars["Float"]["input"]>;
  price: Scalars["Float"]["input"];
  shares: Scalars["Float"]["input"];
  ticker: Scalars["String"]["input"];
  total: Scalars["Float"]["input"];
};

export type MemberInputType = {
  allocation?: InputMaybe<Scalars["Float"]["input"]>;
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  phoneNumber?: InputMaybe<Scalars["GenericScalar"]["input"]>;
  /** Title/prefix: MR, MRS, MS, MISS, DR, PROF */
  prefix?: InputMaybe<Scalars["String"]["input"]>;
  profilePic?: InputMaybe<Scalars["Upload"]["input"]>;
  relatedToHofId?: InputMaybe<Scalars["Int"]["input"]>;
  relations?: InputMaybe<Array<InputMaybe<RelationInputType>>>;
  role?: InputMaybe<InviteRoleTypeEnum>;
};

export type MemberPreferencesInputType = {
  allocatedAmount?: InputMaybe<Scalars["Decimal"]["input"]>;
  id: Scalars["Int"]["input"];
  role?: InputMaybe<InviteRoleTypeEnum>;
};

/** Fetching all meta data for a firm for the reviewer */
export type MetaDataType = {
  __typename?: "MetaDataType";
  isAmp?: Maybe<Scalars["Boolean"]["output"]>;
  metaData?: Maybe<Scalars["GenericScalar"]["output"]>;
};

export type ModelType = {
  __typename?: "ModelType";
  approved: Scalars["Boolean"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  portfolios: Array<AssetPoolType>;
  sponsor?: Maybe<SponsorType>;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type Mutation = {
  __typename?: "Mutation";
  /** Aprove company grant  */
  EditClientGrant?: Maybe<EditClientGrant>;
  /**
   * User: Advisor
   * Cancel an in-progress succession transition from Step 1 (before freeze is confirmed).
   * Reverses all automatic actions taken at initiation:
   *   1. Unfreezes the DAF account
   *   2. Marks the SuccessionTransition record as 'aborted'
   * Campaigns paused by the transition must be manually re-activated if applicable.
   * Family member invites are untouched -- step 1 never cancels them.
   */
  abortTransition?: Maybe<AbortTransition>;
  /** Accept Advisor Agreement Fee details  */
  acceptAdvisorFeeAgreement?: Maybe<AcceptAdvisorFeeAgreement>;
  acceptEmail?: Maybe<AcceptEmail>;
  /**
   * A successor accepts being named in a family's succession plan, from the
   * accept/decline screen shown at the start of successor onboarding.
   *
   * Post-login: the successor is identified by the Successor row's
   * family_member link, so a caller can only accept an invite that is their
   * own. Sets accepted_at and nothing else -- deliberately not the linked
   * User's invite_status, which is account-level and already flips to
   * 'accepted' merely on login (see Successor.accepted_at help_text), and no
   * percentage math, which is decline-only.
   *
   * accepted_at/declined_at are mutually exclusive; both null means invited but
   * undecided, which is exactly when the screen is shown (see the
   * mySuccessorInvite query in portfolio.schema).
   */
  acceptSuccessorInvite?: Maybe<AcceptSuccessorInvite>;
  /** Update terms & conditions of User  */
  acceptTnc?: Maybe<Accept_Tnc>;
  /** API to add multiple admin users to an existing family */
  addAdminUsersToFamily?: Maybe<AddAdminUsersToFamily>;
  addAdventIntegration?: Maybe<AddAdventIntegration>;
  /** Add Beneficiary contributions in Amicus  */
  addBeneficiary?: Maybe<AddBeneficiary>;
  /** Add family members to existing family  */
  addFamilyMember?: Maybe<AddFamilyMember>;
  /** Add existing family member as a successor  */
  addFamilyMemberSuccessor?: Maybe<AddFamilyMemberSuccessor>;
  /** API to add a family to an existing corporate firm */
  addFamilyToExistingFirm?: Maybe<AddFamilyToExistingFirm>;
  addFeaturedCharities?: Maybe<AddFeaturedCharities>;
  /**
   * Create DAF Account with Louise.
   * Requires contact details of the Head of the Family,
   * fund name and optional successor information.
   */
  addLouiseDafAccount?: Maybe<AddLouiseDafAccount>;
  /** Create new advisor user group  */
  addMembersToAdvisorUserGroup?: Maybe<AddMembersToAdvisorUserGroup>;
  /** Add a model to a family  */
  addModel?: Maybe<AddModel>;
  addParticipantFromFile?: Maybe<AddParticipantFromFile>;
  /** Add or remove TagCategory from firm */
  addRemoveTagcategory?: Maybe<AddRemoveTagCategory>;
  /** Add Successor contributions in Amicus  */
  addSuccessor?: Maybe<AddSuccessor>;
  /** API to add to funds table  */
  addToCharity?: Maybe<AddCharity>;
  /**
   * User: ops_admin
   * Run the daily step job for ONE family, right now -- the "Complete Step N"
   * button on the ops pipeline.
   *
   * Deliberately the job itself (run_succession_steps), not a hand-written
   * advance. The step's exit conditions, its emails, its transfers and its
   * beneficiary distributions all live in _advance_one, and a second way to move
   * a transition would be a second set of rules about when money may move. This
   * only changes WHEN the job runs, never what it does.
   *
   * So the side effects are real and intended: pressing this can send the freeze
   * confirmation, invite successors, or create beneficiary distributions. That is
   * the difference between this and the read-only pipeline view, which must never
   * do any of it.
   *
   * At most one step advances per call, because the job advances at most one per
   * run -- "Complete Step 4" moves the transition to step 5 and stops there.
   *
   * `expected_step` guards against a stale page: the button was labelled from
   * what the queue showed, and if the nightly job has moved the transition since,
   * completing "step 4" would silently complete step 5 instead.
   *
   * Refuses, with the reason, on the two states the job will not touch: a death
   * event whose certificate is still under review (ops approves that first, and
   * the transition begins there), and a voluntary transition scheduled for a
   * future date (process_scheduled_transitions activates it on the day -- a
   * different job from this one).
   */
  advanceSuccessionStep?: Maybe<AdvanceSuccessionStep>;
  /**
   * Stamp one of the successor-only onboarding steps as done.
   *
   * Covers the four steps that leave no other trace:
   *   founder_message  step 2 -- founder's voice shown (or skipped as empty)
   *   mission          step 4 -- originating family's mission reviewed
   *   acknowledgment   step 5 -- Successor Acknowledgment Form signed
   *   giving_history   step 6 -- founder's pinned giving history shown (or
   *                    skipped when nothing was pinned)
   *
   * Steps 1, 3 and 7 are not settable here: they already have real markers
   * (accepted_at/declined_at, curation rows, the destination DAF itself).
   *
   * Scoped by destination family, like every other successor-only step -- the
   * caller can only advance their own claim on that family. Idempotent: a repeat
   * call keeps the first timestamp, so a back-and-forward through the wizard does
   * not rewrite history.
   *
   * Ordering is enforced, not assumed: acknowledgment cannot be signed before the
   * invite is accepted. Without that, a client bug could create the destination
   * DAF with no consent on record -- and the transition's step 2/3 'resolved' test
   * reads DAF-exists as proof of consent.
   */
  advanceSuccessorOnboarding?: Maybe<AdvanceSuccessorOnboarding>;
  /** Aprove company grant  */
  approveClientGrant?: Maybe<ApproveClientGrant>;
  /** Aprove company grant  */
  approveCompanyGrant?: Maybe<ApproveCompanyGrant>;
  /**
   * User: ops_admin
   * Approve a pending death event transition after verifying the death certificate.
   * Moves the transition from under_review → initiated so the advisor can confirm Step 1.
   */
  approveDeathTransition?: Maybe<ApproveDeathTransition>;
  attachPaymentMethod?: Maybe<AttachPaymentMethod>;
  /** attest transactions API  */
  attestTransactions?: Maybe<AttestTransactions>;
  /** Cancel all cancelable securities in a batch. */
  bulkCancelSecurityTransactions?: Maybe<BulkCancelSecurityTransactions>;
  cancelCashMovement?: Maybe<CancelCashMovement>;
  /** Cancel a Grant request if it is still in pending status. */
  cancelGifts?: Maybe<CancelGifts>;
  cancelReallocationRebalance?: Maybe<CancelReallocationRebalance>;
  /** Cancel a scheduled contribution  */
  cancelScheduledContribution?: Maybe<CancelScheduledContribution>;
  /** cancel the transactions  */
  cancelTransactions?: Maybe<CancelTransactions>;
  /**
   * Cancel a single active grant or contribution during the Step 1 transition checklist.
   * Routes to the correct action based on item_type:
   *   - recurring_gift: deactivates the recurring gift
   *   - company_grant: rejects the pending advisor-created grant
   *   - contribution: cancels the pending one-time contribution
   */
  cancelTransitionItem?: Maybe<CancelTransitionItem>;
  /** Internal API used to set routine for nudge emails */
  changeNudgeRoutine?: Maybe<ChangeNudgeRoutine>;
  /** Change password for Profile information of User  */
  changePassword?: Maybe<ChangePassword>;
  closeCampaign?: Maybe<CloseCampaign>;
  /**
   * User: Advisor
   * Close a succession transition whose DAF has no balance to distribute.
   *
   * A succession moves the fund's balance to the named successors. With nothing
   * in the fund there is nothing to transfer, so the transition would run to
   * step 4 and wait there indefinitely for transfers that cannot arrive. Step 1
   * emails the advisor when it finds this; this is the way out.
   *
   * Marked COMPLETED rather than aborted. The transition ran its course -- there
   * simply was nothing to distribute -- and aborting would unfreeze the fund and
   * reverse the invites, implying it never happened. The account stays archived,
   * which is the correct end state for a fund that has been succeeded.
   *
   * Refuses while there is any balance. That is the whole premise, and closing a
   * funded transition here would strand the money with the account archived.
   */
  closeEmptyTransition?: Maybe<CloseEmptyTransition>;
  /**
   * Mutation to confirm AMA account opening by advisor.
   * Sets confirm_ama_account = True and optionally updates account_number.
   */
  confirmAmaAccount?: Maybe<ConfirmAmaAccount>;
  /**
   * User: Advisor
   * Confirm the freeze after the advisor has reviewed and actioned all active items
   * (grants, contributions, invites). Sets freeze_confirmed_at timestamp.
   */
  confirmDafFreeze?: Maybe<ConfirmDafFreeze>;
  /**
   * User: ops_admin
   * Accept that a succession transfer moved a different amount than expected.
   *
   * Step 4 requires the contributions landing in a successor's fund to total
   * exactly their share of the frozen balance. The custodian legitimately moves a
   * different figure -- fees, timing, a rounded wire -- so rather than absorbing
   * the difference with a tolerance nobody chose, the transfer waits here for an
   * admin to accept it explicitly.
   *
   * Deliberately narrow. It only unblocks an AMOUNT mismatch: a transfer that has
   * not arrived, or has not been received, is not something ops can confirm away
   * -- that money genuinely has not moved yet, and offering a button would invite
   * approving a payout that never happened.
   *
   * The confirmation is pinned to the amount accepted. If more money lands
   * afterwards the total changes and the transfer returns to this queue, rather
   * than passing on a stale approval.
   */
  confirmTransferVariance?: Maybe<ConfirmTransferVariance>;
  connectAchAccounts?: Maybe<ConnectAchAccounts>;
  connectCustodian?: Maybe<ConnectCustodian>;
  /** Connect Manual ACH Account  */
  connectManualAch?: Maybe<ConnectManualAch>;
  createAchPaymentIntent?: Maybe<CreateAchPaymentIntent>;
  /** Create new advisor user group  */
  createAdvisorUserGroup?: Maybe<CreateAdvisorUserGroup>;
  /** Create advisors from .csv or .xlsx file  */
  createAdvisors?: Maybe<CreateAdvisors>;
  /** Initiate a Cash transfer request from Savings account to DAF.  */
  createAmicusContribution?: Maybe<CreateAmicusContribution>;
  createCashMovement?: Maybe<CreateCashMovement>;
  /** Add gifts by Reviewer or RIA */
  createClientGrant?: Maybe<CreateClientGrant>;
  /** Add grant on behalf of Company */
  createCompanyGrant?: Maybe<CreateCompanyGrant>;
  /** Initiate a Credit Card contribution.  */
  createCreditCardContribution?: Maybe<CreateCreditCardContribution>;
  /** Onboard a client, and their family.  */
  createFamily?: Maybe<CreateFamily>;
  /** Onboard a client, their family and family members  */
  createFamilyAndMembers?: Maybe<CreateFamilyAndMembers>;
  /** API to create Firm with or without RIA  */
  createFirm?: Maybe<CreateFirm>;
  /** API to create Firm Users  */
  createFirmUsers?: Maybe<CreateFirmUsers>;
  /** Create a new inheritance registry entry for a family. */
  createInheritanceRegistry?: Maybe<CreateInheritanceRegistry>;
  createPaymentIntent?: Maybe<CreatePaymentIntent>;
  /**
   * Create or verify a primary advisor exists on Elevate platform and Okta.
   * Takes a family_id, retrieves the associated advisor, and ensures they exist
   * in both Okta and Elevate platforms. Creates them in Okta and/or Elevate if they don't exist.
   */
  createPrimaryAdvisorOnElevate?: Maybe<CreatePrimaryAdvisorOnElevate>;
  createSelfDirectedUser?: Maybe<CreateSelfDirectedUser>;
  createSetupIntent?: Maybe<CreateSetupIntent>;
  /** Create tags to each category  */
  createTag?: Maybe<CreateTag>;
  /** Create tag categories to enterprise  */
  createTagcategories?: Maybe<CreateTagCategories>;
  /** To create ThirdPartyAccountDetail. */
  createThirdpartyAccountDetail?: Maybe<CreateThirdPartyAccountDetail>;
  createUserPortfolioMapping?: Maybe<CreateUserPortfolioMapping>;
  /** Initiate a wire transfer request to DAF.  */
  createWireContribution?: Maybe<CreateWireContribution>;
  creditCardTransactionAmounts?: Maybe<CreditCardTransactionAmounts>;
  /**
   * A successor declines being named in a family's succession plan, from the
   * same accept/decline screen as AcceptSuccessorInvite.
   *
   * Post-login: the successor is identified by the Successor row's
   * family_member link, so a caller can only decline an invite that is their
   * own. (This was previously a token-authorized pre-login URL; the flow is
   * now entirely post-login, so the token was dropped.)
   *
   * Marks THIS Successor row as declined and zeroes its percentage --
   * deliberately not the linked User's invite_status, since for an existing
   * user (SendSuccessionInvites cases 1/2) that field also reflects their own
   * unrelated account status elsewhere. The declined percentage is
   * redistributed to the remaining successors in the same tier -- see
   * portfolio.utils.redistribute_declined_successor_percentage. When a whole
   * tier declines, the cascade to the next one (primaries → contingents →
   * beneficiaries) is handled at step 3 of the batch job instead, not here. The
   * originating family's advisor is notified.
   *
   * Step 2 of the succession batch job (core.tasks._advance_one) treats a
   * declined successor as resolved rather than waiting on their acceptance.
   */
  declineSuccessorInvite?: Maybe<DeclineSuccessorInvite>;
  /** Delete Beneficiary  Details  */
  deleteBeneficiary?: Maybe<DeleteBeneficiary>;
  deleteBunchingPlanDraft?: Maybe<DeleteBunchingPlanDraft>;
  deleteCampaign?: Maybe<DeleteCampaign>;
  /**
   * Delete an unfinished campaign draft (also called after a
   * successful publish, so the draft doesn't linger next to the real campaign).
   */
  deleteCampaignDraft?: Maybe<DeleteCampaignDraft>;
  /** Remove Family if don't have daf accout requested from advisor */
  deleteFamily?: Maybe<DeleteFamily>;
  /** Reset a firm's document override back to its enterprise/platform default. */
  deleteFirmDocument?: Maybe<DeleteFirmDocument>;
  /** Delete Uploaded firm Logo  */
  deleteFirmLogo?: Maybe<DeleteFirmLogo>;
  /** Delete a fund from the cart */
  deleteFromCart?: Maybe<DeleteFromCart>;
  /** Soft-delete a supporting document. */
  deleteInheritanceDocument?: Maybe<DeleteInheritanceDocument>;
  /** Soft-delete an inheritance registry entry. */
  deleteInheritanceRegistry?: Maybe<DeleteInheritanceRegistry>;
  /** API to delete delete a client invitation */
  deleteInvite?: Maybe<DeleteInvite>;
  /** Soft-delete a legacy document (shared InheritanceDocument model). */
  deleteLegacyDocument?: Maybe<DeleteLegacyDocument>;
  /** Cancel Recurring Gift */
  deleteRecurringGift?: Maybe<DeleteRecurringGift>;
  deleteRestrictedCharity?: Maybe<DeleteRestrictedCharity>;
  /** Delete Successor  Details  */
  deleteSuccessor?: Maybe<DeleteSuccessor>;
  /** Delete a tag from tagcategory */
  deleteTag?: Maybe<DeleteTag>;
  /** To Delete ThirdPartyAccountDetail. */
  deleteThirdpartyAccountDetail?: Maybe<DeleteThirdPartyAccountDetail>;
  delinkUserFromPortfolio?: Maybe<DelinkUserFromPortfolios>;
  detachPaymentMethod?: Maybe<DetachPaymentMethod>;
  /** API to disable a user */
  disableUser?: Maybe<DisableUser>;
  /** Disconnect the ClientCustodianPortfolio account  */
  disconnectCustodian?: Maybe<DisConnectCustodian>;
  /** Unlink the Savings Account from DAF. */
  disconnectSavingsAccount?: Maybe<DisconnectSavingsAccount>;
  /** Generate a presigned S3 download URL for a completed N8N envelope doc and mark it as downloaded. */
  downloadN8nLogDocument?: Maybe<DownloadN8NLogDocument>;
  /** Edit  DAF Details  */
  editAdvisorDaf?: Maybe<EditAdvisorDaf>;
  /** Edit Beneficiary  Details  */
  editBeneficiary?: Maybe<EditBeneficiary>;
  /** Edit the campaign with the given input id */
  editCampaign?: Maybe<EditCampaign>;
  /** Edit Campaign Details */
  editCampaignDetails?: Maybe<EditCampaignDetails>;
  /** Edit client details */
  editClientDetails?: Maybe<EditClientDetails>;
  /** Edit Donor details and client_type */
  editDonorDetails?: Maybe<EditDonorDetails>;
  /** Edit Family Details */
  editFamilyDetails?: Maybe<EditFamilyDetails>;
  /** To update the Grant note */
  editGrantNote?: Maybe<EditGrantNote>;
  /** Edit Profile information of User  */
  editNotificationPreferences?: Maybe<EditNotificationPreferences>;
  /** Edit Profile information of User  */
  editProfile?: Maybe<EditProfile>;
  /** Mutation that updates the email of pending self directed user, and resend an invite for the latest email. */
  editSelfDirectedEmail?: Maybe<EditSelfDirectedEmail>;
  /** Edit Successor  Details  */
  editSuccessor?: Maybe<EditSuccessor>;
  /** Update Employee allocation for unattached employee and invite */
  employeeAllocationAndInvite?: Maybe<EmployeeAllocationAndInvite>;
  /** Start Okta Verify push factor enrollment. Returns QR code + enrollment ID. */
  enrollOktaVerify?: Maybe<EnrollOktaVerify>;
  /** Create Okta-hosted TOTP factor. Returns shared secret + QR code data URL. */
  enrollTotp?: Maybe<EnrollTotp>;
  /** API to create favourites  */
  favourite?: Maybe<Favourite>;
  /**
   * Manual trigger for closing a succession transition's step 5: verifies the DAF
   * balance is $0 and every beneficiary distribution has cleared, then marks the
   * transition completed and unfreezes the DAF. Does NOT create distributions
   * itself -- those are created once by the daily batch job
   * (core.tasks._advance_one) as soon as the transition enters step 5. This is a
   * manual check of the exact same close condition the batch job verifies daily,
   * for an advisor who doesn't want to wait for the next run.
   */
  finalizeSuccessionTransition?: Maybe<FinalizeSuccessionTransition>;
  /**
   * User: Advisor
   * Freeze a family's Louise DAF account at the start of a succession transition.
   * Blocks new grants, contributions, and family member invites.
   */
  freezeDafAccount?: Maybe<FreezeDafAccount>;
  generateClientBunchingAnalysis?: Maybe<GenerateClientBunchingAnalysis>;
  generateClientTaxOptimisationResult?: Maybe<GenerateClientTaxOptimisationResult>;
  /** A generic mutation that takes in html and css and returns a base64 encoded pdf. */
  generatePdf?: Maybe<GeneratePdf>;
  /** Endpoint to generate downloadable base64 PDF content of user's signed Sub Advisory Agreement. */
  generateSubAdvisoryAgreement?: Maybe<GenerateSubAdvisoryAgreement>;
  generateTaxOptimiserPdf?: Maybe<GenerateTaxOptimiserPdf>;
  /** Fetch a fees report PDF from Elevate/Amicus and return it as a base64-encoded string for client-side download. */
  getFeeStatement?: Maybe<GetFeeStatement>;
  /** Fetch Individual Tax Receipt from Amicus(if available) and returns a base64 encoded string. This can be converted and downloaded as PDF. */
  getIndividualTaxReceipt?: Maybe<GetIndividualTaxReceipt>;
  /** Fetch Tax Receipt from Amicus(if available) and returns a base64 encoded string. This can be converted and downloaded as PDF. */
  getTaxReceipt?: Maybe<GetTaxReceipt>;
  /** Add a specific charity to user(family member)'s cart, edit the amount to be donated or send the donation request to advisor. */
  give?: Maybe<Give>;
  /** Mutation to perform actions on growth activities */
  growthActivityAction?: Maybe<GrowthActivityActionPayload>;
  /** Step 1 (email path): validate bot signals, create user, send OTP, return temp JWT. */
  initiateEmailSignup?: Maybe<InitiateEmailSignup>;
  /**
   * Kick off a Goldman Sachs book-of-business import using service-level credentials
   * stored in Django settings (GS_CLIENT_ID / GS_CLIENT_SECRET).
   * The advisor's GS loginId is collected from the UI and stored per-advisor.
   * The firm must have the 'gs_book_of_business_enabled' feature flag set to True.
   */
  initiateGoldmanSachsIntegration?: Maybe<InitiateGoldmanSachsIntegration>;
  /**
   * Initiate a GS custodial DAF account opening for a given family.
   *
   * Gating requirements (enforced server-side):
   *   - The advisor's firm must have the 'gs_book_of_business_enabled' feature flag.
   *   - The advisor must have GS credentials stored on the server.
   *   - The family's advisorDaf custodian must be Goldman Sachs.
   *
   * Creates a GsDafAccountApplication record and enqueues the `open_gs_daf_account`
   * Celery task which drives the multi-step GS onboarding workflow.
   */
  initiateGsDafAccountOpening?: Maybe<InitiateGsDafAccountOpening>;
  /** Send Okta Verify push notification for login verification. */
  initiateOktaVerifyLogin?: Maybe<InitiateOktaVerifyLogin>;
  /** Step 1 (social path): verify Okta ID token (Google/Apple via Okta IdP), create/upsert user, return session JWT + prefill. */
  initiateSocialSignup?: Maybe<InitiateSocialSignup>;
  /**
   * User: Advisor
   * Atomically initiates a succession transition for a family:
   *   1. Freezes the Louise DAF account (blocks new grants/contributions)
   *   2. Cancels all non-accepted family member invites (invite + pending statuses)
   *   3. Creates a SuccessionTransition record as the persistent lifecycle anchor
   * Returns the count of cancelled invites and the freeze timestamp.
   */
  initiateTransition?: Maybe<InitiateTransition>;
  internalCampaignDonation?: Maybe<InternalCampaignDonation>;
  /** Launch a new campaign for a specific charity.  */
  launchCampaign?: Maybe<LaunchCampaign>;
  linkUserToPortfolios?: Maybe<LinkUserToPortfolios>;
  /** Mutation to load portfolio  */
  loadPortfolio?: Maybe<LoadPortfolio>;
  /** lock or unlock the connected accounts by owner  */
  lockConnectedAccount?: Maybe<LockConnectedAccount>;
  /** Blocklist the current social access token so it is immediately invalidated on logout. */
  logoutSocialUser?: Maybe<LogoutSocialUser>;
  /** Create Security contributions in Amicus  */
  manualSecurityContribution?: Maybe<ManualSecurityContribution>;
  /**
   * Advisor-triggered reminder nudge for a successor who hasn't accepted (or
   * declined) their invite yet. Registered as a real NudgeRoutine
   * ('successor_invite_reminder', see core migration
   * 0138_seed_successor_invite_reminder_nudge_routine) -- same audience/sender
   * infrastructure (NUDGE_TYPE_AUDIENCE_FN_MAPPING/NUDGE_TYPE_EMAIL_SENDER_MAPPING,
   * UserNudge tracking) as every other nudge type in the system, so this manual
   * click respects the same eligibility window process_all_nudges would, and
   * the same routine could also fire automatically via that daily task.
   */
  nudgeSuccessorInvite?: Maybe<NudgeSuccessorInvite>;
  /** Return screening status: 'checking' | 'pass' | 'pending_review'. */
  pollOfacResult?: Maybe<PollOfacResult>;
  /** Poll Okta push approval. Returns 'waiting' | 'success' | 'error'. */
  pollOktaVerifyEnrollment?: Maybe<PollOktaVerifyEnrollment>;
  /** Poll Okta Verify push result. Returns 'waiting', 'success', or 'rejected'. */
  pollOktaVerifyLogin?: Maybe<PollOktaVerifyLogin>;
  publicCampaignAchDonation?: Maybe<PublicCampaignAchDonation>;
  publicCampaignDonation?: Maybe<PublicCampaignDonation>;
  publicCreateSelfDirectedUser?: Maybe<PublicCreateSelfDirectedUser>;
  /** API to reactivate a user */
  reactivateUser?: Maybe<ReactivateUser>;
  /** Replacing advisor group with new advisor group to the family */
  reassignAdvisorGroupToFamily?: Maybe<ReassignAdvisorGroupToFamily>;
  /** Replacing primary advisor with new advisor to the family */
  reassignPrimaryAdvisorToFamily?: Maybe<ReassignPrimaryAdvisorToFamily>;
  refreshToken?: Maybe<Refresh>;
  /** Accept the invitaion email, and register with Louise(Family Members). */
  registerMember?: Maybe<RegisterMember>;
  /** Accept the terms for an HOH who signs in through the firm's SSO. No password or Okta user. */
  registerMemberForDonorSso?: Maybe<RegisterMemberForDonorSso>;
  /** Aprove company grant  */
  rejectClientGrant?: Maybe<RejectClientGrant>;
  /** Aprove company grant  */
  rejectCompanyGrant?: Maybe<RejectCompanyGrant>;
  /**
   * User: ops_admin
   * Reject a pending death event transition (e.g. certificate could not be verified).
   * Aborts the transition and unfreezes the DAF account.
   */
  rejectDeathTransition?: Maybe<RejectDeathTransition>;
  /** API to remove advisors from an advisor user group  */
  removeAdvisorsFromAdvisorUserGroup?: Maybe<RemoveAdvisorsFromAdvisorUserGroup>;
  /** Remove a bank account from the user  */
  removeBankAccount?: Maybe<RemoveBankAccount>;
  removeCache?: Maybe<RemoveCache>;
  removeCustomCharityImage?: Maybe<RemoveCustomCharityImage>;
  /** Remove a family from Louise database.  */
  removeFamily?: Maybe<RemoveFamily>;
  /** Remove families from an advisor user group  */
  removeFamilyIdsFromUserGroup?: Maybe<RemoveFamilyIDsFromUserGroup>;
  /** Mutation to remove the Louise DAF Account  */
  removeLouiseDaf?: Maybe<RemoveLouiseDaf>;
  /**
   * User: Advisor
   * Remove member from a family
   */
  removeMember?: Maybe<RemoveMember>;
  /** Remove a model from family  */
  removeModel?: Maybe<RemoveModel>;
  /** Mutation to remove the complete portfolio  */
  removePortfolio?: Maybe<RemovePortfolio>;
  /** remove Profile Image */
  removeProfilepic?: Maybe<RemoveProfilePic>;
  /**
   * API to remove/delete an advisor user group completely.
   * This will also remove all associated memberships and family associations.
   */
  removeUserGroup?: Maybe<RemoveUserGroup>;
  removeUserPortfolioMapping?: Maybe<RemoveUserPortfolioMapping>;
  /** Edit  DAF Details  */
  renameDaf?: Maybe<RenameDaf>;
  /** API to request ACH setup for a charity  */
  requestAchSetup?: Maybe<RequestAchSetup>;
  /** Send the review request again and restart the honoree's 30 days. */
  resendConsentRequest?: Maybe<ResendConsentRequest>;
  /** API to resend invite for pending user */
  resendInvite?: Maybe<ResendInvite>;
  /** Reset Password based on token  */
  resetPassword?: Maybe<ResetPassword>;
  /**
   * The honoree's answer to a tribute review request.
   *
   * Deliberately unauthenticated: the honoree may not be a user of the app. The
   * signed token in their emailed link is the credential, and it only ever
   * identifies one campaign.
   */
  respondCampaignConsent?: Maybe<RespondCampaignConsent>;
  runDeployments?: Maybe<RunDeployments>;
  /**
   * Run one of the five Living Legacy beat jobs on demand.
   *
   * Same shape as UpdateContributionStatuses: one endpoint, a string selecting
   * the job, so a new job is one branch rather than a new mutation. The jobs are
   * otherwise only reachable on their schedule, which for two of them is once a
   * year -- a missed 25 December would otherwise wait twelve months.
   *
   *     transitions       process_scheduled_transitions       (06:00 daily)
   *     steps             process_succession_steps            (06:30 daily)
   *     reminders         send_scheduled_transition_reminders (06:45 daily)
   *     payout            process_annual_payout_policy        (25 Dec)
   *     sunset_warnings   process_sunset_year_notifications   (01 Jan)
   *
   * Run SYNCHRONOUSLY, not via .delay(), unlike the contribution-status jobs
   * above. Those fan out over every family and the caller only needs to know the
   * work was queued; these are usually run against one family and the useful
   * answer is what happened -- how many advanced, whether a payout was made, why
   * a step is still blocked. A queued task can only answer "accepted".
   *
   * `family_id` narrows every job except `reminders`, whose task takes no family
   * (it selects on scheduled_date == today + 7, so there is nothing to narrow).
   *
   * REQUIRED for `payout`. The task treats family_id=None as "every family", and
   * a platform-wide grant run is not something that should sit behind an API
   * call -- one mis-click would post grants out of every client's DAF outside
   * the schedule. Ops can still do that deliberately from the management shell.
   *
   * `year` applies to `payout` only, to backfill a missed December. It does not
   * re-open a year already run: the unique (family, year) constraint on
   * AnnualPayoutRun is what prevents a double grant, so a year already present
   * is a no-op by design.
   */
  runSuccessionJob?: Maybe<RunSuccessionJob>;
  /** Save US address. Validates ZIP. Transitions to pending_ofac. */
  saveAddressStep?: Maybe<SaveAddressStep>;
  saveBookLevelSettings?: Maybe<SaveBookLevelSettings>;
  saveBunchingPlanDraft?: Maybe<SaveBunchingPlanDraft>;
  /**
   * Create or update an unfinished campaign draft.
   *
   * Deliberately validation-free (beyond type/ownership checks): a draft is
   * allowed to be half-empty or invalid — full template validation runs in
   * LaunchCampaign when the user actually publishes.
   */
  saveCampaignDraft?: Maybe<SaveCampaignDraft>;
  saveClientLevelSettings?: Maybe<SaveClientLevelSettings>;
  /** Save first name, last name, DOB. Validates 18+. Transitions to pending_address. */
  saveIdentityStep?: Maybe<SaveIdentityStep>;
  selfServiceDafInvite?: Maybe<SelfServiceDafInvite>;
  /** Send invite email to the user  */
  sendInviteMail?: Maybe<SendInviteMail>;
  /**
   * User: ops_admin
   *
   * Invites a new ops admin by email: creates (or upgrades) the User row and
   * grants the role, then emails a set-password link via
   * core.utils.invites.send_ops_admin_invite.
   *
   * Every other role is granted by an invite flow started by somebody who
   * already holds a role -- ops_admin had no such starting point, only the
   * create_ops_admin management command, which requires shell access and has
   * an operator choose (and hand off) the password themselves. This mutation
   * is that starting point for every ops_admin after the first: an existing
   * one can invite the next without anyone touching a password directly.
   * create_ops_admin remains how the very first one gets made in a fresh
   * environment, where no ops_admin yet exists to call this.
   *
   * Does not touch Okta -- that happens once the invitee actually submits a
   * password through ResetPassword's is_ops_admin() branch, the same moment
   * every other role provisions Okta.
   */
  sendOpsAdminInvite?: Maybe<SendOpsAdminInvite>;
  /**
   * For each primary successor: create a new Family + HoH user + AdvisorDAF
   * (inheriting custodian/bps from the originating family) -- the same flow
   * as createFamilyAndMembers, run unconditionally regardless of which of the
   * three cases below applies:
   *   1. Successor's email matches an existing User who already has an active
   *      (non-frozen) DAF elsewhere.
   *   2. Successor's email matches an existing User with no active DAF.
   *   3. Successor's email is brand new.
   * create_family() already sends the right base invite email per case
   * (hoh_invite for new accounts, existing_hoh_invite for existing ones). On
   * top of that, every case gets an additional notification carrying the
   * originating family's mission statement and this successor's allocation
   * (percentage + a dollar amount computed off the live DAF balance).
   */
  sendSuccessionInvites?: Maybe<SendSuccessionInvites>;
  /** Set curate search status to a family */
  setCurateSearchStatus?: Maybe<SetCurateSearchStatus>;
  /** Set a default bank account for the user  */
  setDefaultBankAccount?: Maybe<SetDefaultBankAccount>;
  setGivingPrivacyPreference?: Maybe<SetGivingPrivacyPreference>;
  /** Set include international charity to a family */
  setIncludeInternationalCharity?: Maybe<SetIncludeInternationalCharity>;
  /** Email path only: validate password, create Okta user. */
  setSignupPassword?: Maybe<SetSignupPassword>;
  /**
   * User: Family Member
   * Share the article to the family members
   */
  shareArticle?: Maybe<ShareArticle>;
  /** Share the Campaign to the members */
  shareCampaign?: Maybe<ShareCampaign>;
  /** Verify an Okta ID token (Google/Apple via Okta IdP) and return a Django JWT for existing active social users. */
  socialLogin?: Maybe<SocialLogin>;
  /** API to Update Fund asset Pool ratio   */
  submitTargetRatio?: Maybe<SubmitTargetRatio>;
  syncOptimiserSession?: Maybe<SyncOptimiserSession>;
  /** Obtain auth token by providing right credentials. */
  tokenAuth?: Maybe<ObtainJsonWebToken>;
  /** Endpoint to capture an IRA Contribution  */
  transferIraContribution?: Maybe<TransferIraContribution>;
  /** To contribute ThirdPartyAccountDetail. */
  transferThirdpartyContribution?: Maybe<TransferThirdPartyContribution>;
  /**
   * Manually re-trigger a book-of-business import using stored GS credentials.
   * Useful when the advisor has added new accounts at the custodian.
   */
  triggerGsBookOfBusinessImport?: Maybe<TriggerGsBookOfBusinessImport>;
  /** Internal API to trigger set up instructions to users having individual DAF in a company */
  triggerIndividualDafInvites?: Maybe<TriggerIndividualDafInvites>;
  /** Internal API to trigger admin invite for ineligible admins of a company */
  triggerIneligibleAdminInvite?: Maybe<TriggerIneligibleAdminInvite>;
  /** Enqueue OFAC Celery task. Returns screening_id (ofac_reference). */
  triggerOfacScreening?: Maybe<TriggerOfacScreening>;
  /**
   * Step 4: email the ops team the DAF-to-DAF transfers to move, with the amount
   * and receiving fund for each successor who has completed their own DAF setup.
   *
   * NOTIFICATION ONLY. This does not initiate a transfer or write any transfer
   * record -- ops moves the money at the custodian. Step 4 then completes once the
   * funds land in the receiving DAFs (see core.tasks._advance_one).
   *
   * Successors are included when they have not declined AND their destination
   * family has a LouiseDafAccount -- the same "resolved" test steps 2 and 3 use.
   * A successor with no fund yet has nowhere to receive money, so listing them
   * would put an unactionable row in front of ops.
   */
  triggerSuccessionTransferNotification?: Maybe<TriggerSuccessionTransferNotification>;
  /** API to remove favourite  */
  unfavourite?: Maybe<Unfavourite>;
  /**
   * User: Advisor
   * Lift the freeze on a family's DAF account (revert or complete transition).
   * Clears all freeze timestamps.
   */
  unfreezeDafAccount?: Maybe<UnfreezeDafAccount>;
  /**
   * Status update triggered by events from FE
   * Checks if the status is legit by verify with docusign APIs
   */
  updateAdventIntegrationStatus?: Maybe<UpdateAdventIntegrationStatus>;
  updateAdvisorAgentCodes?: Maybe<UpdateAdvisorAgentCodes>;
  /** advisor fees update API  */
  updateAdvisorFees?: Maybe<UpdateAdvisorFees>;
  updateAdvisorMapClient?: Maybe<UpdateAdvisorMapClient>;
  /** Update Annual Giving Goal for the family */
  updateAnnualGivingGoal?: Maybe<UpdateAnnualGivingGoal>;
  updateContributionStatus?: Maybe<UpdateContributionStatuses>;
  /** Update Curate list for a particular family. Takes in list of charities under a cause to enable/disable it. */
  updateCuration?: Maybe<UpdateCuration>;
  updateCustomFees?: Maybe<UpdateCustomFees>;
  /** API to update Firm primary color, secondary color, and logo */
  updateCustomizeTheme?: Maybe<UpdateCustomizeTheme>;
  updateDafDetails?: Maybe<UpdateDafDetails>;
  /** Update the default allocation for family members */
  updateDefaultAllocation?: Maybe<UpdateDefaultAllocation>;
  /** Update Donor allocation for unattached donor */
  updateDonorAllocation?: Maybe<UpdateDonorAllocation>;
  /** API to update email preferences of a firm  */
  updateEmailPreferences?: Maybe<UpdateEmailPreferences>;
  /** Update Employee allocation for unattached employee */
  updateEmployeeAllocation?: Maybe<UpdateEmployeeAllocation>;
  /** API for reviewers or enterprise admins to lock/unlock features for child firms */
  updateEnterpriseFeatureLocks?: Maybe<UpdateEnterpriseFeatureLocks>;
  /** Update family member details  */
  updateFamilyMember?: Maybe<UpdateFamilyMember>;
  /** Update the preferences for a family. */
  updateFamilyPreferences?: Maybe<UpdateFamilyPreferences>;
  /** Update Family Tree details */
  updateFamilyTree?: Maybe<UpdateFamilyTree>;
  /** Delete Uploaded firm Logo  */
  updateFirm?: Maybe<UpdateFirm>;
  updateGrantRationale?: Maybe<UpdateGrantRationale>;
  /**
   * Added as part of GIVE-4838 (https://magnifi-dev.atlassian.net/browse/GIVE-4838)
   *
   * Updates user group by group id. There is no other data that can be
   * updated for an user group, hence only the name is being updated currently. There
   * are additional endpoints to add and remove advisors/clients from the group. If
   * this changes in the future, this mutation can be updated to accommodate the same.
   * Simply accept more arguments and update the group data accordingly.
   */
  updateGroup?: Maybe<UpdateGroup>;
  /**
   * Advisor action on a queued import record.
   * Currently supports: skip (marks record as skipped, removing it from the review queue).
   */
  updateGsImportRecord?: Maybe<UpdateGsImportRecord>;
  /** Update an existing inheritance registry entry. */
  updateInheritanceRegistry?: Maybe<UpdateInheritanceRegistry>;
  /** Update the status of a registry entry. Sets last_confirmed to today when status is CONFIRMED. */
  updateInheritanceStatus?: Maybe<UpdateInheritanceStatus>;
  /** Update Mutation Script  */
  updateInvestments?: Maybe<UpdateInvestments>;
  updateLastLogin?: Maybe<UpdateLastLogin>;
  /**
   * Upsert a family's Legacy Blueprint (Philanthropic Values & Mission Vault).
   *
   * Creates the LivingLegacyPlan + LegacyBlueprint on first save. Only the
   * provided scalar/JSON fields are updated; `focus_areas` / `impact_goals`,
   * when supplied, fully replace the existing child rows (the wizard/cards send
   * the complete set).
   */
  updateLegacyBlueprint?: Maybe<UpdateLegacyBlueprint>;
  /** Update Mission Statement for the family. */
  updateMission?: Maybe<UpdateMission>;
  /** API to create financial advisor Optimise  */
  updateOptimise?: Maybe<UpdateOptimise>;
  updatePaymentIntent?: Maybe<UpdatePaymentIntent>;
  updatePinnedGivingHistory?: Maybe<UpdatePinnedGivingHistory>;
  /** Update an existing recurring gift by closing the old one and creating a new one */
  updateRecurringGift?: Maybe<UpdateRecurringGift>;
  /** Change password for Profile information of User  */
  updateRelationship?: Maybe<UpdateRelationship>;
  /** Update 'Risk' analytics for each model */
  updateRiskAnalytics?: Maybe<UpdateRiskAnalytics>;
  /** Update amount, frequency, or end date of a recurring ACH scheduled contribution. */
  updateScheduledContribution?: Maybe<UpdateScheduledContribution>;
  /**
   * Advisor: update the scheduled_date on a pending voluntary scheduled transition.
   * The new date must be a future business day. Sends a date_updated notification.
   */
  updateScheduledTransitionDate?: Maybe<UpdateScheduledTransitionDate>;
  /**
   * Upsert a family's payout & sunset policy (Policy & Sunset tab).
   *
   * Creates the LivingLegacyPlan + SuccessionPolicy on first save. Only the
   * provided fields are updated. Returns the policy with the live DAF context.
   */
  updateSuccessionPolicy?: Maybe<UpdateSuccessionPolicy>;
  /** Update the long term and short term taxes in each family */
  updateTaxTerms?: Maybe<UpdateTaxTerms>;
  uploadCustomCharityImage?: Maybe<UploadCustomCharityImage>;
  /** Upload External Giving History data via excel file  */
  uploadExternalGivingHistory?: Maybe<UploadExternalGivingHistory>;
  /** Upload a firm/enterprise-specific override for one of the static legal documents. */
  uploadFirmDocument?: Maybe<UploadFirmDocument>;
  /** Upload firm Logo */
  uploadFirmlogo?: Maybe<UploadFirmLogo>;
  /** Upload a supporting document for an inheritance registry entry. */
  uploadInheritanceDocument?: Maybe<UploadInheritanceDocument>;
  /**
   * Upload a family-owned legacy document (Living Legacy — Identity Vault).
   *
   * Writes to the shared InheritanceDocument model with `family` set and no
   * registry link.
   */
  uploadLegacyDocument?: Maybe<UploadLegacyDocument>;
  /** Upload Participant file in s3 bucket */
  uploadParticipantFile?: Maybe<UploadParticipantFile>;
  /** Mutation to upload portfolio  */
  uploadPortfolio?: Maybe<UploadPortfolio>;
  /** Upload Profile Image */
  uploadProfilepic?: Maybe<UploadProfilePic>;
  uploadRestrictedCharity?: Maybe<UploadRestrictedCharity>;
  /**
   * Bulk-upsert a family's sunset charity allocations.
   *
   * Replaces all existing rows for the family with the submitted list so the
   * frontend sends the complete set. Rows not in the new list are deleted.
   */
  upsertSunsetCharityAllocations?: Maybe<UpsertSunsetCharityAllocations>;
  /** Step 2 (email path): verify OTP, return 30-min session JWT. */
  verifyEmailOtp?: Maybe<VerifyEmailOtp>;
  verifyToken?: Maybe<Verify>;
  /** Verify TOTP OTP with Okta, activate account, return Okta token for cookie storage. */
  verifyTotpEnrollment?: Maybe<VerifyTotpEnrollment>;
  /** Verify TOTP code at login time via Okta. Does not change signup_status or mfa_enrolled. */
  verifyTotpLogin?: Maybe<VerifyTotpLogin>;
};

export type MutationEditClientGrantArgs = {
  amount?: InputMaybe<Scalars["Decimal"]["input"]>;
  anonymous?: InputMaybe<Scalars["Boolean"]["input"]>;
  clientGrantId: Scalars["Int"]["input"];
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  frequency?: InputMaybe<FrequencyChoices>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type MutationAbortTransitionArgs = {
  familyId: Scalars["Int"]["input"];
};

export type MutationAcceptEmailArgs = {
  accepted: Scalars["Boolean"]["input"];
  password?: InputMaybe<Scalars["String"]["input"]>;
  token: Scalars["String"]["input"];
};

export type MutationAcceptSuccessorInviteArgs = {
  successorId: Scalars["Int"]["input"];
};

export type MutationAddAdminUsersToFamilyArgs = {
  familyId: Scalars["Int"]["input"];
  firmId: Scalars["Int"]["input"];
  users: Array<InputMaybe<AdminUserInputType>>;
};

export type MutationAddAdventIntegrationArgs = {
  accountNumbers: Array<InputMaybe<Scalars["String"]["input"]>>;
  custodian: Scalars["String"]["input"];
};

export type MutationAddBeneficiaryArgs = {
  beneficiary: BeneficiaryInputType;
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationAddFamilyMemberArgs = {
  familyId: Scalars["Int"]["input"];
  userData: Array<InputMaybe<MemberInputType>>;
};

export type MutationAddFamilyMemberSuccessorArgs = {
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
  familyMemberId: Scalars["Int"]["input"];
  isContingent?: InputMaybe<Scalars["Boolean"]["input"]>;
  percentage: Scalars["Float"]["input"];
  relation?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationAddFamilyToExistingFirmArgs = {
  dafName: Scalars["String"]["input"];
  email?: InputMaybe<Scalars["String"]["input"]>;
  firmId: Scalars["Int"]["input"];
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  participantId?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  primaryAdmin?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationAddFeaturedCharitiesArgs = {
  charityList: Array<InputMaybe<Scalars["String"]["input"]>>;
  firmId: Scalars["Int"]["input"];
};

export type MutationAddLouiseDafAccountArgs = {
  accountHolder: DafAccountHolderInputType;
  louiseDafAccount: LouiseDafAccountInputType;
  successors?: InputMaybe<Array<InputMaybe<SuccessorInputType>>>;
};

export type MutationAddMembersToAdvisorUserGroupArgs = {
  advisorIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  groupId: Scalars["Int"]["input"];
};

export type MutationAddModelArgs = {
  modelId: Scalars["Int"]["input"];
};

export type MutationAddParticipantFromFileArgs = {
  companyId?: InputMaybe<Scalars["String"]["input"]>;
  sanityCheck?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationAddRemoveTagcategoryArgs = {
  active: Scalars["Boolean"]["input"];
  tagCategoryId: Scalars["Int"]["input"];
};

export type MutationAddSuccessorArgs = {
  createFamilyMember?: InputMaybe<Scalars["Boolean"]["input"]>;
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
  successor: SuccessorUpdateInputType;
};

export type MutationAddToCharityArgs = {
  address?: InputMaybe<AddressInputType>;
  ein: Scalars["String"]["input"];
  fundUrl?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  title: Scalars["String"]["input"];
};

export type MutationAdvanceSuccessionStepArgs = {
  expectedStep?: InputMaybe<Scalars["Int"]["input"]>;
  familyId: Scalars["Int"]["input"];
};

export type MutationAdvanceSuccessorOnboardingArgs = {
  familyId: Scalars["Int"]["input"];
  step: Scalars["String"]["input"];
};

export type MutationApproveClientGrantArgs = {
  clientGrantIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type MutationApproveCompanyGrantArgs = {
  companyGrantId: Scalars["Int"]["input"];
  newStartDate?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type MutationApproveDeathTransitionArgs = {
  familyId: Scalars["Int"]["input"];
  reviewNotes?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationAttachPaymentMethodArgs = {
  ccType?: InputMaybe<Scalars["String"]["input"]>;
  paymentMethodId: Scalars["String"]["input"];
};

export type MutationAttestTransactionsArgs = {
  achTransactionIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  familyId: Scalars["Int"]["input"];
  securityTransactionIds?: InputMaybe<
    Array<InputMaybe<Scalars["Int"]["input"]>>
  >;
  thirdpartyTransactionIds?: InputMaybe<
    Array<InputMaybe<Scalars["Int"]["input"]>>
  >;
  wiredTransactionIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type MutationBulkCancelSecurityTransactionsArgs = {
  transferReference: Scalars["String"]["input"];
};

export type MutationCancelCashMovementArgs = {
  cashMovementId: Scalars["ID"]["input"];
  fundId: Scalars["ID"]["input"];
};

export type MutationCancelGiftsArgs = {
  contributionId: Scalars["Int"]["input"];
};

export type MutationCancelReallocationRebalanceArgs = {
  fundId: Scalars["ID"]["input"];
  reallocationRebalanceId: Scalars["ID"]["input"];
};

export type MutationCancelScheduledContributionArgs = {
  accountType: TransactionAccountEnumType;
  scheduledContributionId: Scalars["Int"]["input"];
};

export type MutationCancelTransactionsArgs = {
  accountType: TransactionAccountEnumTypeV2;
  objectId?: InputMaybe<Scalars["String"]["input"]>;
  transferReference: Scalars["String"]["input"];
};

export type MutationCancelTransitionItemArgs = {
  familyId: Scalars["Int"]["input"];
  itemId: Scalars["Int"]["input"];
  itemType: Scalars["String"]["input"];
};

export type MutationChangeNudgeRoutineArgs = {
  name: Scalars["String"]["input"];
  nudgeExpiryDays?: InputMaybe<Scalars["Int"]["input"]>;
  nudgeExpiryHours?: InputMaybe<Scalars["Int"]["input"]>;
  nudgeExpiryMinutes?: InputMaybe<Scalars["Int"]["input"]>;
  nudgeExpiryWeeks?: InputMaybe<Scalars["Int"]["input"]>;
  nudgeFrequencyDays?: InputMaybe<Scalars["Int"]["input"]>;
  nudgeFrequencyHours?: InputMaybe<Scalars["Int"]["input"]>;
  nudgeFrequencyMinutes?: InputMaybe<Scalars["Int"]["input"]>;
  nudgeFrequencyWeeks?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationChangePasswordArgs = {
  newpassword: Scalars["String"]["input"];
  oldpassword: Scalars["String"]["input"];
};

export type MutationCloseCampaignArgs = {
  campaignId: Scalars["Int"]["input"];
};

export type MutationCloseEmptyTransitionArgs = {
  familyId: Scalars["Int"]["input"];
};

export type MutationConfirmAmaAccountArgs = {
  accountNumber?: InputMaybe<Scalars["String"]["input"]>;
  familyId: Scalars["Int"]["input"];
};

export type MutationConfirmDafFreezeArgs = {
  familyId: Scalars["Int"]["input"];
};

export type MutationConfirmTransferVarianceArgs = {
  notes?: InputMaybe<Scalars["String"]["input"]>;
  successorId: Scalars["Int"]["input"];
};

export type MutationConnectAchAccountsArgs = {
  familyId: Scalars["Int"]["input"];
  institutionId: Scalars["String"]["input"];
  publicToken: Scalars["String"]["input"];
};

export type MutationConnectCustodianArgs = {
  accountNumber: Scalars["String"]["input"];
  clientAccountId: Scalars["String"]["input"];
  custodianId: Scalars["Int"]["input"];
  familyId: Scalars["Int"]["input"];
};

export type MutationConnectManualAchArgs = {
  accountDetails?: InputMaybe<ManualAchInputType>;
  familyId: Scalars["Int"]["input"];
};

export type MutationCreateAchPaymentIntentArgs = {
  amount: Scalars["Int"]["input"];
  contributorEmail: Scalars["String"]["input"];
  contributorName: Scalars["String"]["input"];
};

export type MutationCreateAdvisorUserGroupArgs = {
  advisorIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  familyIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  groupName: Scalars["String"]["input"];
};

export type MutationCreateAdvisorsArgs = {
  advisorsData: Array<InputMaybe<CreateAdvisorInputType>>;
  firmId: Scalars["Int"]["input"];
};

export type MutationCreateAmicusContributionArgs = {
  amount: Scalars["Decimal"]["input"];
  contributionDate: Scalars["DateTime"]["input"];
  contributionEndDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  contributor?: InputMaybe<Scalars["String"]["input"]>;
  familyId: Scalars["Int"]["input"];
  frequency: ContributionFrequencyChoices;
  itemAccountId: Scalars["Int"]["input"];
};

export type MutationCreateCashMovementArgs = {
  fromPool: Scalars["ID"]["input"];
  fundId: Scalars["ID"]["input"];
  requestValue: Scalars["Float"]["input"];
  toPool: Scalars["ID"]["input"];
};

export type MutationCreateClientGrantArgs = {
  clientGrantData?: InputMaybe<CompanyGrantInputType>;
  familyId: Scalars["Int"]["input"];
};

export type MutationCreateCompanyGrantArgs = {
  companyGrantData?: InputMaybe<CompanyGrantInputType>;
};

export type MutationCreateCreditCardContributionArgs = {
  amount: Scalars["Int"]["input"];
  contributionDate: Scalars["DateTime"]["input"];
  contributionEndDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  contributor: Scalars["String"]["input"];
  familyId: Scalars["Int"]["input"];
  frequency: ContributionFrequencyChoices;
  paymentIntentId: Scalars["String"]["input"];
};

export type MutationCreateFamilyArgs = {
  userData: Array<InputMaybe<ClientInputType>>;
};

export type MutationCreateFamilyAndMembersArgs = {
  advisorDaf: AdvisorDafInputType;
  client: ClientInputType;
  clientType?: InputMaybe<ClientTypesChoices>;
  members?: InputMaybe<Array<InputMaybe<MemberInputType>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type MutationCreateFirmArgs = {
  address?: InputMaybe<Scalars["GenericScalar"]["input"]>;
  allowedCustodians?: InputMaybe<Array<InputMaybe<AllowedCustodianType>>>;
  allowedFirmConfigurations?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >;
  companyDafLaunchDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  companyId?: InputMaybe<Scalars["String"]["input"]>;
  customDomain?: InputMaybe<Scalars["String"]["input"]>;
  eligibilityEmails?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  featureFlags?: InputMaybe<Scalars["GenericScalar"]["input"]>;
  firmConfiguration?: InputMaybe<Scalars["String"]["input"]>;
  firmLogo?: InputMaybe<Scalars["Upload"]["input"]>;
  firmName: Scalars["String"]["input"];
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  individualDafLaunchDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  isSelfSignup?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  managedBy?: InputMaybe<Scalars["Int"]["input"]>;
  oktaIssuer?: InputMaybe<Scalars["String"]["input"]>;
  parentFirmId?: InputMaybe<Scalars["Int"]["input"]>;
  participantId?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  pooledSetIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  primaryColour?: InputMaybe<Scalars["String"]["input"]>;
  programType?: InputMaybe<ProgramType>;
  role?: InputMaybe<Scalars["Int"]["input"]>;
  secondaryColour?: InputMaybe<Scalars["String"]["input"]>;
  taxId?: InputMaybe<Scalars["String"]["input"]>;
  tifinGiveAdmin?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationCreateFirmUsersArgs = {
  email: Scalars["String"]["input"];
  firmId: Scalars["Int"]["input"];
  firstName: Scalars["String"]["input"];
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  participantId?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  profilePic?: InputMaybe<Scalars["Upload"]["input"]>;
  role: Scalars["Int"]["input"];
};

export type MutationCreateInheritanceRegistryArgs = {
  familyId: Scalars["Int"]["input"];
  registryData: InheritanceRegistryInput;
};

export type MutationCreatePaymentIntentArgs = {
  amount: Scalars["Int"]["input"];
  ccType?: InputMaybe<Scalars["String"]["input"]>;
  chargePlatformFee?: InputMaybe<Scalars["Boolean"]["input"]>;
  paymentMethodId?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreatePrimaryAdvisorOnElevateArgs = {
  familyId: Scalars["Int"]["input"];
};

export type MutationCreateSelfDirectedUserArgs = {
  email: Scalars["String"]["input"];
};

export type MutationCreateSetupIntentArgs = {
  ccType?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateTagArgs = {
  tagCategoryId: Scalars["Int"]["input"];
  tagName: Scalars["String"]["input"];
};

export type MutationCreateTagcategoriesArgs = {
  categories: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type MutationCreateThirdpartyAccountDetailArgs = {
  familyId: Scalars["Int"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  source: Scalars["String"]["input"];
  sponsorId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationCreateUserPortfolioMappingArgs = {
  portfolioCodes: Array<InputMaybe<Scalars["String"]["input"]>>;
  userId: Scalars["ID"]["input"];
};

export type MutationCreateWireContributionArgs = {
  amount: Scalars["Decimal"]["input"];
  contributor: Scalars["String"]["input"];
  contributorMetadata?: InputMaybe<ContributorMetadataInputType>;
  familyId: Scalars["Int"]["input"];
};

export type MutationCreditCardTransactionAmountsArgs = {
  contributionAmount: Scalars["Decimal"]["input"];
  isChargeAmount?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationDeclineSuccessorInviteArgs = {
  reason?: InputMaybe<Scalars["String"]["input"]>;
  successorId: Scalars["Int"]["input"];
};

export type MutationDeleteBeneficiaryArgs = {
  beneficiaryId: Scalars["Int"]["input"];
};

export type MutationDeleteBunchingPlanDraftArgs = {
  portfolioCode: Scalars["String"]["input"];
};

export type MutationDeleteCampaignArgs = {
  campaignId: Scalars["Int"]["input"];
};

export type MutationDeleteCampaignDraftArgs = {
  draftId: Scalars["Int"]["input"];
};

export type MutationDeleteFamilyArgs = {
  familyId: Scalars["Int"]["input"];
};

export type MutationDeleteFirmDocumentArgs = {
  documentType: Scalars["String"]["input"];
  firmId: Scalars["Int"]["input"];
};

export type MutationDeleteFromCartArgs = {
  cartId: Scalars["Int"]["input"];
};

export type MutationDeleteInheritanceDocumentArgs = {
  documentId: Scalars["Int"]["input"];
};

export type MutationDeleteInheritanceRegistryArgs = {
  registryId: Scalars["Int"]["input"];
};

export type MutationDeleteInviteArgs = {
  familyId: Scalars["Int"]["input"];
};

export type MutationDeleteLegacyDocumentArgs = {
  documentId: Scalars["Int"]["input"];
};

export type MutationDeleteRecurringGiftArgs = {
  contributionId?: InputMaybe<Scalars["Int"]["input"]>;
  deleteType: GiftDeleteTypeEnum;
  recurringGiftId: Scalars["Int"]["input"];
};

export type MutationDeleteRestrictedCharityArgs = {
  eins?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  familyId: Scalars["Int"]["input"];
  reset?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationDeleteSuccessorArgs = {
  successorId: Scalars["Int"]["input"];
};

export type MutationDeleteTagArgs = {
  tagId: Scalars["Int"]["input"];
};

export type MutationDeleteThirdpartyAccountDetailArgs = {
  pkId: Scalars["Int"]["input"];
};

export type MutationDelinkUserFromPortfolioArgs = {
  portfolioId?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationDetachPaymentMethodArgs = {
  ccType?: InputMaybe<Scalars["String"]["input"]>;
  paymentMethodId: Scalars["String"]["input"];
};

export type MutationDisableUserArgs = {
  firmId: Scalars["Int"]["input"];
  userId: Scalars["Int"]["input"];
};

export type MutationDisconnectCustodianArgs = {
  custodianId: Scalars["Int"]["input"];
};

export type MutationDisconnectSavingsAccountArgs = {
  plaidItemId: Scalars["Int"]["input"];
};

export type MutationDownloadN8nLogDocumentArgs = {
  logId: Scalars["String"]["input"];
};

export type MutationEditAdvisorDafArgs = {
  bps?: InputMaybe<Scalars["Int"]["input"]>;
  custodianId?: InputMaybe<Scalars["Int"]["input"]>;
  familyId: Scalars["Int"]["input"];
  fundName?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationEditBeneficiaryArgs = {
  beneficiary: BeneficiaryInputType;
  beneficiaryId: Scalars["Int"]["input"];
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationEditCampaignArgs = {
  campaignId: Scalars["Int"]["input"];
  changes?: InputMaybe<EditCampaignInputType>;
};

export type MutationEditCampaignDetailsArgs = {
  campaignId: Scalars["Int"]["input"];
  goal?: InputMaybe<Scalars["Decimal"]["input"]>;
  message?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationEditClientDetailsArgs = {
  advisorDaf?: InputMaybe<UpdateAdvisorDafInputType>;
  client?: InputMaybe<UpdateClientInputType>;
  clientType?: InputMaybe<ClientTypesChoices>;
  familyId: Scalars["Int"]["input"];
  louiseDaf?: InputMaybe<UpdateLouiseDafInputType>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type MutationEditDonorDetailsArgs = {
  clientType?: InputMaybe<ClientTypesChoices>;
  donorData: UpdateMemberInputType;
  donorId: Scalars["Int"]["input"];
  familyId: Scalars["Int"]["input"];
  tagIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type MutationEditFamilyDetailsArgs = {
  details: FamilyInputType;
  familyId: Scalars["Int"]["input"];
};

export type MutationEditGrantNoteArgs = {
  grantId: Scalars["Int"]["input"];
  updatedNote: Scalars["String"]["input"];
};

export type MutationEditNotificationPreferencesArgs = {
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
  notificationPreferences: NotificationPreferenceInputType;
};

export type MutationEditProfileArgs = {
  tagIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  userData?: InputMaybe<ProfileInputType>;
};

export type MutationEditSelfDirectedEmailArgs = {
  email: Scalars["String"]["input"];
  token?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationEditSuccessorArgs = {
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
  successor: SuccessorUpdateInputType;
  successorId: Scalars["Int"]["input"];
};

export type MutationEmployeeAllocationAndInviteArgs = {
  allocateAmount: Scalars["Float"]["input"];
  selectAll?: InputMaybe<Scalars["Boolean"]["input"]>;
  userIds: Array<InputMaybe<Scalars["Int"]["input"]>>;
};

export type MutationEnrollOktaVerifyArgs = {
  isFamilyMember?: InputMaybe<Scalars["Boolean"]["input"]>;
  sessionToken: Scalars["String"]["input"];
};

export type MutationEnrollTotpArgs = {
  isFamilyMember?: InputMaybe<Scalars["Boolean"]["input"]>;
  sessionToken: Scalars["String"]["input"];
};

export type MutationFavouriteArgs = {
  charityId: Scalars["String"]["input"];
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationFinalizeSuccessionTransitionArgs = {
  familyId: Scalars["Int"]["input"];
};

export type MutationFreezeDafAccountArgs = {
  familyId: Scalars["Int"]["input"];
};

export type MutationGenerateClientBunchingAnalysisArgs = {
  givingPattern: BunchingGivingPatternInputType;
  portfolioCode: Scalars["String"]["input"];
  taxProfile: BunchingTaxProfileInputType;
};

export type MutationGenerateClientTaxOptimisationResultArgs = {
  portfolioCode: Scalars["String"]["input"];
};

export type MutationGeneratePdfArgs = {
  css?: InputMaybe<Scalars["String"]["input"]>;
  html?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationGenerateTaxOptimiserPdfArgs = {
  css?: InputMaybe<Scalars["String"]["input"]>;
  hohId?: InputMaybe<Scalars["String"]["input"]>;
  html?: InputMaybe<Scalars["String"]["input"]>;
  sendEmailToClient?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationGetFeeStatementArgs = {
  endDate: Scalars["String"]["input"];
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  periodLabel: Scalars["String"]["input"];
  startDate: Scalars["String"]["input"];
};

export type MutationGetIndividualTaxReceiptArgs = {
  contributionReference: Scalars["String"]["input"];
  contributionType: Scalars["String"]["input"];
};

export type MutationGetTaxReceiptArgs = {
  contributor?: InputMaybe<Scalars["String"]["input"]>;
  designateName?: InputMaybe<Scalars["String"]["input"]>;
  familyId: Scalars["Int"]["input"];
  year?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationGiveArgs = {
  cartData?: InputMaybe<CartInputType>;
  familyId: Scalars["Int"]["input"];
};

export type MutationGrowthActivityActionArgs = {
  input: GrowthActivityActionInput;
};

export type MutationInitiateEmailSignupArgs = {
  email: Scalars["String"]["input"];
  honeypotValue?: InputMaybe<Scalars["String"]["input"]>;
  recaptchaToken: Scalars["String"]["input"];
  turnstileToken: Scalars["String"]["input"];
};

export type MutationInitiateGoldmanSachsIntegrationArgs = {
  loginId: Scalars["String"]["input"];
};

export type MutationInitiateGsDafAccountOpeningArgs = {
  familyId: Scalars["Int"]["input"];
  fundName?: InputMaybe<Scalars["String"]["input"]>;
  hohFirstName: Scalars["String"]["input"];
  hohLastName: Scalars["String"]["input"];
  hohLoginId: Scalars["String"]["input"];
};

export type MutationInitiateSocialSignupArgs = {
  honeypotValue?: InputMaybe<Scalars["String"]["input"]>;
  oktaToken: Scalars["String"]["input"];
  provider: Scalars["String"]["input"];
  recaptchaToken: Scalars["String"]["input"];
  turnstileToken: Scalars["String"]["input"];
};

export type MutationInitiateTransitionArgs = {
  certificateFile?: InputMaybe<Scalars["Upload"]["input"]>;
  familyId: Scalars["Int"]["input"];
  scheduledDate?: InputMaybe<Scalars["Date"]["input"]>;
  triggerType: Scalars["String"]["input"];
  voluntaryMode?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationInternalCampaignDonationArgs = {
  amount: Scalars["Decimal"]["input"];
  campaignId: Scalars["String"]["input"];
  contributor?: InputMaybe<Scalars["String"]["input"]>;
  contributorEmail: Scalars["String"]["input"];
  familyId: Scalars["Int"]["input"];
  isAnonymous?: InputMaybe<Scalars["Boolean"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationLaunchCampaignArgs = {
  bannerImage?: InputMaybe<Scalars["GenericScalar"]["input"]>;
  campaignImage?: InputMaybe<Scalars["GenericScalar"]["input"]>;
  campaignType?: InputMaybe<Scalars["String"]["input"]>;
  charityId: Scalars["String"]["input"];
  charityLink?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  endIfGoalCompleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  endOnFinalDay?: InputMaybe<Scalars["Boolean"]["input"]>;
  familyId: Scalars["Int"]["input"];
  goal?: InputMaybe<Scalars["Decimal"]["input"]>;
  message?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  templateData?: InputMaybe<Scalars["GenericScalar"]["input"]>;
  thirdImage?: InputMaybe<Scalars["GenericScalar"]["input"]>;
  title: Scalars["String"]["input"];
};

export type MutationLinkUserToPortfoliosArgs = {
  hohId?: InputMaybe<Scalars["String"]["input"]>;
  portfolioIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type MutationLoadPortfolioArgs = {
  familyId: Scalars["Int"]["input"];
};

export type MutationLockConnectedAccountArgs = {
  accountId: Scalars["Int"]["input"];
  accountType: TransactionAccountEnumType;
  locked: Scalars["Boolean"]["input"];
};

export type MutationManualSecurityContributionArgs = {
  account?: InputMaybe<AccountInputType>;
  contributor: Scalars["String"]["input"];
  contributorMetadata?: InputMaybe<ContributorMetadataInputType>;
  donations: Array<InputMaybe<ManualSecurityType>>;
  securityTransactionType?: InputMaybe<SecurityTransactionTypeChoices>;
};

export type MutationNudgeSuccessorInviteArgs = {
  successorId: Scalars["Int"]["input"];
};

export type MutationPollOfacResultArgs = {
  screeningId: Scalars["String"]["input"];
  sessionToken: Scalars["String"]["input"];
};

export type MutationPollOktaVerifyEnrollmentArgs = {
  enrollmentId: Scalars["String"]["input"];
  isFamilyMember?: InputMaybe<Scalars["Boolean"]["input"]>;
  sessionToken: Scalars["String"]["input"];
};

export type MutationPollOktaVerifyLoginArgs = {
  pollUrl: Scalars["String"]["input"];
};

export type MutationPublicCampaignAchDonationArgs = {
  amount: Scalars["Decimal"]["input"];
  campaignId: Scalars["String"]["input"];
  contributor: Scalars["String"]["input"];
  contributorEmail: Scalars["String"]["input"];
  isAnonymous?: InputMaybe<Scalars["Boolean"]["input"]>;
  isMicroDeposit?: InputMaybe<Scalars["Boolean"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  paymentIntentId: Scalars["String"]["input"];
};

export type MutationPublicCampaignDonationArgs = {
  amount: Scalars["Decimal"]["input"];
  campaignId: Scalars["String"]["input"];
  contributor: Scalars["String"]["input"];
  contributorEmail: Scalars["String"]["input"];
  isAnonymous?: InputMaybe<Scalars["Boolean"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  paymentIntentId: Scalars["String"]["input"];
};

export type MutationPublicCreateSelfDirectedUserArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  token: Scalars["String"]["input"];
};

export type MutationReactivateUserArgs = {
  firmId: Scalars["Int"]["input"];
  userId: Scalars["Int"]["input"];
};

export type MutationReassignAdvisorGroupToFamilyArgs = {
  familyId: Scalars["Int"]["input"];
  groupId: Scalars["Int"]["input"];
};

export type MutationReassignPrimaryAdvisorToFamilyArgs = {
  advisorId: Scalars["Int"]["input"];
  familyId: Scalars["Int"]["input"];
};

export type MutationRefreshTokenArgs = {
  token?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationRegisterMemberArgs = {
  acceptedSubAdvisorFeeAgreement?: InputMaybe<Scalars["Boolean"]["input"]>;
  dob?: InputMaybe<Scalars["Date"]["input"]>;
  password: Scalars["String"]["input"];
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  token: Scalars["String"]["input"];
  zipcode?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationRejectClientGrantArgs = {
  clientGrantId: Scalars["Int"]["input"];
};

export type MutationRejectCompanyGrantArgs = {
  companyGrantId: Scalars["Int"]["input"];
};

export type MutationRejectDeathTransitionArgs = {
  familyId: Scalars["Int"]["input"];
  reason: Scalars["String"]["input"];
};

export type MutationRemoveAdvisorsFromAdvisorUserGroupArgs = {
  advisorIds: Array<InputMaybe<Scalars["Int"]["input"]>>;
  groupId: Scalars["Int"]["input"];
};

export type MutationRemoveBankAccountArgs = {
  itemAccountId: Scalars["String"]["input"];
};

export type MutationRemoveCacheArgs = {
  prefixes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type MutationRemoveCustomCharityImageArgs = {
  charityId: Scalars["String"]["input"];
};

export type MutationRemoveFamilyArgs = {
  familyId: Scalars["Int"]["input"];
};

export type MutationRemoveFamilyIdsFromUserGroupArgs = {
  familyIds: Array<InputMaybe<Scalars["Int"]["input"]>>;
  groupId: Scalars["Int"]["input"];
};

export type MutationRemoveLouiseDafArgs = {
  familyId: Scalars["Int"]["input"];
};

export type MutationRemoveMemberArgs = {
  familyId: Scalars["Int"]["input"];
  inviteStatus?: InputMaybe<Scalars["String"]["input"]>;
  memberId: Scalars["Int"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationRemoveModelArgs = {
  modelId: Scalars["Int"]["input"];
};

export type MutationRemovePortfolioArgs = {
  accountId: Scalars["Int"]["input"];
};

export type MutationRemoveUserGroupArgs = {
  groupId: Scalars["Int"]["input"];
};

export type MutationRemoveUserPortfolioMappingArgs = {
  portfolioCode: Scalars["String"]["input"];
  userId: Scalars["ID"]["input"];
};

export type MutationRenameDafArgs = {
  dafName: Scalars["String"]["input"];
  familyId: Scalars["Int"]["input"];
};

export type MutationRequestAchSetupArgs = {
  address?: InputMaybe<Scalars["String"]["input"]>;
  charityId: Scalars["String"]["input"];
  charityName: Scalars["String"]["input"];
  contactEmail: Scalars["String"]["input"];
  contactName: Scalars["String"]["input"];
  contactPhone?: InputMaybe<Scalars["String"]["input"]>;
  ein?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationResendConsentRequestArgs = {
  campaignId: Scalars["Int"]["input"];
};

export type MutationResendInviteArgs = {
  userId: Scalars["Int"]["input"];
};

export type MutationResetPasswordArgs = {
  password: Scalars["String"]["input"];
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  token: Scalars["String"]["input"];
};

export type MutationRespondCampaignConsentArgs = {
  approve: Scalars["Boolean"]["input"];
  token: Scalars["String"]["input"];
};

export type MutationRunDeploymentsArgs = {
  tickets: Scalars["String"]["input"];
};

export type MutationRunSuccessionJobArgs = {
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
  job: Scalars["String"]["input"];
  year?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationSaveAddressStepArgs = {
  apt?: InputMaybe<Scalars["String"]["input"]>;
  city: Scalars["String"]["input"];
  sessionToken: Scalars["String"]["input"];
  state: Scalars["String"]["input"];
  street: Scalars["String"]["input"];
  zipCode: Scalars["String"]["input"];
};

export type MutationSaveBookLevelSettingsArgs = {
  maxContribution?: InputMaybe<Scalars["Float"]["input"]>;
  teError?: InputMaybe<Scalars["Float"]["input"]>;
  tickerLimit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationSaveBunchingPlanDraftArgs = {
  planData: Scalars["JSONString"]["input"];
  portfolioCode: Scalars["String"]["input"];
};

export type MutationSaveCampaignDraftArgs = {
  bannerImage?: InputMaybe<Scalars["GenericScalar"]["input"]>;
  campaignImage?: InputMaybe<Scalars["GenericScalar"]["input"]>;
  campaignType: Scalars["String"]["input"];
  draftId?: InputMaybe<Scalars["Int"]["input"]>;
  familyId: Scalars["Int"]["input"];
  formData: Scalars["GenericScalar"]["input"];
};

export type MutationSaveClientLevelSettingsArgs = {
  adventIntegratedPortfolioId: Scalars["String"]["input"];
  agi?: InputMaybe<Scalars["Float"]["input"]>;
  donationLimit?: InputMaybe<Scalars["Float"]["input"]>;
  filingStatus?: InputMaybe<Scalars["String"]["input"]>;
  restrictedSecurities?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >;
  targetTaxSavings?: InputMaybe<Scalars["Float"]["input"]>;
  taxProposalScenario?: InputMaybe<Scalars["String"]["input"]>;
  teError?: InputMaybe<Scalars["Float"]["input"]>;
  tickerLimit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationSaveIdentityStepArgs = {
  dob: Scalars["Date"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  sessionToken: Scalars["String"]["input"];
};

export type MutationSelfServiceDafInviteArgs = {
  email: Scalars["String"]["input"];
};

export type MutationSendInviteMailArgs = {
  familyId: Scalars["Int"]["input"];
  userIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type MutationSendOpsAdminInviteArgs = {
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
};

export type MutationSendSuccessionInvitesArgs = {
  familyId: Scalars["Int"]["input"];
};

export type MutationSetCurateSearchStatusArgs = {
  curateSearch: Scalars["Boolean"]["input"];
  familyId: Scalars["Int"]["input"];
};

export type MutationSetDefaultBankAccountArgs = {
  itemAccountId: Scalars["String"]["input"];
};

export type MutationSetGivingPrivacyPreferenceArgs = {
  fields?: InputMaybe<Scalars["GenericScalar"]["input"]>;
  preset?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationSetIncludeInternationalCharityArgs = {
  familyId: Scalars["Int"]["input"];
  includeInternationalCharity: Scalars["Boolean"]["input"];
};

export type MutationSetSignupPasswordArgs = {
  password: Scalars["String"]["input"];
  sessionToken: Scalars["String"]["input"];
};

export type MutationShareArticleArgs = {
  articleId: Scalars["Int"]["input"];
  members: Array<InputMaybe<Scalars["Int"]["input"]>>;
};

export type MutationShareCampaignArgs = {
  campaignId: Scalars["Int"]["input"];
  members: Array<InputMaybe<Scalars["Int"]["input"]>>;
  message: Scalars["String"]["input"];
  subject: Scalars["String"]["input"];
};

export type MutationSocialLoginArgs = {
  oktaToken: Scalars["String"]["input"];
  provider: Scalars["String"]["input"];
};

export type MutationSubmitTargetRatioArgs = {
  allocations: Array<InputMaybe<AllocationType>>;
  familyId: Scalars["Int"]["input"];
  returns?: InputMaybe<Scalars["Float"]["input"]>;
  riskScore?: InputMaybe<Scalars["Int"]["input"]>;
  volatility?: InputMaybe<Scalars["Float"]["input"]>;
};

export type MutationSyncOptimiserSessionArgs = {
  hohId?: InputMaybe<Scalars["String"]["input"]>;
  securitiesToOptimise?: InputMaybe<
    Array<InputMaybe<OptimiserSessionSecurityInputType>>
  >;
  sessionId?: InputMaybe<Scalars["String"]["input"]>;
  taxInfo?: InputMaybe<Scalars["JSONString"]["input"]>;
};

export type MutationTokenAuthArgs = {
  email: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
};

export type MutationTransferIraContributionArgs = {
  familyId: Scalars["Int"]["input"];
  intendedAmount: Scalars["Decimal"]["input"];
  name: Scalars["String"]["input"];
};

export type MutationTransferThirdpartyContributionArgs = {
  familyId: Scalars["Int"]["input"];
  intendedAmount: Scalars["Decimal"]["input"];
  name: Scalars["String"]["input"];
};

export type MutationTriggerIndividualDafInvitesArgs = {
  companyId: Scalars["String"]["input"];
  key: Scalars["String"]["input"];
};

export type MutationTriggerIneligibleAdminInviteArgs = {
  companyId: Scalars["String"]["input"];
  key: Scalars["String"]["input"];
};

export type MutationTriggerOfacScreeningArgs = {
  consent: Scalars["Boolean"]["input"];
  sessionToken: Scalars["String"]["input"];
};

export type MutationTriggerSuccessionTransferNotificationArgs = {
  familyId: Scalars["Int"]["input"];
};

export type MutationUnfavouriteArgs = {
  charityIds: Array<InputMaybe<Scalars["String"]["input"]>>;
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationUnfreezeDafAccountArgs = {
  familyId: Scalars["Int"]["input"];
};

export type MutationUpdateAdventIntegrationStatusArgs = {
  adventIntegrationId: Scalars["String"]["input"];
  status: Scalars["String"]["input"];
};

export type MutationUpdateAdvisorAgentCodesArgs = {
  email: Scalars["String"]["input"];
  updatedAttributes: Scalars["GenericScalar"]["input"];
};

export type MutationUpdateAdvisorFeesArgs = {
  bps: Scalars["Int"]["input"];
  familyId: Scalars["Int"]["input"];
};

export type MutationUpdateAnnualGivingGoalArgs = {
  familyId: Scalars["Int"]["input"];
  goalAmount: Scalars["Decimal"]["input"];
};

export type MutationUpdateContributionStatusArgs = {
  cType: Scalars["String"]["input"];
};

export type MutationUpdateCurationArgs = {
  causes: Array<InputMaybe<Scalars["String"]["input"]>>;
  familyId: Scalars["Int"]["input"];
  restrictCuration?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationUpdateCustomFeesArgs = {
  enableFee?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableFeeTier?: InputMaybe<Scalars["Boolean"]["input"]>;
  familyId: Scalars["Int"]["input"];
  feeCoefficient?: InputMaybe<Scalars["Float"]["input"]>;
  feeTier?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateCustomizeThemeArgs = {
  address?: InputMaybe<Scalars["GenericScalar"]["input"]>;
  advisorFeeTier?: InputMaybe<Scalars["String"]["input"]>;
  allowedCustodians?: InputMaybe<Array<InputMaybe<AllowedCustodianType>>>;
  allowedFirmConfigurations?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >;
  companyDafLaunchDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  eligibilityEmails?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  enableAdvisorFeeTier?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableFee?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableFeeTier?: InputMaybe<Scalars["Boolean"]["input"]>;
  featureFlags?: InputMaybe<Scalars["GenericScalar"]["input"]>;
  feeCoefficient?: InputMaybe<Scalars["Float"]["input"]>;
  feeTier?: InputMaybe<Scalars["String"]["input"]>;
  firmConfiguration?: InputMaybe<Scalars["String"]["input"]>;
  firmId: Scalars["Int"]["input"];
  firmLogo?: InputMaybe<Scalars["Upload"]["input"]>;
  firmName?: InputMaybe<Scalars["String"]["input"]>;
  individualDafLaunchDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  lockAdvisorFeeTier?: InputMaybe<Scalars["Boolean"]["input"]>;
  pooledSetIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  primaryColor?: InputMaybe<Scalars["String"]["input"]>;
  secondaryColor?: InputMaybe<Scalars["String"]["input"]>;
  taxId?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateDafDetailsArgs = {
  fundRefs?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type MutationUpdateDefaultAllocationArgs = {
  defaultAllocation: Scalars["Int"]["input"];
};

export type MutationUpdateDonorAllocationArgs = {
  allocateAmount: Scalars["Float"]["input"];
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
  userId: Scalars["Int"]["input"];
};

export type MutationUpdateEmailPreferencesArgs = {
  firmData?: InputMaybe<EmailPreferencesInputType>;
};

export type MutationUpdateEmployeeAllocationArgs = {
  allocateAmount: Scalars["Float"]["input"];
  selectAll?: InputMaybe<Scalars["Boolean"]["input"]>;
  userIds: Array<InputMaybe<Scalars["Int"]["input"]>>;
};

export type MutationUpdateEnterpriseFeatureLocksArgs = {
  firmId: Scalars["Int"]["input"];
  lockAdvisorFees?: InputMaybe<Scalars["Boolean"]["input"]>;
  lockBranding?: InputMaybe<Scalars["Boolean"]["input"]>;
  lockCustodians?: InputMaybe<Scalars["Boolean"]["input"]>;
  lockFeatureFlags?: InputMaybe<Scalars["Boolean"]["input"]>;
  lockedFeatureFlags?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >;
};

export type MutationUpdateFamilyMemberArgs = {
  familyId: Scalars["Int"]["input"];
  memberId: Scalars["Int"]["input"];
  userData: MemberInputType;
};

export type MutationUpdateFamilyPreferencesArgs = {
  annualGivingGoal?: InputMaybe<Scalars["Decimal"]["input"]>;
  causes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
  foundersMessage?: InputMaybe<Scalars["String"]["input"]>;
  members?: InputMaybe<Array<InputMaybe<MemberPreferencesInputType>>>;
  mission?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  restrictCuration?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationUpdateFamilyTreeArgs = {
  familyId: Scalars["Int"]["input"];
  familyTree: Scalars["GenericScalar"]["input"];
};

export type MutationUpdateFirmArgs = {
  firmData?: InputMaybe<FirmInputType>;
};

export type MutationUpdateGrantRationaleArgs = {
  contributionId: Scalars["Int"]["input"];
  rationale: Scalars["String"]["input"];
};

export type MutationUpdateGroupArgs = {
  groupId: Scalars["Int"]["input"];
  groupName: Scalars["String"]["input"];
};

export type MutationUpdateGsImportRecordArgs = {
  action: Scalars["String"]["input"];
  recordId: Scalars["Int"]["input"];
};

export type MutationUpdateInheritanceRegistryArgs = {
  registryData: InheritanceRegistryInput;
  registryId: Scalars["Int"]["input"];
};

export type MutationUpdateInheritanceStatusArgs = {
  registryId: Scalars["Int"]["input"];
  status: Scalars["String"]["input"];
};

export type MutationUpdateLegacyBlueprintArgs = {
  coreValues?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  familyId: Scalars["Int"]["input"];
  focusAreas?: InputMaybe<Array<InputMaybe<FocusAreaInput>>>;
  geographicFocus?: InputMaybe<Scalars["String"]["input"]>;
  impactGoals?: InputMaybe<Array<InputMaybe<ImpactGoalInput>>>;
  motivation?: InputMaybe<Scalars["String"]["input"]>;
  motivationTags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  personalConnection?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateMissionArgs = {
  familyId: Scalars["Int"]["input"];
  isCustom: Scalars["Boolean"]["input"];
  mission: Scalars["String"]["input"];
  updateCasuses: Scalars["Boolean"]["input"];
};

export type MutationUpdateOptimiseArgs = {
  coreAssetId: Scalars["String"]["input"];
  familyId: Scalars["Int"]["input"];
  givingWallet: Scalars["Float"]["input"];
  maxTrackingError: Scalars["Float"]["input"];
  thematicMaxAllocation: Scalars["Float"]["input"];
  thematicWeights: Scalars["GenericScalar"]["input"];
};

export type MutationUpdatePaymentIntentArgs = {
  amount: Scalars["Int"]["input"];
  ccType?: InputMaybe<Scalars["String"]["input"]>;
  intentId: Scalars["String"]["input"];
  paymentMethodId?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdatePinnedGivingHistoryArgs = {
  contributionIds: Array<InputMaybe<Scalars["Int"]["input"]>>;
  familyId: Scalars["Int"]["input"];
};

export type MutationUpdateRecurringGiftArgs = {
  amount?: InputMaybe<Scalars["Decimal"]["input"]>;
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
  frequency?: InputMaybe<FrequencyChoices>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  onBehalfOf?: InputMaybe<Scalars["Int"]["input"]>;
  recurringGiftId: Scalars["Int"]["input"];
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type MutationUpdateRelationshipArgs = {
  relatedToHofId: Scalars["Int"]["input"];
  userId: Scalars["Int"]["input"];
};

export type MutationUpdateScheduledContributionArgs = {
  amount?: InputMaybe<Scalars["Decimal"]["input"]>;
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  frequency?: InputMaybe<Scalars["String"]["input"]>;
  scheduledContributionId: Scalars["Int"]["input"];
};

export type MutationUpdateScheduledTransitionDateArgs = {
  familyId: Scalars["Int"]["input"];
  scheduledDate: Scalars["String"]["input"];
};

export type MutationUpdateSuccessionPolicyArgs = {
  annualPayoutTarget?: InputMaybe<Scalars["Float"]["input"]>;
  familyId: Scalars["Int"]["input"];
  policyMode?: InputMaybe<Scalars["String"]["input"]>;
  sunsetTimeframeYears?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationUpdateTaxTermsArgs = {
  familyId: Scalars["Int"]["input"];
  longTerm?: InputMaybe<Scalars["Decimal"]["input"]>;
  reset?: InputMaybe<Scalars["Boolean"]["input"]>;
  shortTerm?: InputMaybe<Scalars["Decimal"]["input"]>;
};

export type MutationUploadCustomCharityImageArgs = {
  charityId: Scalars["String"]["input"];
  image: Scalars["Upload"]["input"];
};

export type MutationUploadExternalGivingHistoryArgs = {
  familyId: Scalars["Int"]["input"];
  file?: InputMaybe<Scalars["Upload"]["input"]>;
  useSample?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationUploadFirmDocumentArgs = {
  documentType: Scalars["String"]["input"];
  file: Scalars["Upload"]["input"];
  firmId: Scalars["Int"]["input"];
};

export type MutationUploadFirmlogoArgs = {
  fileLogo: Scalars["Upload"]["input"];
  firmId: Scalars["Int"]["input"];
};

export type MutationUploadInheritanceDocumentArgs = {
  documentType?: InputMaybe<Scalars["String"]["input"]>;
  file: Scalars["Upload"]["input"];
  registryId: Scalars["Int"]["input"];
};

export type MutationUploadLegacyDocumentArgs = {
  documentType?: InputMaybe<Scalars["String"]["input"]>;
  familyId: Scalars["Int"]["input"];
  file: Scalars["Upload"]["input"];
  visibility?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUploadParticipantFileArgs = {
  companyId: Scalars["String"]["input"];
  file: Scalars["Upload"]["input"];
  key: Scalars["String"]["input"];
};

export type MutationUploadPortfolioArgs = {
  input: PortfolioInputType;
};

export type MutationUploadProfilepicArgs = {
  file: Scalars["Upload"]["input"];
};

export type MutationUploadRestrictedCharityArgs = {
  familyId: Scalars["Int"]["input"];
  file?: InputMaybe<Scalars["Upload"]["input"]>;
  useSample?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationUpsertSunsetCharityAllocationsArgs = {
  allocations: Array<SunsetCharityAllocationInput>;
  familyId: Scalars["Int"]["input"];
};

export type MutationVerifyEmailOtpArgs = {
  otp: Scalars["String"]["input"];
  tempToken: Scalars["String"]["input"];
};

export type MutationVerifyTokenArgs = {
  token?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationVerifyTotpEnrollmentArgs = {
  isFamilyMember?: InputMaybe<Scalars["Boolean"]["input"]>;
  otp: Scalars["String"]["input"];
  sessionToken: Scalars["String"]["input"];
};

export type MutationVerifyTotpLoginArgs = {
  otp: Scalars["String"]["input"];
};

export type N8NIntegrationLogType = {
  __typename?: "N8NIntegrationLogType";
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  docusignStatus?: Maybe<Scalars["String"]["output"]>;
  docusignStatusUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  envelopeId?: Maybe<Scalars["String"]["output"]>;
  eventType?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  isDownloaded?: Maybe<Scalars["Boolean"]["output"]>;
  s3Key?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

/** Response fields to have pagination for users list  */
export type NodePaginatedType = {
  __typename?: "NodePaginatedType";
  objects?: Maybe<Array<Maybe<Scalars["GenericScalar"]["output"]>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
  uid?: Maybe<Scalars["String"]["output"]>;
};

/** Input fields for changing communication preferences */
export type NotificationPreferenceInputType = {
  emailPrefDafContribution?: InputMaybe<Scalars["Boolean"]["input"]>;
  emailPrefGifts?: InputMaybe<Scalars["Boolean"]["input"]>;
  emailPrefOnboarding?: InputMaybe<Scalars["Boolean"]["input"]>;
  subscribeGivingTrends?: InputMaybe<Scalars["Boolean"]["input"]>;
  subscribeNewFeatures?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NotificationsType = {
  __typename?: "NotificationsType";
  alerts?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  familyAlerts?: Maybe<AlertsType>;
};

/**
 * Advisor-triggered reminder nudge for a successor who hasn't accepted (or
 * declined) their invite yet. Registered as a real NudgeRoutine
 * ('successor_invite_reminder', see core migration
 * 0138_seed_successor_invite_reminder_nudge_routine) -- same audience/sender
 * infrastructure (NUDGE_TYPE_AUDIENCE_FN_MAPPING/NUDGE_TYPE_EMAIL_SENDER_MAPPING,
 * UserNudge tracking) as every other nudge type in the system, so this manual
 * click respects the same eligibility window process_all_nudges would, and
 * the same routine could also fire automatically via that daily task.
 */
export type NudgeSuccessorInvite = {
  __typename?: "NudgeSuccessorInvite";
  lastNudgedAt?: Maybe<Scalars["String"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ObtainJsonWebToken = {
  __typename?: "ObtainJSONWebToken";
  payload: Scalars["GenericScalar"]["output"];
  refreshExpiresIn: Scalars["Int"]["output"];
  token: Scalars["String"]["output"];
  user?: Maybe<UserType>;
};

export type OktaPasswordPolicyType = {
  __typename?: "OktaPasswordPolicyType";
  excludeFirstName?: Maybe<Scalars["Boolean"]["output"]>;
  excludeLastName?: Maybe<Scalars["Boolean"]["output"]>;
  excludeUsername?: Maybe<Scalars["Boolean"]["output"]>;
  historyCount?: Maybe<Scalars["Int"]["output"]>;
  minAgeMinutes?: Maybe<Scalars["Int"]["output"]>;
  minLength?: Maybe<Scalars["Int"]["output"]>;
  requireLowercase?: Maybe<Scalars["Boolean"]["output"]>;
  requireNumber?: Maybe<Scalars["Boolean"]["output"]>;
  requireSymbol?: Maybe<Scalars["Boolean"]["output"]>;
  requireUppercase?: Maybe<Scalars["Boolean"]["output"]>;
};

export type OperationsAchStatsType = {
  __typename?: "OperationsAchStatsType";
  /** Average cycle time days */
  averageCycleTimeDays?: Maybe<Scalars["Float"]["output"]>;
  /** Lois to funds available */
  loisToFundsAvailable?: Maybe<Scalars["Float"]["output"]>;
};

export type OperationsAumByInvestmentModelType = {
  __typename?: "OperationsAumByInvestmentModelType";
  /** Data */
  data?: Maybe<Scalars["GenericScalar"]["output"]>;
  /** Models */
  models?: Maybe<Scalars["GenericScalar"]["output"]>;
};

export type OperationsContributionsCountsType = {
  __typename?: "OperationsContributionsCountsType";
  /** Number of LOI funds available */
  fundsAvailable?: Maybe<Scalars["Int"]["output"]>;
  /** Number of LOI reconciled */
  fundsReconciled?: Maybe<Scalars["Int"]["output"]>;
  /** Number of LOI submitted */
  inFlightLois?: Maybe<Scalars["Int"]["output"]>;
  /** Number of LOI liquidated */
  liquidation?: Maybe<Scalars["Int"]["output"]>;
  /** Total number of contributions */
  total?: Maybe<Scalars["Int"]["output"]>;
};

export type OperationsContributionsKpIsType = {
  __typename?: "OperationsContributionsKPIsType";
  achStats?: Maybe<OperationsAchStatsType>;
  securityStats?: Maybe<OperationsSecurityStatsType>;
  thirdPartyStats?: Maybe<OperationsThirdPartyStatsType>;
};

export type OperationsContributionsStatsItemType = {
  __typename?: "OperationsContributionsStatsItemType";
  /** Amount */
  amount?: Maybe<Scalars["Float"]["output"]>;
  /** Contribution type */
  contributionType?: Maybe<Scalars["String"]["output"]>;
  /** Contributor */
  contributor?: Maybe<Scalars["String"]["output"]>;
  /** Firm name */
  firmName?: Maybe<Scalars["String"]["output"]>;
  /** Initiated date */
  initiatedDate?: Maybe<Scalars["String"]["output"]>;
  /** Method */
  method?: Maybe<Scalars["String"]["output"]>;
  /** Object ID */
  objectId?: Maybe<Scalars["UUID"]["output"]>;
  /** Shares */
  shares?: Maybe<Scalars["Int"]["output"]>;
  /** Status */
  status?: Maybe<Scalars["String"]["output"]>;
  /** Ticker */
  ticker?: Maybe<Scalars["String"]["output"]>;
  /** Timeline */
  timeline?: Maybe<Array<Maybe<ContributionTimelineStatsType>>>;
};

export type OperationsContributionsStatsType = {
  __typename?: "OperationsContributionsStatsType";
  /** Is last page */
  isLastPage?: Maybe<Scalars["Boolean"]["output"]>;
  /** Is paginated */
  isPaginated?: Maybe<Scalars["Boolean"]["output"]>;
  /** Page number */
  page?: Maybe<Scalars["Int"]["output"]>;
  /** Page size */
  pageSize?: Maybe<Scalars["Int"]["output"]>;
  results?: Maybe<Array<Maybe<OperationsContributionsStatsItemType>>>;
  /** Total number of contributions */
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type OperationsGrantsKpIsType = {
  __typename?: "OperationsGrantsKPIsType";
  /** Average cycle time days */
  averageCycleTimeDays?: Maybe<Scalars["Float"]["output"]>;
  /** Charity receives funds days */
  charityReceivesFundsDays?: Maybe<Scalars["Float"]["output"]>;
  /** Funds made available days */
  fundsMadeAvailableDays?: Maybe<Scalars["Float"]["output"]>;
  /** Sent to charity days */
  sentToCharityDays?: Maybe<Scalars["Float"]["output"]>;
  /** Submitted to approved days */
  submittedToApprovedDays?: Maybe<Scalars["Float"]["output"]>;
};

export type OperationsGrantsStatsItemType = {
  __typename?: "OperationsGrantsStatsItemType";
  /** Amount */
  amount?: Maybe<Scalars["Float"]["output"]>;
  /** Charity address */
  charityAddress?: Maybe<GranteeAddressType>;
  /** Charity name */
  charityName?: Maybe<Scalars["String"]["output"]>;
  /** EIN */
  ein?: Maybe<Scalars["String"]["output"]>;
  /** Firm name */
  firmName?: Maybe<Scalars["String"]["output"]>;
  /** Grant note */
  grantNote?: Maybe<Scalars["String"]["output"]>;
  /** Initiated date */
  initiatedDate?: Maybe<Scalars["String"]["output"]>;
  /** Is anonymous */
  isAnonymous?: Maybe<Scalars["Boolean"]["output"]>;
  /** Method */
  method?: Maybe<Scalars["String"]["output"]>;
  /** Object ID */
  objectId?: Maybe<Scalars["UUID"]["output"]>;
  /** Recommended by */
  recommendedBy?: Maybe<Scalars["String"]["output"]>;
  /** Status */
  status?: Maybe<Scalars["String"]["output"]>;
  /** Timeline */
  timeline?: Maybe<Array<Maybe<ContributionTimelineStatsType>>>;
};

export type OperationsGrantsStatsType = {
  __typename?: "OperationsGrantsStatsType";
  /** Is last page */
  isLastPage?: Maybe<Scalars["Boolean"]["output"]>;
  /** Is paginated */
  isPaginated?: Maybe<Scalars["Boolean"]["output"]>;
  /** Page number */
  page?: Maybe<Scalars["Int"]["output"]>;
  /** Page size */
  pageSize?: Maybe<Scalars["Int"]["output"]>;
  results?: Maybe<Array<Maybe<OperationsGrantsStatsItemType>>>;
  /** Total number of grants */
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type OperationsGrantsVolumeStatusStatsType = {
  __typename?: "OperationsGrantsVolumeStatusStatsType";
  /** Number of approved grants */
  approvedGrants?: Maybe<Scalars["Int"]["output"]>;
  /** Number of completed grants */
  completedGrants?: Maybe<Scalars["Int"]["output"]>;
  /** Number of funds sent grants */
  fundsSentGrants?: Maybe<Scalars["Int"]["output"]>;
  /** Number of sent to charity grants */
  sentToCharityGrants?: Maybe<Scalars["Int"]["output"]>;
  /** Number of submitted grants */
  submittedGrants?: Maybe<Scalars["Int"]["output"]>;
};

export type OperationsListEnterprisesResponseType = {
  __typename?: "OperationsListEnterprisesResponseType";
  /** Is last page */
  isLastPage?: Maybe<Scalars["Boolean"]["output"]>;
  results?: Maybe<Array<Maybe<OperationsListEnterprisesType>>>;
  /** Total number of enterprises */
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type OperationsListEnterprisesType = {
  __typename?: "OperationsListEnterprisesType";
  /** Creation Time */
  creationTime?: Maybe<Scalars["String"]["output"]>;
  /** Earliest DAF Creation Time */
  earliestDafCreation?: Maybe<Scalars["String"]["output"]>;
  /** Enterprise ID */
  giveReferenceId?: Maybe<Scalars["Int"]["output"]>;
  /** Enterprise Name */
  name?: Maybe<Scalars["String"]["output"]>;
};

export type OperationsListFirmsResponseType = {
  __typename?: "OperationsListFirmsResponseType";
  /** Is last page */
  isLastPage?: Maybe<Scalars["Boolean"]["output"]>;
  results?: Maybe<Array<Maybe<OperationsListFirmsType>>>;
  /** Total number of firms */
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type OperationsListFirmsType = {
  __typename?: "OperationsListFirmsType";
  /** Company Launch Date */
  companyLaunchDate?: Maybe<Scalars["String"]["output"]>;
  /** Creation Time */
  creationTime?: Maybe<Scalars["String"]["output"]>;
  /** Earliest DAF Creation Time */
  earliestDafCreation?: Maybe<Scalars["String"]["output"]>;
  /** Firm ID */
  giveReferenceId?: Maybe<Scalars["Int"]["output"]>;
  /** Individual Launch Date */
  individualLaunchDate?: Maybe<Scalars["String"]["output"]>;
  /** Firm Name */
  name?: Maybe<Scalars["String"]["output"]>;
};

export type OperationsSecurityStatsType = {
  __typename?: "OperationsSecurityStatsType";
  /** Average cycle time days */
  averageCycleTimeDays?: Maybe<Scalars["Float"]["output"]>;
  /** Funds available days */
  fundsAvailableDays?: Maybe<Scalars["Float"]["output"]>;
  /** Liquidation days */
  liquidationDays?: Maybe<Scalars["Float"]["output"]>;
  /** Lois to security received days */
  loisToSecurityReceivedDays?: Maybe<Scalars["Float"]["output"]>;
};

export type OperationsStatsType = {
  __typename?: "OperationsStatsType";
  /** Number of contributions */
  contributions?: Maybe<Scalars["Int"]["output"]>;
  /** Number of grants */
  grants?: Maybe<Scalars["Int"]["output"]>;
  /** Number of in-flight contributions */
  inFlightContributions?: Maybe<Scalars["Int"]["output"]>;
  /** Number of in-flight grants */
  inFlightGrants?: Maybe<Scalars["Int"]["output"]>;
};

export type OperationsThirdPartyStatsType = {
  __typename?: "OperationsThirdPartyStatsType";
  /** Average cycle time days */
  averageCycleTimeDays?: Maybe<Scalars["Float"]["output"]>;
  /** Lois to funds available */
  loisToFundsAvailable?: Maybe<Scalars["Float"]["output"]>;
};

/**
 * One entry from the ops audit trail, as the console's activity feed shows it.
 *
 * Attempts, not just successes: `succeeded` is false for a refusal or a step
 * that was not ready, and those are the entries that explain a plan nobody
 * could move.
 */
export type OpsActivityType = {
  __typename?: "OpsActivityType";
  action?: Maybe<Scalars["String"]["output"]>;
  /** The action in words, from the model's own choices, so the client does not keep a second copy of the vocabulary. */
  actionLabel?: Maybe<Scalars["String"]["output"]>;
  actorName?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["String"]["output"]>;
  detail?: Maybe<Scalars["GenericScalar"]["output"]>;
  familyId?: Maybe<Scalars["Int"]["output"]>;
  familyName?: Maybe<Scalars["String"]["output"]>;
  fundName?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  step?: Maybe<Scalars["Int"]["output"]>;
  succeeded?: Maybe<Scalars["Boolean"]["output"]>;
  summary?: Maybe<Scalars["String"]["output"]>;
  transitionId?: Maybe<Scalars["Int"]["output"]>;
};

/**
 * One family's succession transition, as the ops pipeline view lists it.
 *
 * Ops could previously see two slices of the pipeline -- death certificates
 * awaiting review, and transfers sitting at step 4 -- and nothing in between.
 * A transition parked on step 2 for three weeks because a successor never
 * opened their DAF was invisible until it reached a queue, by which point the
 * wait was already long.
 *
 * Deliberately not SuccessionTransitionType. That type is per-family and
 * advisor-scoped; this is every family at once, so it carries the family and
 * fund names an ops admin needs to identify a row they have no other context
 * for, and it carries `blocked_reason` -- which the step itself computes and
 * the model does not store.
 */
export type OpsTransitionRowType = {
  __typename?: "OpsTransitionRowType";
  advisorName?: Maybe<Scalars["String"]["output"]>;
  /** True when this transition is waiting on OPS and nobody else. Exactly two things qualify: a death certificate to approve, and a DAF-to-DAF transfer whose received amount differs from the expected one and needs an admin to confirm the difference. Every other hold waits on a successor opening a fund or a transaction settling, which is not ops's move to make. */
  awaitingAction?: Maybe<Scalars["Boolean"]["output"]>;
  beneficiaryCount?: Maybe<Scalars["Int"]["output"]>;
  /** When blocked_reason was last written, i.e. the last time the daily job looked at this transition. Shown next to the reason so ops reads it as of a moment rather than as live. */
  blockedCheckedAt?: Maybe<Scalars["String"]["output"]>;
  /** Why the daily job did not advance this transition on its last run, in the pipeline's own words. Null when nothing held it. Read from the column the job writes -- never recomputed here, because computing it means running the step, and the step sends email and posts grants. */
  blockedReason?: Maybe<Scalars["String"]["output"]>;
  completedAt?: Maybe<Scalars["String"]["output"]>;
  currentStep?: Maybe<Scalars["Int"]["output"]>;
  /** How long this transition has been on its current step. The column ops actually sorts by: a step is not a problem, a step nobody has touched in three weeks is. */
  daysOnStep?: Maybe<Scalars["Int"]["output"]>;
  familyId?: Maybe<Scalars["Int"]["output"]>;
  familyName?: Maybe<Scalars["String"]["output"]>;
  /** The firm the family sits under. Ops works the queue by firm as often as by step -- an escalation is a phone call to one firm's advisors, not to all of them. */
  firmName?: Maybe<Scalars["String"]["output"]>;
  /** The fund's value at the freeze, re-anchored when step 1 closed. What every successor's share is measured against. */
  frozenBalance?: Maybe<Scalars["Float"]["output"]>;
  fundName?: Maybe<Scalars["String"]["output"]>;
  /** The head of household whose legacy this is. */
  hofName?: Maybe<Scalars["String"]["output"]>;
  initiatedAt?: Maybe<Scalars["String"]["output"]>;
  /** Who started the transition. An advisor for a voluntary plan; whoever filed the death event otherwise. */
  initiatedByName?: Maybe<Scalars["String"]["output"]>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  step1CompletedAt?: Maybe<Scalars["String"]["output"]>;
  step2CompletedAt?: Maybe<Scalars["String"]["output"]>;
  step3CompletedAt?: Maybe<Scalars["String"]["output"]>;
  step4CompletedAt?: Maybe<Scalars["String"]["output"]>;
  step5CompletedAt?: Maybe<Scalars["String"]["output"]>;
  /** When the CURRENT step's predecessor finished -- i.e. when this step started. Null on a transition still at step 1. */
  stepCompletedAt?: Maybe<Scalars["String"]["output"]>;
  successorCount?: Maybe<Scalars["Int"]["output"]>;
  transitionId?: Maybe<Scalars["Int"]["output"]>;
  triggerType?: Maybe<Scalars["String"]["output"]>;
  voluntaryMode?: Maybe<Scalars["String"]["output"]>;
};

export type OptimiseConfigType = {
  __typename?: "OptimiseConfigType";
  coreAssetId?: Maybe<Scalars["String"]["output"]>;
  coreAssetName?: Maybe<Scalars["String"]["output"]>;
  family: FamilyType;
  givingWallet: Scalars["Decimal"]["output"];
  id: Scalars["ID"]["output"];
  lastSubmitted?: Maybe<Scalars["Date"]["output"]>;
  maxTrackingError: Scalars["Decimal"]["output"];
  thematicMaxAllocation: Scalars["Decimal"]["output"];
  thematicPools?: Maybe<Array<Maybe<ThematicPoolType>>>;
};

export type OptimiserSessionSecurityInputType = {
  generatedLotId?: InputMaybe<Scalars["String"]["input"]>;
  portfolioId?: InputMaybe<Scalars["String"]["input"]>;
  quantity?: InputMaybe<Scalars["Float"]["input"]>;
  ticker?: InputMaybe<Scalars["String"]["input"]>;
};

export type OptimiserSessionSecurityType = {
  __typename?: "OptimiserSessionSecurityType";
  costBasis?: Maybe<Scalars["Float"]["output"]>;
  gains?: Maybe<Scalars["Float"]["output"]>;
  generatedLotId?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isLongTerm?: Maybe<Scalars["Boolean"]["output"]>;
  marketValue?: Maybe<Scalars["Float"]["output"]>;
  portfolioCode?: Maybe<Scalars["String"]["output"]>;
  portfolioId?: Maybe<Scalars["String"]["output"]>;
  quantity: Scalars["Float"]["output"];
  ticker: Scalars["String"]["output"];
};

export type OptimiserSessionType = {
  __typename?: "OptimiserSessionType";
  id: Scalars["ID"]["output"];
  invalidSecuritiesInSession?: Maybe<Scalars["Boolean"]["output"]>;
  securities?: Maybe<Array<Maybe<OptimiserSessionSecurityType>>>;
  summary?: Maybe<SummaryType>;
  taxInfo?: Maybe<Scalars["JSONString"]["output"]>;
};

export type OptimizationSummaryType = {
  __typename?: "OptimizationSummaryType";
  assets?: Maybe<Scalars["Float"]["output"]>;
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  maxTrackingError?: Maybe<Scalars["Float"]["output"]>;
  numberOfRecommendations?: Maybe<Scalars["Int"]["output"]>;
  optimizationMethod?: Maybe<Scalars["String"]["output"]>;
  totalCapitalGainsSavings?: Maybe<Scalars["Float"]["output"]>;
  totalDonationDeductionValue?: Maybe<Scalars["Float"]["output"]>;
  totalDonationMarketValue?: Maybe<Scalars["Float"]["output"]>;
  totalIncomeTaxSavings?: Maybe<Scalars["Float"]["output"]>;
  totalSharesDonated?: Maybe<Scalars["Float"]["output"]>;
  totalTaxSavings?: Maybe<Scalars["Float"]["output"]>;
  trackingError?: Maybe<Scalars["Float"]["output"]>;
  uniqueTickersDonated?: Maybe<Scalars["Int"]["output"]>;
};

export type OrganizeType = {
  __typename?: "OrganizeType";
  /** List of users containing parent and children data, which describes the heirarchy. */
  accepted?: Maybe<Array<Maybe<FamilyTreeType>>>;
  /** List of users who have not accepted the invitation, and hence do not have heirarchy defined. */
  unaccepted?: Maybe<Array<Maybe<UserType>>>;
};

export type OverviewCorporateClientsListType = {
  __typename?: "OverviewCorporateClientsListType";
  /** Number of advisors */
  advisorCount?: Maybe<Scalars["Int"]["output"]>;
  /** Total AUM */
  aum?: Maybe<Scalars["Float"]["output"]>;
  /** Total contributions */
  contributions?: Maybe<Scalars["Float"]["output"]>;
  /** Number of DAFs funded */
  dafsFunded?: Maybe<Scalars["Int"]["output"]>;
  /** Number of DAFs opened */
  dafsOpened?: Maybe<Scalars["Int"]["output"]>;
  /** Firm give reference ID */
  firmGiveReferenceId?: Maybe<Scalars["String"]["output"]>;
  /** Firm ID */
  firmId?: Maybe<Scalars["String"]["output"]>;
  /** Firm name */
  firmName?: Maybe<Scalars["String"]["output"]>;
  /** Total grants */
  grants?: Maybe<Scalars["Float"]["output"]>;
  /** Number of LOIs */
  lois?: Maybe<Scalars["Int"]["output"]>;
};

export type OverviewCorporateClientsListWrapperType = {
  __typename?: "OverviewCorporateClientsListWrapperType";
  /** Corporate clients list data */
  corporateClientsList?: Maybe<Array<Maybe<OverviewCorporateClientsListType>>>;
  /** Is last page */
  isLastPage?: Maybe<Scalars["Boolean"]["output"]>;
  /** Page */
  page?: Maybe<Scalars["Int"]["output"]>;
  /** Page size */
  pageSize?: Maybe<Scalars["Int"]["output"]>;
  /** Total count */
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type OverviewCorporateDafsListType = {
  __typename?: "OverviewCorporateDafsListType";
  /** Total AUM */
  aum?: Maybe<Scalars["Float"]["output"]>;
  /** DAF ID */
  dafId?: Maybe<Scalars["Int"]["output"]>;
  /** DAF name */
  dafName?: Maybe<Scalars["String"]["output"]>;
  /** Initial funding date */
  initialFundedDate?: Maybe<Scalars["String"]["output"]>;
  /** Latest funding date */
  latestFundedDate?: Maybe<Scalars["String"]["output"]>;
  /** Open date */
  openDate?: Maybe<Scalars["String"]["output"]>;
  /** Users */
  users?: Maybe<Array<Maybe<OverviewCorporateDafsUsersType>>>;
};

export type OverviewCorporateDafsListWrapperType = {
  __typename?: "OverviewCorporateDafsListWrapperType";
  /** Corporate admins list data */
  corporateAdminsList?: Maybe<Array<Maybe<OverviewCorporateDafsListType>>>;
  /** Corporate participants list data */
  corporateParticipantsList?: Maybe<
    Array<Maybe<OverviewCorporateDafsListType>>
  >;
  /** Is last page */
  isLastPage?: Maybe<Scalars["Boolean"]["output"]>;
  /** Page */
  page?: Maybe<Scalars["Int"]["output"]>;
  /** Page size */
  pageSize?: Maybe<Scalars["Int"]["output"]>;
  /** Total count */
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type OverviewCorporateDafsUsersType = {
  __typename?: "OverviewCorporateDafsUsersType";
  /** Email */
  email?: Maybe<Scalars["String"]["output"]>;
  /** First name */
  firstName?: Maybe<Scalars["String"]["output"]>;
  /** Last name */
  lastName?: Maybe<Scalars["String"]["output"]>;
  /** Roles */
  roles?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type OverviewDafContributionsStatsType = {
  __typename?: "OverviewDafContributionsStatsType";
  /** Amount */
  amount?: Maybe<Scalars["Float"]["output"]>;
  /** Contribution type */
  contributionType?: Maybe<Scalars["String"]["output"]>;
  /** Contributor */
  contributor?: Maybe<Scalars["String"]["output"]>;
  /** Firm name */
  firmName?: Maybe<Scalars["String"]["output"]>;
  /** Initiated date */
  initiatedDate?: Maybe<Scalars["String"]["output"]>;
  /** Method */
  method?: Maybe<Scalars["String"]["output"]>;
  /** Object ID */
  objectId?: Maybe<Scalars["UUID"]["output"]>;
  /** Shares */
  shares?: Maybe<Scalars["String"]["output"]>;
  /** Status */
  status?: Maybe<Scalars["String"]["output"]>;
  /** Ticker */
  ticker?: Maybe<Scalars["String"]["output"]>;
  /** Timeline */
  timeline?: Maybe<Array<Maybe<ContributionTimelineType>>>;
};

export type OverviewDafContributionsStatsWrapperType = {
  __typename?: "OverviewDafContributionsStatsWrapperType";
  /** Is last page */
  isLastPage?: Maybe<Scalars["Boolean"]["output"]>;
  /** Is paginated */
  isPaginated?: Maybe<Scalars["Boolean"]["output"]>;
  /** Page number */
  page?: Maybe<Scalars["Int"]["output"]>;
  /** Page size */
  pageSize?: Maybe<Scalars["Int"]["output"]>;
  /** Contributions stats data */
  results?: Maybe<Array<Maybe<OverviewDafContributionsStatsType>>>;
  /** Total number of contributions */
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type OverviewDafGrantsStatsType = {
  __typename?: "OverviewDafGrantsStatsType";
  /** Amount */
  amount?: Maybe<Scalars["Float"]["output"]>;
  /** Charity address */
  charityAddress?: Maybe<CharityAddressType>;
  /** Charity name */
  charityName?: Maybe<Scalars["String"]["output"]>;
  /** EIN */
  ein?: Maybe<Scalars["String"]["output"]>;
  /** Firm name */
  firmName?: Maybe<Scalars["String"]["output"]>;
  /** Grant note */
  grantNote?: Maybe<Scalars["String"]["output"]>;
  /** Initiated date */
  initiatedDate?: Maybe<Scalars["String"]["output"]>;
  /** Is anonymous */
  isAnonymous?: Maybe<Scalars["Boolean"]["output"]>;
  /** Method */
  method?: Maybe<Scalars["String"]["output"]>;
  /** Object ID */
  objectId?: Maybe<Scalars["UUID"]["output"]>;
  /** Recommended by */
  recommendedBy?: Maybe<Scalars["String"]["output"]>;
  /** Status */
  status?: Maybe<Scalars["String"]["output"]>;
  /** Timeline */
  timeline?: Maybe<Array<Maybe<ContributionTimelineType>>>;
};

export type OverviewDafGrantsStatsWrapperType = {
  __typename?: "OverviewDafGrantsStatsWrapperType";
  /** Is last page */
  isLastPage?: Maybe<Scalars["Boolean"]["output"]>;
  /** Is paginated */
  isPaginated?: Maybe<Scalars["Boolean"]["output"]>;
  /** Page number */
  page?: Maybe<Scalars["Int"]["output"]>;
  /** Page size */
  pageSize?: Maybe<Scalars["Int"]["output"]>;
  /** Grants stats data */
  results?: Maybe<Array<Maybe<OverviewDafGrantsStatsType>>>;
  /** Total number of grants */
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type OverviewDafStatsType = {
  __typename?: "OverviewDafStatsType";
  /** Total AUM */
  aum?: Maybe<Scalars["Float"]["output"]>;
  /** DAF ID */
  dafId?: Maybe<Scalars["Int"]["output"]>;
  /** DAF name */
  dafName?: Maybe<Scalars["String"]["output"]>;
  /** In flight contributions */
  inFlightContributions?: Maybe<Scalars["Float"]["output"]>;
  /** In flight grants */
  inFlightGrants?: Maybe<Scalars["Float"]["output"]>;
  /** YTD contributions */
  ytdContributions?: Maybe<Scalars["Float"]["output"]>;
  /** YTD grants */
  ytdGrants?: Maybe<Scalars["Float"]["output"]>;
};

export type OverviewDistributionListType = {
  __typename?: "OverviewDistributionListType";
  /** Balance */
  balance?: Maybe<Scalars["Float"]["output"]>;
  /** Fund external ID */
  fundExternalId?: Maybe<Scalars["String"]["output"]>;
  /** Fund name */
  fundName?: Maybe<Scalars["String"]["output"]>;
  /** Participant */
  participant?: Maybe<Scalars["String"]["output"]>;
};

export type OverviewDistributionListWrapperType = {
  __typename?: "OverviewDistributionListWrapperType";
  /** Distribution list data */
  distributionList?: Maybe<Array<Maybe<OverviewDistributionListType>>>;
  /** Is last page */
  isLastPage?: Maybe<Scalars["Boolean"]["output"]>;
  /** Is paginated */
  isPaginated?: Maybe<Scalars["Boolean"]["output"]>;
  /** Page */
  page?: Maybe<Scalars["Int"]["output"]>;
  /** Page size */
  pageSize?: Maybe<Scalars["Int"]["output"]>;
  /** Total count */
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type OverviewDistributionStatsType = {
  __typename?: "OverviewDistributionStatsType";
  /** Distribution stats data */
  distribution?: Maybe<Array<Maybe<DistributionStatsDataType>>>;
  /** Period */
  period?: Maybe<Scalars["String"]["output"]>;
  /** Year */
  year?: Maybe<Scalars["Int"]["output"]>;
};

export type OverviewDistributionStatsWrapperType = {
  __typename?: "OverviewDistributionStatsWrapperType";
  /** Distribution stats data */
  distributionStats?: Maybe<Array<Maybe<OverviewDistributionStatsType>>>;
};

export type OverviewEnterpriseClientsListType = {
  __typename?: "OverviewEnterpriseClientsListType";
  /** Total AUM */
  aum?: Maybe<Scalars["Float"]["output"]>;
  /** Total contributions */
  contributions?: Maybe<Scalars["Float"]["output"]>;
  /** Number of DAFs funded */
  dafsFunded?: Maybe<Scalars["Int"]["output"]>;
  /** Number of DAFs opened */
  dafsOpened?: Maybe<Scalars["Int"]["output"]>;
  /** Enterprise give reference ID */
  enterpriseGiveReferenceId?: Maybe<Scalars["String"]["output"]>;
  /** Enterprise ID */
  enterpriseId?: Maybe<Scalars["ID"]["output"]>;
  /** Enterprise name */
  enterpriseName?: Maybe<Scalars["String"]["output"]>;
  /** Number of firms */
  firmCount?: Maybe<Scalars["Int"]["output"]>;
  /** Total grants */
  grants?: Maybe<Scalars["Float"]["output"]>;
  /** Number of LOIs */
  lois?: Maybe<Scalars["Int"]["output"]>;
};

export type OverviewEnterpriseClientsListWrapperType = {
  __typename?: "OverviewEnterpriseClientsListWrapperType";
  /** Enterprise clients list data */
  enterpriseClientsList?: Maybe<
    Array<Maybe<OverviewEnterpriseClientsListType>>
  >;
  /** Is last page */
  isLastPage?: Maybe<Scalars["Boolean"]["output"]>;
  /** Page */
  page?: Maybe<Scalars["Int"]["output"]>;
  /** Page size */
  pageSize?: Maybe<Scalars["Int"]["output"]>;
  /** Total count */
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type OverviewProgramAumStatsType = {
  __typename?: "OverviewProgramAUMStatsType";
  /** Program AUM stats data */
  aumStats?: Maybe<Array<Maybe<ProgramAumStatsDataType>>>;
};

export type OverviewStatsType = {
  __typename?: "OverviewStatsType";
  /** Number of advisors */
  advisors?: Maybe<Scalars["Int"]["output"]>;
  /** Total AUM */
  aum?: Maybe<Scalars["Float"]["output"]>;
  /** Number of corporate clients */
  corporateClients?: Maybe<Scalars["Int"]["output"]>;
  /** Number of DAFs funded */
  dafsFunded?: Maybe<Scalars["Int"]["output"]>;
  /** Number of DAFs opened */
  dafsOpened?: Maybe<Scalars["Int"]["output"]>;
  /** Number of enterprises */
  enterprises?: Maybe<Scalars["Int"]["output"]>;
  /** Firm name */
  firmName?: Maybe<Scalars["String"]["output"]>;
  /** Initial funded date */
  launchDate?: Maybe<Scalars["String"]["output"]>;
  /** Total contributions */
  totalContributions?: Maybe<Scalars["Float"]["output"]>;
  /** Total grants */
  totalGrants?: Maybe<Scalars["Float"]["output"]>;
  /** Number of wealth clients */
  wealthClients?: Maybe<Scalars["Int"]["output"]>;
};

export type PaginatedGrantHistoryRecordType = {
  __typename?: "PaginatedGrantHistoryRecordType";
  isLastPage?: Maybe<Scalars["Boolean"]["output"]>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pageSize?: Maybe<Scalars["Int"]["output"]>;
  results?: Maybe<Array<Maybe<GrantHistoryRecordType>>>;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type PaginatedSecurityItemType = {
  __typename?: "PaginatedSecurityItemType";
  count?: Maybe<Scalars["Int"]["output"]>;
  objects?: Maybe<Array<Maybe<SecurityItemType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export type ParticipantSummaryType = {
  __typename?: "ParticipantSummaryType";
  activeCount?: Maybe<Scalars["Int"]["output"]>;
  dafsFundedCount?: Maybe<Scalars["Int"]["output"]>;
  dafsOpenedCount?: Maybe<Scalars["Int"]["output"]>;
  pendingCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Paginated participants results using UserType with FirmType support */
export type ParticipantsPaginatedType = {
  __typename?: "ParticipantsPaginatedType";
  count?: Maybe<Scalars["Int"]["output"]>;
  objects?: Maybe<Array<Maybe<UserType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

/** Stripe's Payment Method Type */
export type PaymentMethodType = {
  __typename?: "PaymentMethodType";
  billingDetails?: Maybe<BillingDetailsType>;
  card?: Maybe<CardType>;
  id?: Maybe<Scalars["String"]["output"]>;
  metadata?: Maybe<Scalars["GenericScalar"]["output"]>;
};

/** Response fields to have pagination for users list  */
export type PendingUsersPaginatedType = {
  __typename?: "PendingUsersPaginatedType";
  objects?: Maybe<Array<Maybe<UserType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export type PeriodStatsType = {
  __typename?: "PeriodStatsType";
  /** Number of DAFs funded */
  dafsFunded?: Maybe<Scalars["Int"]["output"]>;
  /** Number of DAFs opened */
  dafsOpened?: Maybe<Scalars["Int"]["output"]>;
  /** End date in ISO format */
  endDate?: Maybe<Scalars["String"]["output"]>;
  /** Funded rate percentage (dafs_funded / dafs_opened) */
  fundedRate?: Maybe<Scalars["Float"]["output"]>;
  /** Open rate percentage (dafs_opened / total_eligible_participants) */
  openRate?: Maybe<Scalars["Float"]["output"]>;
  /** Start date in ISO format */
  startDate?: Maybe<Scalars["String"]["output"]>;
  /** Total number of eligible participants */
  totalEligibleParticipants?: Maybe<Scalars["Int"]["output"]>;
};

export type PlaidItemType = {
  __typename?: "PlaidItemType";
  family: FamilyType;
  id: Scalars["ID"]["output"];
  institutionId?: Maybe<Scalars["String"]["output"]>;
  institutionName?: Maybe<Scalars["String"]["output"]>;
  itemAccounts?: Maybe<Array<ItemAccountType>>;
};

/** Return screening status: 'checking' | 'pass' | 'pending_review'. */
export type PollOfacResult = {
  __typename?: "PollOfacResult";
  error?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
};

/** Poll Okta push approval. Returns 'waiting' | 'success' | 'error'. */
export type PollOktaVerifyEnrollment = {
  __typename?: "PollOktaVerifyEnrollment";
  error?: Maybe<Scalars["String"]["output"]>;
  oktaToken?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
};

/** Poll Okta Verify push result. Returns 'waiting', 'success', or 'rejected'. */
export type PollOktaVerifyLogin = {
  __typename?: "PollOktaVerifyLogin";
  error?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
};

export type PoolSetPools = {
  __typename?: "PoolSetPools";
  pooledAssetName?: Maybe<Scalars["String"]["output"]>;
};

export type PooledSetRecommendationDataType = {
  __typename?: "PooledSetRecommendationDataType";
  custodianName?: Maybe<Scalars["String"]["output"]>;
  pooledSets?: Maybe<Array<Maybe<PooledSets>>>;
};

export type PooledSets = {
  __typename?: "PooledSets";
  isSmaPooledSets?: Maybe<Scalars["Boolean"]["output"]>;
  pooledSetId?: Maybe<Scalars["String"]["output"]>;
  pooledSetName?: Maybe<Scalars["String"]["output"]>;
  pooledSetPools?: Maybe<Array<Maybe<PoolSetPools>>>;
};

export type PortfolioImpactType = {
  __typename?: "PortfolioImpactType";
  absWeightChange?: Maybe<Scalars["Float"]["output"]>;
  currentValue?: Maybe<Scalars["Float"]["output"]>;
  currentWeight?: Maybe<Scalars["Float"]["output"]>;
  postDonationValue?: Maybe<Scalars["Float"]["output"]>;
  postDonationWeight?: Maybe<Scalars["Float"]["output"]>;
  secType?: Maybe<Scalars["String"]["output"]>;
  ticker?: Maybe<Scalars["String"]["output"]>;
  weightChange?: Maybe<Scalars["Float"]["output"]>;
};

/** Complete portfolio input field type  */
export type PortfolioInputType = {
  account?: InputMaybe<AccountInputType>;
  summary?: InputMaybe<Array<InputMaybe<HoldingSummaryInputType>>>;
};

/** Portfolio mapping data for families. */
export type PortfolioMappingType = {
  __typename?: "PortfolioMappingType";
  accountName?: Maybe<Scalars["String"]["output"]>;
  accountType?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["String"]["output"]>;
  custodianId?: Maybe<Scalars["String"]["output"]>;
  masterAccountNumber?: Maybe<Scalars["String"]["output"]>;
  portfolioCode?: Maybe<Scalars["String"]["output"]>;
  taxStatus?: Maybe<Scalars["String"]["output"]>;
  totalBalance?: Maybe<Scalars["Float"]["output"]>;
};

export type PortfolioType = {
  __typename?: "PortfolioType";
  approved: Scalars["Boolean"]["output"];
  assetId?: Maybe<Scalars["String"]["output"]>;
  assets?: Maybe<Array<Maybe<AssetType>>>;
  id?: Maybe<Scalars["Int"]["output"]>;
  returns: Scalars["Decimal"]["output"];
  riskScore: Scalars["Int"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
  volatility: Scalars["Decimal"]["output"];
};

/** Input fields for profile page  */
export type ProfileInputType = {
  address?: InputMaybe<Scalars["GenericScalar"]["input"]>;
  dob?: InputMaybe<Scalars["Date"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firmName?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["GenericScalar"]["input"]>;
  relatedToHof?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ProgramAumStatsDataType = {
  __typename?: "ProgramAUMStatsDataType";
  /** Closing AUM fund asset */
  closingAumFundAsset?: Maybe<Scalars["Float"]["output"]>;
  /** Closing AUM investment fund fee */
  closingAumInvestmentFundFee?: Maybe<Scalars["Float"]["output"]>;
  /** Contributions */
  contributions?: Maybe<Scalars["Float"]["output"]>;
  /** Grants */
  grants?: Maybe<Scalars["Float"]["output"]>;
  /** Opening AUM fund asset */
  openingAumFundAsset?: Maybe<Scalars["Float"]["output"]>;
  /** Opening AUM investment fund fee */
  openingAumInvestmentFundFee?: Maybe<Scalars["Float"]["output"]>;
  /** Period */
  period?: Maybe<Scalars["String"]["output"]>;
  /** Year */
  year?: Maybe<Scalars["Int"]["output"]>;
};

export type ProgramFeeRowType = {
  __typename?: "ProgramFeeRowType";
  adminFees?: Maybe<Scalars["Float"]["output"]>;
  aum?: Maybe<Scalars["String"]["output"]>;
  avgBps?: Maybe<Scalars["String"]["output"]>;
  enterpriseFeePct?: Maybe<Scalars["Float"]["output"]>;
  enterpriseGiveReferenceId?: Maybe<Scalars["String"]["output"]>;
  enterpriseId?: Maybe<Scalars["String"]["output"]>;
  enterpriseName?: Maybe<Scalars["String"]["output"]>;
  enterpriseShare?: Maybe<Scalars["Float"]["output"]>;
  platformFeePct?: Maybe<Scalars["Float"]["output"]>;
  platformShare?: Maybe<Scalars["Float"]["output"]>;
  subAdvisorFees?: Maybe<Scalars["Float"]["output"]>;
};

export enum ProgramType {
  Standalone = "standalone",
  TifinWealth = "tifin_wealth",
}

/** Response fields to provide proximity details  */
export type ProximityType = {
  __typename?: "ProximityType";
  member?: Maybe<UserType>;
  overlapScore?: Maybe<Scalars["Int"]["output"]>;
  relatedScore?: Maybe<Scalars["Int"]["output"]>;
};

export type PublicCampaignAchDonation = {
  __typename?: "PublicCampaignACHDonation";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type PublicCampaignDonation = {
  __typename?: "PublicCampaignDonation";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type PublicCreateSelfDirectedUser = {
  __typename?: "PublicCreateSelfDirectedUser";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type Query = {
  __typename?: "Query";
  /** Get list of active hands of families of the firm. */
  activeHofs?: Maybe<UserPaginatedType>;
  activities?: Maybe<ActivityPaginatedType>;
  advisorClientInsights?: Maybe<Scalars["GenericScalar"]["output"]>;
  /** List all transactions with pagination */
  advisorClientTransactions?: Maybe<ListTransactionsPaginatedType>;
  advisorClientsSummary?: Maybe<AdvisorSummaryType>;
  advisorCustodianMetadata?: Maybe<AdvisorCustodianMetadataType>;
  /** Get DAF details created by advisor */
  advisorDafDetails?: Maybe<AdvisorDafType>;
  advisorDashboard?: Maybe<AdvisorDashboardType>;
  advisorDashboardSummary?: Maybe<Scalars["GenericScalar"]["output"]>;
  /** count of advisor family, member and contribution. */
  advisorData?: Maybe<AdvisorOnboardType>;
  /** Get details of a specific family. */
  advisorFamily?: Maybe<FamilyType>;
  advisorFamilyDashboard?: Maybe<AdvisorFamilyDashboardType>;
  /** Fetch all users of a specific family. */
  advisorFamilyMembers?: Maybe<UserPaginatedType>;
  /** Details of advisors group */
  advisorGroup?: Maybe<AdvisorGroupType>;
  /** Details of advisors group associated with the family */
  advisorGroupFamily?: Maybe<AdvisorGroupType>;
  /** list of of advisor groups */
  advisorGroups?: Maybe<AdvisorGroupPaginatedType>;
  advisorLogin?: Maybe<AuthType>;
  /** Advisor dashboard details. */
  advisorNewSummary?: Maybe<AdvisorSummaryDashboardType>;
  advisorOpsClientsDetails?: Maybe<AdvisorPaginatedType>;
  /** Advisor dashboard details. */
  advisorSummary?: Maybe<AdvisorSummaryDashboardType>;
  /** Advisor weekly summary details. */
  advisorWeeklySummary?: Maybe<AdvisorWeeklySummaryType>;
  advisors?: Maybe<Array<Maybe<UserType>>>;
  advisoryOpsSummary?: Maybe<AdvisorSummaryType>;
  alerts?: Maybe<ActionablePaginatedType>;
  /** Highlevel bucket to get all the necessary information to track the alignment between the giving portfolio and the investement portfolio. */
  align?: Maybe<AlignModuleType>;
  /** Get all the articles related to the list of categories or funds specified. */
  articles?: Maybe<ArticlePaginatedType>;
  /** List of all families that HOH / family member is part of.            No arguments required, UserId is taken from auth token. */
  associatedFamilies?: Maybe<FamilyPaginatedType>;
  beneficiaries?: Maybe<Array<Maybe<BeneficiaryType>>>;
  bookLevelSettings?: Maybe<BookLevelSettingsType>;
  bunchingPlanDraft?: Maybe<BunchingPlanDraftType>;
  /** Campaign dashboard metrics. */
  campaignDashboardMetrics?: Maybe<CampaignDashboardMetricsType>;
  /** List of donations (Both internal and external) */
  campaignDonations?: Maybe<CampaignDonationPaginatedType>;
  /** Unfinished campaign drafts for the family, newest first. */
  campaignDrafts?: Maybe<Array<Maybe<CampaignDraftType>>>;
  /** Stat cards for the campaign details page. */
  campaignStats?: Maybe<CampaignStatsType>;
  /** Choices and windows the campaign templates allow. */
  campaignTemplateSettings: CampaignTemplateSettingsType;
  /** List all the Campaigns created for the family. */
  campaigns?: Maybe<CampaignPaginatedType>;
  /** List all campaigns for families associated with the logged-in advisor. */
  campaignsByAdvisor?: Maybe<CampaignPaginatedType>;
  /** Card related fees */
  cardFees?: Maybe<FeesType>;
  cashContributionDetails?: Maybe<CashContributionDetailType>;
  /** Fetch all the curated categories and charities for a family. */
  categories?: Maybe<EngageCategoriesType>;
  causes?: Maybe<Array<Maybe<CauseType>>>;
  charities?: Maybe<CharityPaginatedType>;
  charityDetail?: Maybe<CharityType>;
  charityMatches?: Maybe<Array<Maybe<CharityType>>>;
  charitySearch?: Maybe<NodePaginatedType>;
  charitySearchDetail?: Maybe<CharityType>;
  checkCharityEligibility?: Maybe<CharityEligibilityType>;
  clientLevelSettings?: Maybe<ClientLevelSettingsType>;
  /** Count of all client's active and pending DAFs of an advisor */
  clientsDafDetails?: Maybe<ClientDafDetailsType>;
  clientsEligibleForDaf?: Maybe<Array<Maybe<ClientsEligibleForDafType>>>;
  clientsWithThirdPartyDaf?: Maybe<ClientsWithThirdPartyDafPaginatedType>;
  /** List of all active bank accounts, for the family, added by the current user */
  connectedBankAccounts?: Maybe<Array<Maybe<ItemAccountType>>>;
  contribution?: Maybe<Array<Maybe<ContributionType>>>;
  contributionsSummary?: Maybe<ContributionsSummaryType>;
  contributorYears?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  contributors?: Maybe<Array<Maybe<ContributorType>>>;
  corporateUserSummary?: Maybe<CorporateUserSummaryType>;
  createLinkToken?: Maybe<LinkTokenType>;
  /** Get list of all the curates categories, along with if category is enabled for the family. */
  curatesList?: Maybe<Array<Maybe<CuratesType>>>;
  custodianPortfolio?: Maybe<Scalars["GenericScalar"]["output"]>;
  /** Get the list of custodians */
  custodiansList?: Maybe<Array<Maybe<CustodianType>>>;
  customFeeDetails?: Maybe<CustomFeeType>;
  /** List of availabe custom models in Louise. */
  customModels?: Maybe<Array<Maybe<ModelType>>>;
  /** List of all families under a specific advisor.            No arguments required, AdvisorId is taken from auth token.            Status could be provided to get active or pending DAFs. */
  dafClients?: Maybe<FamilyPaginatedType>;
  /** Get the list of custodians fetched from elevate */
  dafCustodiansList?: Maybe<Array<Maybe<DafCustodianType>>>;
  dafImpactReport?: Maybe<DafImpactReportType>;
  dafPools?: Maybe<Array<Maybe<PortfolioType>>>;
  dashboardGraphsData?: Maybe<DashboardGraphsDataType>;
  /** List of tnc_signed_date and fee_agreement_signed_date. */
  documentDates?: Maybe<SignedDateType>;
  downloadFamilyData?: Maybe<FamilyReturnJsonType>;
  employeesSummary?: Maybe<EmployeeSummaryType>;
  /** Fetch the charities related to the ctype */
  engagedCharities?: Maybe<CharityPaginatedType>;
  /** Fetch the giving portfolio distribution */
  engagementDistribution?: Maybe<EngageType>;
  /** List of all families under a specific advisor. No arguments required, AdvisorId is taken from auth token. */
  families?: Maybe<Array<Maybe<FamilyType>>>;
  /** List of all families under a specific advisor with their mapped portfolio data.            No arguments required, AdvisorId is taken from auth token.            Status could be provided to get active or pending DAFs. */
  familiesWithPortfolioMappings?: Maybe<FamilyPaginatedType>;
  /** Details of the family. Family ID is picked from the authenticated family member. */
  family?: Maybe<FamilyType>;
  familyCharityCauses?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  familyFavoriteCharities?: Maybe<CharityPaginatedType>;
  familyMembers?: Maybe<Array<Maybe<UserType>>>;
  /** Describes the family hierarchy. Uses parent-child relationship to . */
  familyTree?: Maybe<OrganizeType>;
  favoriteCharities?: Maybe<CharityPaginatedType>;
  /** List of all the charities under the cateogry, and their details. */
  favourites?: Maybe<Array<Maybe<FavouritesType>>>;
  featuredCharities?: Maybe<Array<Maybe<CharityType>>>;
  /** Top grants by amount for the Giving History section. Pass ids to fetch specific pinned grants. */
  featuredGrants?: Maybe<Array<Maybe<FeaturedGrantType>>>;
  fetchEmailChangeDetails?: Maybe<EmailRequestType>;
  fetchZipCodes?: Maybe<ZipCodesType>;
  firm?: Maybe<FirmType>;
  /** Details of the family and its advisor. */
  firmClientDetails?: Maybe<FirmClientDetailType>;
  firmDocuments?: Maybe<Array<Maybe<FirmDocumentType>>>;
  firmSummary?: Maybe<FirmAdvisorsType>;
  fundSearch?: Maybe<NodePaginatedType>;
  /** List of all the charities under the cateogry, and their details. */
  funds?: Maybe<Array<Maybe<CharityType>>>;
  getAccountStatement?: Maybe<Scalars["String"]["output"]>;
  getAdoptionBannerStats?: Maybe<AdoptionBannerStatsType>;
  getChannelPerformanceMetrics?: Maybe<ChannelPerformanceMetricsType>;
  getCharity?: Maybe<CharityType>;
  getConversationTopIssues?: Maybe<ConversationTopIssueThemeType>;
  getCorporateClientsList?: Maybe<OverviewCorporateClientsListWrapperType>;
  getCorporateDafFilters?: Maybe<CorporateDafFiltersType>;
  getCorporateDafsList?: Maybe<OverviewCorporateDafsListWrapperType>;
  getCuratedListCount?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  getCustomFees?: Maybe<CustomFees>;
  getCustomerSuccessMetrics?: Maybe<CustomerSuccessStatsType>;
  getDafContributions?: Maybe<OverviewDafContributionsStatsWrapperType>;
  getDafGrants?: Maybe<OverviewDafGrantsStatsWrapperType>;
  getDafStats?: Maybe<OverviewDafStatsType>;
  getDistributionList?: Maybe<OverviewDistributionListWrapperType>;
  getDistributionStats?: Maybe<OverviewDistributionStatsWrapperType>;
  /** List all the email preferences of the firm. */
  getEmailPreferences?: Maybe<FirmEmailPreferencesType>;
  /** Get employee details. */
  getEmployeeDetails?: Maybe<UserType>;
  getEngagementFunnel?: Maybe<EngagementFunnelType>;
  getEngagementOverTime?: Maybe<EngagementOverTimeType>;
  getEnterpriseClientsList?: Maybe<OverviewEnterpriseClientsListWrapperType>;
  /** List all the default allocations for the family. */
  getFamilyAllocations?: Maybe<DefaultAllocationsType>;
  getFeeTier?: Maybe<FeeTierType>;
  getFeesByAdvisor?: Maybe<FeesByAdvisorIdType>;
  getFeesByEnterprise?: Maybe<FeesByEnterpriseType>;
  getFeesByFirm?: Maybe<FeesByFirmType>;
  getFeesByProgram?: Maybe<FeesByProgramType>;
  getFeesStats?: Maybe<FeesStatsType>;
  getFirmEmailStatistics?: Maybe<FirmEmailStatisticsType>;
  getFirmPoolsets?: Maybe<Array<Maybe<FirmPoolSetsType>>>;
  /** List of fund asset pool data. */
  getFundAssetPools?: Maybe<Array<Maybe<FundAssetPoolType>>>;
  getFundReallocationRebalanceRequests?: Maybe<FundReallocationsRebalancePaginatedType>;
  getFundTransferRequests?: Maybe<FundTransferRequestsPaginatedType>;
  getImaAccountNumber?: Maybe<Scalars["String"]["output"]>;
  getMetaData?: Maybe<MetaDataType>;
  getOperationsAumByInvestmentModel?: Maybe<OperationsAumByInvestmentModelType>;
  getOperationsContributionsCount?: Maybe<OperationsContributionsCountsType>;
  getOperationsContributionsKPIs?: Maybe<OperationsContributionsKpIsType>;
  getOperationsContributionsStats?: Maybe<OperationsContributionsStatsType>;
  getOperationsGrantsKPIs?: Maybe<OperationsGrantsKpIsType>;
  getOperationsGrantsStats?: Maybe<OperationsGrantsStatsType>;
  getOperationsGrantsVolumeStatusStats?: Maybe<OperationsGrantsVolumeStatusStatsType>;
  getOperationsListEnterprises?: Maybe<OperationsListEnterprisesResponseType>;
  getOperationsListFirms?: Maybe<OperationsListFirmsResponseType>;
  getOperationsStats?: Maybe<OperationsStatsType>;
  getOverviewStats?: Maybe<OverviewStatsType>;
  getPoolSetRecommendations?: Maybe<
    Array<Maybe<PooledSetRecommendationDataType>>
  >;
  getProgramAUMStats?: Maybe<OverviewProgramAumStatsType>;
  getRestrictedCharities?: Maybe<Array<Maybe<RestrictedCategoryType>>>;
  getServiceRequestsByChannel?: Maybe<ServiceRequestsByChannelType>;
  getServiceRequestsByIssueType?: Maybe<ServiceRequestByIssueTypeType>;
  /** Return user data and current step for a signup session. */
  getSignupState?: Maybe<SignupStateType>;
  /** Get filters for contributions, grants and related statuses in period */
  getTransactionFilters?: Maybe<TransactionFiltersType>;
  /** List of all the contribution requests/grants which were completed and reached the specified charity. */
  giftHistory?: Maybe<Array<Maybe<GiftHistoryType>>>;
  giftedYears?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  /** List all the contribution grants made by the family members. */
  gifts?: Maybe<Array<Maybe<ContributionType>>>;
  /** List all the contribution grants made by the family members. */
  giftsActivity?: Maybe<GiftHistory>;
  give?: Maybe<Scalars["GenericScalar"]["output"]>;
  givingPlan?: Maybe<GivingPlanType>;
  grantDetails?: Maybe<GrantDetailType>;
  /** All grant history upload batches for a family. */
  grantHistoryBatches?: Maybe<Array<Maybe<GrantHistoryBatchType>>>;
  /** Paginated imported grant history records for a family. */
  grantHistoryRecords?: Maybe<PaginatedGrantHistoryRecordType>;
  growthActivities?: Maybe<GrowthActivityPaginatedType>;
  /** All GS book-of-business import jobs for the current advisor. */
  gsBookOfBusinessImportJobs?: Maybe<Array<Maybe<BookOfBusinessImportJobType>>>;
  /** Branch and rep codes available to the logged-in advisor from GSCS. */
  gsBranchRepCodes?: Maybe<GsBranchRepCodesType>;
  /** Current GS DAF account opening application for a family. */
  gsDafAccountApplication?: Maybe<GsDafAccountApplicationType>;
  /** Paginated import records for a specific import job. */
  gsImportRecords?: Maybe<GsImportRecordsPaginatedType>;
  /** Resolve the GS owner(s) of an imported account for the Link-to-DAF flow. */
  gsPortfolioOwners?: Maybe<GsPortfolioOwnersType>;
  inheritanceRegistries?: Maybe<Array<Maybe<InheritanceRegistryType>>>;
  integratedMasterAccounts?: Maybe<
    Array<Maybe<AdventIntegratedMasterAccountType>>
  >;
  integrations?: Maybe<Array<Maybe<AdventIntegrationType>>>;
  investmentChangeRequests?: Maybe<InvestmentChangeRequestPaginatedType>;
  isGiveUser?: Maybe<Scalars["Boolean"]["output"]>;
  legacyBlueprint?: Maybe<LegacyBlueprintType>;
  legacyDocuments?: Maybe<Array<Maybe<InheritanceDocumentType>>>;
  linkedAccounts?: Maybe<LinkedAccountPaginatedType>;
  listAccountStatementDates?: Maybe<
    Array<Maybe<Scalars["GenericScalar"]["output"]>>
  >;
  listAdvisorClients?: Maybe<AdvisorPaginatedType>;
  listAdvisorGroupClients?: Maybe<AdvisorGroupClientsPaginatedType>;
  listAdvisorsAssign?: Maybe<Array<Maybe<ListAdvisorAssignType>>>;
  listAdvisorsOpsAssign?: Maybe<Array<Maybe<ListAdvisorAssignType>>>;
  listAdvisoryOps?: Maybe<AdvisoryopsPaginatedType>;
  listAllFirms?: Maybe<FirmPaginatedType>;
  listArchivedUsers?: Maybe<ArchivedUsersPaginatedType>;
  listCashContributions?: Maybe<ListCashContributionsPaginatedType>;
  listClientAssign?: Maybe<Array<Maybe<ListClientAssignType>>>;
  /** List Company Grants. */
  listCompanyGrants?: Maybe<CompanyGrantPaginatedType>;
  /** List employees. */
  listEmployees?: Maybe<EmployeePaginatedType>;
  listFamilyAdmins?: Maybe<Array<Maybe<UserType>>>;
  listFirmAdmins?: Maybe<Array<Maybe<UserType>>>;
  listFirmAdvisors?: Maybe<FirmPaginationType>;
  /** List all the categories and its tags of the firm. */
  listFirmTagCategories?: Maybe<Array<Maybe<TagCategoryType>>>;
  listFirmUsers?: Maybe<FirmUsersPaginationType>;
  listIndividualClients?: Maybe<IndividualClientPaginatedType>;
  /** List minimum grant and contribution settings */
  listMinimumGrantsContributions?: Maybe<Scalars["GenericScalar"]["output"]>;
  /** List participants. */
  listParticipants?: Maybe<EmployeePaginatedType>;
  listPendingUsers?: Maybe<PendingUsersPaginatedType>;
  listRecentContributions?: Maybe<Array<Maybe<CashTransactionIntegeratedType>>>;
  listRecentFamilies?: Maybe<Array<Maybe<RecentFamilyType>>>;
  listRecentFirms?: Maybe<RecentFirmType>;
  listRiaClients?: Maybe<RiaClientDetailPaginatedType>;
  listSecurityContributions?: Maybe<SecurityTransactionPaginatedType>;
  listThirdpartyContributions?: Maybe<Array<Maybe<ThirdPartyTransactionType>>>;
  /** List all transactions with filtering and pagination */
  listTransactions?: Maybe<ListTransactionsPaginatedType>;
  listUplodedFamily?: Maybe<Array<Maybe<FamilyListType>>>;
  /** Plan-derived figures for the Living Legacy KPI strip, without fetching the plans themselves. */
  livingLegacyKpis?: Maybe<LivingLegacyKpisType>;
  /** One client's Living Legacy plan. Use this instead of livingLegacyPlans when showing a single plan -- the list runs a live DAF balance lookup per family. Null when the family is not the caller's client or is not eligible (single-charity fund, no DAF account, inactive head of family). */
  livingLegacyPlan?: Maybe<LivingLegacyPlanType>;
  livingLegacyPlans?: Maybe<Array<Maybe<LivingLegacyPlanType>>>;
  /** Conditions on the advisor's in-flight succession transitions that need a person to look at them. Derived live, so an alert disappears as soon as its condition clears. */
  livingLegacyTransitionAlerts?: Maybe<Array<Maybe<TransitionAlertType>>>;
  /** List of all sponsor/models/portfolio availabe in Louise. */
  marketModels?: Maybe<Array<Maybe<SponsorType>>>;
  /** Prepare performance chart for the provided models */
  modelPerformanceCharts?: Maybe<Scalars["GenericScalar"]["output"]>;
  /** List of portfolios for each model and corresponding asset breakdowns. */
  modelPortfolios?: Maybe<Array<Maybe<PortfolioType>>>;
  /** List of all sponsor/models/portfolio availabe for an advisor in Louise. */
  myModels?: Maybe<Array<Maybe<ModelType>>>;
  /** The logged-in user's undecided successor invite (neither accepted nor declined) for the given family, or null. Drives the accept/decline screen at the start of successor onboarding. */
  mySuccessorInvite?: Maybe<SuccessorType>;
  /** The logged-in user's successor onboarding progress for the given family, or null when they are not a successor claiming it. Tells the client which step to resume on. */
  mySuccessorOnboarding?: Maybe<SuccessorOnboardingType>;
  newCashContributionDetails?: Maybe<CashContributionDetailType>;
  /** For new UI, List of all families under a specific advisor.                No arguments required, AdvisorId is taken from auth token.                Status could be provided to get active or pending DAFs. */
  newDafClients?: Maybe<FamilyPaginatedType>;
  notifications?: Maybe<NotificationsType>;
  oktaPasswordPolicy?: Maybe<OktaPasswordPolicyType>;
  /** What YOU have done on the succession queue (ops_admin only) -- your own audit trail behind every step attempted, certificate ruled on and variance accepted. Scoped to the signed-in admin on the server. */
  opsActivity?: Maybe<Array<Maybe<OpsActivityType>>>;
  /** One family's newest succession transition, as the ops detail view shows it (ops_admin only). The same row the queue lists, so the page you open is the row you clicked. */
  opsTransition?: Maybe<OpsTransitionRowType>;
  /** Every succession transition across all families, with the step it is on, how long it has sat there and what is holding it (ops_admin only). The pipeline view: ops could previously see only the death-certificate queue and the step 4 transfers, so a transition stalled anywhere else was invisible. */
  opsTransitions?: Maybe<Array<Maybe<OpsTransitionRowType>>>;
  /** Returns the family's configuration/constraints added for the portfolio construction */
  optimise?: Maybe<OptimiseConfigType>;
  optimiserPrefetchValues?: Maybe<Scalars["JSONString"]["output"]>;
  optimizeTax?: Maybe<TaxOptimizeType>;
  optimizerSecuritiesListing?: Maybe<
    Array<Maybe<AdventIntegratedPortfolioSodEntryType>>
  >;
  /** Get Payment Method Details. */
  paymentMethod?: Maybe<PaymentMethodType>;
  /** All death event transitions pending ops review (ops_admin only). */
  pendingDeathTransitions?: Maybe<Array<Maybe<SuccessionTransitionType>>>;
  perfectScoreCharities?: Maybe<Array<Maybe<CharityType>>>;
  /** Ordered list of up to 4 contribution IDs pinned to the Giving History section. */
  pinnedGivingHistory?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  plaidItems?: Maybe<Array<Maybe<PlaidItemType>>>;
  /** Get a particular portfolio based on asset id. */
  portfolioByAssetId?: Maybe<PortfolioType>;
  portfolios?: Maybe<Array<Maybe<AccountType>>>;
  /** Proximity details amongst family members */
  proximity?: Maybe<Array<Maybe<ProximityType>>>;
  publicCampaign?: Maybe<CampaignPublicType>;
  /** Public endpoint to list all donations for a campaign without authentication */
  publicCampaignDonations?: Maybe<CampaignDonationPaginatedType>;
  recentlyEngaged?: Maybe<Array<Maybe<CharityType>>>;
  recentlyViewed?: Maybe<Array<Maybe<CharityType>>>;
  recommendedCharities?: Maybe<Array<Maybe<RecommendedCategoryType>>>;
  recommendedFundsDonor?: Maybe<RecommendedFundDonorType>;
  recommendedFundsFamily?: Maybe<RecommendedFundFamilyType>;
  recurringGift?: Maybe<RecurringGiftType>;
  recurringGifts?: Maybe<RecurringGiftsPaginatedType>;
  relationOptions?: Maybe<Array<Maybe<RelationOptionsType>>>;
  savedCards?: Maybe<Array<Maybe<PaymentMethodType>>>;
  /** Get details of a specific scheduled credit card contribution by ID */
  scheduledCcContributionDetails?: Maybe<ScheduledCcContributionDto>;
  /** Get details of a specific scheduled ACH contribution by ID */
  scheduledContributionDetails?: Maybe<ScheduledContributionType>;
  /** Get list of all active scheduled contributions for a family */
  scheduledContributions?: Maybe<Array<Maybe<ScheduledContributionType>>>;
  /** Search users in families managed by advisors (direct or indirect) */
  searchAdvisorFamilyUsers?: Maybe<UsersPaginatedType>;
  searchAll?: Maybe<SearchAllResultsType>;
  searchFirmAdvisors?: Maybe<UsersInGroupPaginationType>;
  searchSuggestions?: Maybe<SearchSuggestionsType>;
  searchTickers?: Maybe<Array<Maybe<TickerType>>>;
  searchUser?: Maybe<UsersPaginatedType>;
  securityContributionDetails?: Maybe<SecurityContributionDetailType>;
  /** List all the bank/securities accounts and details linked to DAF. */
  selectedAccountList?: Maybe<Array<Maybe<ConnectedAccountType>>>;
  /** List of all Sponsors. */
  sponsors?: Maybe<Array<Maybe<ThirdPartySponsorsType>>>;
  subCauses?: Maybe<Array<Maybe<CauseType>>>;
  successionIntegration?: Maybe<SuccessionIntegrationType>;
  successionPolicy?: Maybe<SuccessionPolicyType>;
  /** Every succession transfer currently at step 4, across all families, with what was expected against what actually arrived (ops_admin only). Transfers whose amounts differ sit here until an ops admin accepts the difference. */
  successionReconciliations?: Maybe<Array<Maybe<SuccessionReconciliationType>>>;
  /** Each successor's DAF-to-DAF transfer for this family, with the real amounts and settlement dates. What the step 4 card renders instead of deriving rows client-side. */
  successionTransfers?: Maybe<Array<Maybe<SuccessionTransferType>>>;
  /** Return the active succession transition for a family, or null if none exists. */
  successionTransition?: Maybe<SuccessionTransitionType>;
  /** Payout policy and sunset terms of the originating fund, for the Successor Acknowledgment Form. Null when the caller is not a successor claiming the given destination family. */
  successorAcknowledgment?: Maybe<SuccessorAcknowledgmentType>;
  /** The originating founder's message, recordings and mission, for a successor claiming that fund into the given destination family. Null when the caller is not such a successor. */
  successorFoundersVoice?: Maybe<SuccessorFoundersVoiceType>;
  /** The originating founder's pinned giving history, for successor onboarding step 6. Null when the caller is not a successor claiming the given destination family. */
  successorGivingHistory?: Maybe<SuccessorGivingHistoryType>;
  successors?: Maybe<Array<Maybe<SuccessorType>>>;
  sunsetCharityAllocations?: Maybe<Array<Maybe<SunsetCharityAllocationType>>>;
  superSizedCharities?: Maybe<Array<Maybe<CharityType>>>;
  /** Lists all the Cash/Securities transfer made to DAF,             along with details like Bank/Custodian, Date of Transfer, Estimated Tax Savings etc. */
  taxSavings?: Maybe<Array<Maybe<TaxSavingsAccountType>>>;
  thirdpartyTransactionsReciept?: Maybe<Scalars["String"]["output"]>;
  todos?: Maybe<ActionablePaginatedType>;
  /** List of top contribution categories. */
  topCategories?: Maybe<Array<Maybe<TopCategoryType>>>;
  topRecommendations?: Maybe<TopRecommendationsType>;
  transactionHistory?: Maybe<Array<Maybe<TransactionType>>>;
  /** Download transaction instructions */
  transactionInstructions?: Maybe<Scalars["String"]["output"]>;
  /** All active recurring gifts, pending company grants, and pending contributions for the Step 1 transition review checklist. */
  transitionActiveItems?: Maybe<TransitionActiveItemsPaginatedType>;
  /** All past (aborted/completed) succession transitions for a family, newest first. */
  transitionHistory?: Maybe<Array<Maybe<SuccessionTransitionType>>>;
  trendingCharities?: Maybe<Array<Maybe<CharityType>>>;
  user?: Maybe<UserType>;
  /** Fetch the giving portfolio distribution */
  userContributionDistribution?: Maybe<
    Array<Maybe<UserContributionDistributionType>>
  >;
  userLinkedPortfolio?: Maybe<Array<Maybe<AdventIntegratedPortfolioType>>>;
  userRecentlyEngaged?: Maybe<Array<Maybe<CharityType>>>;
  userTaxOptimiserSession?: Maybe<OptimiserSessionType>;
  users?: Maybe<Array<Maybe<UserType>>>;
  validateEin?: Maybe<Scalars["Boolean"]["output"]>;
  validateEmail?: Maybe<UserType>;
  validateSelfDirectedUser?: Maybe<UserType>;
  validateTickerList?: Maybe<Array<Maybe<ValidatedTicker>>>;
  validateTickers?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  validateUserEmail?: Maybe<EmailValidationType>;
  /** Point lookup for a single ZIP code; returns null if the ZIP is unknown. */
  validateZipCode?: Maybe<ZipCodeInfoType>;
};

export type QueryActiveHofsArgs = {
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchStr?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryActivitiesArgs = {
  filter?: InputMaybe<ActivityFilterInput>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchStr?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAdvisorClientTransactionsArgs = {
  filters?: InputMaybe<TransactionFilterInputType>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryAdvisorClientsSummaryArgs = {
  advisorId: Scalars["Int"]["input"];
};

export type QueryAdvisorCustodianMetadataArgs = {
  advisorId: Scalars["Int"]["input"];
  dafCustodianId: Scalars["Int"]["input"];
};

export type QueryAdvisorDafDetailsArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryAdvisorFamilyArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryAdvisorFamilyDashboardArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryAdvisorFamilyMembersArgs = {
  familyId: Scalars["Int"]["input"];
  inviteStatus?: InputMaybe<Scalars["String"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryAdvisorGroupArgs = {
  groupId: Scalars["Int"]["input"];
};

export type QueryAdvisorGroupFamilyArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryAdvisorGroupsArgs = {
  excludeIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchString?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAdvisorLoginArgs = {
  userId: Scalars["Int"]["input"];
};

export type QueryAdvisorOpsClientsDetailsArgs = {
  advisorOpsId: Scalars["Int"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAdvisorsArgs = {
  searchString?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAdvisoryOpsSummaryArgs = {
  advisorOpsId: Scalars["Int"]["input"];
};

export type QueryAlertsArgs = {
  filter?: InputMaybe<ActionableFilterInput>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchStr?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAlignArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryArticlesArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  fundIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryAssociatedFamiliesArgs = {
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchStr?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryBeneficiariesArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryBookLevelSettingsArgs = {
  userId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryBunchingPlanDraftArgs = {
  portfolioCode: Scalars["String"]["input"];
};

export type QueryCampaignDashboardMetricsArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryCampaignDonationsArgs = {
  campaignId: Scalars["Int"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryCampaignDraftsArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryCampaignStatsArgs = {
  campaignId: Scalars["String"]["input"];
};

export type QueryCampaignsArgs = {
  familyId: Scalars["Int"]["input"];
  filters?: InputMaybe<CampaignFilterInputType>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryCampaignsByAdvisorArgs = {
  filters?: InputMaybe<CampaignFilterInputType>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryCashContributionDetailsArgs = {
  familyId: Scalars["Int"]["input"];
  transactionReference: Scalars["String"]["input"];
  transactionType: CashTransactionAccountEnumType;
};

export type QueryCategoriesArgs = {
  ctype?: InputMaybe<CTypeEnumType>;
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryCausesArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryCharitiesArgs = {
  catId?: InputMaybe<Scalars["String"]["input"]>;
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryCharityDetailArgs = {
  charityId?: InputMaybe<Scalars["String"]["input"]>;
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
  isFamily?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryCharityMatchesArgs = {
  searchString: Scalars["String"]["input"];
};

export type QueryCharitySearchArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  parentUid?: InputMaybe<Scalars["Boolean"]["input"]>;
  searchQuery: Scalars["String"]["input"];
  uid?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryCharitySearchDetailArgs = {
  charityId: Scalars["String"]["input"];
};

export type QueryCheckCharityEligibilityArgs = {
  ein: Scalars["String"]["input"];
};

export type QueryClientLevelSettingsArgs = {
  portfolioId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryClientsWithThirdPartyDafArgs = {
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryConnectedBankAccountsArgs = {
  plaidItemId: Scalars["Int"]["input"];
};

export type QueryContributionsSummaryArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryContributorYearsArgs = {
  contributor: Scalars["String"]["input"];
  familyId: Scalars["Int"]["input"];
};

export type QueryContributorsArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryCorporateUserSummaryArgs = {
  firmId: Scalars["Int"]["input"];
};

export type QueryCreateLinkTokenArgs = {
  familyId: Scalars["Int"]["input"];
  itemId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryCuratesListArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryCustodianPortfolioArgs = {
  ccPortfolioId: Scalars["Int"]["input"];
};

export type QueryCustomFeeDetailsArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryDafClientsArgs = {
  filters?: InputMaybe<AdvisorDafClientsFilterType>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchStr?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryDafImpactReportArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryDafPoolsArgs = {
  dafRef: Scalars["String"]["input"];
};

export type QueryDashboardGraphsDataArgs = {
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryDownloadFamilyDataArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryEmployeesSummaryArgs = {
  firmId: Scalars["Int"]["input"];
};

export type QueryEngagedCharitiesArgs = {
  causeKey?: InputMaybe<Scalars["String"]["input"]>;
  ctype?: InputMaybe<CTypeEnumType>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  year?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryEngagementDistributionArgs = {
  ctype?: InputMaybe<CTypeEnumType>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  year?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryFamiliesWithPortfolioMappingsArgs = {
  filters?: InputMaybe<AdvisorDafClientsFilterType>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchStr?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryFamilyArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryFamilyCharityCausesArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryFamilyFavoriteCharitiesArgs = {
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryFamilyMembersArgs = {
  categoryId: Scalars["Int"]["input"];
};

export type QueryFamilyTreeArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryFavoriteCharitiesArgs = {
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryFavouritesArgs = {
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryFeaturedCharitiesArgs = {
  firmId: Scalars["Int"]["input"];
};

export type QueryFeaturedGrantsArgs = {
  familyId: Scalars["Int"]["input"];
  ids?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryFetchEmailChangeDetailsArgs = {
  token: Scalars["String"]["input"];
};

export type QueryFirmArgs = {
  firmId: Scalars["Int"]["input"];
};

export type QueryFirmClientDetailsArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryFirmDocumentsArgs = {
  firmId: Scalars["Int"]["input"];
};

export type QueryFirmSummaryArgs = {
  firmId: Scalars["Int"]["input"];
};

export type QueryFundSearchArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  familyId: Scalars["Int"]["input"];
  filterKeys?: InputMaybe<Array<InputMaybe<FilterKeyType>>>;
  genSearchStr?: InputMaybe<Scalars["String"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryFundsArgs = {
  categoryId: Scalars["Int"]["input"];
  ftype?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetAccountStatementArgs = {
  date: Scalars["Date"]["input"];
  familyId: Scalars["Int"]["input"];
  period: Scalars["String"]["input"];
};

export type QueryGetAdoptionBannerStatsArgs = {
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetChannelPerformanceMetricsArgs = {
  filterType?: InputMaybe<Scalars["String"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetCharityArgs = {
  id: Scalars["String"]["input"];
};

export type QueryGetConversationTopIssuesArgs = {
  filterType?: InputMaybe<Scalars["String"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetCorporateClientsListArgs = {
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  programFilter?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetCorporateDafsListArgs = {
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetCuratedListCountArgs = {
  donorId?: InputMaybe<Scalars["Int"]["input"]>;
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetCustomFeesArgs = {
  firmId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetCustomerSuccessMetricsArgs = {
  filterType?: InputMaybe<Scalars["String"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetDafContributionsArgs = {
  dafId?: InputMaybe<Scalars["Int"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  filterBy?: InputMaybe<Scalars["String"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetDafGrantsArgs = {
  dafId?: InputMaybe<Scalars["Int"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  filterBy?: InputMaybe<Scalars["String"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetDafStatsArgs = {
  dafId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetDistributionListArgs = {
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  period?: InputMaybe<Scalars["String"]["input"]>;
  programFilter?: InputMaybe<Scalars["String"]["input"]>;
  segmentKey?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  year?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetDistributionStatsArgs = {
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  frequency?: InputMaybe<Scalars["String"]["input"]>;
  programFilter?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetEmailPreferencesArgs = {
  firmId: Scalars["Int"]["input"];
};

export type QueryGetEmployeeDetailsArgs = {
  employeeId: Scalars["Int"]["input"];
};

export type QueryGetEngagementFunnelArgs = {
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetEngagementOverTimeArgs = {
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetEnterpriseClientsListArgs = {
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetFamilyAllocationsArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryGetFeeTierArgs = {
  advisorId?: InputMaybe<Scalars["String"]["input"]>;
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetFeesByAdvisorArgs = {
  advisorId?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetFeesByEnterpriseArgs = {
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetFeesByFirmArgs = {
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetFeesByProgramArgs = {
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetFeesStatsArgs = {
  advisorId?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetFirmEmailStatisticsArgs = {
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetFirmPoolsetsArgs = {
  firmId: Scalars["String"]["input"];
};

export type QueryGetFundAssetPoolsArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryGetFundReallocationRebalanceRequestsArgs = {
  fundId: Scalars["ID"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetFundTransferRequestsArgs = {
  fundId: Scalars["ID"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetImaAccountNumberArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryGetOperationsAumByInvestmentModelArgs = {
  frequency?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetOperationsContributionsCountArgs = {
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  filterBy?: InputMaybe<Scalars["String"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetOperationsContributionsKpIsArgs = {
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  filterBy?: InputMaybe<Scalars["String"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetOperationsContributionsStatsArgs = {
  contributionStateFilter?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  filterBy?: InputMaybe<Scalars["String"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetOperationsGrantsKpIsArgs = {
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  filterBy?: InputMaybe<Scalars["String"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetOperationsGrantsStatsArgs = {
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  filterBy?: InputMaybe<Scalars["String"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  grantsStateFilter?: InputMaybe<Scalars["String"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetOperationsGrantsVolumeStatusStatsArgs = {
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  filterBy?: InputMaybe<Scalars["String"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetOperationsListEnterprisesArgs = {
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetOperationsListFirmsArgs = {
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetOperationsStatsArgs = {
  dafId?: InputMaybe<Scalars["Int"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  filterBy?: InputMaybe<Scalars["String"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetOverviewStatsArgs = {
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  programFilter?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetPoolSetRecommendationsArgs = {
  custodianIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type QueryGetProgramAumStatsArgs = {
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  frequency?: InputMaybe<Scalars["String"]["input"]>;
  programFilter?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetRestrictedCharitiesArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryGetServiceRequestsByChannelArgs = {
  filterType?: InputMaybe<Scalars["String"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetServiceRequestsByIssueTypeArgs = {
  filterType?: InputMaybe<Scalars["String"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  issueType?: InputMaybe<Scalars["String"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetSignupStateArgs = {
  sessionToken: Scalars["String"]["input"];
};

export type QueryGetTransactionFiltersArgs = {
  endDate: Scalars["Date"]["input"];
  startDate: Scalars["Date"]["input"];
};

export type QueryGiftHistoryArgs = {
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGiftedYearsArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryGiftsArgs = {
  familyId: Scalars["Int"]["input"];
  year?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGiftsActivityArgs = {
  familyId: Scalars["Int"]["input"];
  filters?: InputMaybe<GiftActivityFilterInputType>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  shouldPaginate?: InputMaybe<Scalars["Boolean"]["input"]>;
  sort?: InputMaybe<Scalars["String"]["input"]>;
  year?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGiveArgs = {
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
  internationalCharity?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryGrantDetailsArgs = {
  grantId: Scalars["Int"]["input"];
};

export type QueryGrantHistoryBatchesArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryGrantHistoryRecordsArgs = {
  charityEin?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["Date"]["input"]>;
  familyId: Scalars["Int"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  startDate?: InputMaybe<Scalars["Date"]["input"]>;
};

export type QueryGrowthActivitiesArgs = {
  filter?: InputMaybe<GrowthActivityFilterInput>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGsDafAccountApplicationArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryGsImportRecordsArgs = {
  jobId: Scalars["Int"]["input"];
  page: Scalars["Int"]["input"];
  pageSize: Scalars["Int"]["input"];
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGsPortfolioOwnersArgs = {
  portfolioCode: Scalars["String"]["input"];
};

export type QueryInheritanceRegistriesArgs = {
  familyId: Scalars["Int"]["input"];
  sourceType?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryInvestmentChangeRequestsArgs = {
  fundId: Scalars["ID"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryLegacyBlueprintArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryLegacyDocumentsArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryLinkedAccountsArgs = {
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryListAccountStatementDatesArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryListAdvisorClientsArgs = {
  advisorId: Scalars["Int"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryListAdvisorGroupClientsArgs = {
  groupId: Scalars["Int"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryListAdvisorsAssignArgs = {
  clientId: Scalars["Int"]["input"];
  firmId: Scalars["Int"]["input"];
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryListAdvisorsOpsAssignArgs = {
  firmId: Scalars["Int"]["input"];
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryListAdvisoryOpsArgs = {
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
  userId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryListAllFirmsArgs = {
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  onlyEnterprises?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryListArchivedUsersArgs = {
  firmId: Scalars["Int"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryListCashContributionsArgs = {
  familyId: Scalars["Int"]["input"];
  page: Scalars["Int"]["input"];
  pageSize: Scalars["Int"]["input"];
  transactionType?: InputMaybe<CashTransactionAccountEnumType>;
};

export type QueryListClientAssignArgs = {
  advisorId: Scalars["Int"]["input"];
  firmId: Scalars["Int"]["input"];
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryListCompanyGrantsArgs = {
  charityIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
  page: Scalars["Int"]["input"];
  pageSize: Scalars["Int"]["input"];
  sorters?: InputMaybe<Sorter>;
  status?: InputMaybe<CompanyGrantStatusChoices>;
  year?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryListEmployeesArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
  page: Scalars["Int"]["input"];
  pageSize: Scalars["Int"]["input"];
  searchString?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<SortOrderEnum>;
  sortingKey?: InputMaybe<EmployeeSortingKeysEnum>;
  status?: InputMaybe<EmployeeTypeEnum>;
  statusList?: InputMaybe<Array<InputMaybe<EmployeeTypeEnum>>>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  userType?: InputMaybe<Array<InputMaybe<CorporateDafUserTypeFilterType>>>;
};

export type QueryListFamilyAdminsArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryListFirmAdminsArgs = {
  firmId: Scalars["Int"]["input"];
};

export type QueryListFirmAdvisorsArgs = {
  excludeIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  firmId: Scalars["Int"]["input"];
  isForAddClient?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
  userId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryListFirmTagCategoriesArgs = {
  tagCategoryId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryListFirmUsersArgs = {
  excludeIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  firmId: Scalars["Int"]["input"];
  inviteStatus?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
  userId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryListIndividualClientsArgs = {
  clientId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId: Scalars["Int"]["input"];
  isDafExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryListMinimumGrantsContributionsArgs = {
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryListParticipantsArgs = {
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  page: Scalars["Int"]["input"];
  pageSize: Scalars["Int"]["input"];
  searchString?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<SortOrderEnum>;
  sortingKey?: InputMaybe<EmployeeSortingKeysEnum>;
  statusList?: InputMaybe<Array<InputMaybe<IndividualDafStatusFilterType>>>;
};

export type QueryListPendingUsersArgs = {
  firmId: Scalars["Int"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryListRecentContributionsArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryListRiaClientsArgs = {
  clientId?: InputMaybe<Scalars["Int"]["input"]>;
  excludeGroupId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId: Scalars["Int"]["input"];
  isDafExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryListSecurityContributionsArgs = {
  familyId: Scalars["Int"]["input"];
  page: Scalars["Int"]["input"];
  pageSize: Scalars["Int"]["input"];
  securityType?: InputMaybe<SecurityTransactionTypeChoices>;
};

export type QueryListThirdpartyContributionsArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryListTransactionsArgs = {
  familyId: Scalars["Int"]["input"];
  filters?: InputMaybe<TransactionFilterInputType>;
};

export type QueryLivingLegacyPlanArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryMarketModelsArgs = {
  sponsorId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryModelPerformanceChartsArgs = {
  model1AssetId: Scalars["String"]["input"];
  model2AssetId: Scalars["String"]["input"];
};

export type QueryModelPortfoliosArgs = {
  modelId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryMyModelsArgs = {
  custodianId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryMySuccessorInviteArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryMySuccessorOnboardingArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryNewCashContributionDetailsArgs = {
  familyId: Scalars["Int"]["input"];
  source: TransactionAccountEnumTypeV2;
  transactionId: Scalars["Int"]["input"];
};

export type QueryNewDafClientsArgs = {
  advisorId?: InputMaybe<Scalars["Int"]["input"]>;
  filters?: InputMaybe<AdvisorDafClientsFilterType>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchStr?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryNotificationsArgs = {
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryOktaPasswordPolicyArgs = {
  firmId: Scalars["Int"]["input"];
};

export type QueryOpsActivityArgs = {
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryOpsTransitionArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryOpsTransitionsArgs = {
  includeCompleted?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryOptimiseArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryOptimiserPrefetchValuesArgs = {
  hohId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryOptimizeTaxArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryOptimizerSecuritiesListingArgs = {
  portfolioIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type QueryPaymentMethodArgs = {
  ccType?: InputMaybe<Scalars["String"]["input"]>;
  paymentMethodId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryPinnedGivingHistoryArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryPlaidItemsArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryPortfolioByAssetIdArgs = {
  assetId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryPortfoliosArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryProximityArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryPublicCampaignArgs = {
  campaignId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryPublicCampaignDonationsArgs = {
  campaignId: Scalars["Int"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryRecentlyEngagedArgs = {
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryRecentlyViewedArgs = {
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryRecommendedFundsDonorArgs = {
  donorId: Scalars["Int"]["input"];
  familyId: Scalars["Int"]["input"];
};

export type QueryRecommendedFundsFamilyArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryRecurringGiftArgs = {
  giftId: Scalars["Int"]["input"];
};

export type QueryRecurringGiftsArgs = {
  familyId: Scalars["Int"]["input"];
  filters?: InputMaybe<GiftActivityFilterInputType>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  shouldPaginate?: InputMaybe<Scalars["Boolean"]["input"]>;
  sort?: InputMaybe<Scalars["String"]["input"]>;
  year?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QuerySavedCardsArgs = {
  ccType?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryScheduledCcContributionDetailsArgs = {
  scheduledCcContributionId: Scalars["Int"]["input"];
};

export type QueryScheduledContributionDetailsArgs = {
  scheduledContributionId: Scalars["Int"]["input"];
};

export type QueryScheduledContributionsArgs = {
  familyId: Scalars["Int"]["input"];
  transactionType?: InputMaybe<CashTransactionAccountEnumType>;
};

export type QuerySearchAdvisorFamilyUsersArgs = {
  advisorId?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchStr?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuerySearchAllArgs = {
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchText: Scalars["String"]["input"];
};

export type QuerySearchFirmAdvisorsArgs = {
  firmId: Scalars["Int"]["input"];
  isForAddClient?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuerySearchSuggestionsArgs = {
  familyId: Scalars["Int"]["input"];
  international?: InputMaybe<Scalars["Boolean"]["input"]>;
  searchString: Scalars["String"]["input"];
};

export type QuerySearchTickersArgs = {
  searchString: Scalars["String"]["input"];
};

export type QuerySearchUserArgs = {
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchStr?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuerySecurityContributionDetailsArgs = {
  familyId: Scalars["Int"]["input"];
  pageNumber?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  transactionReference: Scalars["String"]["input"];
};

export type QuerySelectedAccountListArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QuerySubCausesArgs = {
  catId?: InputMaybe<Scalars["String"]["input"]>;
  familyId: Scalars["Int"]["input"];
};

export type QuerySuccessionIntegrationArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QuerySuccessionPolicyArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QuerySuccessionTransfersArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QuerySuccessionTransitionArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QuerySuccessorAcknowledgmentArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QuerySuccessorFoundersVoiceArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QuerySuccessorGivingHistoryArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QuerySuccessorsArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QuerySunsetCharityAllocationsArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryTaxSavingsArgs = {
  familyId: Scalars["Int"]["input"];
  year?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryThirdpartyTransactionsRecieptArgs = {
  familyId: Scalars["Int"]["input"];
  transactionId: Scalars["Int"]["input"];
};

export type QueryTodosArgs = {
  filter?: InputMaybe<ActionableFilterInput>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchStr?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryTopCategoriesArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryTransactionHistoryArgs = {
  accountId: Scalars["Int"]["input"];
  accountType: Scalars["String"]["input"];
};

export type QueryTransactionInstructionsArgs = {
  familyId: Scalars["Int"]["input"];
  transactionId: Scalars["Int"]["input"];
};

export type QueryTransitionActiveItemsArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryTransitionHistoryArgs = {
  familyId: Scalars["Int"]["input"];
};

export type QueryTrendingCharitiesArgs = {
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryUserArgs = {
  userId: Scalars["Int"]["input"];
};

export type QueryUserContributionDistributionArgs = {
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryUserLinkedPortfolioArgs = {
  hohId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryUserRecentlyEngagedArgs = {
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryUserTaxOptimiserSessionArgs = {
  sessionId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryValidateEinArgs = {
  ein: Scalars["String"]["input"];
};

export type QueryValidateEmailArgs = {
  token: Scalars["String"]["input"];
};

export type QueryValidateSelfDirectedUserArgs = {
  token: Scalars["String"]["input"];
};

export type QueryValidateTickerListArgs = {
  tickerList: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type QueryValidateTickersArgs = {
  tickers: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type QueryValidateUserEmailArgs = {
  desiredRole: Scalars["String"]["input"];
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  userEmail: Scalars["String"]["input"];
};

export type QueryValidateZipCodeArgs = {
  zipCode: Scalars["String"]["input"];
};

/** API to reactivate a user */
export type ReactivateUser = {
  __typename?: "ReactivateUser";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Replacing advisor group with new advisor group to the family */
export type ReassignAdvisorGroupToFamily = {
  __typename?: "ReassignAdvisorGroupToFamily";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Replacing primary advisor with new advisor to the family */
export type ReassignPrimaryAdvisorToFamily = {
  __typename?: "ReassignPrimaryAdvisorToFamily";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Response fields to have pagination for users list  */
export type RecentFamilyType = {
  __typename?: "RecentFamilyType";
  id?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type RecentFirmType = {
  __typename?: "RecentFirmType";
  firmsCount?: Maybe<Scalars["Int"]["output"]>;
  recentFirm?: Maybe<Array<Maybe<FirmType>>>;
};

export type RecommendedCategoryType = {
  __typename?: "RecommendedCategoryType";
  funds?: Maybe<Array<Maybe<CharityType>>>;
  fundsCount?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  images?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  value?: Maybe<Scalars["String"]["output"]>;
};

export type RecommendedFundDonorType = {
  __typename?: "RecommendedFundDonorType";
  funds?: Maybe<Array<Maybe<CharityType>>>;
};

export type RecommendedFundFamilyType = {
  __typename?: "RecommendedFundFamilyType";
  funds?: Maybe<Array<Maybe<CharityType>>>;
};

export enum RecurringGiftFrequency {
  /** Annually */
  Annually = "ANNUALLY",
  /** Monthly */
  Monthly = "MONTHLY",
  /** One Time */
  OneTime = "ONE_TIME",
  /** Quarterly */
  Quarterly = "QUARTERLY",
}

export type RecurringGiftType = {
  __typename?: "RecurringGiftType";
  amount: Scalars["Decimal"]["output"];
  anonymous: Scalars["Boolean"]["output"];
  cancelledAt?: Maybe<Scalars["DateTime"]["output"]>;
  cancelledBy?: Maybe<UserType>;
  cancelledByName?: Maybe<Scalars["String"]["output"]>;
  charity?: Maybe<CharityType>;
  charityId?: Maybe<Scalars["String"]["output"]>;
  charityName?: Maybe<Scalars["String"]["output"]>;
  companyGrant?: Maybe<CompanyGrantType>;
  completedOccurrences?: Maybe<Scalars["Int"]["output"]>;
  contributions: Array<GiftActivityType>;
  createdOn: Scalars["DateTime"]["output"];
  ein?: Maybe<Scalars["String"]["output"]>;
  endDate?: Maybe<Scalars["DateTime"]["output"]>;
  family?: Maybe<FamilyType>;
  frequency: RecurringGiftFrequency;
  id: Scalars["ID"]["output"];
  impersonatedBy?: Maybe<UserType>;
  isActive: Scalars["Boolean"]["output"];
  nextScheduled?: Maybe<Scalars["DateTime"]["output"]>;
  note?: Maybe<Scalars["String"]["output"]>;
  privacyFields?: Maybe<Scalars["JSONString"]["output"]>;
  privacyPreset?: Maybe<Scalars["String"]["output"]>;
  seriesDisplayStatus?: Maybe<Scalars["String"]["output"]>;
  seriesStartedOn?: Maybe<Scalars["DateTime"]["output"]>;
  startDate?: Maybe<Scalars["DateTime"]["output"]>;
  supersededBy?: Maybe<RecurringGiftType>;
  supersedes: Array<RecurringGiftType>;
  sweepsFinalBalance: Scalars["Boolean"]["output"];
  totalOccurrences?: Maybe<Scalars["Int"]["output"]>;
  updatedOn: Scalars["DateTime"]["output"];
  user: UserType;
};

export type RecurringGiftsPaginatedType = {
  __typename?: "RecurringGiftsPaginatedType";
  objects?: Maybe<Array<Maybe<RecurringGiftType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export type Refresh = {
  __typename?: "Refresh";
  payload: Scalars["GenericScalar"]["output"];
  refreshExpiresIn: Scalars["Int"]["output"];
  token: Scalars["String"]["output"];
};

/** Accept the invitaion email, and register with Louise(Family Members). */
export type RegisterMember = {
  __typename?: "RegisterMember";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Accept the terms for an HOH who signs in through the firm's SSO. No password or Okta user. */
export type RegisterMemberForDonorSso = {
  __typename?: "RegisterMemberForDonorSSO";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Aprove company grant  */
export type RejectClientGrant = {
  __typename?: "RejectClientGrant";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Aprove company grant  */
export type RejectCompanyGrant = {
  __typename?: "RejectCompanyGrant";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * User: ops_admin
 * Reject a pending death event transition (e.g. certificate could not be verified).
 * Aborts the transition and unfreezes the DAF account.
 */
export type RejectDeathTransition = {
  __typename?: "RejectDeathTransition";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type RelationInputType = {
  relatedUserId: Scalars["Int"]["input"];
  relation: Scalars["String"]["input"];
};

/** Response fields to provide relation options  */
export type RelationOptionsType = {
  __typename?: "RelationOptionsType";
  id: Scalars["ID"]["output"];
  value: Scalars["String"]["output"];
};

/** API to remove advisors from an advisor user group  */
export type RemoveAdvisorsFromAdvisorUserGroup = {
  __typename?: "RemoveAdvisorsFromAdvisorUserGroup";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Remove a bank account from the user  */
export type RemoveBankAccount = {
  __typename?: "RemoveBankAccount";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type RemoveCache = {
  __typename?: "RemoveCache";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type RemoveCustomCharityImage = {
  __typename?: "RemoveCustomCharityImage";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Remove a family from Louise database.  */
export type RemoveFamily = {
  __typename?: "RemoveFamily";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Remove families from an advisor user group  */
export type RemoveFamilyIDsFromUserGroup = {
  __typename?: "RemoveFamilyIDsFromUserGroup";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  status?: Maybe<StatusSummaryType>;
};

/** Mutation to remove the Louise DAF Account  */
export type RemoveLouiseDaf = {
  __typename?: "RemoveLouiseDaf";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * User: Advisor
 * Remove member from a family
 */
export type RemoveMember = {
  __typename?: "RemoveMember";
  members?: Maybe<UserPaginatedType>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Remove a model from family  */
export type RemoveModel = {
  __typename?: "RemoveModel";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Mutation to remove the complete portfolio  */
export type RemovePortfolio = {
  __typename?: "RemovePortfolio";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** remove Profile Image */
export type RemoveProfilePic = {
  __typename?: "RemoveProfilePic";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * API to remove/delete an advisor user group completely.
 * This will also remove all associated memberships and family associations.
 */
export type RemoveUserGroup = {
  __typename?: "RemoveUserGroup";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type RemoveUserPortfolioMapping = {
  __typename?: "RemoveUserPortfolioMapping";
  message?: Maybe<Scalars["String"]["output"]>;
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Edit  DAF Details  */
export type RenameDaf = {
  __typename?: "RenameDAF";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** API to request ACH setup for a charity  */
export type RequestAchSetup = {
  __typename?: "RequestAchSetup";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Send the review request again and restart the honoree's 30 days. */
export type ResendConsentRequest = {
  __typename?: "ResendConsentRequest";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** API to resend invite for pending user */
export type ResendInvite = {
  __typename?: "ResendInvite";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Reset Password based on token  */
export type ResetPassword = {
  __typename?: "ResetPassword";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * The honoree's answer to a tribute review request.
 *
 * Deliberately unauthenticated: the honoree may not be a user of the app. The
 * signed token in their emailed link is the credential, and it only ever
 * identifies one campaign.
 */
export type RespondCampaignConsent = {
  __typename?: "RespondCampaignConsent";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  /** approved, declined, expired or already_answered */
  result?: Maybe<Scalars["String"]["output"]>;
  /** Campaign state after the response */
  state?: Maybe<Scalars["String"]["output"]>;
};

export type RestrictedCategoryType = {
  __typename?: "RestrictedCategoryType";
  charities?: Maybe<Scalars["String"]["output"]>;
  ein?: Maybe<Scalars["String"]["output"]>;
};

/** Response fields to have pagination for advisor's detail list  */
export type RiaClientDetailPaginatedType = {
  __typename?: "RiaClientDetailPaginatedType";
  objects?: Maybe<Array<Maybe<RiaClientDetailType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

export type RiaClientDetailType = {
  __typename?: "RiaClientDetailType";
  advisorGroup?: Maybe<AdvisorGroupType>;
  advisorId?: Maybe<Scalars["Int"]["output"]>;
  advisorName?: Maybe<Scalars["String"]["output"]>;
  aum?: Maybe<Scalars["Float"]["output"]>;
  clientId?: Maybe<Scalars["Int"]["output"]>;
  clientName?: Maybe<Scalars["String"]["output"]>;
  companyAdmins?: Maybe<Array<Maybe<CompanyMemberType>>>;
  dafId?: Maybe<Scalars["Int"]["output"]>;
  dafName?: Maybe<Scalars["String"]["output"]>;
  employeeCount?: Maybe<Scalars["Int"]["output"]>;
  familyMembers?: Maybe<Array<Maybe<FamilyMemberBasicType>>>;
  isDafCreated?: Maybe<Scalars["Boolean"]["output"]>;
  secondaryHohs?: Maybe<Array<Maybe<FamilyMemberBasicType>>>;
  subAdvisorFee?: Maybe<Scalars["Float"]["output"]>;
  tncAcceptedTime?: Maybe<Scalars["DateTime"]["output"]>;
  userId?: Maybe<Scalars["Int"]["output"]>;
  ytdAdminFees?: Maybe<Scalars["Float"]["output"]>;
};

export type RiaMemberType = {
  __typename?: "RiaMemberType";
  email?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  lastLogin?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
};

export type RunDeployments = {
  __typename?: "RunDeployments";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * Run one of the five Living Legacy beat jobs on demand.
 *
 * Same shape as UpdateContributionStatuses: one endpoint, a string selecting
 * the job, so a new job is one branch rather than a new mutation. The jobs are
 * otherwise only reachable on their schedule, which for two of them is once a
 * year -- a missed 25 December would otherwise wait twelve months.
 *
 *     transitions       process_scheduled_transitions       (06:00 daily)
 *     steps             process_succession_steps            (06:30 daily)
 *     reminders         send_scheduled_transition_reminders (06:45 daily)
 *     payout            process_annual_payout_policy        (25 Dec)
 *     sunset_warnings   process_sunset_year_notifications   (01 Jan)
 *
 * Run SYNCHRONOUSLY, not via .delay(), unlike the contribution-status jobs
 * above. Those fan out over every family and the caller only needs to know the
 * work was queued; these are usually run against one family and the useful
 * answer is what happened -- how many advanced, whether a payout was made, why
 * a step is still blocked. A queued task can only answer "accepted".
 *
 * `family_id` narrows every job except `reminders`, whose task takes no family
 * (it selects on scheduled_date == today + 7, so there is nothing to narrow).
 *
 * REQUIRED for `payout`. The task treats family_id=None as "every family", and
 * a platform-wide grant run is not something that should sit behind an API
 * call -- one mis-click would post grants out of every client's DAF outside
 * the schedule. Ops can still do that deliberately from the management shell.
 *
 * `year` applies to `payout` only, to backfill a missed December. It does not
 * re-open a year already run: the unique (family, year) constraint on
 * AnnualPayoutRun is what prevents a double grant, so a year already present
 * is a no-op by design.
 */
export type RunSuccessionJob = {
  __typename?: "RunSuccessionJob";
  message?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  /** What the job returned -- transitions/steps advanced, reminders or warnings sent, families paid out. 0 means it ran and there was nothing to do. */
  result?: Maybe<Scalars["Int"]["output"]>;
};

/** Save US address. Validates ZIP. Transitions to pending_ofac. */
export type SaveAddressStep = {
  __typename?: "SaveAddressStep";
  error?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type SaveBookLevelSettings = {
  __typename?: "SaveBookLevelSettings";
  bookLevelSettings?: Maybe<BookLevelSettingsType>;
};

export type SaveBunchingPlanDraft = {
  __typename?: "SaveBunchingPlanDraft";
  draft?: Maybe<BunchingPlanDraftType>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * Create or update an unfinished campaign draft.
 *
 * Deliberately validation-free (beyond type/ownership checks): a draft is
 * allowed to be half-empty or invalid — full template validation runs in
 * LaunchCampaign when the user actually publishes.
 */
export type SaveCampaignDraft = {
  __typename?: "SaveCampaignDraft";
  draft?: Maybe<CampaignDraftType>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type SaveClientLevelSettings = {
  __typename?: "SaveClientLevelSettings";
  clientLevelSettings?: Maybe<ClientLevelSettingsType>;
};

/** Save first name, last name, DOB. Validates 18+. Transitions to pending_address. */
export type SaveIdentityStep = {
  __typename?: "SaveIdentityStep";
  error?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** DTO for ScheduledCCContribution model data */
export type ScheduledCcContributionDto = {
  __typename?: "ScheduledCCContributionDTO";
  amount: Scalars["Decimal"]["output"];
  brand: Scalars["String"]["output"];
  chargeAmount: Scalars["Decimal"]["output"];
  contributor: Scalars["String"]["output"];
  country: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  createdBy: UserType;
  endDate?: Maybe<Scalars["DateTime"]["output"]>;
  family: FamilyType;
  firstSchedule: Scalars["Date"]["output"];
  frequency: ScheduledCcContributionFrequency;
  funding: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  isActive: Scalars["Boolean"]["output"];
  last4: Scalars["String"]["output"];
  lastTransaction?: Maybe<Scalars["Date"]["output"]>;
  nextScheduled?: Maybe<Scalars["DateTime"]["output"]>;
  oneTimeFee: Scalars["Decimal"]["output"];
  paymentIntentId: Scalars["String"]["output"];
  paymentMethodId: Scalars["String"]["output"];
  processingFee: Scalars["Decimal"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export enum ScheduledCcContributionFrequency {
  /** Annually */
  Annually = "ANNUALLY",
  /** Monthly */
  Monthly = "MONTHLY",
  /** One Time */
  OneTime = "ONE_TIME",
  /** Quarterly */
  Quarterly = "QUARTERLY",
}

export type ScheduledContributionType = {
  __typename?: "ScheduledContributionType";
  account?: Maybe<BankItemAccountType>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  contributor?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  createdBy?: Maybe<UserType>;
  endDate?: Maybe<Scalars["String"]["output"]>;
  family: FamilyType;
  firstSchedule?: Maybe<Scalars["DateTime"]["output"]>;
  frequency?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  institutionName?: Maybe<Scalars["String"]["output"]>;
  isActive?: Maybe<Scalars["String"]["output"]>;
  lastTransaction?: Maybe<Scalars["String"]["output"]>;
  nextScheduled?: Maybe<Scalars["DateTime"]["output"]>;
  source?: Maybe<Scalars["String"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

/** Structured search results with separate fields for firms, advisors, and clients */
export type SearchAllResultsType = {
  __typename?: "SearchAllResultsType";
  corporateAdmins?: Maybe<CorporateAdminsPaginatedType>;
  employees?: Maybe<EmployeesPaginatedType>;
  enterpriseAdmins?: Maybe<EnterpriseAdminsPaginatedType>;
  familyMembers?: Maybe<FamilyMembersPaginatedType>;
  firmAdmins?: Maybe<FirmAdminsPaginatedType>;
  firmAdvisors?: Maybe<FirmAdvisorsPaginatedType>;
  firmClients?: Maybe<FirmClientsPaginatedType>;
  firms?: Maybe<FirmPaginatedType>;
  participants?: Maybe<ParticipantsPaginatedType>;
};

export type SearchCharityType = {
  __typename?: "SearchCharityType";
  address?: Maybe<Scalars["String"]["output"]>;
  campaignedBy?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  categories?: Maybe<Array<Maybe<CauseType>>>;
  causes?: Maybe<Array<Maybe<CauseType>>>;
  charityNavRatings?: Maybe<Scalars["GenericScalar"]["output"]>;
  contributors?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  ein?: Maybe<Scalars["String"]["output"]>;
  fundUrl?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  international?: Maybe<Scalars["Boolean"]["output"]>;
  isAch?: Maybe<Scalars["Boolean"]["output"]>;
  isBlacklisted?: Maybe<Scalars["Boolean"]["output"]>;
  isUserFavourite?: Maybe<Scalars["Boolean"]["output"]>;
  mediumImg?: Maybe<Scalars["String"]["output"]>;
  membersLiked?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  mission?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  nteeCode?: Maybe<Scalars["String"]["output"]>;
  nteeDesc?: Maybe<Scalars["String"]["output"]>;
  orgSecondName?: Maybe<Scalars["String"]["output"]>;
  parentCategories?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  parentCauses?: Maybe<Array<Maybe<CauseType>>>;
  payment?: Maybe<CharityPaymentType>;
  pcsSubject?: Maybe<Scalars["String"]["output"]>;
  restricted?: Maybe<Scalars["Boolean"]["output"]>;
  rotate?: Maybe<Scalars["Boolean"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  totalGrantsAmount?: Maybe<Scalars["Float"]["output"]>;
  totalGrantsCount?: Maybe<Scalars["Int"]["output"]>;
  value?: Maybe<Scalars["String"]["output"]>;
  ytdGrantsAmount?: Maybe<Scalars["Float"]["output"]>;
  ytdGrantsCount?: Maybe<Scalars["Int"]["output"]>;
};

export type SearchSuggestionsType = {
  __typename?: "SearchSuggestionsType";
  charityMatches?: Maybe<Array<Maybe<SearchCharityType>>>;
  subCausesMatches?: Maybe<Array<Maybe<CauseType>>>;
};

export type SecurityContributionDetailType = {
  __typename?: "SecurityContributionDetailType";
  batchId?: Maybe<Scalars["String"]["output"]>;
  custodian?: Maybe<Scalars["String"]["output"]>;
  initiatedOn?: Maybe<Scalars["DateTime"]["output"]>;
  securities?: Maybe<PaginatedSecurityItemType>;
  statusCounts?: Maybe<Array<Maybe<StatusCountType>>>;
  submittedBy?: Maybe<Scalars["String"]["output"]>;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
  totalValue?: Maybe<Scalars["Float"]["output"]>;
};

export type SecurityItemType = {
  __typename?: "SecurityItemType";
  amount?: Maybe<Scalars["Float"]["output"]>;
  objectId?: Maybe<Scalars["String"]["output"]>;
  quantity?: Maybe<Scalars["String"]["output"]>;
  securityName?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  statusTimeline?: Maybe<Array<Maybe<ContributionStatusTimelineType>>>;
  ticker?: Maybe<Scalars["String"]["output"]>;
  transactionId?: Maybe<Scalars["String"]["output"]>;
};

/** Pagination for security transactions */
export type SecurityTransactionPaginatedType = {
  __typename?: "SecurityTransactionPaginatedType";
  count?: Maybe<Scalars["Int"]["output"]>;
  objects?: Maybe<Array<Maybe<SecurityTransactionType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

/** Security Transaction Details. */
export type SecurityTransactionType = {
  __typename?: "SecurityTransactionType";
  amount?: Maybe<Scalars["Float"]["output"]>;
  contributor?: Maybe<Scalars["String"]["output"]>;
  contributorMetadata?: Maybe<Scalars["JSONString"]["output"]>;
  custodian?: Maybe<Scalars["String"]["output"]>;
  dateInitiated?: Maybe<Scalars["DateTime"]["output"]>;
  dateReceived?: Maybe<Scalars["Date"]["output"]>;
  dateUpdated?: Maybe<Scalars["DateTime"]["output"]>;
  impersonatedBy?: Maybe<Scalars["String"]["output"]>;
  impersonatedById?: Maybe<Scalars["Int"]["output"]>;
  objectId?: Maybe<Scalars["String"]["output"]>;
  quantity?: Maybe<Scalars["String"]["output"]>;
  receiptDate?: Maybe<Scalars["DateTime"]["output"]>;
  saleProceeds?: Maybe<Scalars["Float"]["output"]>;
  security?: Maybe<Scalars["String"]["output"]>;
  securityName?: Maybe<Scalars["String"]["output"]>;
  soldDate?: Maybe<Scalars["Date"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  transactionId?: Maybe<Scalars["Int"]["output"]>;
  transactionReference?: Maybe<Scalars["String"]["output"]>;
  transactionType?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<SecurityTransactionTypeChoices>;
  valueOnDateInitiated?: Maybe<Scalars["Float"]["output"]>;
  valueOnDateReceived?: Maybe<Scalars["Float"]["output"]>;
};

export enum SecurityTransactionTypeChoices {
  ExternalDaf = "EXTERNAL_DAF",
  Manual = "MANUAL",
}

export type SelfDirectedType = {
  __typename?: "SelfDirectedType";
  email?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  inviteStatus?: Maybe<Scalars["String"]["output"]>;
};

export type SelfServiceDafInvite = {
  __typename?: "SelfServiceDAFInvite";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Send invite email to the user  */
export type SendInviteMail = {
  __typename?: "SendInviteMail";
  status?: Maybe<StatusSummaryType>;
};

/**
 * User: ops_admin
 *
 * Invites a new ops admin by email: creates (or upgrades) the User row and
 * grants the role, then emails a set-password link via
 * core.utils.invites.send_ops_admin_invite.
 *
 * Every other role is granted by an invite flow started by somebody who
 * already holds a role -- ops_admin had no such starting point, only the
 * create_ops_admin management command, which requires shell access and has
 * an operator choose (and hand off) the password themselves. This mutation
 * is that starting point for every ops_admin after the first: an existing
 * one can invite the next without anyone touching a password directly.
 * create_ops_admin remains how the very first one gets made in a fresh
 * environment, where no ops_admin yet exists to call this.
 *
 * Does not touch Okta -- that happens once the invitee actually submits a
 * password through ResetPassword's is_ops_admin() branch, the same moment
 * every other role provisions Okta.
 */
export type SendOpsAdminInvite = {
  __typename?: "SendOpsAdminInvite";
  message?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * For each primary successor: create a new Family + HoH user + AdvisorDAF
 * (inheriting custodian/bps from the originating family) -- the same flow
 * as createFamilyAndMembers, run unconditionally regardless of which of the
 * three cases below applies:
 *   1. Successor's email matches an existing User who already has an active
 *      (non-frozen) DAF elsewhere.
 *   2. Successor's email matches an existing User with no active DAF.
 *   3. Successor's email is brand new.
 * create_family() already sends the right base invite email per case
 * (hoh_invite for new accounts, existing_hoh_invite for existing ones). On
 * top of that, every case gets an additional notification carrying the
 * originating family's mission statement and this successor's allocation
 * (percentage + a dollar amount computed off the live DAF balance).
 */
export type SendSuccessionInvites = {
  __typename?: "SendSuccessionInvites";
  invitesSent?: Maybe<Scalars["Int"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ServiceRequestByIssueTypeItemType = {
  __typename?: "ServiceRequestByIssueTypeItemType";
  /** Channel */
  channel?: Maybe<Scalars["String"]["output"]>;
  /** Client name */
  client?: Maybe<Scalars["String"]["output"]>;
  correspondence?: Maybe<Array<Maybe<CorrespondenceItemType>>>;
  /** First closed */
  firstClosed?: Maybe<Scalars["DateTime"]["output"]>;
  /** First response */
  firstResponse?: Maybe<Scalars["DateTime"]["output"]>;
  /** Issue opened */
  issueOpened?: Maybe<Scalars["DateTime"]["output"]>;
  /** Issue type */
  issueType?: Maybe<Scalars["String"]["output"]>;
  /** Participant name */
  participant?: Maybe<Scalars["String"]["output"]>;
  /** Priority */
  priority?: Maybe<Scalars["String"]["output"]>;
  /** Request ID */
  requestId?: Maybe<Scalars["String"]["output"]>;
  /** Response time */
  responseTime?: Maybe<Scalars["Float"]["output"]>;
  /** Status */
  status?: Maybe<Scalars["String"]["output"]>;
};

export type ServiceRequestByIssueTypeType = {
  __typename?: "ServiceRequestByIssueTypeType";
  /** Is last page */
  isLastPage?: Maybe<Scalars["Boolean"]["output"]>;
  /** Page number */
  page?: Maybe<Scalars["Int"]["output"]>;
  /** Page size */
  pageSize?: Maybe<Scalars["Int"]["output"]>;
  serviceRequests?: Maybe<Array<Maybe<ServiceRequestByIssueTypeItemType>>>;
  /** Total number of service requests */
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type ServiceRequestsByChannelItemType = {
  __typename?: "ServiceRequestsByChannelItemType";
  /** Average first response time */
  avgFirstResponse?: Maybe<Scalars["Float"]["output"]>;
  /** Average resolution time */
  avgResolution?: Maybe<Scalars["Float"]["output"]>;
  /** Number of chat requests */
  chatRequests?: Maybe<Scalars["Int"]["output"]>;
  /** Number of email requests */
  emailRequests?: Maybe<Scalars["Int"]["output"]>;
  /** Period */
  period?: Maybe<Scalars["String"]["output"]>;
};

export type ServiceRequestsByChannelType = {
  __typename?: "ServiceRequestsByChannelType";
  serviceRequests?: Maybe<Array<Maybe<ServiceRequestsByChannelItemType>>>;
};

/** Set curate search status to a family */
export type SetCurateSearchStatus = {
  __typename?: "SetCurateSearchStatus";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Set a default bank account for the user  */
export type SetDefaultBankAccount = {
  __typename?: "SetDefaultBankAccount";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type SetGivingPrivacyPreference = {
  __typename?: "SetGivingPrivacyPreference";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Set include international charity to a family */
export type SetIncludeInternationalCharity = {
  __typename?: "SetIncludeInternationalCharity";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Email path only: validate password, create Okta user. */
export type SetSignupPassword = {
  __typename?: "SetSignupPassword";
  error?: Maybe<Scalars["String"]["output"]>;
  mfaEnrolled?: Maybe<Scalars["Boolean"]["output"]>;
  mfaRequired?: Maybe<Scalars["Boolean"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * User: Family Member
 * Share the article to the family members
 */
export type ShareArticle = {
  __typename?: "ShareArticle";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  status?: Maybe<StatusSummaryType>;
};

/** Share the Campaign to the members */
export type ShareCampaign = {
  __typename?: "ShareCampaign";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  status?: Maybe<StatusSummaryType>;
};

/** Top Contribution category details. */
export type SignedDateType = {
  __typename?: "SignedDateType";
  feeAgreementSignedDate?: Maybe<Scalars["Date"]["output"]>;
  tncSignedDate?: Maybe<Scalars["Date"]["output"]>;
};

export type SignupStateType = {
  __typename?: "SignupStateType";
  address?: Maybe<Scalars["JSONString"]["output"]>;
  currentStep?: Maybe<Scalars["String"]["output"]>;
  dob?: Maybe<Scalars["Date"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  error?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  flow?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  screeningId?: Maybe<Scalars["String"]["output"]>;
};

/** Verify an Okta ID token (Google/Apple via Okta IdP) and return a Django JWT for existing active social users. */
export type SocialLogin = {
  __typename?: "SocialLogin";
  error?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  token?: Maybe<Scalars["String"]["output"]>;
};

export enum SortOrderEnum {
  Asc = "ASC",
  Desc = "DESC",
}

export type Sorter = {
  sortKey: Scalars["String"]["input"];
  sortOrder: SortOrderEnum;
};

export type SponsorType = {
  __typename?: "SponsorType";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  logoUrl?: Maybe<Scalars["String"]["output"]>;
  models: Array<ModelType>;
  riskScore: Scalars["Int"]["output"];
  sortIdx?: Maybe<Scalars["Int"]["output"]>;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type StatusCountType = {
  __typename?: "StatusCountType";
  count?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
};

export type StatusSummaryType = {
  __typename?: "StatusSummaryType";
  fail?: Maybe<ListStatusType>;
  success?: Maybe<ListStatusType>;
};

export type StatusType = {
  __typename?: "StatusType";
  message?: Maybe<Scalars["String"]["output"]>;
  object?: Maybe<Scalars["GenericScalar"]["output"]>;
  status?: Maybe<Scalars["Boolean"]["output"]>;
};

/** API to Update Fund asset Pool ratio   */
export type SubmitTargetRatio = {
  __typename?: "SubmitTargetRatio";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type SuccessionIntegrationType = {
  __typename?: "SuccessionIntegrationType";
  createdAt: Scalars["DateTime"]["output"];
  expectedInheritancesCount?: Maybe<Scalars["Int"]["output"]>;
  expectedInheritancesTotal?: Maybe<Scalars["Decimal"]["output"]>;
  family: FamilyType;
  id: Scalars["ID"]["output"];
  inheritanceRegistries?: Maybe<Array<Maybe<InheritanceRegistryType>>>;
  projectedTotal?: Maybe<Scalars["Decimal"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type SuccessionIntegrationTypeInheritanceRegistriesArgs = {
  sourceType?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * Payout & sunset preferences plus the live DAF context the UI needs.
 *
 * `annual_payout_target` / `sunset_timeframe_years` are the stored prefs (or
 * sensible defaults before first save). `current_balance` and
 * `account_age_years` are derived from the family's DAF so the frontend can
 * compute the minimum annual distribution and the years-until-sunset readout.
 */
export type SuccessionPolicyType = {
  __typename?: "SuccessionPolicyType";
  accountAgeYears?: Maybe<Scalars["Int"]["output"]>;
  annualPayoutTarget?: Maybe<Scalars["Float"]["output"]>;
  currentBalance?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  isConfigured?: Maybe<Scalars["Boolean"]["output"]>;
  policyMode?: Maybe<Scalars["String"]["output"]>;
  sunsetTimeframeYears?: Maybe<Scalars["Int"]["output"]>;
};

/**
 * One successor's expected payout set against what actually landed in their
 * fund -- the ops team's view of a transition sitting at step 4.
 *
 * Read-only except for `confirm_transfer_variance`. Ops does not assert that a
 * transfer happened; the custodian does, through the cleared DAF-to-DAF
 * contributions this is computed from. What ops decides is whether a
 * DIFFERENCE between the two is acceptable.
 */
export type SuccessionReconciliationType = {
  __typename?: "SuccessionReconciliationType";
  contributionCount?: Maybe<Scalars["Int"]["output"]>;
  destinationFundName?: Maybe<Scalars["String"]["output"]>;
  expectedAmount?: Maybe<Scalars["Float"]["output"]>;
  familyId?: Maybe<Scalars["Int"]["output"]>;
  familyName?: Maybe<Scalars["String"]["output"]>;
  freezeInitiatedAt?: Maybe<Scalars["String"]["output"]>;
  frozenBalance?: Maybe<Scalars["Float"]["output"]>;
  isReconciled?: Maybe<Scalars["Boolean"]["output"]>;
  /** True when an amount mismatch is the only thing blocking, which is the case an ops admin can resolve. */
  needsReview?: Maybe<Scalars["Boolean"]["output"]>;
  percentage?: Maybe<Scalars["Float"]["output"]>;
  reason?: Maybe<Scalars["String"]["output"]>;
  receivedAmount?: Maybe<Scalars["Float"]["output"]>;
  successorId?: Maybe<Scalars["Int"]["output"]>;
  successorName?: Maybe<Scalars["String"]["output"]>;
  /** received minus expected; 0 when they agree. */
  variance?: Maybe<Scalars["Float"]["output"]>;
  varianceConfirmedAt?: Maybe<Scalars["String"]["output"]>;
  varianceConfirmedBy?: Maybe<Scalars["String"]["output"]>;
};

/**
 * One successor's DAF-to-DAF transfer, as the advisor's step 4 card shows it.
 *
 * The console previously derived these rows in the browser -- amount from a
 * percentage of the live balance, status from the amount, an invented ETA --
 * so it could show "initiated / on track" for a transfer ops had never sent.
 * This is the same data reconcile_successor_transfer works from, so the card
 * and the pipeline cannot tell different stories.
 *
 * Distinct from SuccessionReconciliationType, which is the ops exceptions queue
 * across every family and is ops_admin-only. This is one family, advisor-
 * readable, and carries the dates the card renders.
 */
export type SuccessionTransferType = {
  __typename?: "SuccessionTransferType";
  /** When the last of them was received. Null while any is still in flight, so it is only ever a real settlement date. */
  completedAt?: Maybe<Scalars["String"]["output"]>;
  destinationFundName?: Maybe<Scalars["String"]["output"]>;
  /** frozen_balance x percentage -- what the plan says they are owed. Null when the fund was frozen without a balance recorded, in which case nothing can be reconciled. */
  expectedAmount?: Maybe<Scalars["Float"]["output"]>;
  /** When the first matched contribution was created -- i.e. when the money started moving. Null before any arrives. */
  initiatedAt?: Maybe<Scalars["String"]["output"]>;
  isReconciled?: Maybe<Scalars["Boolean"]["output"]>;
  percentage?: Maybe<Scalars["Int"]["output"]>;
  /** Null when reconciled; otherwise what is outstanding, in the same words the pipeline logs when it holds step 4. */
  reason?: Maybe<Scalars["String"]["output"]>;
  /** Total of the DAF-to-DAF contributions that have landed in their fund since the originating DAF was frozen. */
  receivedAmount?: Maybe<Scalars["Float"]["output"]>;
  successorId?: Maybe<Scalars["Int"]["output"]>;
  successorName?: Maybe<Scalars["String"]["output"]>;
};

export enum SuccessionTransitionStatus {
  /** aborted */
  Aborted = "ABORTED",
  /** completed */
  Completed = "COMPLETED",
  /** initiated */
  Initiated = "INITIATED",
  /** in_progress */
  InProgress = "IN_PROGRESS",
  /** scheduled */
  Scheduled = "SCHEDULED",
  /** under_review */
  UnderReview = "UNDER_REVIEW",
}

export enum SuccessionTransitionTriggerType {
  /** death */
  Death = "DEATH",
  /** voluntary */
  Voluntary = "VOLUNTARY",
}

export type SuccessionTransitionType = {
  __typename?: "SuccessionTransitionType";
  cancelledInviteCount: Scalars["Int"]["output"];
  completedAt?: Maybe<Scalars["DateTime"]["output"]>;
  currentStep: Scalars["Int"]["output"];
  /** When the freeze was confirmed on the fund itself -- LouiseDafAccount.freeze_confirmed_at, stamped by ConfirmDAFFreeze once the advisor has actioned every open grant, contribution and invite. Rendered as "Fund activity frozen" on the step 1 card, paired with the lock date above. Distinct from freeze_confirmation_sent_at, which is when the confirmation EMAIL went out -- the fund can be confirmed frozen without that send having been recorded. */
  dafFreezeConfirmedAt?: Maybe<Scalars["String"]["output"]>;
  /** When the fund was locked -- LouiseDafAccount.freeze_initiated_at, stamped by InitiateTransition and by the scheduled-transition job. Rendered as "Fund access locked" on the step 1 card, paired with freeze_confirmation_sent_at ("Fund activity frozen"). Read off the DAF rather than reusing initiated_at: the two happen to be the same instant today because one mutation writes both, and a step 1 date should not depend on that staying true. */
  dafFreezeInitiatedAt?: Maybe<Scalars["String"]["output"]>;
  /** S3 key for uploaded death certificate */
  deathCertKey?: Maybe<Scalars["String"]["output"]>;
  deathCertUrl?: Maybe<Scalars["String"]["output"]>;
  family: FamilyType;
  /** When the advisor and head(s) of household were emailed to confirm the freeze is in effect -- stamped at the end of step 1, and only on a send the mailer confirmed. Distinct from LouiseDafAccount.freeze_initiated_at, which is when the fund was locked: the console shows the first as 'fund activity frozen' and the second as 'fund access locked', and they are minutes to days apart because step 1 has to clear every open grant and contribution in between. Null means the email has not gone out, so the UI must not claim it has. */
  freezeConfirmationSentAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** The originating fund's available balance at the moment it was frozen. Captured at freeze because by the time step 4 reconciles, the money has left and the live balance can no longer say what each successor was owed. Each successor's expected transfer is this times their percentage, so correcting this one figure re-bases every expectation at once. */
  frozenBalance?: Maybe<Scalars["Decimal"]["output"]>;
  /** Whether money is still on its way into the fund. A $0 balance with something in flight is temporary, so the console uses this to decide whether an empty fund is really empty. */
  hasOpenContributions?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  initiatedAt: Scalars["DateTime"]["output"];
  initiatedBy?: Maybe<UserType>;
  /** Notes from ops_admin when approving or rejecting a death transition */
  reviewNotes?: Maybe<Scalars["String"]["output"]>;
  scheduledDate?: Maybe<Scalars["Date"]["output"]>;
  status: SuccessionTransitionStatus;
  step1CompletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  step2CompletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  step3CompletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  step4CompletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** When the ops team was last emailed the step 4 DAF-to-DAF transfer instructions (TriggerSuccessionTransferNotification). Distinct from step4_completed_at: ops moves the money by hand, so being notified and the funds actually landing are separate events. Set on every send, so it is the LAST send, not the first -- the UI uses its presence to offer a resend. */
  step4NotifiedAt?: Maybe<Scalars["DateTime"]["output"]>;
  step5CompletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  triggerType: SuccessionTransitionTriggerType;
  voluntaryMode?: Maybe<SuccessionTransitionVoluntaryMode>;
};

export enum SuccessionTransitionVoluntaryMode {
  /** immediate */
  Immediate = "IMMEDIATE",
  /** scheduled */
  Scheduled = "SCHEDULED",
}

/**
 * The terms a successor attests to in step 5: the originating fund's payout
 * policy, its sunset terms, and their own allocation.
 *
 * Exists as its own successor-scoped query because successionPolicy and
 * sunsetCharityAllocations both go through get_user_family, which correctly
 * rejects a successor -- they are not a member of the family they are inheriting
 * from. Same rule as successorFoundersVoice: the caller passes their DESTINATION
 * family and the originating family is derived server-side.
 */
export type SuccessorAcknowledgmentType = {
  __typename?: "SuccessorAcknowledgmentType";
  accountAgeYears?: Maybe<Scalars["Int"]["output"]>;
  alreadySignedAt?: Maybe<Scalars["DateTime"]["output"]>;
  annualPayoutTarget?: Maybe<Scalars["Float"]["output"]>;
  isContingent?: Maybe<Scalars["Boolean"]["output"]>;
  isPolicyConfigured?: Maybe<Scalars["Boolean"]["output"]>;
  originatingFamilyId?: Maybe<Scalars["Int"]["output"]>;
  originatingFamilyName?: Maybe<Scalars["String"]["output"]>;
  percentage?: Maybe<Scalars["Float"]["output"]>;
  policyMode?: Maybe<Scalars["String"]["output"]>;
  sunsetCharityAllocations?: Maybe<Array<Maybe<SunsetCharityAllocationType>>>;
  sunsetTimeframeYears?: Maybe<Scalars["Int"]["output"]>;
  yearsUntilSunset?: Maybe<Scalars["Int"]["output"]>;
};

/**
 * Everything the originating founder left for their successors: the written
 * message, the audio and video recordings, and the family mission.
 *
 * Feeds successor onboarding steps 2 (founder's voice) and 4 (review mission).
 * Both come from the originating family, so they are served together rather
 * than as two round trips.
 *
 * `has_content` is what lets step 2 be skipped cleanly -- a founder who
 * recorded nothing successor-visible must not leave the successor staring at an
 * empty screen.
 */
export type SuccessorFoundersVoiceType = {
  __typename?: "SuccessorFoundersVoiceType";
  audioUrl?: Maybe<Scalars["String"]["output"]>;
  foundersMessage?: Maybe<Scalars["String"]["output"]>;
  hasContent?: Maybe<Scalars["Boolean"]["output"]>;
  mission?: Maybe<Scalars["String"]["output"]>;
  originatingFamilyId?: Maybe<Scalars["Int"]["output"]>;
  originatingFamilyName?: Maybe<Scalars["String"]["output"]>;
  videoUrl?: Maybe<Scalars["String"]["output"]>;
};

/**
 * The originating founder's pinned giving history, for successor onboarding
 * step 6 (shown after the acknowledgment, immediately before DAF setup).
 *
 * Deliberately the PINNED selection only -- LivingLegacyPlan.pinned_giving_history,
 * the grants the founder deliberately curated into their Legacy Plan, carrying
 * the rationale they wrote for each. The family's largest grants are not a
 * substitute: this step exists to pass on what the founder chose to be
 * remembered for, and an unpinned top-4 by dollar amount says nothing about
 * intent.
 *
 * `has_content` is what lets the step be skipped cleanly, the same way
 * `SuccessorFoundersVoiceType.has_content` does for step 2 -- a founder who
 * pinned nothing must not leave the successor staring at an empty screen.
 */
export type SuccessorGivingHistoryType = {
  __typename?: "SuccessorGivingHistoryType";
  grants?: Maybe<Array<Maybe<FeaturedGrantType>>>;
  hasContent?: Maybe<Scalars["Boolean"]["output"]>;
  originatingFamilyId?: Maybe<Scalars["Int"]["output"]>;
  originatingFamilyName?: Maybe<Scalars["String"]["output"]>;
};

/** Successor input field type  */
export type SuccessorInputType = {
  address: Scalars["String"]["input"];
  city: Scalars["String"]["input"];
  dob: Scalars["Date"]["input"];
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  isContingent?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastName: Scalars["String"]["input"];
  percentage: Scalars["Float"]["input"];
  phoneNumber: Scalars["String"]["input"];
  relation?: InputMaybe<Scalars["String"]["input"]>;
  state: Scalars["String"]["input"];
  zipCode: Scalars["String"]["input"];
};

/**
 * Successor onboarding progress for one successor claiming one destination family.
 *
 * Steps 1, 2, 4, 5 and 6 of the flow (accept/decline, founder's voice, review
 * mission, sign acknowledgment, giving history) exist ONLY for a successor
 * claiming the originating DAF's funds into their destination family. Steps 3
 * (curate list) and 7 (DAF setup) are the ordinary onboarding screens every
 * client sees. The timestamps below are what let the client resume mid-flow
 * rather than replaying steps the successor already completed.
 */
export type SuccessorOnboardingType = {
  __typename?: "SuccessorOnboardingType";
  acceptedAt?: Maybe<Scalars["DateTime"]["output"]>;
  acknowledgmentSignedAt?: Maybe<Scalars["DateTime"]["output"]>;
  dafCreated?: Maybe<Scalars["Boolean"]["output"]>;
  declinedAt?: Maybe<Scalars["DateTime"]["output"]>;
  founderMessageViewedAt?: Maybe<Scalars["DateTime"]["output"]>;
  givingHistoryViewedAt?: Maybe<Scalars["DateTime"]["output"]>;
  isContingent?: Maybe<Scalars["Boolean"]["output"]>;
  missionReviewedAt?: Maybe<Scalars["DateTime"]["output"]>;
  originatingFamilyId?: Maybe<Scalars["Int"]["output"]>;
  originatingFamilyName?: Maybe<Scalars["String"]["output"]>;
  percentage?: Maybe<Scalars["Float"]["output"]>;
  successorId?: Maybe<Scalars["Int"]["output"]>;
};

/** Input type for successor relations (avoid circular import from family.schema) */
export type SuccessorRelationInputType = {
  relatedUserId: Scalars["Int"]["input"];
  relation: Scalars["String"]["input"];
};

/** Successor response field type  */
export type SuccessorType = {
  __typename?: "SuccessorType";
  /** Set when this successor explicitly accepts their invite, on the accept/decline screen shown at the start of successor onboarding. Mutually exclusive with declined_at; both null means the successor has been invited but hasn't decided yet. Tracked separately from family_member.invite_status, which is account-level and flips to 'accepted' merely on login, and from the destination DAF existing, which only happens once setup is finished. */
  acceptedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** Set when this successor signs the Successor Acknowledgment Form (payout policy, sunset terms, and the advisory-only nature of the role under IRC 4966). Load-bearing for sequencing: the destination DAF is only created after this is set, so the DAF's existence implies consent was given -- which is what lets the transition's step 2/3 'resolved' test stay a simple DAF-exists check. */
  acknowledgmentSignedAt?: Maybe<Scalars["DateTime"]["output"]>;
  address: Scalars["String"]["output"];
  city: Scalars["String"]["output"];
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** Optional free-text reason the successor gave when declining. Never required -- a successor may decline without explaining, so absence carries no meaning. Surfaced to the originating advisor in the decline notification so they can follow up on a reallocation. */
  declineReason?: Maybe<Scalars["String"]["output"]>;
  /** Set when this successor explicitly declines their invite. Tracked separately from family_member.invite_status, which is a shared account-level field that (for an existing user named as successor) also reflects their own unrelated account status elsewhere -- declining the successor role must not overwrite that. */
  declinedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** The new family/DAF created for this successor when their invite was sent (distinct from `family`, the original/source family being succeeded). */
  destinationFamily?: Maybe<FamilyType>;
  dob?: Maybe<Scalars["Date"]["output"]>;
  email: Scalars["String"]["output"];
  family?: Maybe<FamilyType>;
  familyMember?: Maybe<UserType>;
  firstName: Scalars["String"]["output"];
  /** Set when this successor has been shown the founder's voice step (written message, audio and video from the originating family). Also set when the step is skipped because the founder left nothing successor-visible, so the flow does not stall on it. */
  founderMessageViewedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** Set when this successor has been shown the originating family's pinned giving history -- the grants the founder deliberately curated into their Legacy Plan, with the rationale they wrote for each. Shown after the acknowledgment, so it is the last thing before DAF setup. Also set when the step is skipped because the founder pinned nothing, so the flow does not stall on a step that has nothing to show. */
  givingHistoryViewedAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  isContingent?: Maybe<Scalars["Boolean"]["output"]>;
  isSubmitted?: Maybe<Scalars["Boolean"]["output"]>;
  lastName: Scalars["String"]["output"];
  /** When this successor was last sent an invite reminder, from the UserNudge row NudgeSuccessorInvite writes. Server-owned so the transition console shows it on first paint instead of only after a nudge click in the current session. Null if never nudged, or if the successor has no linked user yet (never invited). */
  lastNudgedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** Set when this successor has reviewed and confirmed the originating family's mission statement. A read-and-confirm, not authorship -- the successor does not edit the founder's mission. */
  missionReviewedAt?: Maybe<Scalars["DateTime"]["output"]>;
  percentage?: Maybe<Scalars["Float"]["output"]>;
  phoneNumber: Scalars["String"]["output"];
  relation: Scalars["String"]["output"];
  state: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  zipCode: Scalars["String"]["output"];
};

/** Successor input field type for add/edit operations (with optional dob and phone) */
export type SuccessorUpdateInputType = {
  address: Scalars["String"]["input"];
  city?: InputMaybe<Scalars["String"]["input"]>;
  dob?: InputMaybe<Scalars["Date"]["input"]>;
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  isContingent?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastName: Scalars["String"]["input"];
  percentage: Scalars["Float"]["input"];
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  relatedToHofId?: InputMaybe<Scalars["Int"]["input"]>;
  relation?: InputMaybe<Scalars["String"]["input"]>;
  relations?: InputMaybe<Array<InputMaybe<SuccessorRelationInputType>>>;
  state?: InputMaybe<Scalars["String"]["input"]>;
  zipCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type SummaryType = {
  __typename?: "SummaryType";
  charitableBonus?: Maybe<Scalars["Float"]["output"]>;
  charitableContribution?: Maybe<Scalars["Float"]["output"]>;
  exceededLimits?: Maybe<Scalars["Boolean"]["output"]>;
  itDeduction?: Maybe<Scalars["Float"]["output"]>;
  total?: Maybe<Scalars["Float"]["output"]>;
};

export type SunsetCharityAllocationInput = {
  charityId: Scalars["String"]["input"];
  charityName: Scalars["String"]["input"];
  percentage: Scalars["Float"]["input"];
  source?: InputMaybe<Scalars["String"]["input"]>;
};

export type SunsetCharityAllocationType = {
  __typename?: "SunsetCharityAllocationType";
  charityId?: Maybe<Scalars["String"]["output"]>;
  charityName?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  percentage?: Maybe<Scalars["Float"]["output"]>;
  source?: Maybe<Scalars["String"]["output"]>;
};

export type SyncOptimiserSession = {
  __typename?: "SyncOptimiserSession";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  session?: Maybe<OptimiserSessionType>;
  sessionId?: Maybe<Scalars["String"]["output"]>;
};

/** List firm's tagcategories and its tags */
export type TagCategoryType = {
  __typename?: "TagCategoryType";
  category: Scalars["String"]["output"];
  firm: FirmType;
  id: Scalars["ID"]["output"];
  tags?: Maybe<Array<Maybe<TagType>>>;
  userTags: Array<UserTagType>;
};

/** Response type to tags  */
export type TagType = {
  __typename?: "TagType";
  id: Scalars["ID"]["output"];
  tag: Scalars["String"]["output"];
  tagCategory: TagCategoryType;
  userTags: Array<UserTagType>;
};

export type TargetType = {
  __typename?: "TargetType";
  assetId?: Maybe<Scalars["String"]["output"]>;
  targetRatio?: Maybe<Scalars["String"]["output"]>;
  targetValue?: Maybe<Scalars["String"]["output"]>;
};

export type TaxOptimisationMetaDataType = {
  __typename?: "TaxOptimisationMetaDataType";
  additionalMessage?: Maybe<Scalars["String"]["output"]>;
  adjustedGrossIncome?: Maybe<Scalars["Float"]["output"]>;
  donationLimit?: Maybe<Scalars["Float"]["output"]>;
  excludeTicker?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  filingStatus?: Maybe<Scalars["String"]["output"]>;
  isRerun?: Maybe<Scalars["Boolean"]["output"]>;
  numTickerAllowed?: Maybe<Scalars["Int"]["output"]>;
  shareLimit?: Maybe<Scalars["Float"]["output"]>;
  targetTaxSavings?: Maybe<Scalars["Float"]["output"]>;
  teLimit?: Maybe<Scalars["Float"]["output"]>;
};

export type TaxOptimisationResultType = {
  __typename?: "TaxOptimisationResultType";
  appreciatedSecurities?: Maybe<AppreciatedSecuritiesType>;
  barChartData?: Maybe<Array<Maybe<BarChartDataType>>>;
  clientName?: Maybe<Scalars["String"]["output"]>;
  contributionDetails?: Maybe<Array<Maybe<ContributionDetailType>>>;
  copySettings?: Maybe<CopySettingsType>;
  generatedAt?: Maybe<Scalars["String"]["output"]>;
  metaData?: Maybe<TaxOptimisationMetaDataType>;
  optimizationSummary?: Maybe<OptimizationSummaryType>;
  portfolioCode?: Maybe<Scalars["String"]["output"]>;
  portfolioImpact?: Maybe<Array<Maybe<PortfolioImpactType>>>;
  runtimeSeconds?: Maybe<Scalars["Float"]["output"]>;
};

export type TaxOptimizeType = {
  __typename?: "TaxOptimizeType";
  taxSavedLastMonth?: Maybe<Scalars["Int"]["output"]>;
};

export type TaxSavingsAccountType = {
  __typename?: "TaxSavingsAccountType";
  accountName?: Maybe<Scalars["String"]["output"]>;
  accountType?: Maybe<Scalars["String"]["output"]>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  contributionReference?: Maybe<Scalars["String"]["output"]>;
  contributionType?: Maybe<Scalars["String"]["output"]>;
  contributor?: Maybe<Scalars["String"]["output"]>;
  contributorMetadata?: Maybe<Scalars["JSONString"]["output"]>;
  date?: Maybe<Scalars["String"]["output"]>;
  elevateStatus?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  receiptDate?: Maybe<Scalars["String"]["output"]>;
  receiptValue?: Maybe<Scalars["Float"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  taxSaving?: Maybe<Scalars["Float"]["output"]>;
};

export type ThematicPoolType = {
  __typename?: "ThematicPoolType";
  assetId?: Maybe<Scalars["String"]["output"]>;
  categoryId?: Maybe<Scalars["String"]["output"]>;
  categoryKey?: Maybe<Scalars["String"]["output"]>;
  categoryValue?: Maybe<Scalars["String"]["output"]>;
  weight?: Maybe<Scalars["Float"]["output"]>;
};

/** Account response field type  */
export type ThirdPartyAccountInputType = {
  __typename?: "ThirdPartyAccountInputType";
  createdBy?: Maybe<UserType>;
  family: FamilyType;
  id: Scalars["ID"]["output"];
  locked: Scalars["Boolean"]["output"];
  sponsor?: Maybe<ThirdPartySponsorsType>;
};

/** Account response field type  */
export type ThirdPartySponsorsType = {
  __typename?: "ThirdPartySponsorsType";
  id: Scalars["ID"]["output"];
  sponsor: Scalars["String"]["output"];
  thirdpartyaccount: Array<ThirdPartyAccountInputType>;
  transferType: Scalars["String"]["output"];
  validation: Scalars["Boolean"]["output"];
};

/** Third Party Transaction Details.  */
export type ThirdPartyTransactionType = {
  __typename?: "ThirdPartyTransactionType";
  accountType?: Maybe<Scalars["String"]["output"]>;
  amountContributed?: Maybe<Scalars["Float"]["output"]>;
  contributor?: Maybe<Scalars["String"]["output"]>;
  dateInitiated?: Maybe<Scalars["String"]["output"]>;
  dateReceived?: Maybe<Scalars["Date"]["output"]>;
  dateReconciled?: Maybe<Scalars["Date"]["output"]>;
  dateUpdated?: Maybe<Scalars["String"]["output"]>;
  transactionId?: Maybe<Scalars["Int"]["output"]>;
  transactionReference?: Maybe<Scalars["String"]["output"]>;
  transactionStatus?: Maybe<Scalars["String"]["output"]>;
};

export type TickerType = {
  __typename?: "TickerType";
  assetPoolHoldings: Array<AssetType>;
  holdingsSummary: Array<HoldingSummaryType>;
  name: Scalars["String"]["output"];
  ticker: Scalars["String"]["output"];
  tickerType?: Maybe<Scalars["String"]["output"]>;
};

/** Top Contribution category details. */
export type TopCategoryType = {
  __typename?: "TopCategoryType";
  category?: Maybe<Scalars["String"]["output"]>;
  contribution?: Maybe<Scalars["Float"]["output"]>;
};

export type TopCauseType = {
  __typename?: "TopCauseType";
  cause?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  totalContribution?: Maybe<Scalars["Float"]["output"]>;
};

export type TopCharityType = {
  __typename?: "TopCharityType";
  charityId?: Maybe<Scalars["String"]["output"]>;
  charityName?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  totalContribution?: Maybe<Scalars["Float"]["output"]>;
};

export type TopRecommendationsType = {
  __typename?: "TopRecommendationsType";
  topDafClients?: Maybe<Array<Maybe<ClientsEligibleForDafType>>>;
  topNewClients?: Maybe<Array<Maybe<ClientsEligibleForDafType>>>;
};

/** HoldingSummary input field type  */
export type TransSecurityType = {
  __typename?: "TransSecurityType";
  amount?: Maybe<Scalars["Float"]["output"]>;
  identifier?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  price?: Maybe<Scalars["Float"]["output"]>;
  quantity?: Maybe<Scalars["Float"]["output"]>;
};

export enum TransactionAccountEnumType {
  BankAccount = "bank_account",
  CreditCard = "credit_card",
  Securities = "securities",
  ThirdParty = "third_party",
  WireTransfer = "wire_transfer",
}

export enum TransactionAccountEnumTypeV2 {
  CreditCard = "CREDIT_CARD",
  Grant = "GRANT",
  IraTransfer = "IRA_TRANSFER",
  Plaid = "PLAID",
  ScheduledCcContribution = "SCHEDULED_CC_CONTRIBUTION",
  ScheduledContribution = "SCHEDULED_CONTRIBUTION",
  ScheduledGrant = "SCHEDULED_GRANT",
  Securities = "SECURITIES",
  ThirdParty = "THIRD_PARTY",
  ThirdPartySecurities = "THIRD_PARTY_SECURITIES",
  WireTransfer = "WIRE_TRANSFER",
}

/** Transaction filter input type */
export type TransactionFilterInputType = {
  /** Filter by charity IDs */
  charities?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** Filter by transaction display status */
  displayStatuses?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** Filter transactions until this date */
  endDate?: InputMaybe<Scalars["Date"]["input"]>;
  /** Sort order for initiated_on field (ASC or DESC) */
  orderBy?: InputMaybe<SortOrderEnum>;
  /** Page number for pagination */
  page?: InputMaybe<Scalars["Int"]["input"]>;
  /** Number of items per page */
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  /** Search query */
  searchQuery?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by transaction type */
  source?: InputMaybe<Array<InputMaybe<TransactionAccountEnumTypeV2>>>;
  /** Filter by source-status combinations with precedence over source and statuses filters */
  sourceStatus?: InputMaybe<Scalars["GenericScalar"]["input"]>;
  /** Filter transactions from this date */
  startDate?: InputMaybe<Scalars["Date"]["input"]>;
  /** Filter by multiple statuses */
  statuses?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** Filter by transaction category: 'contribution', 'grant', or 'campaign' */
  type?: InputMaybe<TransactionTypeEnum>;
  /** User ID */
  userId?: InputMaybe<Scalars["Int"]["input"]>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

/** Transaction filters response type */
export type TransactionFiltersType = {
  __typename?: "TransactionFiltersType";
  adminGrants?: Maybe<GrantFiltersType>;
  campaigns?: Maybe<CampaignFiltersType>;
  companyGrants?: Maybe<GrantFiltersType>;
  contributions?: Maybe<ContributionFiltersType>;
  employeeGrants?: Maybe<GrantFiltersType>;
  grants?: Maybe<GrantFiltersType>;
  myGrants?: Maybe<GrantFiltersType>;
};

/** Account Details with Institution, Account Name, Account Number, Balance etc. */
export type TransactionType = {
  __typename?: "TransactionType";
  amount?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  securities?: Maybe<Array<Maybe<TransSecurityType>>>;
  transDate?: Maybe<Scalars["String"]["output"]>;
};

export enum TransactionTypeEnum {
  AdminGrant = "admin_grant",
  Campaign = "campaign",
  CompanyGrant = "company_grant",
  Contribution = "contribution",
  EmployeeGrant = "employee_grant",
  Grant = "grant",
  MyGrant = "my_grant",
}

/** Endpoint to capture an IRA Contribution  */
export type TransferIraContribution = {
  __typename?: "TransferIRAContribution";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  transactionId?: Maybe<Scalars["Int"]["output"]>;
};

/** To contribute ThirdPartyAccountDetail. */
export type TransferThirdPartyContribution = {
  __typename?: "TransferThirdPartyContribution";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  transactionId?: Maybe<Scalars["Int"]["output"]>;
};

export type TransitionActiveItemType = {
  __typename?: "TransitionActiveItemType";
  amount?: Maybe<Scalars["Float"]["output"]>;
  charityName?: Maybe<Scalars["String"]["output"]>;
  frequency?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  sourceType?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
};

export type TransitionActiveItemsPaginatedType = {
  __typename?: "TransitionActiveItemsPaginatedType";
  achProcessingCount?: Maybe<Scalars["Int"]["output"]>;
  contributionsCount?: Maybe<Scalars["Int"]["output"]>;
  contributionsProcessingCount?: Maybe<Scalars["Int"]["output"]>;
  count?: Maybe<Scalars["Int"]["output"]>;
  creditCardProcessingCount?: Maybe<Scalars["Int"]["output"]>;
  dafTransferProcessingCount?: Maybe<Scalars["Int"]["output"]>;
  grantsCount?: Maybe<Scalars["Int"]["output"]>;
  grantsProcessingCount?: Maybe<Scalars["Int"]["output"]>;
  hasCampaigns?: Maybe<Scalars["Boolean"]["output"]>;
  hasContributions?: Maybe<Scalars["Boolean"]["output"]>;
  hasGrants?: Maybe<Scalars["Boolean"]["output"]>;
  objects?: Maybe<Array<Maybe<TransitionActiveItemType>>>;
  securitiesProcessingCount?: Maybe<Scalars["Int"]["output"]>;
  wireProcessingCount?: Maybe<Scalars["Int"]["output"]>;
};

/**
 * One thing about an in-flight transition that an advisor should look at.
 *
 * Derived on read rather than stored: every one of these is a CURRENT
 * condition, and a stored alert would need invalidating the moment the
 * condition cleared -- a transfer that arrives overnight should stop being an
 * alert without anything having to remember to delete it.
 */
export type TransitionAlertType = {
  __typename?: "TransitionAlertType";
  alertType?: Maybe<Scalars["String"]["output"]>;
  currentStep?: Maybe<Scalars["Int"]["output"]>;
  /** Days until the scheduled date; negative if overdue. */
  daysUntil?: Maybe<Scalars["Int"]["output"]>;
  detail?: Maybe<Scalars["String"]["output"]>;
  familyId?: Maybe<Scalars["Int"]["output"]>;
  familyName?: Maybe<Scalars["String"]["output"]>;
  fundName?: Maybe<Scalars["String"]["output"]>;
  initiatedAt?: Maybe<Scalars["String"]["output"]>;
  scheduledDate?: Maybe<Scalars["String"]["output"]>;
  severity?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

/**
 * Manually re-trigger a book-of-business import using stored GS credentials.
 * Useful when the advisor has added new accounts at the custodian.
 */
export type TriggerGsBookOfBusinessImport = {
  __typename?: "TriggerGsBookOfBusinessImport";
  jobId?: Maybe<Scalars["Int"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Internal API to trigger set up instructions to users having individual DAF in a company */
export type TriggerIndividualDafInvites = {
  __typename?: "TriggerIndividualDAFInvites";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Internal API to trigger admin invite for ineligible admins of a company */
export type TriggerIneligibleAdminInvite = {
  __typename?: "TriggerIneligibleAdminInvite";
  triggeredEmails?: Maybe<Array<Maybe<Scalars["GenericScalar"]["output"]>>>;
};

/** Enqueue OFAC Celery task. Returns screening_id (ofac_reference). */
export type TriggerOfacScreening = {
  __typename?: "TriggerOfacScreening";
  error?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  screeningId?: Maybe<Scalars["String"]["output"]>;
};

/**
 * Step 4: email the ops team the DAF-to-DAF transfers to move, with the amount
 * and receiving fund for each successor who has completed their own DAF setup.
 *
 * NOTIFICATION ONLY. This does not initiate a transfer or write any transfer
 * record -- ops moves the money at the custodian. Step 4 then completes once the
 * funds land in the receiving DAFs (see core.tasks._advance_one).
 *
 * Successors are included when they have not declined AND their destination
 * family has a LouiseDafAccount -- the same "resolved" test steps 2 and 3 use.
 * A successor with no fund yet has nowhere to receive money, so listing them
 * would put an unactionable row in front of ops.
 */
export type TriggerSuccessionTransferNotification = {
  __typename?: "TriggerSuccessionTransferNotification";
  message?: Maybe<Scalars["String"]["output"]>;
  notifiedAt?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  previouslyNotifiedAt?: Maybe<Scalars["String"]["output"]>;
  transferCount?: Maybe<Scalars["Int"]["output"]>;
};

/** API to remove favourite  */
export type Unfavourite = {
  __typename?: "Unfavourite";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * User: Advisor
 * Lift the freeze on a family's DAF account (revert or complete transition).
 * Clears all freeze timestamps.
 */
export type UnfreezeDafAccount = {
  __typename?: "UnfreezeDAFAccount";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * Status update triggered by events from FE
 * Checks if the status is legit by verify with docusign APIs
 */
export type UpdateAdventIntegrationStatus = {
  __typename?: "UpdateAdventIntegrationStatus";
  adventIntegration?: Maybe<AdventIntegrationType>;
};

export type UpdateAdvisorAgentCodes = {
  __typename?: "UpdateAdvisorAgentCodes";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UpdateAdvisorDafInputType = {
  accountNumber?: InputMaybe<Scalars["String"]["input"]>;
  benchmark?: InputMaybe<Scalars["String"]["input"]>;
  /** Getting Advisor Fees. */
  bps?: InputMaybe<Scalars["Int"]["input"]>;
  dafCustodianId?: InputMaybe<Scalars["Int"]["input"]>;
  disableAllocations?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Name of the fund to be reflected in DAF. Eg: <Your Family Name>'s Family Fund. */
  fundName: Scalars["String"]["input"];
  /** Whether the fund is single charity fund or not. */
  isSingleCharityFund?: InputMaybe<Scalars["Boolean"]["input"]>;
  managementFees?: InputMaybe<Scalars["Decimal"]["input"]>;
  /** Charity EIN to restrict the single charity fund to */
  restrictedCharityEin?: InputMaybe<Scalars["String"]["input"]>;
  /** Charity ID to restrict the single charity fund to. */
  restrictedCharityId?: InputMaybe<Scalars["String"]["input"]>;
  /** Charity Name to restrict the the single charity fund to. */
  restrictedCharityName?: InputMaybe<Scalars["String"]["input"]>;
};

/** advisor fees update API  */
export type UpdateAdvisorFees = {
  __typename?: "UpdateAdvisorFees";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UpdateAdvisorMapClient = {
  __typename?: "UpdateAdvisorMapClient";
  currentHousehold?: Maybe<Scalars["String"]["output"]>;
  familyId?: Maybe<Scalars["Int"]["output"]>;
  isDafSetup?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Update Annual Giving Goal for the family */
export type UpdateAnnualGivingGoal = {
  __typename?: "UpdateAnnualGivingGoal";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UpdateClientInputType = {
  /** Annual income of the DAF holder in dollars. */
  annualIncome?: InputMaybe<Scalars["Int"]["input"]>;
  /** Goldman Sachs branch code for this DAF. */
  branchCode?: InputMaybe<Scalars["String"]["input"]>;
  clientRole?: InputMaybe<InviteRoleTypeEnum>;
  clientType?: InputMaybe<ClientTypesChoices>;
  dob?: InputMaybe<Scalars["Date"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** Employer line of business (GS API enum, e.g. FINANCE, TECHNOLOGY). */
  employerLineOfBusiness?: InputMaybe<Scalars["String"]["input"]>;
  /** Employment status. One of: FULL_TIME_EMPLOYED, SELF_EMPLOYED, RETIRED, PART_TIME_EMPLOYED, NOT_EMPLOYED. */
  employmentStatus?: InputMaybe<Scalars["String"]["input"]>;
  /** Differentiates Individual vs Family Subscription. */
  engageFamily?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Optional GS loginId (or other external identity) to persist on the HoF User. */
  externalId?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  /** Optional middle name */
  middleName?: InputMaybe<Scalars["String"]["input"]>;
  participantId?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["GenericScalar"]["input"]>;
  /** Title/prefix: MR, MRS, MS, MISS, DR, PROF */
  prefix?: InputMaybe<Scalars["String"]["input"]>;
  /** ID of the primary advisor for this client. Defaults to logged-in user if not provided. */
  primaryAdvisor?: InputMaybe<Scalars["Int"]["input"]>;
  /** Goldman Sachs rep code for this DAF. */
  repCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Source(s) of wealth for the DAF holder. */
  sourceOfWealth?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** Optional suffix: II, III, IV, JR, SR */
  suffix?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateContributionStatuses = {
  __typename?: "UpdateContributionStatuses";
  message?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Update Curate list for a particular family. Takes in list of charities under a cause to enable/disable it. */
export type UpdateCuration = {
  __typename?: "UpdateCuration";
  status?: Maybe<StatusType>;
};

export type UpdateCustomFees = {
  __typename?: "UpdateCustomFees";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** API to update Firm primary color, secondary color, and logo */
export type UpdateCustomizeTheme = {
  __typename?: "UpdateCustomizeTheme";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UpdateDafDetails = {
  __typename?: "UpdateDafDetails";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Update the default allocation for family members */
export type UpdateDefaultAllocation = {
  __typename?: "UpdateDefaultAllocation";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Update Donor allocation for unattached donor */
export type UpdateDonorAllocation = {
  __typename?: "UpdateDonorAllocation";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** API to update email preferences of a firm  */
export type UpdateEmailPreferences = {
  __typename?: "UpdateEmailPreferences";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Update Employee allocation for unattached employee */
export type UpdateEmployeeAllocation = {
  __typename?: "UpdateEmployeeAllocation";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** API for reviewers or enterprise admins to lock/unlock features for child firms */
export type UpdateEnterpriseFeatureLocks = {
  __typename?: "UpdateEnterpriseFeatureLocks";
  featureLocks?: Maybe<FeatureLocksType>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Update family member details  */
export type UpdateFamilyMember = {
  __typename?: "UpdateFamilyMember";
  status?: Maybe<StatusSummaryType>;
};

/** Update the preferences for a family. */
export type UpdateFamilyPreferences = {
  __typename?: "UpdateFamilyPreferences";
  status?: Maybe<StatusType>;
};

/** Update Family Tree details */
export type UpdateFamilyTree = {
  __typename?: "UpdateFamilyTree";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Delete Uploaded firm Logo  */
export type UpdateFirm = {
  __typename?: "UpdateFirm";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UpdateGrantRationale = {
  __typename?: "UpdateGrantRationale";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * Added as part of GIVE-4838 (https://magnifi-dev.atlassian.net/browse/GIVE-4838)
 *
 * Updates user group by group id. There is no other data that can be
 * updated for an user group, hence only the name is being updated currently. There
 * are additional endpoints to add and remove advisors/clients from the group. If
 * this changes in the future, this mutation can be updated to accommodate the same.
 * Simply accept more arguments and update the group data accordingly.
 */
export type UpdateGroup = {
  __typename?: "UpdateGroup";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * Advisor action on a queued import record.
 * Currently supports: skip (marks record as skipped, removing it from the review queue).
 */
export type UpdateGsImportRecord = {
  __typename?: "UpdateGsImportRecord";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Update an existing inheritance registry entry. */
export type UpdateInheritanceRegistry = {
  __typename?: "UpdateInheritanceRegistry";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  registry?: Maybe<InheritanceRegistryType>;
};

/** Update the status of a registry entry. Sets last_confirmed to today when status is CONFIRMED. */
export type UpdateInheritanceStatus = {
  __typename?: "UpdateInheritanceStatus";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  registry?: Maybe<InheritanceRegistryType>;
};

/** Update Mutation Script  */
export type UpdateInvestments = {
  __typename?: "UpdateInvestments";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UpdateLastLogin = {
  __typename?: "UpdateLastLogin";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * Upsert a family's Legacy Blueprint (Philanthropic Values & Mission Vault).
 *
 * Creates the LivingLegacyPlan + LegacyBlueprint on first save. Only the
 * provided scalar/JSON fields are updated; `focus_areas` / `impact_goals`,
 * when supplied, fully replace the existing child rows (the wizard/cards send
 * the complete set).
 */
export type UpdateLegacyBlueprint = {
  __typename?: "UpdateLegacyBlueprint";
  blueprint?: Maybe<LegacyBlueprintType>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UpdateLouiseDafInputType = {
  /** Account number for AMA accounts. */
  accountNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** Advisor Fees in basis points. */
  bps?: InputMaybe<Scalars["Int"]["input"]>;
  /** Name of the fund to be reflected in DAF. Eg: <Your Family Name>'s Family Fund. */
  fundName?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateMemberInputType = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  role?: InputMaybe<InviteRoleTypeEnum>;
};

/** Update Mission Statement for the family. */
export type UpdateMission = {
  __typename?: "UpdateMission";
  status?: Maybe<StatusType>;
};

/** API to create financial advisor Optimise  */
export type UpdateOptimise = {
  __typename?: "UpdateOptimise";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UpdatePaymentIntent = {
  __typename?: "UpdatePaymentIntent";
  intentId?: Maybe<Scalars["String"]["output"]>;
  intentSecret?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UpdatePinnedGivingHistory = {
  __typename?: "UpdatePinnedGivingHistory";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  pinnedGivingHistory?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
};

/** Update an existing recurring gift by closing the old one and creating a new one */
export type UpdateRecurringGift = {
  __typename?: "UpdateRecurringGift";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Change password for Profile information of User  */
export type UpdateRelationship = {
  __typename?: "UpdateRelationship";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Update 'Risk' analytics for each model */
export type UpdateRiskAnalytics = {
  __typename?: "UpdateRiskAnalytics";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Update amount, frequency, or end date of a recurring ACH scheduled contribution. */
export type UpdateScheduledContribution = {
  __typename?: "UpdateScheduledContribution";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * Advisor: update the scheduled_date on a pending voluntary scheduled transition.
 * The new date must be a future business day. Sends a date_updated notification.
 */
export type UpdateScheduledTransitionDate = {
  __typename?: "UpdateScheduledTransitionDate";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * Upsert a family's payout & sunset policy (Policy & Sunset tab).
 *
 * Creates the LivingLegacyPlan + SuccessionPolicy on first save. Only the
 * provided fields are updated. Returns the policy with the live DAF context.
 */
export type UpdateSuccessionPolicy = {
  __typename?: "UpdateSuccessionPolicy";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  policy?: Maybe<SuccessionPolicyType>;
};

/** Update the long term and short term taxes in each family */
export type UpdateTaxTerms = {
  __typename?: "UpdateTaxTerms";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UploadCustomCharityImage = {
  __typename?: "UploadCustomCharityImage";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Upload External Giving History data via excel file  */
export type UploadExternalGivingHistory = {
  __typename?: "UploadExternalGivingHistory";
  externalGiving?: Maybe<Array<Maybe<ExternalGivingHistoryType>>>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Upload a firm/enterprise-specific override for one of the static legal documents. */
export type UploadFirmDocument = {
  __typename?: "UploadFirmDocument";
  firmDocument?: Maybe<FirmDocumentType>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Upload firm Logo */
export type UploadFirmLogo = {
  __typename?: "UploadFirmLogo";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Upload a supporting document for an inheritance registry entry. */
export type UploadInheritanceDocument = {
  __typename?: "UploadInheritanceDocument";
  document?: Maybe<InheritanceDocumentType>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * Upload a family-owned legacy document (Living Legacy — Identity Vault).
 *
 * Writes to the shared InheritanceDocument model with `family` set and no
 * registry link.
 */
export type UploadLegacyDocument = {
  __typename?: "UploadLegacyDocument";
  document?: Maybe<InheritanceDocumentType>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Upload Participant file in s3 bucket */
export type UploadParticipantFile = {
  __typename?: "UploadParticipantFile";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Mutation to upload portfolio  */
export type UploadPortfolio = {
  __typename?: "UploadPortfolio";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Upload Profile Image */
export type UploadProfilePic = {
  __typename?: "UploadProfilePic";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UploadRestrictedCharity = {
  __typename?: "UploadRestrictedCharity";
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  unmatchedCauses?: Maybe<Scalars["GenericScalar"]["output"]>;
};

/**
 * Bulk-upsert a family's sunset charity allocations.
 *
 * Replaces all existing rows for the family with the submitted list so the
 * frontend sends the complete set. Rows not in the new list are deleted.
 */
export type UpsertSunsetCharityAllocations = {
  __typename?: "UpsertSunsetCharityAllocations";
  allocations?: Maybe<Array<Maybe<SunsetCharityAllocationType>>>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UserContributionDistributionType = {
  __typename?: "UserContributionDistributionType";
  giftDistribution?: Maybe<EngageType>;
  user?: Maybe<Scalars["GenericScalar"]["output"]>;
};

export type UserContributionType = {
  __typename?: "UserContributionType";
  contribution?: Maybe<Scalars["Int"]["output"]>;
  contributionDate?: Maybe<Scalars["String"]["output"]>;
};

export enum UserGroupTypeEnum {
  Admins = "ADMINS",
  Employees = "EMPLOYEES",
  Others = "OTHERS",
}

export type UserInGroupType = {
  __typename?: "UserInGroupType";
  userEmail?: Maybe<Scalars["String"]["output"]>;
  userGroupExternalId?: Maybe<Scalars["String"]["output"]>;
  userGroupId?: Maybe<Scalars["Int"]["output"]>;
  userGroupName?: Maybe<Scalars["String"]["output"]>;
  userId?: Maybe<Scalars["Int"]["output"]>;
  userName?: Maybe<Scalars["String"]["output"]>;
};

export enum UserInviteStatus {
  /** accepted */
  Accepted = "ACCEPTED",
  /** cancelled */
  Cancelled = "CANCELLED",
  /** invite */
  Invite = "INVITE",
  /** pending */
  Pending = "PENDING",
}

/** Response fields to have pagination for users list  */
export type UserPaginatedType = {
  __typename?: "UserPaginatedType";
  objects?: Maybe<Array<Maybe<UserType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export enum UserPrefix {
  /** DR */
  Dr = "DR",
  /** MISS */
  Miss = "MISS",
  /** MR */
  Mr = "MR",
  /** MRS */
  Mrs = "MRS",
  /** MS */
  Ms = "MS",
  /** PROF */
  Prof = "PROF",
}

export type UserRelationsType = {
  __typename?: "UserRelationsType";
  familyId?: Maybe<Scalars["Int"]["output"]>;
  relatedUserId?: Maybe<Scalars["Int"]["output"]>;
  relation?: Maybe<Scalars["String"]["output"]>;
  userId?: Maybe<Scalars["Int"]["output"]>;
};

export enum UserSuffix {
  /** II */
  Ii = "II",
  /** III */
  Iii = "III",
  /** IV */
  Iv = "IV",
  /** JR */
  Jr = "JR",
  /** SR */
  Sr = "SR",
}

/** List user's categories  */
export type UserTagType = {
  __typename?: "UserTagType";
  id: Scalars["ID"]["output"];
  tag?: Maybe<TagType>;
  tagCategory?: Maybe<TagCategoryType>;
  user: UserType;
};

/** Response type to provide user details  */
export type UserType = {
  __typename?: "UserType";
  address?: Maybe<Scalars["GenericScalar"]["output"]>;
  advisorFamilies: Array<FamilyType>;
  authProvider?: Maybe<Scalars["String"]["output"]>;
  contributions: Array<GiftActivityType>;
  corporateBenefit?: Maybe<Scalars["Boolean"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  disabledAt?: Maybe<Scalars["DateTime"]["output"]>;
  disabledBy?: Maybe<UserType>;
  dob?: Maybe<Scalars["Date"]["output"]>;
  email: Scalars["String"]["output"];
  emailChangeRequest?: Maybe<Scalars["String"]["output"]>;
  emailPrefDafContribution?: Maybe<Scalars["Boolean"]["output"]>;
  emailPrefGifts?: Maybe<Scalars["Boolean"]["output"]>;
  emailPrefOnboarding?: Maybe<Scalars["Boolean"]["output"]>;
  employeeDafDetails?: Maybe<EmployeeDafDetailsType>;
  employeeStatus?: Maybe<Scalars["String"]["output"]>;
  externalId?: Maybe<Scalars["String"]["output"]>;
  family?: Maybe<FamilyType>;
  familyRole?: Maybe<Scalars["String"]["output"]>;
  firm?: Maybe<FirmType>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  givingPrivacyPreference?: Maybe<Scalars["GenericScalar"]["output"]>;
  id: Scalars["ID"]["output"];
  individualBenefit?: Maybe<Scalars["Boolean"]["output"]>;
  inviteSent?: Maybe<Scalars["DateTime"]["output"]>;
  inviteStatus: UserInviteStatus;
  isActive: Scalars["Boolean"]["output"];
  isStaff: Scalars["Boolean"]["output"];
  lastLogin?: Maybe<Scalars["DateTime"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  linkedAssets?: Maybe<Scalars["Float"]["output"]>;
  mfaEnrolled?: Maybe<Scalars["Boolean"]["output"]>;
  mfaMethod?: Maybe<Scalars["String"]["output"]>;
  middleName?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  onboardingStage?: Maybe<Scalars["String"]["output"]>;
  phoneNumber?: Maybe<Scalars["GenericScalar"]["output"]>;
  portfolioAccounts?: Maybe<Array<Maybe<AdventIntegratedPortfolioType>>>;
  prefix?: Maybe<UserPrefix>;
  profilepicUrl?: Maybe<Scalars["String"]["output"]>;
  relatedToHof?: Maybe<Scalars["Int"]["output"]>;
  relations?: Maybe<Array<Maybe<UserRelationsType>>>;
  relationship?: Maybe<Scalars["String"]["output"]>;
  roleType?: Maybe<Scalars["String"]["output"]>;
  roles?: Maybe<Scalars["GenericScalar"]["output"]>;
  selfDirected?: Maybe<SelfDirectedType>;
  signupStatus?: Maybe<Scalars["String"]["output"]>;
  socialSubs?: Maybe<Scalars["JSONString"]["output"]>;
  sourceFirm?: Maybe<FirmType>;
  stateCode?: Maybe<Scalars["String"]["output"]>;
  subscribeGivingTrends?: Maybe<Scalars["Boolean"]["output"]>;
  subscribeNewFeatures?: Maybe<Scalars["Boolean"]["output"]>;
  suffix?: Maybe<UserSuffix>;
  tncAcceptedTime?: Maybe<Scalars["DateTime"]["output"]>;
  userRoles?: Maybe<Scalars["GenericScalar"]["output"]>;
  userTags: Array<UserTagType>;
  yearlyFamilyUserGroupData?: Maybe<YearlyFamilyUserGroupDataType>;
  yearlyPendingGrants?: Maybe<Scalars["Float"]["output"]>;
  yearlyUserData?: Maybe<YearlyUserDataType>;
  yellowRef?: Maybe<Scalars["String"]["output"]>;
};

export type UsersInGroupPaginationType = {
  __typename?: "UsersInGroupPaginationType";
  objects?: Maybe<Array<Maybe<UserInGroupType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
};

/** Response fields to have pagination for users search list  */
export type UsersPaginatedType = {
  __typename?: "UsersPaginatedType";
  objects?: Maybe<Array<Maybe<UserType>>>;
  page?: Maybe<Scalars["Int"]["output"]>;
  pages?: Maybe<Scalars["Int"]["output"]>;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type ValidatedTicker = {
  __typename?: "ValidatedTicker";
  isValid?: Maybe<Scalars["Boolean"]["output"]>;
  ticker?: Maybe<Scalars["String"]["output"]>;
  tickerName?: Maybe<Scalars["String"]["output"]>;
  validationError?: Maybe<Scalars["String"]["output"]>;
};

export type Verify = {
  __typename?: "Verify";
  payload: Scalars["GenericScalar"]["output"];
};

/** Step 2 (email path): verify OTP, return 30-min session JWT. */
export type VerifyEmailOtp = {
  __typename?: "VerifyEmailOtp";
  error?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  sessionToken?: Maybe<Scalars["String"]["output"]>;
};

/** Verify TOTP OTP with Okta, activate account, return Okta token for cookie storage. */
export type VerifyTotpEnrollment = {
  __typename?: "VerifyTotpEnrollment";
  error?: Maybe<Scalars["String"]["output"]>;
  ok?: Maybe<Scalars["Boolean"]["output"]>;
  oktaToken?: Maybe<Scalars["String"]["output"]>;
};

/** Verify TOTP code at login time via Okta. Does not change signup_status or mfa_enrolled. */
export type VerifyTotpLogin = {
  __typename?: "VerifyTotpLogin";
  error?: Maybe<Scalars["String"]["output"]>;
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type WeekEngagementType = {
  __typename?: "WeekEngagementType";
  /** Number of DAFs funded for the week */
  dafsFunded?: Maybe<Scalars["Int"]["output"]>;
  /** Number of DAFs opened for the week */
  dafsOpened?: Maybe<Scalars["Int"]["output"]>;
  /** Number of sign ups for the week */
  signUps?: Maybe<Scalars["Int"]["output"]>;
  /** Week label (e.g., 'Week 1') */
  week?: Maybe<Scalars["String"]["output"]>;
  /** Week start date in ISO format */
  weekStart?: Maybe<Scalars["String"]["output"]>;
};

export type YearlyFamilyUserGroupDataType = {
  __typename?: "YearlyFamilyUserGroupDataType";
  /** Allocated Amount */
  allocatedAmount: Scalars["Decimal"]["output"];
  contributedAmount?: Maybe<Scalars["Float"]["output"]>;
  year: Scalars["Int"]["output"];
};

export type YearlyUserDataType = {
  __typename?: "YearlyUserDataType";
  /** Allocated Amount */
  allocatedAmount: Scalars["Decimal"]["output"];
  contributedAmount: Scalars["Decimal"]["output"];
  year: Scalars["Int"]["output"];
};

export type ZipCodeInfoType = {
  __typename?: "ZipCodeInfoType";
  city?: Maybe<Scalars["String"]["output"]>;
  stateCode?: Maybe<Scalars["String"]["output"]>;
  stateName?: Maybe<Scalars["String"]["output"]>;
  zipCode?: Maybe<Scalars["String"]["output"]>;
};

export type ZipCodesType = {
  __typename?: "ZipCodesType";
  countryCode?: Maybe<Scalars["String"]["output"]>;
  zipMetadata?: Maybe<Scalars["JSONString"]["output"]>;
};

export type ActivitiesQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  filter?: InputMaybe<ActivityFilterInput>;
}>;

export type ActivitiesQuery = {
  __typename?: "Query";
  activities?: {
    __typename?: "ActivityPaginatedType";
    page?: number | null;
    pages?: number | null;
    count?: number | null;
    objects?: Array<{
      __typename?: "ActivityTypeSchema";
      id: string;
      type: ActivityType;
      category: ActivityCategory;
      message?: string | null;
      actionUrl: string;
      actionText: string;
      createdAt: any;
    } | null> | null;
  } | null;
};

export type GetAllGrowthActivitiesQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  filter?: InputMaybe<GrowthActivityFilterInput>;
}>;

export type GetAllGrowthActivitiesQuery = {
  __typename?: "Query";
  growthActivities?: {
    __typename?: "GrowthActivityPaginatedType";
    page?: number | null;
    pages?: number | null;
    count?: number | null;
    snoozedCount?: number | null;
    normalCount?: number | null;
    objects?: Array<{
      __typename?: "GrowthActivityTypeSchema";
      id: string;
      type?: string | null;
      category: GrowthActivityCategory;
      message?: string | null;
      actionUrl: string;
      actionText: string;
      pathToRevenue: string;
      recommendedAction: string;
      createdAt: any;
      actions?: Array<{
        __typename?: "GrowthActivityActionType";
        id: string;
        actionType: GrowthActivityActionActionType;
        actionAt: any;
        actionByUser?: {
          __typename?: "UserType";
          id: string;
          email: string;
          firstName?: string | null;
          lastName?: string | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type TodosQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchStr?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<ActionableFilterInput>;
}>;

export type TodosQuery = {
  __typename?: "Query";
  todos?: {
    __typename?: "ActionablePaginatedType";
    page?: number | null;
    pages?: number | null;
    count?: number | null;
    objects?: Array<{
      __typename?: "ActionableTypeSchema";
      id: string;
      type: ActionableType;
      category: ActionableCategory;
      message?: string | null;
      actionUrl: string;
      actionText: string;
      metaData: any;
    } | null> | null;
  } | null;
};

export type AlertsQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchStr?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<ActionableFilterInput>;
}>;

export type AlertsQuery = {
  __typename?: "Query";
  alerts?: {
    __typename?: "ActionablePaginatedType";
    page?: number | null;
    count?: number | null;
    objects?: Array<{
      __typename?: "ActionableTypeSchema";
      id: string;
      type: ActionableType;
      category: ActionableCategory;
      message?: string | null;
      actionUrl: string;
      actionText: string;
    } | null> | null;
  } | null;
};

export type ResendInviteMutationVariables = Exact<{
  userId: Scalars["Int"]["input"];
}>;

export type ResendInviteMutation = {
  __typename?: "Mutation";
  resendInvite?: { __typename?: "ResendInvite"; ok?: boolean | null } | null;
};

export type GrowthActivityActionMutationMutationVariables = Exact<{
  input: GrowthActivityActionInput;
}>;

export type GrowthActivityActionMutationMutation = {
  __typename?: "Mutation";
  growthActivityAction?: {
    __typename?: "GrowthActivityActionPayload";
    ok?: boolean | null;
    errors?: Array<string | null> | null;
    action?: {
      __typename?: "GrowthActivityActionType";
      id: string;
      actionType: GrowthActivityActionActionType;
      actionAt: any;
      actionBy: {
        __typename?: "UserType";
        id: string;
        email: string;
        firstName?: string | null;
        lastName?: string | null;
      };
      growthActivity: {
        __typename?: "GrowthActivityTypeSchema";
        id: string;
        type?: string | null;
      };
    } | null;
  } | null;
};

export type NewDafClientsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  searchStr?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<AdvisorDafClientsFilterType>;
  advisorId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type NewDafClientsQuery = {
  __typename?: "Query";
  newDafClients?: {
    __typename?: "FamilyPaginatedType";
    count?: number | null;
    page?: number | null;
    pages?: number | null;
    objects?: Array<{
      __typename?: "FamilyType";
      id: string;
      name: string;
      clientType?: FamilyClientType | null;
      createdAt: any;
      isFunded?: boolean | null;
      engageFamily: boolean;
      isLinkedPortfolio?: boolean | null;
      taxOptimisationSessionIds?: Array<number | null> | null;
      linkedAssets?: number | null;
      isIndividualDaf?: boolean | null;
      n8nLog?: {
        __typename?: "N8NIntegrationLogType";
        id?: string | null;
        eventType?: string | null;
        status?: string | null;
        envelopeId?: string | null;
        docusignStatus?: string | null;
        docusignStatusUpdatedAt?: any | null;
        s3Key?: string | null;
        isDownloaded?: boolean | null;
        createdAt?: any | null;
        updatedAt?: any | null;
      } | null;
      familyMembers?: Array<{
        __typename?: "UserType";
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        familyRole?: string | null;
        email: string;
        yellowRef?: string | null;
        inviteStatus: UserInviteStatus;
        profilepicUrl?: string | null;
        tncAcceptedTime?: any | null;
        phoneNumber?: any | null;
        linkedAssets?: number | null;
        yearlyFamilyUserGroupData?: {
          __typename?: "YearlyFamilyUserGroupDataType";
          allocatedAmount: any;
          contributedAmount?: number | null;
        } | null;
        relations?: Array<{
          __typename?: "UserRelationsType";
          relatedUserId?: number | null;
          relation?: string | null;
        } | null> | null;
        portfolioAccounts?: Array<{
          __typename?: "AdventIntegratedPortfolioType";
          id: string;
          portfolioCode: string;
          accountName: string;
          totalBalance: number;
          portfolioNameTwo?: string | null;
          custodianId?: string | null;
          totalUnrealizedGain?: number | null;
          appreciatedSecuritiesCount?: number | null;
        } | null> | null;
      } | null> | null;
      hof?: {
        __typename?: "UserType";
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email: string;
        inviteStatus: UserInviteStatus;
        inviteSent?: any | null;
        yellowRef?: string | null;
        onboardingStage?: string | null;
      } | null;
      louiseDaf?: {
        __typename?: "LouiseDAFSummary";
        dafId?: number | null;
        fundId?: string | null;
        fundName?: string | null;
        availableBalance?: any | null;
        accumulatedGrants?: any | null;
        accumulatedContributions?: any | null;
        accumulatedYearlyContributions?: any | null;
        custodian?: string | null;
        custodianId?: number | null;
        isSingleCharityFund?: boolean | null;
        restrictedCharityId?: string | null;
        restrictedCharityName?: string | null;
        restrictedCharityEin?: string | null;
        ytdAdvisorFees?: number | null;
        totalGrantsCount?: number | null;
        confirmAmaAccount?: boolean | null;
        custodialVerified?: boolean | null;
        custodialVerifiedAt?: any | null;
        disableAllocations?: boolean | null;
        accountNumber?: string | null;
      } | null;
      advisorDaf?: {
        __typename?: "AdvisorDAFType";
        fundName: string;
        isSingleCharityFund: boolean;
        restrictedCharityId?: string | null;
        restrictedCharityName?: string | null;
        restrictedCharityEin?: string | null;
        custodian?: { __typename?: "DafCustodianType"; name: string } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type DafClientsByEmailQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  searchStr?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<AdvisorDafClientsFilterType>;
}>;

export type DafClientsByEmailQuery = {
  __typename?: "Query";
  dafClients?: {
    __typename?: "FamilyPaginatedType";
    count?: number | null;
    objects?: Array<{
      __typename?: "FamilyType";
      id: string;
      name: string;
      hof?: {
        __typename?: "UserType";
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        phoneNumber?: any | null;
      } | null;
    } | null> | null;
  } | null;
};

export type CreateFamilyAndMembersMutationVariables = Exact<{
  client: ClientInputType;
  members?: InputMaybe<
    Array<InputMaybe<MemberInputType>> | InputMaybe<MemberInputType>
  >;
  advisorDaf: AdvisorDafInputType;
}>;

export type CreateFamilyAndMembersMutation = {
  __typename?: "Mutation";
  createFamilyAndMembers?: {
    __typename: "CreateFamilyAndMembers";
    status?: {
      __typename: "StatusSummaryType";
      success?: {
        __typename: "ListStatusType";
        total?: number | null;
        statuses?: Array<{
          __typename: "StatusType";
          object?: any | null;
          status?: boolean | null;
          message?: string | null;
        } | null> | null;
      } | null;
      fail?: {
        __typename: "ListStatusType";
        total?: number | null;
        statuses?: Array<{
          __typename: "StatusType";
          object?: any | null;
          status?: boolean | null;
          message?: string | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type AdvisorNewSummaryQueryVariables = Exact<{ [key: string]: never }>;

export type AdvisorNewSummaryQuery = {
  __typename?: "Query";
  advisorNewSummary?: {
    __typename?: "AdvisorSummaryDashboardType";
    campaigns?: number | null;
    totalDafAum?: string | null;
    clientCount?: number | null;
    dafInvestmentPercent?: number | null;
    totalGifted?: number | null;
    ytdSubadvisoryFee?: number | null;
    ytdContribution?: number | null;
  } | null;
};

export type AdvisorCampaignsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  searchStr?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<AdvisorDafClientsFilterType>;
}>;

export type AdvisorCampaignsQuery = {
  __typename?: "Query";
  newDafClients?: {
    __typename?: "FamilyPaginatedType";
    count?: number | null;
    page?: number | null;
    pages?: number | null;
    objects?: Array<{
      __typename?: "FamilyType";
      id: string;
      name: string;
      hof?: {
        __typename?: "UserType";
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
      } | null;
      campaigns: Array<{
        __typename?: "CampaignPublicType";
        id: string;
        title?: string | null;
        publicId: any;
        startDate?: any | null;
        endDate?: any | null;
        state?: CampaignState | null;
        bannerImage?: string | null;
        goal?: any | null;
        achieved?: any | null;
        charity?: {
          __typename?: "CharityType";
          id?: string | null;
          title?: string | null;
        } | null;
        donation: Array<{
          __typename?: "CampaignDonationType";
          id: string;
          contributor?: string | null;
          email?: string | null;
          amount: any;
          createdAt: any;
          isExternal: boolean;
          status?: CampaignDonationStatus | null;
        }>;
      }>;
    } | null> | null;
  } | null;
};

export type GetAdvisorCampaignsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  filters?: InputMaybe<CampaignFilterInputType>;
}>;

export type GetAdvisorCampaignsQuery = {
  __typename?: "Query";
  campaignsByAdvisor?: {
    __typename?: "CampaignPaginatedType";
    page?: number | null;
    pages?: number | null;
    count?: number | null;
    objects?: Array<{
      __typename?: "CampaignType";
      id: string;
      title?: string | null;
      goal?: any | null;
      achieved?: any | null;
      message?: string | null;
      state?: CampaignState | null;
      isActive: boolean;
      startDate?: any | null;
      endDate?: any | null;
      campaignImage?: string | null;
      bannerImage?: string | null;
      publicId: any;
      numberOfDonations?: number | null;
      charity?: {
        __typename?: "CharityType";
        id?: string | null;
        title?: string | null;
      } | null;
      startedBy: { __typename?: "UserType"; id: string; name?: string | null };
      donation?: Array<{
        __typename?: "CampaignDonationType";
        id: string;
        amount: any;
        contributor?: string | null;
        email?: string | null;
        createdAt: any;
        status?: CampaignDonationStatus | null;
        isExternal: boolean;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type InvestmentChangeRequestsQueryVariables = Exact<{
  fundId: Scalars["ID"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type InvestmentChangeRequestsQuery = {
  __typename?: "Query";
  investmentChangeRequests?: {
    __typename?: "InvestmentChangeRequestPaginatedType";
    page?: number | null;
    pages?: number | null;
    objects?: Array<{
      __typename?: "InvestmentChangeRequestType";
      id?: string | null;
      initiatedOn?: string | null;
      status?: string | null;
      targets?: string | null;
      type?: string | null;
    } | null> | null;
  } | null;
};

export type CancelCashMovementMutationVariables = Exact<{
  fundId: Scalars["ID"]["input"];
  cashMovementId: Scalars["ID"]["input"];
}>;

export type CancelCashMovementMutation = {
  __typename?: "Mutation";
  cancelCashMovement?: {
    __typename?: "CancelCashMovement";
    ok?: boolean | null;
  } | null;
};

export type CancelReallocationRebalanceMutationVariables = Exact<{
  fundId: Scalars["ID"]["input"];
  reallocationRebalanceId: Scalars["ID"]["input"];
}>;

export type CancelReallocationRebalanceMutation = {
  __typename?: "Mutation";
  cancelReallocationRebalance?: {
    __typename?: "CancelReallocationRebalance";
    ok?: boolean | null;
  } | null;
};

export type AdvisorWeeklySummaryQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdvisorWeeklySummaryQuery = {
  __typename?: "Query";
  advisorWeeklySummary?: {
    __typename: "AdvisorWeeklySummaryType";
    contributions?: number | null;
    grants?: number | null;
    pendingContributions?: number | null;
    pendingGrants?: number | null;
  } | null;
};

export type AdvisorClientInsightsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdvisorClientInsightsQuery = {
  __typename?: "Query";
  advisorClientInsights?: any | null;
};

export type AdvisorClientTransactionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  filters?: InputMaybe<TransactionFilterInputType>;
}>;

export type AdvisorClientTransactionsQuery = {
  __typename?: "Query";
  advisorClientTransactions?: {
    __typename?: "ListTransactionsPaginatedType";
    page?: number | null;
    pages?: number | null;
    objects?: Array<{
      __typename?: "AllTransactionsType";
      transactionId: string;
      amount?: number | null;
      contributor: string;
      description: string;
      status: string;
      displayStatus: string;
      initiatedOn: any;
      lastUpdatedOn?: any | null;
      searchDescription: string;
      source: string;
      familyId: number;
      userId: number;
    } | null> | null;
  } | null;
};

export type CustodianIntegrationsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CustodianIntegrationsQuery = {
  __typename?: "Query";
  integrations?: Array<{
    __typename: "AdventIntegrationType";
    id: string;
    status: AdventIntegrationStatus;
    docusignUrl?: string | null;
    connectedOn?: any | null;
    masterAccount?: Array<string | null> | null;
    totalAccounts?: Array<number | null> | null;
    lastSyncedAt?: Array<any | null> | null;
    custodian?: {
      __typename: "DafCustodianType";
      id: string;
      name: string;
    } | null;
  } | null> | null;
};

export type LinkedAccountsQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type LinkedAccountsQuery = {
  __typename?: "Query";
  linkedAccounts?: {
    __typename?: "LinkedAccountPaginatedType";
    page?: number | null;
    pages?: number | null;
    totalCount?: number | null;
    objects?: Array<{
      __typename?: "LinkedAccountType";
      clientName?: string | null;
      ownerName?: string | null;
      custodianName?: string | null;
      accountId?: string | null;
      accountNumber?: string | null;
      assets?: number | null;
      costBasis?: number | null;
      unrealizedGain?: number | null;
      appreciatedSecuritiesCount?: number | null;
      hasGsOwners?: boolean | null;
    } | null> | null;
  } | null;
};

export type ClientsWithThirdPartyDafQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ClientsWithThirdPartyDafQuery = {
  __typename?: "Query";
  clientsWithThirdPartyDaf?: {
    __typename?: "ClientsWithThirdPartyDAFPaginatedType";
    page?: number | null;
    pages?: number | null;
    totalCount?: number | null;
    objects?: Array<{
      __typename?: "ClientsWithThirdPartyDAFType";
      clientName?: string | null;
      custodianName?: string | null;
      accountId?: string | null;
      assets?: number | null;
    } | null> | null;
  } | null;
};

export type GetTopRecommendationsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetTopRecommendationsQuery = {
  __typename?: "Query";
  topRecommendations?: {
    __typename?: "TopRecommendationsType";
    topDafClients?: Array<{
      __typename?: "ClientsEligibleForDAFType";
      clientName?: string | null;
      portfolioCode?: string | null;
      portfolioValue?: number | null;
      costBasis?: number | null;
      unrealizedGain?: number | null;
      appreciatedSecuritiesCount?: number | null;
      familyId?: string | null;
      hofUserId?: string | null;
    } | null> | null;
    topNewClients?: Array<{
      __typename?: "ClientsEligibleForDAFType";
      accountNumber?: string | null;
      clientName?: string | null;
      portfolioCode?: string | null;
      portfolioValue?: number | null;
      costBasis?: number | null;
      unrealizedGain?: number | null;
      appreciatedSecuritiesCount?: number | null;
      familyId?: string | null;
      hofUserId?: string | null;
    } | null> | null;
  } | null;
};

export type GetBunchingPlanDraftQueryVariables = Exact<{
  portfolioCode: Scalars["String"]["input"];
}>;

export type GetBunchingPlanDraftQuery = {
  __typename?: "Query";
  bunchingPlanDraft?: {
    __typename?: "BunchingPlanDraftType";
    id: string;
    status: BunchingPlanDraftStatus;
    planData?: any | null;
    updatedAt?: any | null;
  } | null;
};

export type GetBookLevelSettingsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetBookLevelSettingsQuery = {
  __typename?: "Query";
  bookLevelSettings?: {
    __typename?: "BookLevelSettingsType";
    id: string;
    teError?: number | null;
    tickerLimit?: number | null;
    maxContribution?: number | null;
    createdAt?: any | null;
    updatedAt?: any | null;
    coreUser: {
      __typename?: "UserType";
      id: string;
      email: string;
      firstName?: string | null;
      lastName?: string | null;
    };
  } | null;
};

export type GetClientLevelSettingsQueryVariables = Exact<{
  portfolioId: Scalars["String"]["input"];
}>;

export type GetClientLevelSettingsQuery = {
  __typename?: "Query";
  clientLevelSettings?: {
    __typename?: "ClientLevelSettingsType";
    id: string;
    filingStatus?: ClientLevelSettingsFilingStatus | null;
    agi?: number | null;
    restrictedSecurities: Array<string>;
    teError?: number | null;
    donationLimit?: number | null;
    targetTaxSavings?: number | null;
    tickerLimit?: number | null;
    createdAt?: any | null;
    updatedAt?: any | null;
    taxProposalScenario?: ClientLevelSettingsTaxProposalScenario | null;
    adventIntegratedPortfolio: {
      __typename?: "AdventIntegratedPortfolioType";
      id: string;
      portfolioCode: string;
      accountName: string;
    };
  } | null;
};

export type SaveBookLevelSettingsMutationVariables = Exact<{
  teError?: InputMaybe<Scalars["Float"]["input"]>;
  tickerLimit?: InputMaybe<Scalars["Int"]["input"]>;
  maxContribution?: InputMaybe<Scalars["Float"]["input"]>;
}>;

export type SaveBookLevelSettingsMutation = {
  __typename?: "Mutation";
  saveBookLevelSettings?: {
    __typename?: "SaveBookLevelSettings";
    bookLevelSettings?: {
      __typename?: "BookLevelSettingsType";
      id: string;
      teError?: number | null;
      tickerLimit?: number | null;
      maxContribution?: number | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      coreUser: {
        __typename?: "UserType";
        id: string;
        email: string;
        firstName?: string | null;
        lastName?: string | null;
      };
    } | null;
  } | null;
};

export type SaveClientLevelSettingsMutationVariables = Exact<{
  adventIntegratedPortfolioId: Scalars["String"]["input"];
  filingStatus?: InputMaybe<Scalars["String"]["input"]>;
  agi?: InputMaybe<Scalars["Float"]["input"]>;
  restrictedSecurities?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
  teError?: InputMaybe<Scalars["Float"]["input"]>;
  donationLimit?: InputMaybe<Scalars["Float"]["input"]>;
  targetTaxSavings?: InputMaybe<Scalars["Float"]["input"]>;
  tickerLimit?: InputMaybe<Scalars["Int"]["input"]>;
  taxProposalScenario?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type SaveClientLevelSettingsMutation = {
  __typename?: "Mutation";
  saveClientLevelSettings?: {
    __typename?: "SaveClientLevelSettings";
    clientLevelSettings?: {
      __typename?: "ClientLevelSettingsType";
      id: string;
      filingStatus?: ClientLevelSettingsFilingStatus | null;
      agi?: number | null;
      restrictedSecurities: Array<string>;
      teError?: number | null;
      donationLimit?: number | null;
      targetTaxSavings?: number | null;
      tickerLimit?: number | null;
      taxProposalScenario?: ClientLevelSettingsTaxProposalScenario | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      adventIntegratedPortfolio: {
        __typename?: "AdventIntegratedPortfolioType";
        id: string;
        portfolioCode: string;
        accountName: string;
      };
    } | null;
  } | null;
};

export type FamiliesWithPortfolioMappingsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type FamiliesWithPortfolioMappingsQuery = {
  __typename?: "Query";
  familiesWithPortfolioMappings?: {
    __typename?: "FamilyPaginatedType";
    page?: number | null;
    pages?: number | null;
    objects?: Array<{
      __typename?: "FamilyType";
      id: string;
      name: string;
      portfolioMappings?: Array<{
        __typename?: "PortfolioMappingType";
        portfolioCode?: string | null;
        accountName?: string | null;
        totalBalance?: number | null;
        createdAt?: string | null;
        custodianId?: string | null;
        masterAccountNumber?: string | null;
        accountType?: string | null;
        taxStatus?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type SearchAdvisorFamilyUsersQueryVariables = Exact<{
  advisorId?: InputMaybe<Scalars["Int"]["input"]>;
  searchStr?: InputMaybe<Scalars["String"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type SearchAdvisorFamilyUsersQuery = {
  __typename?: "Query";
  searchAdvisorFamilyUsers?: {
    __typename?: "UsersPaginatedType";
    page?: number | null;
    pages?: number | null;
    totalCount?: number | null;
    objects?: Array<{
      __typename?: "UserType";
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      email: string;
      roles?: any | null;
      isActive: boolean;
    } | null> | null;
  } | null;
};

export type RemoveUserPortfolioMappingMutationVariables = Exact<{
  userId: Scalars["ID"]["input"];
  portfolioCode: Scalars["String"]["input"];
}>;

export type RemoveUserPortfolioMappingMutation = {
  __typename?: "Mutation";
  removeUserPortfolioMapping?: {
    __typename?: "RemoveUserPortfolioMapping";
    success?: boolean | null;
    message?: string | null;
  } | null;
};

export type AdvisorGroupsQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchString?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
}>;

export type AdvisorGroupsQuery = {
  __typename?: "Query";
  advisorGroups?: {
    __typename?: "AdvisorGroupPaginatedType";
    page?: number | null;
    pages?: number | null;
    totalCount?: number | null;
    objects?: Array<{
      __typename?: "AdvisorGroupType";
      id?: number | null;
      name?: string | null;
      externalId?: string | null;
      groupType?: string | null;
      familyCount?: number | null;
      advisors?: Array<{
        __typename?: "UserType";
        id: string;
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email: string;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type ListFirmAdvisorsQueryVariables = Exact<{
  firmId: Scalars["Int"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
  excludeIds?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  userId?: InputMaybe<Scalars["Int"]["input"]>;
  isForAddClient?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type ListFirmAdvisorsQuery = {
  __typename?: "Query";
  listFirmAdvisors?: {
    __typename?: "FirmPaginationType";
    page?: number | null;
    pages?: number | null;
    objects?: Array<{
      __typename?: "AdvisorDetailsType";
      id?: number | null;
      name?: string | null;
      email?: string | null;
      aum?: string | null;
      clientsManaged?: number | null;
      clientsSupported?: number | null;
      dafsCount?: number | null;
      profileUrl?: string | null;
      tncAcceptedTime?: any | null;
      ytd?: string | null;
    } | null> | null;
  } | null;
};

export type AdvisorGroupQueryVariables = Exact<{
  groupId: Scalars["Int"]["input"];
}>;

export type AdvisorGroupQuery = {
  __typename?: "Query";
  advisorGroup?: {
    __typename?: "AdvisorGroupType";
    id?: number | null;
    name?: string | null;
    externalId?: string | null;
    groupType?: string | null;
    advisors?: Array<{
      __typename?: "UserType";
      id: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email: string;
    } | null> | null;
  } | null;
};

export type ListAdvisorGroupClientsQueryVariables = Exact<{
  groupId: Scalars["Int"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ListAdvisorGroupClientsQuery = {
  __typename?: "Query";
  listAdvisorGroupClients?: {
    __typename?: "AdvisorGroupClientsPaginatedType";
    page?: number | null;
    pages?: number | null;
    objects?: Array<{
      __typename?: "AdvisorGroupClientsDetailsType";
      id?: number | null;
      name?: string | null;
      primaryAdvisor?: string | null;
      fundName?: string | null;
      aum?: number | null;
      subAdvisorFee?: number | null;
      ytd?: number | null;
    } | null> | null;
  } | null;
};

export type FundSearchQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
  genSearchStr?: InputMaybe<Scalars["String"]["input"]>;
  filterKeys?: InputMaybe<
    Array<InputMaybe<FilterKeyType>> | InputMaybe<FilterKeyType>
  >;
  categoryIds?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type FundSearchQuery = {
  __typename?: "Query";
  fundSearch?: {
    __typename?: "NodePaginatedType";
    objects?: Array<any | null> | null;
    page?: number | null;
    pages?: number | null;
  } | null;
};

export type CampaignsQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
  pageSize: Scalars["Int"]["input"];
  page: Scalars["Int"]["input"];
  filters?: InputMaybe<CampaignFilterInputType>;
}>;

export type CampaignsQuery = {
  __typename?: "Query";
  campaigns?: {
    __typename: "CampaignPaginatedType";
    page?: number | null;
    pages?: number | null;
    count?: number | null;
    objects?: Array<{
      __typename: "CampaignType";
      id: string;
      title?: string | null;
      publicId: any;
      startDate?: any | null;
      endDate?: any | null;
      state?: CampaignState | null;
      campaignType: CampaignCampaignType;
      templateData?: any | null;
      bannerImage?: string | null;
      goal?: any | null;
      achieved?: any | null;
      charity?: {
        __typename?: "CharityType";
        id?: string | null;
        title?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type PublicCampaignQueryVariables = Exact<{
  campaignId: Scalars["String"]["input"];
}>;

export type PublicCampaignQuery = {
  __typename?: "Query";
  publicCampaign?: {
    __typename?: "CampaignPublicType";
    id: string;
    goal?: any | null;
    message?: string | null;
    achieved?: any | null;
    title?: string | null;
    startDate?: any | null;
    endDate?: any | null;
    campaignImage?: string | null;
    bannerImage?: string | null;
    thirdImage?: string | null;
    publicId: any;
    startedByFirstName?: string | null;
    endOnFinalDay?: boolean | null;
    endIfGoalCompleted?: boolean | null;
    state?: CampaignState | null;
    campaignType: CampaignCampaignType;
    templateData?: any | null;
    charity?: {
      __typename: "CharityType";
      id?: string | null;
      title?: string | null;
      fundUrl?: string | null;
      mission?: string | null;
      mediumImg?: string | null;
      isBlacklisted?: boolean | null;
      ein?: string | null;
      address?: string | null;
      status?: string | null;
    } | null;
    startedBy?: {
      __typename?: "UserType";
      id: string;
      name?: string | null;
      firm?: {
        __typename?: "FirmType";
        id: string;
        firmName?: string | null;
        logoUrl?: string | null;
        primaryColor?: string | null;
        secondaryColor?: string | null;
      } | null;
    } | null;
  } | null;
};

export type FetchGuestPublicCampaignDetailsQueryVariables = Exact<{
  campaignId: Scalars["String"]["input"];
}>;

export type FetchGuestPublicCampaignDetailsQuery = {
  __typename?: "Query";
  publicCampaign?: {
    __typename?: "CampaignPublicType";
    id: string;
    goal?: any | null;
    message?: string | null;
    achieved?: any | null;
    title?: string | null;
    startDate?: any | null;
    endDate?: any | null;
    campaignImage?: string | null;
    bannerImage?: string | null;
    thirdImage?: string | null;
    publicId: any;
    startedByFirstName?: string | null;
    state?: CampaignState | null;
    campaignType: CampaignCampaignType;
    templateData?: any | null;
    charity?: {
      __typename: "CharityType";
      id?: string | null;
      title?: string | null;
      fundUrl?: string | null;
      mission?: string | null;
      mediumImg?: string | null;
      isBlacklisted?: boolean | null;
      ein?: string | null;
      address?: string | null;
      status?: string | null;
    } | null;
    startedBy?: {
      __typename?: "UserType";
      id: string;
      name?: string | null;
      firm?: {
        __typename?: "FirmType";
        id: string;
        firmName?: string | null;
        logoUrl?: string | null;
        primaryColor?: string | null;
        secondaryColor?: string | null;
      } | null;
    } | null;
  } | null;
};

export type ListCampaignDonationsQueryVariables = Exact<{
  campaignId: Scalars["Int"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type ListCampaignDonationsQuery = {
  __typename?: "Query";
  campaignDonations?: {
    __typename?: "CampaignDonationPaginatedType";
    page?: number | null;
    pages?: number | null;
    objects?: Array<{
      __typename?: "CampaignDonationType";
      contributor?: string | null;
      status?: CampaignDonationStatus | null;
      amount: any;
      createdAt: any;
      email?: string | null;
      note?: string | null;
    } | null> | null;
  } | null;
};

export type CampaignDashboardMetricsQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type CampaignDashboardMetricsQuery = {
  __typename?: "Query";
  campaignDashboardMetrics?: {
    __typename: "CampaignDashboardMetricsType";
    activeCampaigns?: number | null;
    pendingCampaigns?: number | null;
    completedCampaigns?: number | null;
    totalDonations?: any | null;
    totalDonors?: number | null;
  } | null;
};

export type GetPublicCampaignDonationsQueryVariables = Exact<{
  campaignId: Scalars["Int"]["input"];
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetPublicCampaignDonationsQuery = {
  __typename?: "Query";
  publicCampaignDonations?: {
    __typename?: "CampaignDonationPaginatedType";
    page?: number | null;
    pages?: number | null;
    objects?: Array<{
      __typename?: "CampaignDonationType";
      contributor?: string | null;
      status?: CampaignDonationStatus | null;
      amount: any;
      createdAt: any;
      email?: string | null;
      note?: string | null;
    } | null> | null;
  } | null;
};

export type CampaignDraftsQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type CampaignDraftsQuery = {
  __typename?: "Query";
  campaignDrafts?: Array<{
    __typename: "CampaignDraftType";
    id: string;
    campaignType: CampaignDraftCampaignType;
    formData?: any | null;
    bannerImage?: string | null;
    campaignImage?: string | null;
    updatedAt: any;
  } | null> | null;
};

export type CampaignStatsQueryVariables = Exact<{
  campaignId: Scalars["String"]["input"];
}>;

export type CampaignStatsQuery = {
  __typename?: "Query";
  campaignStats?: {
    __typename?: "CampaignStatsType";
    totalRaised: any;
    raisedThisWeek: any;
    contributors: number;
    newContributorsThisWeek: number;
    goal?: any | null;
    goalProgressPercent?: number | null;
    amountRemaining?: any | null;
  } | null;
};

export type CampaignTemplateSettingsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CampaignTemplateSettingsQuery = {
  __typename?: "Query";
  campaignTemplateSettings: {
    __typename?: "CampaignTemplateSettingsType";
    milestoneAutoCloseDays: Array<number>;
    milestoneEventTypes: Array<string>;
    consentWindowDays: number;
  };
};

export type CausesQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type CausesQuery = {
  __typename?: "Query";
  causes?: Array<{
    __typename?: "CauseType";
    id?: string | null;
    images?: Array<string | null> | null;
    key?: string | null;
    value?: string | null;
  } | null> | null;
};

export type GetRestrictedCharitiesQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type GetRestrictedCharitiesQuery = {
  __typename?: "Query";
  getRestrictedCharities?: Array<{
    __typename?: "RestrictedCategoryType";
    ein?: string | null;
    charities?: string | null;
  } | null> | null;
};

export type CharityMatchesQueryVariables = Exact<{
  searchString: Scalars["String"]["input"];
}>;

export type CharityMatchesQuery = {
  __typename?: "Query";
  charityMatches?: Array<{
    __typename?: "CharityType";
    id?: string | null;
    title?: string | null;
    ein?: string | null;
    status?: string | null;
  } | null> | null;
};

export type CreateLinkTokenQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
  itemId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type CreateLinkTokenQuery = {
  __typename?: "Query";
  createLinkToken?: {
    __typename?: "LinkTokenType";
    linkToken?: string | null;
    expiration?: string | null;
  } | null;
};

export type ConnectAchAccountsMutationVariables = Exact<{
  familyId: Scalars["Int"]["input"];
  publicToken: Scalars["String"]["input"];
  institutionId: Scalars["String"]["input"];
}>;

export type ConnectAchAccountsMutation = {
  __typename?: "Mutation";
  connectAchAccounts?: {
    __typename?: "ConnectAchAccounts";
    ok?: boolean | null;
    plaidItem?: {
      __typename?: "PlaidItemType";
      id: string;
      institutionId?: string | null;
      institutionName?: string | null;
      itemAccounts?: Array<{
        __typename?: "ItemAccountType";
        id: string;
        accountId?: string | null;
        accountName?: string | null;
        default: boolean;
        mask?: string | null;
        institutionName?: string | null;
        balance?: any | null;
        verificationStatus?: string | null;
      }> | null;
    } | null;
  } | null;
};

export type FetchPlaidItemsQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type FetchPlaidItemsQuery = {
  __typename?: "Query";
  plaidItems?: Array<{
    __typename?: "PlaidItemType";
    id: string;
    institutionId?: string | null;
    institutionName?: string | null;
    itemAccounts?: Array<{
      __typename?: "ItemAccountType";
      id: string;
      accountId?: string | null;
      accountName?: string | null;
      default: boolean;
      mask?: string | null;
      institutionName?: string | null;
      balance?: any | null;
      verificationStatus?: string | null;
    }> | null;
  } | null> | null;
};

export type DisconnectSavingsAccountMutationVariables = Exact<{
  plaidItemId: Scalars["Int"]["input"];
}>;

export type DisconnectSavingsAccountMutation = {
  __typename?: "Mutation";
  disconnectSavingsAccount?: {
    __typename?: "DisconnectSavingsAccount";
    ok?: boolean | null;
  } | null;
};

export type SetDefaultBankAccountMutationVariables = Exact<{
  itemAccountId: Scalars["String"]["input"];
}>;

export type SetDefaultBankAccountMutation = {
  __typename?: "Mutation";
  setDefaultBankAccount?: {
    __typename?: "SetDefaultBankAccount";
    ok?: boolean | null;
  } | null;
};

export type RemoveBankAccountMutationVariables = Exact<{
  itemAccountId: Scalars["String"]["input"];
}>;

export type RemoveBankAccountMutation = {
  __typename?: "Mutation";
  removeBankAccount?: {
    __typename?: "RemoveBankAccount";
    ok?: boolean | null;
  } | null;
};

export type GetConnectedBankAccountsQueryVariables = Exact<{
  plaidItemId: Scalars["Int"]["input"];
}>;

export type GetConnectedBankAccountsQuery = {
  __typename?: "Query";
  connectedBankAccounts?: Array<{
    __typename?: "ItemAccountType";
    id: string;
    accountId?: string | null;
    accountName?: string | null;
    default: boolean;
    mask?: string | null;
    institutionName?: string | null;
    balance?: any | null;
    verificationStatus?: string | null;
    plaidItem?: { __typename?: "PlaidItemType"; id: string } | null;
  } | null> | null;
};

export type CreateAmicusContributionMutationVariables = Exact<{
  familyId: Scalars["Int"]["input"];
  itemAccountId: Scalars["Int"]["input"];
  amount: Scalars["Decimal"]["input"];
  contributionDate: Scalars["DateTime"]["input"];
  contributionEndDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  frequency: ContributionFrequencyChoices;
}>;

export type CreateAmicusContributionMutation = {
  __typename?: "Mutation";
  createAmicusContribution?: {
    __typename?: "CreateAmicusContribution";
    ok?: boolean | null;
  } | null;
};

export type ValidateZipCodeQueryVariables = Exact<{
  zipCode: Scalars["String"]["input"];
}>;

export type ValidateZipCodeQuery = {
  __typename?: "Query";
  validateZipCode?: {
    __typename?: "ZipCodeInfoType";
    zipCode?: string | null;
    stateCode?: string | null;
    stateName?: string | null;
    city?: string | null;
  } | null;
};

export type ListCompanyGrantsQueryVariables = Exact<{
  pageSize: Scalars["Int"]["input"];
  page: Scalars["Int"]["input"];
  status?: InputMaybe<CompanyGrantStatusChoices>;
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
  year?: InputMaybe<Scalars["Int"]["input"]>;
  sorters?: InputMaybe<Sorter>;
  charityIds?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
}>;

export type ListCompanyGrantsQuery = {
  __typename?: "Query";
  listCompanyGrants?: {
    __typename?: "CompanyGrantPaginatedType";
    page?: number | null;
    pages?: number | null;
    count?: number | null;
    objects?: Array<{
      __typename?: "CompanyGrantType";
      id: string;
      charityId?: string | null;
      amount: number;
      grantor?: string | null;
      frequency: CompanyGrantFrequency;
      note?: string | null;
      startDate?: any | null;
      newStartDate?: any | null;
      endDate?: any | null;
      endorsedAt?: any | null;
      createdAt: any;
      status?: CompanyGrantStatus | null;
      anonymous: boolean;
      charity?: {
        __typename?: "CharityType";
        id?: string | null;
        name?: string | null;
        isBlacklisted?: boolean | null;
        address?: string | null;
        ein?: string | null;
      } | null;
      endorsedBy?: {
        __typename?: "UserType";
        id: string;
        name?: string | null;
      } | null;
      createdBy: { __typename?: "UserType"; id: string; name?: string | null };
      contributions: Array<{ __typename?: "GiftActivityType"; id: string }>;
      recurringGifts: Array<{ __typename?: "RecurringGiftType"; id: string }>;
    } | null> | null;
  } | null;
};

export type CorporateUserSummaryQueryVariables = Exact<{
  firmId: Scalars["Int"]["input"];
}>;

export type CorporateUserSummaryQuery = {
  __typename?: "Query";
  corporateUserSummary?: {
    __typename?: "CorporateUserSummaryType";
    companySummary?: {
      __typename?: "EmployeeSummaryType";
      unallocatedCount?: number | null;
      acceptedCount?: number | null;
      pendingCount?: number | null;
      inactiveCount?: number | null;
      ineligibleCount?: number | null;
      reservedCredits?: number | null;
      companyGiftsUnderApproval?: number | null;
    } | null;
    participantSummary?: {
      __typename?: "ParticipantSummaryType";
      pendingCount?: number | null;
      activeCount?: number | null;
      dafsOpenedCount?: number | null;
      dafsFundedCount?: number | null;
    } | null;
  } | null;
};

export type ListFirmTagCategoriesQueryVariables = Exact<{
  tagCategoryId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type ListFirmTagCategoriesQuery = {
  __typename?: "Query";
  listFirmTagCategories?: Array<{
    __typename: "TagCategoryType";
    id: string;
    category: string;
    tags?: Array<{
      __typename: "TagType";
      id: string;
      tag: string;
    } | null> | null;
  } | null> | null;
};

export type GetEmployeeDetailsQueryVariables = Exact<{
  employeeId: Scalars["Int"]["input"];
}>;

export type GetEmployeeDetailsQuery = {
  __typename?: "Query";
  getEmployeeDetails?: {
    __typename: "UserType";
    id: string;
    name?: string | null;
    email: string;
    yearlyFamilyUserGroupData?: {
      __typename: "YearlyFamilyUserGroupDataType";
      allocatedAmount: any;
      contributedAmount?: number | null;
    } | null;
  } | null;
};

export type ListEmployeesQueryVariables = Exact<{
  pageSize: Scalars["Int"]["input"];
  page: Scalars["Int"]["input"];
  status?: InputMaybe<EmployeeTypeEnum>;
  tagIds?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  searchString?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<SortOrderEnum>;
  sortingKey?: InputMaybe<EmployeeSortingKeysEnum>;
  categoryIds?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  userType?: InputMaybe<
    | Array<InputMaybe<CorporateDafUserTypeFilterType>>
    | InputMaybe<CorporateDafUserTypeFilterType>
  >;
  statusList?: InputMaybe<
    Array<InputMaybe<EmployeeTypeEnum>> | InputMaybe<EmployeeTypeEnum>
  >;
}>;

export type ListEmployeesQuery = {
  __typename?: "Query";
  listEmployees?: {
    __typename: "EmployeePaginatedType";
    page?: number | null;
    pages?: number | null;
    count?: number | null;
    objects?: Array<{
      __typename: "UserType";
      id: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      createdAt: any;
      email: string;
      roles?: any | null;
      address?: any | null;
      inviteStatus: UserInviteStatus;
      isActive: boolean;
      inviteSent?: any | null;
      corporateBenefit?: boolean | null;
      employeeStatus?: string | null;
      userTags: Array<{
        __typename: "UserTagType";
        id: string;
        tagCategory?: {
          __typename: "TagCategoryType";
          id: string;
          category: string;
          tags?: Array<{
            __typename: "TagType";
            id: string;
            tag: string;
          } | null> | null;
        } | null;
        tag?: { __typename: "TagType"; id: string; tag: string } | null;
      }>;
      yearlyUserData?: {
        __typename: "YearlyUserDataType";
        allocatedAmount: any;
        contributedAmount: any;
      } | null;
      yearlyFamilyUserGroupData?: {
        __typename: "YearlyFamilyUserGroupDataType";
        allocatedAmount: any;
        contributedAmount?: number | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ListParticipantsQueryVariables = Exact<{
  pageSize: Scalars["Int"]["input"];
  page: Scalars["Int"]["input"];
  searchString?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<SortOrderEnum>;
  sortingKey?: InputMaybe<EmployeeSortingKeysEnum>;
  statusList?: InputMaybe<
    | Array<InputMaybe<IndividualDafStatusFilterType>>
    | InputMaybe<IndividualDafStatusFilterType>
  >;
}>;

export type ListParticipantsQuery = {
  __typename?: "Query";
  listParticipants?: {
    __typename: "EmployeePaginatedType";
    page?: number | null;
    pages?: number | null;
    count?: number | null;
    objects?: Array<{
      __typename: "UserType";
      id: string;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      createdAt: any;
      email: string;
      roles?: any | null;
      address?: any | null;
      inviteStatus: UserInviteStatus;
      isActive: boolean;
      inviteSent?: any | null;
      corporateBenefit?: boolean | null;
      employeeStatus?: string | null;
      userTags: Array<{
        __typename: "UserTagType";
        id: string;
        tagCategory?: {
          __typename: "TagCategoryType";
          id: string;
          category: string;
          tags?: Array<{
            __typename: "TagType";
            id: string;
            tag: string;
          } | null> | null;
        } | null;
        tag?: { __typename: "TagType"; id: string; tag: string } | null;
      }>;
      yearlyUserData?: {
        __typename: "YearlyUserDataType";
        allocatedAmount: any;
        contributedAmount: any;
      } | null;
      yearlyFamilyUserGroupData?: {
        __typename: "YearlyFamilyUserGroupDataType";
        allocatedAmount: any;
        contributedAmount?: number | null;
      } | null;
      employeeDafDetails?: {
        __typename?: "EmployeeDafDetailsType";
        dafOpenedDate?: any | null;
        dafFundedDate?: any | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetCorporateDafFiltersQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetCorporateDafFiltersQuery = {
  __typename?: "Query";
  getCorporateDafFilters?: {
    __typename?: "CorporateDafFiltersType";
    companyDafFilters?: Array<{
      __typename?: "CorporateDafFilterType";
      type?: string | null;
      options?: Array<{
        __typename?: "CorporateDafFilterOptionType";
        id?: string | null;
        title?: string | null;
        isSubType?: boolean | null;
        subTypeTitle?: string | null;
        subTypeOptions?: Array<{
          __typename?: "CorporateDafFilterSubOptionType";
          id?: string | null;
          title?: string | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
    individualDafFilters?: Array<{
      __typename?: "CorporateDafFilterType";
      type?: string | null;
      options?: Array<{
        __typename?: "CorporateDafFilterOptionType";
        id?: string | null;
        title?: string | null;
        isSubType?: boolean | null;
        subTypeTitle?: string | null;
        subTypeOptions?: Array<{
          __typename?: "CorporateDafFilterSubOptionType";
          id?: string | null;
          title?: string | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type FeaturedCharitiesQueryVariables = Exact<{
  firmId: Scalars["Int"]["input"];
}>;

export type FeaturedCharitiesQuery = {
  __typename?: "Query";
  featuredCharities?: Array<{
    __typename?: "CharityType";
    id?: string | null;
    ein?: string | null;
    mission?: string | null;
    title?: string | null;
    mediumImg?: string | null;
  } | null> | null;
};

export type GetAssociatedFamiliesQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  searchStr?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetAssociatedFamiliesQuery = {
  __typename?: "Query";
  associatedFamilies?: {
    __typename?: "FamilyPaginatedType";
    page?: number | null;
    pages?: number | null;
    objects?: Array<{
      __typename?: "FamilyType";
      id: string;
      name: string;
      louiseDaf?: {
        __typename?: "LouiseDAFSummary";
        fundName?: string | null;
        custodian?: string | null;
        isSingleCharityFund?: boolean | null;
        pendingContributions?: any | null;
        accumulatedYearlyGrants?: any | null;
        pendingYearlyGrants?: any | null;
        accumulatedContributions?: any | null;
        accumulatedYearlyContributions?: any | null;
      } | null;
      advisorDaf?: {
        __typename?: "AdvisorDAFType";
        fundName: string;
        isSingleCharityFund: boolean;
      } | null;
    } | null> | null;
  } | null;
};

export type FirmQueryVariables = Exact<{
  firmId: Scalars["Int"]["input"];
}>;

export type FirmQuery = {
  __typename?: "Query";
  firm?: {
    __typename: "FirmType";
    id: string;
    firmName?: string | null;
    logoUrl?: string | null;
    metaData?: any | null;
    address?: any | null;
    phoneNumber?: any | null;
    website?: string | null;
    members: number;
    primaryColor?: string | null;
    secondaryColor?: string | null;
    isSetupDone: boolean;
    isEnterprise?: boolean | null;
    companyDafLaunchDate?: any | null;
    individualDafLaunchDate?: any | null;
    taxId?: string | null;
    parentFirm?: {
      __typename?: "FirmType";
      id: string;
      firmName?: string | null;
      metaData?: any | null;
      primaryColor?: string | null;
      secondaryColor?: string | null;
      logoUrl?: string | null;
    } | null;
    firmSummary?: {
      __typename?: "FirmSummaryType";
      totalUsers?: number | null;
      totalClients?: number | null;
      totalDafs?: number | null;
      totalAum?: number | null;
      ytdFees?: number | null;
      totalAdvisors?: number | null;
      totalFirms?: number | null;
    } | null;
  } | null;
};

export type ListRiaClientsQueryVariables = Exact<{
  firmId: Scalars["Int"]["input"];
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  page: Scalars["Int"]["input"];
  searchText?: InputMaybe<Scalars["String"]["input"]>;
  isDafExists?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type ListRiaClientsQuery = {
  __typename?: "Query";
  listRiaClients?: {
    __typename: "RiaClientDetailPaginatedType";
    page?: number | null;
    pages?: number | null;
    objects?: Array<{
      __typename: "RiaClientDetailType";
      dafId?: number | null;
      dafName?: string | null;
      clientName?: string | null;
      clientId?: number | null;
      userId?: number | null;
      advisorId?: number | null;
      advisorName?: string | null;
      aum?: number | null;
      ytdAdminFees?: number | null;
      subAdvisorFee?: number | null;
      employeeCount?: number | null;
      isDafCreated?: boolean | null;
      tncAcceptedTime?: any | null;
      companyAdmins?: Array<{
        __typename?: "CompanyMemberType";
        id?: number | null;
        name?: string | null;
        email?: string | null;
        phoneNumber?: any | null;
        lastLogin?: any | null;
        inviteStatus?: string | null;
      } | null> | null;
      familyMembers?: Array<{
        __typename?: "FamilyMemberBasicType";
        userId?: number | null;
        name?: string | null;
        email?: string | null;
        tncAcceptedTime?: any | null;
      } | null> | null;
      secondaryHohs?: Array<{
        __typename?: "FamilyMemberBasicType";
        userId?: number | null;
        name?: string | null;
        email?: string | null;
        tncAcceptedTime?: any | null;
      } | null> | null;
      advisorGroup?: {
        __typename?: "AdvisorGroupType";
        id?: number | null;
        name?: string | null;
        externalId?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ListFirmUsersQueryVariables = Exact<{
  firmId: Scalars["Int"]["input"];
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  page: Scalars["Int"]["input"];
  searchText?: InputMaybe<Scalars["String"]["input"]>;
  inviteStatus?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
}>;

export type ListFirmUsersQuery = {
  __typename?: "Query";
  listFirmUsers?: {
    __typename: "FirmUsersPaginationType";
    page?: number | null;
    pages?: number | null;
    objects?: Array<{
      __typename: "FirmUserDetailsType";
      elevateUserRef?: string | null;
      id?: number | null;
      name?: string | null;
      email?: string | null;
      dafsCount?: number | null;
      clientsManaged?: number | null;
      clientsSupported?: number | null;
      aum?: string | null;
      ytd?: string | null;
      tncAcceptedTime?: any | null;
      role?: string | null;
    } | null> | null;
  } | null;
};

export type SearchFirmAdvisorsQueryVariables = Exact<{
  firmId: Scalars["Int"]["input"];
  searchText?: InputMaybe<Scalars["String"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type SearchFirmAdvisorsQuery = {
  __typename?: "Query";
  searchFirmAdvisors?: {
    __typename: "UsersInGroupPaginationType";
    pages?: number | null;
    page?: number | null;
    objects?: Array<{
      __typename?: "UserInGroupType";
      userId?: number | null;
      userName?: string | null;
      userEmail?: string | null;
      userGroupId?: number | null;
      userGroupName?: string | null;
    } | null> | null;
  } | null;
};

export type GetPoolSetRecommendationsQueryVariables = Exact<{
  custodianIds: Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"];
}>;

export type GetPoolSetRecommendationsQuery = {
  __typename?: "Query";
  getPoolSetRecommendations?: Array<{
    __typename?: "PooledSetRecommendationDataType";
    custodianName?: string | null;
    pooledSets?: Array<{
      __typename?: "PooledSets";
      pooledSetName?: string | null;
      pooledSetId?: string | null;
      isSmaPooledSets?: boolean | null;
      pooledSetPools?: Array<{
        __typename?: "PoolSetPools";
        pooledAssetName?: string | null;
      } | null> | null;
    } | null> | null;
  } | null> | null;
};

export type GetFirmPoolsetsQueryVariables = Exact<{
  firmId: Scalars["String"]["input"];
}>;

export type GetFirmPoolsetsQuery = {
  __typename?: "Query";
  getFirmPoolsets?: Array<{
    __typename?: "FirmPoolSetsType";
    id?: string | null;
    custodianName?: string | null;
    isSmaPooledSets?: boolean | null;
    name?: string | null;
    pools?: Array<{
      __typename?: "PoolSetPools";
      pooledAssetName?: string | null;
    } | null> | null;
  } | null> | null;
};

export type GetCustomFeesQueryVariables = Exact<{
  firmId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetCustomFeesQuery = {
  __typename?: "Query";
  getCustomFees?: {
    __typename: "CustomFees";
    enableFee?: boolean | null;
    enableFeeTier?: boolean | null;
    feeTier?: any | null;
    feeCoefficient?: number | null;
    lockAdvisorFeeTier?: boolean | null;
    advisorFeeTier?: any | null;
    enableAdvisorFeeTier?: boolean | null;
  } | null;
};

export type ListIndividualClientsQueryVariables = Exact<{
  firmId: Scalars["Int"]["input"];
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  page: Scalars["Int"]["input"];
  searchText?: InputMaybe<Scalars["String"]["input"]>;
  isDafExists?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type ListIndividualClientsQuery = {
  __typename?: "Query";
  listIndividualClients?: {
    __typename: "IndividualClientPaginatedType";
    page?: number | null;
    pages?: number | null;
    objects?: Array<{
      __typename: "IndividualClientDetailType";
      dafName?: string | null;
      email?: string | null;
      isDafCreated?: boolean | null;
      clientName?: string | null;
      userId?: number | null;
      clientId?: number | null;
      aum?: number | null;
      ytdAdminFees?: number | null;
      subAdvisorFee?: number | null;
    } | null> | null;
  } | null;
};

export type ListFirmAdminsQueryVariables = Exact<{
  firmId: Scalars["Int"]["input"];
}>;

export type ListFirmAdminsQuery = {
  __typename?: "Query";
  listFirmAdmins?: Array<{
    __typename: "UserType";
    id: string;
    email: string;
    name?: string | null;
    isStaff: boolean;
    roles?: any | null;
    dob?: any | null;
    address?: any | null;
    phoneNumber?: any | null;
    relationship?: string | null;
    profilepicUrl?: string | null;
    emailPrefDafContribution?: boolean | null;
    emailPrefGifts?: boolean | null;
    tncAcceptedTime?: any | null;
    lastLogin?: any | null;
    yearlyUserData?: {
      __typename: "YearlyUserDataType";
      allocatedAmount: any;
      contributedAmount: any;
      year: number;
    } | null;
    family?: {
      __typename: "FamilyType";
      id: string;
      alignStatus?: boolean | null;
      mission?: string | null;
      name: string;
      engageFamily: boolean;
      isFunded?: boolean | null;
      advisor?: {
        __typename: "UserType";
        name?: string | null;
        email: string;
      } | null;
      louiseDaf?: {
        __typename: "LouiseDAFSummary";
        fundName?: string | null;
      } | null;
      hof?: {
        __typename: "UserType";
        name?: string | null;
        email: string;
        inviteStatus: UserInviteStatus;
      } | null;
    } | null;
    firm?: {
      __typename: "FirmType";
      id: string;
      firmName?: string | null;
      logo?: string | null;
      logoUrl?: string | null;
      address?: any | null;
      phoneNumber?: any | null;
      website?: string | null;
    } | null;
  } | null> | null;
};

export type FirmDocumentsQueryVariables = Exact<{
  firmId: Scalars["Int"]["input"];
}>;

export type FirmDocumentsQuery = {
  __typename?: "Query";
  firmDocuments?: Array<{
    __typename?: "FirmDocumentType";
    id: string;
    documentType?: string | null;
    documentUrl?: string | null;
    source?: string | null;
    originalFilename?: string | null;
    uploadedAt: any;
    updatedAt: any;
  } | null> | null;
};

export type ContributorsQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type ContributorsQuery = {
  __typename?: "Query";
  contributors?: Array<{
    __typename?: "ContributorType";
    name?: string | null;
    isHoh?: boolean | null;
    isSelfDirected?: boolean | null;
    isCorporateAdmin?: boolean | null;
  } | null> | null;
};

export type SearchTickersQueryVariables = Exact<{
  searchString: Scalars["String"]["input"];
}>;

export type SearchTickersQuery = {
  __typename?: "Query";
  searchTickers?: Array<{
    __typename: "TickerType";
    name: string;
    ticker: string;
    tickerType?: string | null;
  } | null> | null;
};

export type ValidateUploadedTickersQueryVariables = Exact<{
  tickerList: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type ValidateUploadedTickersQuery = {
  __typename?: "Query";
  validateTickerList?: Array<{
    __typename?: "ValidatedTicker";
    ticker?: string | null;
    tickerName?: string | null;
    isValid?: boolean | null;
    validationError?: string | null;
  } | null> | null;
};

export type ListMinimumGrantsContributionsQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type ListMinimumGrantsContributionsQuery = {
  __typename?: "Query";
  listMinimumGrantsContributions?: any | null;
};

export type DafPoolsQueryVariables = Exact<{
  dafRef: Scalars["String"]["input"];
}>;

export type DafPoolsQuery = {
  __typename?: "Query";
  dafPools?: Array<{
    __typename: "PortfolioType";
    id?: number | null;
    title?: string | null;
    approved: boolean;
    assetId?: string | null;
    riskScore: number;
    volatility: any;
    returns: any;
    assets?: Array<{
      __typename: "AssetType";
      id: string;
      ticker?: string | null;
      tickerName?: string | null;
      category?: string | null;
      Type?: string | null;
      Class?: string | null;
      weight?: number | null;
    } | null> | null;
  } | null> | null;
};

export type AlignQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type AlignQuery = {
  __typename?: "Query";
  align?: {
    __typename?: "AlignModuleType";
    targetPortfolio?: Array<any | null> | null;
    lastSubmitted?: any | null;
    currentPortfolio?: Array<{
      __typename?: "CurrentPortfolioType";
      poolId?: string | null;
      poolName?: string | null;
      poolType?: string | null;
      poolValue?: number | null;
      poolWeight?: number | null;
    } | null> | null;
    selectedCores?: Array<{
      __typename?: "AssetPoolType";
      assetId: string;
      assetName: string;
      poolType?: AssetPoolPoolType | null;
    } | null> | null;
    cashModel?: {
      __typename?: "AssetPoolType";
      assetId: string;
      assetName: string;
      poolType?: AssetPoolPoolType | null;
    } | null;
  } | null;
};

export type SubmitTargetRatioMutationVariables = Exact<{
  familyId: Scalars["Int"]["input"];
  allocations: Array<InputMaybe<AllocationType>> | InputMaybe<AllocationType>;
  returns?: InputMaybe<Scalars["Float"]["input"]>;
  riskScore?: InputMaybe<Scalars["Int"]["input"]>;
  volatility?: InputMaybe<Scalars["Float"]["input"]>;
}>;

export type SubmitTargetRatioMutation = {
  __typename?: "Mutation";
  submitTargetRatio?: {
    __typename?: "SubmitTargetRatio";
    ok?: boolean | null;
  } | null;
};

export type UpdateAdvisorFeesMutationVariables = Exact<{
  bps: Scalars["Int"]["input"];
  familyId: Scalars["Int"]["input"];
}>;

export type UpdateAdvisorFeesMutation = {
  __typename?: "Mutation";
  updateAdvisorFees?: {
    __typename?: "UpdateAdvisorFees";
    ok?: boolean | null;
  } | null;
};

export type CreateCashMovementMutationVariables = Exact<{
  fundId: Scalars["ID"]["input"];
  requestValue: Scalars["Float"]["input"];
  fromPool: Scalars["ID"]["input"];
  toPool: Scalars["ID"]["input"];
}>;

export type CreateCashMovementMutation = {
  __typename?: "Mutation";
  createCashMovement?: {
    __typename?: "CreateCashMovement";
    id?: string | null;
    ok?: boolean | null;
    fundId?: string | null;
    requestValue?: number | null;
    fromPool?: any | null;
    toPool?: any | null;
    advisorId?: string | null;
    dateRequested?: string | null;
  } | null;
};

export type GetFundReallocationRebalanceRequestsQueryVariables = Exact<{
  fundId: Scalars["ID"]["input"];
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetFundReallocationRebalanceRequestsQuery = {
  __typename?: "Query";
  getFundReallocationRebalanceRequests?: {
    __typename?: "FundReallocationsRebalancePaginatedType";
    page?: number | null;
    pages?: number | null;
    objects?: Array<{
      __typename?: "FundReallocationsRebalanceType";
      id?: string | null;
      daf?: string | null;
      dateRequested?: string | null;
      name?: string | null;
      status?: string | null;
      targets?: Array<{
        __typename?: "TargetType";
        assetId?: string | null;
        targetRatio?: string | null;
        targetValue?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type LegacyDocumentsQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type LegacyDocumentsQuery = {
  __typename?: "Query";
  legacyDocuments?: Array<{
    __typename?: "InheritanceDocumentType";
    id: string;
    documentType?: string | null;
    visibility?: string | null;
    status?: string | null;
    originalFilename: string;
    uploadedAt: any;
    updatedAt: any;
    documentUrl?: string | null;
  } | null> | null;
};

export type LivingLegacyPlansQueryVariables = Exact<{ [key: string]: never }>;

export type LivingLegacyPlansQuery = {
  __typename?: "Query";
  livingLegacyPlans?: Array<{
    __typename?: "LivingLegacyPlanType";
    id?: string | null;
    familyId?: number | null;
    name?: string | null;
    founderName?: string | null;
    successorCount?: number | null;
    documentCount?: number | null;
    totalValue?: number | null;
    progress?: number | null;
    status?: string | null;
    myFamilyCompleted?: boolean | null;
    legacyPlanDefined?: boolean | null;
    impactVelocityDefined?: boolean | null;
    transitionState?: string | null;
    lastActivity?: string | null;
  } | null> | null;
};

export type LivingLegacyPlanQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type LivingLegacyPlanQuery = {
  __typename?: "Query";
  livingLegacyPlan?: {
    __typename?: "LivingLegacyPlanType";
    id?: string | null;
    familyId?: number | null;
    name?: string | null;
    founderName?: string | null;
    successorCount?: number | null;
    documentCount?: number | null;
    totalValue?: number | null;
    progress?: number | null;
    status?: string | null;
    myFamilyCompleted?: boolean | null;
    legacyPlanDefined?: boolean | null;
    impactVelocityDefined?: boolean | null;
    transitionState?: string | null;
    lastActivity?: string | null;
  } | null;
};

export type LivingLegacyKpisQueryVariables = Exact<{ [key: string]: never }>;

export type LivingLegacyKpisQuery = {
  __typename?: "Query";
  livingLegacyKpis?: {
    __typename?: "LivingLegacyKpisType";
    successors?: number | null;
    allDafs?: number | null;
    legacyPlanDefined?: number | null;
    inTransition?: number | null;
    transitionCompleted?: number | null;
  } | null;
};

export type SuccessionPolicyQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type SuccessionPolicyQuery = {
  __typename?: "Query";
  successionPolicy?: {
    __typename?: "SuccessionPolicyType";
    id?: string | null;
    policyMode?: string | null;
    annualPayoutTarget?: number | null;
    sunsetTimeframeYears?: number | null;
    currentBalance?: number | null;
    accountAgeYears?: number | null;
    isConfigured?: boolean | null;
  } | null;
};

export type LegacyBlueprintQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type LegacyBlueprintQuery = {
  __typename?: "Query";
  legacyBlueprint?: {
    __typename?: "LegacyBlueprintType";
    id: string;
    motivation: string;
    motivationTags?: any | null;
    personalConnection: string;
    coreValues?: any | null;
    geographicFocus?: string | null;
    focusAreas?: Array<{
      __typename?: "FocusAreaType";
      id: string;
      label: string;
      weight?: number | null;
    } | null> | null;
    impactGoals?: Array<{
      __typename?: "ImpactGoalType";
      id: string;
      label: string;
      causeArea?: string | null;
      metricType?: string | null;
      targetValue?: number | null;
      period?: string | null;
      currentValue?: number | null;
      status?: string | null;
      order: number;
    } | null> | null;
  } | null;
};

export type FamilyCharityCausesQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type FamilyCharityCausesQuery = {
  __typename?: "Query";
  familyCharityCauses?: Array<string | null> | null;
};

export type FamilyGivingGoalQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type FamilyGivingGoalQuery = {
  __typename?: "Query";
  family?: {
    __typename?: "FamilyType";
    id: string;
    annualGivingGoal?: any | null;
    annualGivingGoalAchieved?: any | null;
  } | null;
};

export type SunsetCharityAllocationsQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type SunsetCharityAllocationsQuery = {
  __typename?: "Query";
  sunsetCharityAllocations?: Array<{
    __typename?: "SunsetCharityAllocationType";
    id?: number | null;
    charityId?: string | null;
    charityName?: string | null;
    percentage?: number | null;
    source?: string | null;
  } | null> | null;
};

export type FamilyFoundersMessageQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type FamilyFoundersMessageQuery = {
  __typename?: "Query";
  family?: {
    __typename?: "FamilyType";
    id: string;
    foundersMessage?: string | null;
  } | null;
};

export type FamilyMissionQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type FamilyMissionQuery = {
  __typename?: "Query";
  family?: {
    __typename?: "FamilyType";
    id: string;
    mission?: string | null;
  } | null;
};

export type TransitionActiveCampaignsQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
  pageSize: Scalars["Int"]["input"];
  page: Scalars["Int"]["input"];
  filters?: InputMaybe<CampaignFilterInputType>;
}>;

export type TransitionActiveCampaignsQuery = {
  __typename?: "Query";
  campaigns?: {
    __typename?: "CampaignPaginatedType";
    count?: number | null;
    objects?: Array<{
      __typename?: "CampaignType";
      id: string;
      title?: string | null;
      state?: CampaignState | null;
      unreconciledExternalCount?: number | null;
    } | null> | null;
  } | null;
};

export type TransitionActiveItemsQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type TransitionActiveItemsQuery = {
  __typename?: "Query";
  transitionActiveItems?: {
    __typename?: "TransitionActiveItemsPaginatedType";
    count?: number | null;
    grantsCount?: number | null;
    contributionsCount?: number | null;
    grantsProcessingCount?: number | null;
    contributionsProcessingCount?: number | null;
    hasGrants?: boolean | null;
    hasContributions?: boolean | null;
    hasCampaigns?: boolean | null;
    objects?: Array<{
      __typename?: "TransitionActiveItemType";
      id?: number | null;
      sourceType?: string | null;
      charityName?: string | null;
      amount?: number | null;
      frequency?: string | null;
      status?: string | null;
    } | null> | null;
  } | null;
};

export type SuccessionTransitionQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type SuccessionTransitionQuery = {
  __typename?: "Query";
  successionTransition?: {
    __typename?: "SuccessionTransitionType";
    id: string;
    triggerType: SuccessionTransitionTriggerType;
    voluntaryMode?: SuccessionTransitionVoluntaryMode | null;
    status: SuccessionTransitionStatus;
    currentStep: number;
    initiatedAt: any;
    completedAt?: any | null;
    scheduledDate?: any | null;
    cancelledInviteCount: number;
    step1CompletedAt?: any | null;
    step2CompletedAt?: any | null;
    step3CompletedAt?: any | null;
    step4CompletedAt?: any | null;
    step5CompletedAt?: any | null;
    step4NotifiedAt?: any | null;
    hasOpenContributions?: boolean | null;
    frozenBalance?: any | null;
    dafFreezeInitiatedAt?: string | null;
    dafFreezeConfirmedAt?: string | null;
    freezeConfirmationSentAt?: any | null;
    family: {
      __typename?: "FamilyType";
      hof?: {
        __typename?: "UserType";
        firstName?: string | null;
        lastName?: string | null;
      } | null;
    };
  } | null;
};

export type TransitionHistoryQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type TransitionHistoryQuery = {
  __typename?: "Query";
  transitionHistory?: Array<{
    __typename?: "SuccessionTransitionType";
    id: string;
    triggerType: SuccessionTransitionTriggerType;
    voluntaryMode?: SuccessionTransitionVoluntaryMode | null;
    status: SuccessionTransitionStatus;
    scheduledDate?: any | null;
    initiatedAt: any;
    completedAt?: any | null;
    cancelledInviteCount: number;
    step1CompletedAt?: any | null;
    step2CompletedAt?: any | null;
    step3CompletedAt?: any | null;
    step4CompletedAt?: any | null;
    step5CompletedAt?: any | null;
    frozenBalance?: any | null;
    dafFreezeInitiatedAt?: string | null;
    dafFreezeConfirmedAt?: string | null;
    freezeConfirmationSentAt?: any | null;
    family: {
      __typename?: "FamilyType";
      hof?: {
        __typename?: "UserType";
        firstName?: string | null;
        lastName?: string | null;
      } | null;
    };
  } | null> | null;
};

export type PendingDeathTransitionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PendingDeathTransitionsQuery = {
  __typename?: "Query";
  pendingDeathTransitions?: Array<{
    __typename?: "SuccessionTransitionType";
    id: string;
    triggerType: SuccessionTransitionTriggerType;
    status: SuccessionTransitionStatus;
    initiatedAt: any;
    deathCertUrl?: string | null;
    family: {
      __typename?: "FamilyType";
      id: string;
      name: string;
      louiseDaf?: {
        __typename?: "LouiseDAFSummary";
        fundName?: string | null;
      } | null;
    };
    initiatedBy?: {
      __typename?: "UserType";
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      email: string;
    } | null;
  } | null> | null;
};

export type ApproveDeathTransitionMutationVariables = Exact<{
  familyId: Scalars["Int"]["input"];
  reviewNotes?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ApproveDeathTransitionMutation = {
  __typename?: "Mutation";
  approveDeathTransition?: {
    __typename?: "ApproveDeathTransition";
    ok?: boolean | null;
  } | null;
};

export type RejectDeathTransitionMutationVariables = Exact<{
  familyId: Scalars["Int"]["input"];
  reason: Scalars["String"]["input"];
}>;

export type RejectDeathTransitionMutation = {
  __typename?: "Mutation";
  rejectDeathTransition?: {
    __typename?: "RejectDeathTransition";
    ok?: boolean | null;
  } | null;
};

export type UpdateScheduledTransitionDateMutationVariables = Exact<{
  familyId: Scalars["Int"]["input"];
  scheduledDate: Scalars["String"]["input"];
}>;

export type UpdateScheduledTransitionDateMutation = {
  __typename?: "Mutation";
  updateScheduledTransitionDate?: {
    __typename?: "UpdateScheduledTransitionDate";
    ok?: boolean | null;
  } | null;
};

export type TriggerSuccessionTransferNotificationMutationVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type TriggerSuccessionTransferNotificationMutation = {
  __typename?: "Mutation";
  triggerSuccessionTransferNotification?: {
    __typename?: "TriggerSuccessionTransferNotification";
    ok?: boolean | null;
    transferCount?: number | null;
    message?: string | null;
    notifiedAt?: string | null;
    previouslyNotifiedAt?: string | null;
  } | null;
};

export type SendSuccessionInvitesMutationVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type SendSuccessionInvitesMutation = {
  __typename?: "Mutation";
  sendSuccessionInvites?: {
    __typename?: "SendSuccessionInvites";
    ok?: boolean | null;
    invitesSent?: number | null;
    message?: string | null;
  } | null;
};

export type NudgeSuccessorInviteMutationVariables = Exact<{
  successorId: Scalars["Int"]["input"];
}>;

export type NudgeSuccessorInviteMutation = {
  __typename?: "Mutation";
  nudgeSuccessorInvite?: {
    __typename?: "NudgeSuccessorInvite";
    ok?: boolean | null;
    message?: string | null;
    lastNudgedAt?: string | null;
  } | null;
};

export type FinalizeSuccessionTransitionMutationVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type FinalizeSuccessionTransitionMutation = {
  __typename?: "Mutation";
  finalizeSuccessionTransition?: {
    __typename?: "FinalizeSuccessionTransition";
    ok?: boolean | null;
    grantsCreated?: number | null;
    message?: string | null;
  } | null;
};

export type SuccessionReconciliationsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SuccessionReconciliationsQuery = {
  __typename?: "Query";
  successionReconciliations?: Array<{
    __typename?: "SuccessionReconciliationType";
    successorId?: number | null;
    successorName?: string | null;
    familyId?: number | null;
    familyName?: string | null;
    destinationFundName?: string | null;
    percentage?: number | null;
    frozenBalance?: number | null;
    expectedAmount?: number | null;
    receivedAmount?: number | null;
    variance?: number | null;
    contributionCount?: number | null;
    isReconciled?: boolean | null;
    reason?: string | null;
    needsReview?: boolean | null;
    varianceConfirmedAt?: string | null;
    varianceConfirmedBy?: string | null;
    freezeInitiatedAt?: string | null;
  } | null> | null;
};

export type OpsActivityQueryVariables = Exact<{
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type OpsActivityQuery = {
  __typename?: "Query";
  opsActivity?: Array<{
    __typename?: "OpsActivityType";
    id?: number | null;
    action?: string | null;
    actionLabel?: string | null;
    actorName?: string | null;
    familyId?: number | null;
    familyName?: string | null;
    fundName?: string | null;
    transitionId?: number | null;
    step?: number | null;
    succeeded?: boolean | null;
    summary?: string | null;
    createdAt?: string | null;
  } | null> | null;
};

export type OpsTransitionQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type OpsTransitionQuery = {
  __typename?: "Query";
  opsTransition?: {
    __typename?: "OpsTransitionRowType";
    transitionId?: number | null;
    familyId?: number | null;
    familyName?: string | null;
    fundName?: string | null;
    advisorName?: string | null;
    firmName?: string | null;
    initiatedByName?: string | null;
    hofName?: string | null;
    triggerType?: string | null;
    voluntaryMode?: string | null;
    status?: string | null;
    currentStep?: number | null;
    frozenBalance?: number | null;
    initiatedAt?: string | null;
    scheduledDate?: string | null;
    completedAt?: string | null;
    step1CompletedAt?: string | null;
    step2CompletedAt?: string | null;
    step3CompletedAt?: string | null;
    step4CompletedAt?: string | null;
    step5CompletedAt?: string | null;
    stepCompletedAt?: string | null;
    daysOnStep?: number | null;
    successorCount?: number | null;
    beneficiaryCount?: number | null;
    awaitingAction?: boolean | null;
    blockedReason?: string | null;
    blockedCheckedAt?: string | null;
  } | null;
};

export type AdvanceSuccessionStepMutationVariables = Exact<{
  familyId: Scalars["Int"]["input"];
  expectedStep?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type AdvanceSuccessionStepMutation = {
  __typename?: "Mutation";
  advanceSuccessionStep?: {
    __typename?: "AdvanceSuccessionStep";
    ok?: boolean | null;
    advanced?: boolean | null;
    step?: number | null;
    currentStep?: number | null;
    status?: string | null;
    reason?: string | null;
    message?: string | null;
  } | null;
};

export type OpsTransitionsQueryVariables = Exact<{
  includeCompleted?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type OpsTransitionsQuery = {
  __typename?: "Query";
  opsTransitions?: Array<{
    __typename?: "OpsTransitionRowType";
    transitionId?: number | null;
    familyId?: number | null;
    familyName?: string | null;
    fundName?: string | null;
    advisorName?: string | null;
    firmName?: string | null;
    triggerType?: string | null;
    voluntaryMode?: string | null;
    status?: string | null;
    currentStep?: number | null;
    frozenBalance?: number | null;
    initiatedAt?: string | null;
    scheduledDate?: string | null;
    stepCompletedAt?: string | null;
    daysOnStep?: number | null;
    successorCount?: number | null;
    beneficiaryCount?: number | null;
    awaitingAction?: boolean | null;
    blockedReason?: string | null;
    blockedCheckedAt?: string | null;
  } | null> | null;
};

export type SuccessionTransfersQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type SuccessionTransfersQuery = {
  __typename?: "Query";
  successionTransfers?: Array<{
    __typename?: "SuccessionTransferType";
    successorId?: number | null;
    successorName?: string | null;
    destinationFundName?: string | null;
    percentage?: number | null;
    expectedAmount?: number | null;
    receivedAmount?: number | null;
    initiatedAt?: string | null;
    completedAt?: string | null;
    isReconciled?: boolean | null;
    reason?: string | null;
  } | null> | null;
};

export type ConfirmTransferVarianceMutationVariables = Exact<{
  successorId: Scalars["Int"]["input"];
  notes?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ConfirmTransferVarianceMutation = {
  __typename?: "Mutation";
  confirmTransferVariance?: {
    __typename?: "ConfirmTransferVariance";
    ok?: boolean | null;
    message?: string | null;
  } | null;
};

export type CloseEmptyTransitionMutationVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type CloseEmptyTransitionMutation = {
  __typename?: "Mutation";
  closeEmptyTransition?: {
    __typename?: "CloseEmptyTransition";
    ok?: boolean | null;
    message?: string | null;
  } | null;
};

export type LivingLegacyTransitionAlertsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type LivingLegacyTransitionAlertsQuery = {
  __typename?: "Query";
  livingLegacyTransitionAlerts?: Array<{
    __typename?: "TransitionAlertType";
    familyId?: number | null;
    familyName?: string | null;
    fundName?: string | null;
    alertType?: string | null;
    severity?: string | null;
    title?: string | null;
    detail?: string | null;
    currentStep?: number | null;
    scheduledDate?: string | null;
    daysUntil?: number | null;
    initiatedAt?: string | null;
  } | null> | null;
};

export type FamilyFreezeFlagsQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type FamilyFreezeFlagsQuery = {
  __typename?: "Query";
  family?: {
    __typename?: "FamilyType";
    id: string;
    isDafFrozen?: boolean | null;
    isSuccessorFund?: boolean | null;
    successionSourceDonorName?: string | null;
  } | null;
};

export type GetOverviewStatsQueryVariables = Exact<{
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  programFilter?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetOverviewStatsQuery = {
  __typename?: "Query";
  getOverviewStats?: {
    __typename?: "OverviewStatsType";
    corporateClients?: number | null;
    aum?: number | null;
    dafsOpened?: number | null;
    dafsFunded?: number | null;
    totalContributions?: number | null;
    totalGrants?: number | null;
    firmName?: string | null;
    launchDate?: string | null;
  } | null;
};

export type GetProgramAumStatsQueryVariables = Exact<{
  frequency: Scalars["String"]["input"];
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  programFilter?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetProgramAumStatsQuery = {
  __typename?: "Query";
  getProgramAUMStats?: {
    __typename?: "OverviewProgramAUMStatsType";
    aumStats?: Array<{
      __typename?: "ProgramAUMStatsDataType";
      period?: string | null;
      year?: number | null;
      openingAumFundAsset?: number | null;
      closingAumFundAsset?: number | null;
      contributions?: number | null;
      grants?: number | null;
    } | null> | null;
  } | null;
};

export type GetDistributionStatsQueryVariables = Exact<{
  frequency: Scalars["String"]["input"];
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  programFilter?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetDistributionStatsQuery = {
  __typename?: "Query";
  getDistributionStats?: {
    __typename?: "OverviewDistributionStatsWrapperType";
    distributionStats?: Array<{
      __typename?: "OverviewDistributionStatsType";
      period?: string | null;
      year?: number | null;
      distribution?: Array<{
        __typename?: "DistributionStatsDataType";
        segmentName?: string | null;
        segmentKey?: string | null;
        count?: number | null;
        startDate?: string | null;
        endDate?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type GetDistributionListQueryVariables = Exact<{
  period: Scalars["String"]["input"];
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  year?: InputMaybe<Scalars["Int"]["input"]>;
  segmentKey?: InputMaybe<Scalars["String"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
  programFilter?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetDistributionListQuery = {
  __typename?: "Query";
  getDistributionList?: {
    __typename?: "OverviewDistributionListWrapperType";
    totalCount?: number | null;
    isLastPage?: boolean | null;
    distributionList?: Array<{
      __typename?: "OverviewDistributionListType";
      fundExternalId?: string | null;
      fundName?: string | null;
      balance?: number | null;
      participant?: string | null;
    } | null> | null;
  } | null;
};

export type GetCorporateClientsListQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
  programFilter?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetCorporateClientsListQuery = {
  __typename?: "Query";
  getCorporateClientsList?: {
    __typename?: "OverviewCorporateClientsListWrapperType";
    totalCount?: number | null;
    isLastPage?: boolean | null;
    page?: number | null;
    pageSize?: number | null;
    corporateClientsList?: Array<{
      __typename?: "OverviewCorporateClientsListType";
      firmId?: string | null;
      firmGiveReferenceId?: string | null;
      firmName?: string | null;
      dafsOpened?: number | null;
      dafsFunded?: number | null;
      aum?: number | null;
      lois?: number | null;
      contributions?: number | null;
      grants?: number | null;
    } | null> | null;
  } | null;
};

export type GetCorporateDafsListQueryVariables = Exact<{
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type GetCorporateDafsListQuery = {
  __typename?: "Query";
  getCorporateDafsList?: {
    __typename?: "OverviewCorporateDafsListWrapperType";
    totalCount?: number | null;
    isLastPage?: boolean | null;
    corporateAdminsList?: Array<{
      __typename?: "OverviewCorporateDafsListType";
      dafName?: string | null;
      openDate?: string | null;
      initialFundedDate?: string | null;
      latestFundedDate?: string | null;
      aum?: number | null;
      dafId?: number | null;
      users?: Array<{
        __typename?: "OverviewCorporateDafsUsersType";
        email?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        roles?: Array<string | null> | null;
      } | null> | null;
    } | null> | null;
    corporateParticipantsList?: Array<{
      __typename?: "OverviewCorporateDafsListType";
      dafName?: string | null;
      openDate?: string | null;
      initialFundedDate?: string | null;
      latestFundedDate?: string | null;
      aum?: number | null;
      dafId?: number | null;
      users?: Array<{
        __typename?: "OverviewCorporateDafsUsersType";
        email?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        roles?: Array<string | null> | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type GetDafStatsQueryVariables = Exact<{
  dafId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetDafStatsQuery = {
  __typename?: "Query";
  getDafStats?: {
    __typename?: "OverviewDafStatsType";
    aum?: number | null;
    dafName?: string | null;
    dafId?: number | null;
    ytdContributions?: number | null;
    ytdGrants?: number | null;
    inFlightContributions?: number | null;
    inFlightGrants?: number | null;
  } | null;
};

export type GetDafContributionsQueryVariables = Exact<{
  dafId?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
  filterBy?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetDafContributionsQuery = {
  __typename?: "Query";
  getDafContributions?: {
    __typename?: "OverviewDafContributionsStatsWrapperType";
    totalCount?: number | null;
    page?: number | null;
    pageSize?: number | null;
    isPaginated?: boolean | null;
    isLastPage?: boolean | null;
    results?: Array<{
      __typename?: "OverviewDafContributionsStatsType";
      objectId?: any | null;
      status?: string | null;
      amount?: number | null;
      contributor?: string | null;
      method?: string | null;
      initiatedDate?: string | null;
      contributionType?: string | null;
      firmName?: string | null;
      shares?: string | null;
      ticker?: string | null;
      timeline?: Array<{
        __typename?: "ContributionTimelineType";
        state?: string | null;
        value?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type GetDafGrantsQueryVariables = Exact<{
  dafId?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
  filterBy?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetDafGrantsQuery = {
  __typename?: "Query";
  getDafGrants?: {
    __typename?: "OverviewDafGrantsStatsWrapperType";
    totalCount?: number | null;
    page?: number | null;
    pageSize?: number | null;
    isPaginated?: boolean | null;
    isLastPage?: boolean | null;
    results?: Array<{
      __typename?: "OverviewDafGrantsStatsType";
      objectId?: any | null;
      status?: string | null;
      amount?: number | null;
      recommendedBy?: string | null;
      charityName?: string | null;
      grantNote?: string | null;
      method?: string | null;
      initiatedDate?: string | null;
      isAnonymous?: boolean | null;
      ein?: string | null;
      firmName?: string | null;
      timeline?: Array<{
        __typename?: "ContributionTimelineType";
        state?: string | null;
        value?: string | null;
      } | null> | null;
      charityAddress?: {
        __typename?: "CharityAddressType";
        streetAddress?: string | null;
        cityStateZip?: string | null;
        country?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetOperationsListFirmsQueryVariables = Exact<{
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type GetOperationsListFirmsQuery = {
  __typename?: "Query";
  getOperationsListFirms?: {
    __typename?: "OperationsListFirmsResponseType";
    totalCount?: number | null;
    isLastPage?: boolean | null;
    results?: Array<{
      __typename?: "OperationsListFirmsType";
      giveReferenceId?: number | null;
      name?: string | null;
      companyLaunchDate?: string | null;
      individualLaunchDate?: string | null;
      creationTime?: string | null;
      earliestDafCreation?: string | null;
    } | null> | null;
  } | null;
};

export type GetOperationsListEnterprisesQueryVariables = Exact<{
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  searchText?: InputMaybe<Scalars["String"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type GetOperationsListEnterprisesQuery = {
  __typename?: "Query";
  getOperationsListEnterprises?: {
    __typename?: "OperationsListEnterprisesResponseType";
    totalCount?: number | null;
    isLastPage?: boolean | null;
    results?: Array<{
      __typename?: "OperationsListEnterprisesType";
      giveReferenceId?: number | null;
      name?: string | null;
      creationTime?: string | null;
      earliestDafCreation?: string | null;
    } | null> | null;
  } | null;
};

export type GetOperationsContributionsKpIsQueryVariables = Exact<{
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  filterBy?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetOperationsContributionsKpIsQuery = {
  __typename?: "Query";
  getOperationsContributionsKPIs?: {
    __typename?: "OperationsContributionsKPIsType";
    achStats?: {
      __typename?: "OperationsAchStatsType";
      averageCycleTimeDays?: number | null;
      loisToFundsAvailable?: number | null;
    } | null;
    thirdPartyStats?: {
      __typename?: "OperationsThirdPartyStatsType";
      averageCycleTimeDays?: number | null;
      loisToFundsAvailable?: number | null;
    } | null;
    securityStats?: {
      __typename?: "OperationsSecurityStatsType";
      averageCycleTimeDays?: number | null;
      loisToSecurityReceivedDays?: number | null;
      fundsAvailableDays?: number | null;
      liquidationDays?: number | null;
    } | null;
  } | null;
};

export type GetOperationsContributionsCountQueryVariables = Exact<{
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  filterBy?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetOperationsContributionsCountQuery = {
  __typename?: "Query";
  getOperationsContributionsCount?: {
    __typename?: "OperationsContributionsCountsType";
    inFlightLois?: number | null;
    fundsReconciled?: number | null;
    liquidation?: number | null;
    fundsAvailable?: number | null;
    total?: number | null;
  } | null;
};

export type GetOperationsContributionsStatsQueryVariables = Exact<{
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  filterBy?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  contributionStateFilter?: InputMaybe<Scalars["String"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type GetOperationsContributionsStatsQuery = {
  __typename?: "Query";
  getOperationsContributionsStats?: {
    __typename?: "OperationsContributionsStatsType";
    totalCount?: number | null;
    page?: number | null;
    pageSize?: number | null;
    isPaginated?: boolean | null;
    isLastPage?: boolean | null;
    results?: Array<{
      __typename?: "OperationsContributionsStatsItemType";
      objectId?: any | null;
      status?: string | null;
      amount?: number | null;
      contributor?: string | null;
      method?: string | null;
      initiatedDate?: string | null;
      contributionType?: string | null;
      firmName?: string | null;
      timeline?: Array<{
        __typename?: "ContributionTimelineStatsType";
        state?: string | null;
        value?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type GetOperationsStatsQueryVariables = Exact<{
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  dafId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  filterBy?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetOperationsStatsQuery = {
  __typename?: "Query";
  getOperationsStats?: {
    __typename?: "OperationsStatsType";
    contributions?: number | null;
    grants?: number | null;
    inFlightContributions?: number | null;
    inFlightGrants?: number | null;
  } | null;
};

export type GetFeesStatsQueryVariables = Exact<{
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  advisorId?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetFeesStatsQuery = {
  __typename?: "Query";
  getFeesStats?: {
    __typename?: "FeesStatsType";
    aum?: number | null;
    avgBps?: number | null;
    adminFees?: number | null;
    subAdvisorFees?: number | null;
    platformFeePct?: number | null;
    enterpriseFeePct?: number | null;
    platformShare?: number | null;
    enterpriseShare?: number | null;
  } | null;
};

export type GetFeeTierQueryVariables = Exact<{
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  advisorId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetFeeTierQuery = {
  __typename?: "Query";
  getFeeTier?: { __typename?: "FeeTierType"; feeTier?: any | null } | null;
};

export type GetFeesByProgramQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type GetFeesByProgramQuery = {
  __typename?: "Query";
  getFeesByProgram?: {
    __typename?: "FeesByProgramType";
    totalCount?: number | null;
    page?: number | null;
    pageSize?: number | null;
    isPaginated?: boolean | null;
    isLastPage?: boolean | null;
    isCustomFeeSplit?: boolean | null;
    results?: Array<{
      __typename?: "ProgramFeeRowType";
      enterpriseName?: string | null;
      enterpriseId?: string | null;
      enterpriseGiveReferenceId?: string | null;
      aum?: string | null;
      avgBps?: string | null;
      adminFees?: number | null;
      subAdvisorFees?: number | null;
      platformFeePct?: number | null;
      enterpriseFeePct?: number | null;
      platformShare?: number | null;
      enterpriseShare?: number | null;
    } | null> | null;
  } | null;
};

export type GetFeesByEnterpriseQueryVariables = Exact<{
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetFeesByEnterpriseQuery = {
  __typename?: "Query";
  getFeesByEnterprise?: {
    __typename?: "FeesByEnterpriseType";
    totalCount?: number | null;
    page?: number | null;
    pageSize?: number | null;
    isPaginated?: boolean | null;
    isLastPage?: boolean | null;
    isCustomFeeSplit?: boolean | null;
    results?: Array<{
      __typename?: "EnterpriseFeeRowType";
      firmName?: string | null;
      firmId?: string | null;
      firmGiveReferenceId?: string | null;
      aum?: string | null;
      avgBps?: string | null;
      adminFees?: number | null;
      subAdvisorFees?: number | null;
      platformFeePct?: number | null;
      enterpriseFeePct?: number | null;
      platformShare?: number | null;
      enterpriseShare?: number | null;
    } | null> | null;
  } | null;
};

export type GetFeesByFirmQueryVariables = Exact<{
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetFeesByFirmQuery = {
  __typename?: "Query";
  getFeesByFirm?: {
    __typename?: "FeesByFirmType";
    totalCount?: number | null;
    page?: number | null;
    pageSize?: number | null;
    isPaginated?: boolean | null;
    isLastPage?: boolean | null;
    isCustomFeeSplit?: boolean | null;
    results?: Array<{
      __typename?: "FirmFeeRowType";
      advisorName?: string | null;
      advisorId?: string | null;
      advisorGiveReferenceId?: string | null;
      id?: number | null;
      aum?: string | null;
      avgBps?: string | null;
      adminFees?: number | null;
      subAdvisorFees?: number | null;
      platformFeePct?: number | null;
      enterpriseFeePct?: number | null;
      platformShare?: number | null;
      enterpriseShare?: number | null;
    } | null> | null;
  } | null;
};

export type GetFeesByAdvisorQueryVariables = Exact<{
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  advisorId?: InputMaybe<Scalars["String"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetFeesByAdvisorQuery = {
  __typename?: "Query";
  getFeesByAdvisor?: {
    __typename?: "FeesByAdvisorIdType";
    totalCount?: number | null;
    page?: number | null;
    pageSize?: number | null;
    isPaginated?: boolean | null;
    isLastPage?: boolean | null;
    isCustomFeeSplit?: boolean | null;
    results?: Array<{
      __typename?: "AdvisorFeeRowType";
      dafName?: string | null;
      dafId?: string | null;
      dafGiveReferenceId?: string | null;
      aum?: string | null;
      avgBps?: string | null;
      adminFees?: number | null;
      subAdvisorFees?: number | null;
      platformFeePct?: number | null;
      enterpriseFeePct?: number | null;
      platformShare?: number | null;
      enterpriseShare?: number | null;
    } | null> | null;
  } | null;
};

export type GetOperationsGrantsKpIsQueryVariables = Exact<{
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  filterBy?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetOperationsGrantsKpIsQuery = {
  __typename?: "Query";
  getOperationsGrantsKPIs?: {
    __typename?: "OperationsGrantsKPIsType";
    averageCycleTimeDays?: number | null;
    submittedToApprovedDays?: number | null;
    fundsMadeAvailableDays?: number | null;
    sentToCharityDays?: number | null;
    charityReceivesFundsDays?: number | null;
  } | null;
};

export type GetOperationsGrantsStatsQueryVariables = Exact<{
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  filterBy?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
  grantsStateFilter?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetOperationsGrantsStatsQuery = {
  __typename?: "Query";
  getOperationsGrantsStats?: {
    __typename?: "OperationsGrantsStatsType";
    totalCount?: number | null;
    page?: number | null;
    pageSize?: number | null;
    isPaginated?: boolean | null;
    isLastPage?: boolean | null;
    results?: Array<{
      __typename?: "OperationsGrantsStatsItemType";
      objectId?: any | null;
      status?: string | null;
      amount?: number | null;
      recommendedBy?: string | null;
      method?: string | null;
      charityName?: string | null;
      grantNote?: string | null;
      initiatedDate?: string | null;
      firmName?: string | null;
      ein?: string | null;
      isAnonymous?: boolean | null;
      timeline?: Array<{
        __typename?: "ContributionTimelineStatsType";
        state?: string | null;
        value?: string | null;
      } | null> | null;
      charityAddress?: {
        __typename?: "GranteeAddressType";
        streetAddress?: string | null;
        cityStateZip?: string | null;
        country?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetOperationsGrantsVolumeStatusStatsQueryVariables = Exact<{
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  filterBy?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetOperationsGrantsVolumeStatusStatsQuery = {
  __typename?: "Query";
  getOperationsGrantsVolumeStatusStats?: {
    __typename?: "OperationsGrantsVolumeStatusStatsType";
    submittedGrants?: number | null;
    approvedGrants?: number | null;
    fundsSentGrants?: number | null;
    sentToCharityGrants?: number | null;
    completedGrants?: number | null;
  } | null;
};

export type GetOperationsAumByInvestmentModelQueryVariables = Exact<{
  frequency?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetOperationsAumByInvestmentModelQuery = {
  __typename?: "Query";
  getOperationsAumByInvestmentModel?: {
    __typename?: "OperationsAumByInvestmentModelType";
    models?: any | null;
    data?: any | null;
  } | null;
};

export type GetAdoptionBannerStatsQueryVariables = Exact<{
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetAdoptionBannerStatsQuery = {
  __typename?: "Query";
  getAdoptionBannerStats?: {
    __typename?: "AdoptionBannerStatsType";
    period?: {
      __typename?: "PeriodStatsType";
      startDate?: string | null;
      endDate?: string | null;
      totalEligibleParticipants?: number | null;
      openRate?: number | null;
      dafsOpened?: number | null;
      dafsFunded?: number | null;
      fundedRate?: number | null;
    } | null;
  } | null;
};

export type GetEngagementOverTimeQueryVariables = Exact<{
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetEngagementOverTimeQuery = {
  __typename?: "Query";
  getEngagementOverTime?: {
    __typename?: "EngagementOverTimeType";
    weeks?: Array<{
      __typename?: "WeekEngagementType";
      week?: string | null;
      weekStart?: string | null;
      signUps?: number | null;
      dafsOpened?: number | null;
      dafsFunded?: number | null;
    } | null> | null;
  } | null;
};

export type GetEngagementFunnelQueryVariables = Exact<{
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetEngagementFunnelQuery = {
  __typename?: "Query";
  getEngagementFunnel?: {
    __typename?: "EngagementFunnelType";
    emailsSent?: number | null;
    emailsOpened?: number | null;
    emailsBounced?: number | null;
    signUps?: number | null;
    dafsOpened?: number | null;
    firstContribution?: number | null;
    firstGrant?: number | null;
    startDate?: string | null;
    endDate?: string | null;
  } | null;
};

export type GetCustomerSuccessMetricsQueryVariables = Exact<{
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  filterType?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetCustomerSuccessMetricsQuery = {
  __typename?: "Query";
  getCustomerSuccessMetrics?: {
    __typename?: "CustomerSuccessStatsType";
    totalServiceRequests?: number | null;
    avgFirstResponse?: number | null;
    avgResolutionTime?: number | null;
    outstandingRequests?: number | null;
  } | null;
};

export type GetServiceRequestsByChannelQueryVariables = Exact<{
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  filterType?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetServiceRequestsByChannelQuery = {
  __typename?: "Query";
  getServiceRequestsByChannel?: {
    __typename?: "ServiceRequestsByChannelType";
    serviceRequests?: Array<{
      __typename?: "ServiceRequestsByChannelItemType";
      period?: string | null;
      chatRequests?: number | null;
      emailRequests?: number | null;
      avgFirstResponse?: number | null;
      avgResolution?: number | null;
    } | null> | null;
  } | null;
};

export type GetChannelPerformanceMetricsQueryVariables = Exact<{
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  filterType?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetChannelPerformanceMetricsQuery = {
  __typename?: "Query";
  getChannelPerformanceMetrics?: {
    __typename?: "ChannelPerformanceMetricsType";
    chat?: {
      __typename?: "GeneralPerformanceMetricsType";
      requests?: number | null;
      avgSatisfaction?: number | null;
    } | null;
    email?: {
      __typename?: "GeneralPerformanceMetricsType";
      requests?: number | null;
      avgSatisfaction?: number | null;
    } | null;
  } | null;
};

export type GetConversationTopIssuesQueryVariables = Exact<{
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  filterType?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetConversationTopIssuesQuery = {
  __typename?: "Query";
  getConversationTopIssues?: {
    __typename?: "ConversationTopIssueThemeType";
    topIssues?: Array<{
      __typename?: "ConversationTopIssueTypeObject";
      issueType?: string | null;
      count?: number | null;
    } | null> | null;
  } | null;
};

export type GetServiceRequestsByIssueTypeQueryVariables = Exact<{
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  filterType?: InputMaybe<Scalars["String"]["input"]>;
  issueType?: InputMaybe<Scalars["String"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetServiceRequestsByIssueTypeQuery = {
  __typename?: "Query";
  getServiceRequestsByIssueType?: {
    __typename?: "ServiceRequestByIssueTypeType";
    totalCount?: number | null;
    page?: number | null;
    pageSize?: number | null;
    isLastPage?: boolean | null;
    serviceRequests?: Array<{
      __typename?: "ServiceRequestByIssueTypeItemType";
      requestId?: string | null;
      client?: string | null;
      participant?: string | null;
      channel?: string | null;
      issueType?: string | null;
      status?: string | null;
      priority?: string | null;
      responseTime?: number | null;
      issueOpened?: any | null;
      firstResponse?: any | null;
      firstClosed?: any | null;
      correspondence?: Array<{
        __typename?: "CorrespondenceItemType";
        name?: string | null;
        message?: string | null;
        date?: any | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type GetFeeStatementMutationVariables = Exact<{
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  startDate: Scalars["String"]["input"];
  endDate: Scalars["String"]["input"];
  periodLabel: Scalars["String"]["input"];
}>;

export type GetFeeStatementMutation = {
  __typename?: "Mutation";
  getFeeStatement?: {
    __typename?: "GetFeeStatement";
    ok?: boolean | null;
    feeStatement?: string | null;
  } | null;
};

export type GetReportsOverviewStatsQueryVariables = Exact<{
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
  programFilter?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetReportsOverviewStatsQuery = {
  __typename?: "Query";
  getOverviewStats?: {
    __typename?: "OverviewStatsType";
    enterprises?: number | null;
    wealthClients?: number | null;
    advisors?: number | null;
    corporateClients?: number | null;
    aum?: number | null;
    dafsOpened?: number | null;
    dafsFunded?: number | null;
    totalContributions?: number | null;
    totalGrants?: number | null;
  } | null;
};

export type GetReportsProgramAumStatsQueryVariables = Exact<{
  frequency: Scalars["String"]["input"];
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  familyId?: InputMaybe<Scalars["Int"]["input"]>;
  firmId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetReportsProgramAumStatsQuery = {
  __typename?: "Query";
  getProgramAUMStats?: {
    __typename?: "OverviewProgramAUMStatsType";
    aumStats?: Array<{
      __typename?: "ProgramAUMStatsDataType";
      period?: string | null;
      year?: number | null;
      openingAumInvestmentFundFee?: number | null;
      openingAumFundAsset?: number | null;
      closingAumInvestmentFundFee?: number | null;
      closingAumFundAsset?: number | null;
      contributions?: number | null;
      grants?: number | null;
    } | null> | null;
  } | null;
};

export type GetReportsCorporateClientsListQueryVariables = Exact<{
  enterpriseId?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type GetReportsCorporateClientsListQuery = {
  __typename?: "Query";
  getCorporateClientsList?: {
    __typename?: "OverviewCorporateClientsListWrapperType";
    totalCount?: number | null;
    isLastPage?: boolean | null;
    page?: number | null;
    pageSize?: number | null;
    corporateClientsList?: Array<{
      __typename?: "OverviewCorporateClientsListType";
      firmId?: string | null;
      firmGiveReferenceId?: string | null;
      firmName?: string | null;
      advisorCount?: number | null;
      dafsOpened?: number | null;
      dafsFunded?: number | null;
      aum?: number | null;
      lois?: number | null;
      contributions?: number | null;
      grants?: number | null;
    } | null> | null;
  } | null;
};

export type GetEnterpriseClientsListQueryVariables = Exact<{
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
  isPaginated?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type GetEnterpriseClientsListQuery = {
  __typename?: "Query";
  getEnterpriseClientsList?: {
    __typename?: "OverviewEnterpriseClientsListWrapperType";
    totalCount?: number | null;
    isLastPage?: boolean | null;
    page?: number | null;
    pageSize?: number | null;
    enterpriseClientsList?: Array<{
      __typename?: "OverviewEnterpriseClientsListType";
      enterpriseId?: string | null;
      enterpriseGiveReferenceId?: string | null;
      enterpriseName?: string | null;
      firmCount?: number | null;
      dafsOpened?: number | null;
      dafsFunded?: number | null;
      aum?: number | null;
      lois?: number | null;
      contributions?: number | null;
      grants?: number | null;
    } | null> | null;
  } | null;
};

export type MySuccessorInviteQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type MySuccessorInviteQuery = {
  __typename?: "Query";
  mySuccessorInvite?: {
    __typename?: "SuccessorType";
    id: string;
    firstName: string;
    lastName: string;
    percentage?: number | null;
    isContingent?: boolean | null;
    acceptedAt?: any | null;
    declinedAt?: any | null;
    family?: { __typename?: "FamilyType"; id: string; name: string } | null;
    destinationFamily?: { __typename?: "FamilyType"; id: string } | null;
  } | null;
};

export type MySuccessorOnboardingQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type MySuccessorOnboardingQuery = {
  __typename?: "Query";
  mySuccessorOnboarding?: {
    __typename?: "SuccessorOnboardingType";
    successorId?: number | null;
    isContingent?: boolean | null;
    percentage?: number | null;
    originatingFamilyId?: number | null;
    originatingFamilyName?: string | null;
    acceptedAt?: any | null;
    declinedAt?: any | null;
    founderMessageViewedAt?: any | null;
    missionReviewedAt?: any | null;
    acknowledgmentSignedAt?: any | null;
    givingHistoryViewedAt?: any | null;
    dafCreated?: boolean | null;
  } | null;
};

export type SuccessorAcknowledgmentQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type SuccessorAcknowledgmentQuery = {
  __typename?: "Query";
  successorAcknowledgment?: {
    __typename?: "SuccessorAcknowledgmentType";
    originatingFamilyId?: number | null;
    originatingFamilyName?: string | null;
    isContingent?: boolean | null;
    percentage?: number | null;
    policyMode?: string | null;
    annualPayoutTarget?: number | null;
    sunsetTimeframeYears?: number | null;
    accountAgeYears?: number | null;
    yearsUntilSunset?: number | null;
    isPolicyConfigured?: boolean | null;
    alreadySignedAt?: any | null;
    sunsetCharityAllocations?: Array<{
      __typename?: "SunsetCharityAllocationType";
      id?: number | null;
      charityName?: string | null;
      percentage?: number | null;
    } | null> | null;
  } | null;
};

export type SuccessorFoundersVoiceQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type SuccessorFoundersVoiceQuery = {
  __typename?: "Query";
  successorFoundersVoice?: {
    __typename?: "SuccessorFoundersVoiceType";
    originatingFamilyId?: number | null;
    originatingFamilyName?: string | null;
    foundersMessage?: string | null;
    mission?: string | null;
    audioUrl?: string | null;
    videoUrl?: string | null;
    hasContent?: boolean | null;
  } | null;
};

export type SuccessorGivingHistoryQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type SuccessorGivingHistoryQuery = {
  __typename?: "Query";
  successorGivingHistory?: {
    __typename?: "SuccessorGivingHistoryType";
    originatingFamilyId?: number | null;
    originatingFamilyName?: string | null;
    hasContent?: boolean | null;
    grants?: Array<{
      __typename?: "FeaturedGrantType";
      id?: string | null;
      charityName?: string | null;
      contribution?: number | null;
      submittedOn?: string | null;
      causes?: Array<string | null> | null;
      rationale?: string | null;
      status?: string | null;
    } | null> | null;
  } | null;
};

export type SuggestedForYouQueryVariables = Exact<{
  donorId: Scalars["Int"]["input"];
  familyId: Scalars["Int"]["input"];
}>;

export type SuggestedForYouQuery = {
  __typename?: "Query";
  recommendedFundsDonor?: {
    __typename: "RecommendedFundDonorType";
    funds?: Array<{
      __typename?: "CharityType";
      id?: string | null;
      mediumImg?: string | null;
      mission?: string | null;
      nteeDesc?: string | null;
      ein?: string | null;
      restricted?: boolean | null;
      isBlacklisted?: boolean | null;
      title?: string | null;
      membersLiked?: Array<string | null> | null;
      campaignedBy?: Array<string | null> | null;
      contributors?: Array<string | null> | null;
      charityNavRatings?: any | null;
      status?: string | null;
      isUserFavourite?: boolean | null;
      orgSecondName?: string | null;
      address?: string | null;
      payment?: {
        __typename?: "CharityPaymentType";
        paymentMethod?: string | null;
        isAch?: boolean | null;
      } | null;
      causes?: Array<{
        __typename?: "CauseType";
        id?: string | null;
        key?: string | null;
        value?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type RecommendedFundsFamilyQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
}>;

export type RecommendedFundsFamilyQuery = {
  __typename?: "Query";
  recommendedFundsFamily?: {
    __typename?: "RecommendedFundFamilyType";
    funds?: Array<{
      __typename?: "CharityType";
      id?: string | null;
      ein?: string | null;
      charityNavRatings?: any | null;
      mediumImg?: string | null;
      mission?: string | null;
      nteeDesc?: string | null;
      title?: string | null;
      membersLiked?: Array<string | null> | null;
      campaignedBy?: Array<string | null> | null;
      contributors?: Array<string | null> | null;
      status?: string | null;
      restricted?: boolean | null;
      isUserFavourite?: boolean | null;
      orgSecondName?: string | null;
      address?: string | null;
      causes?: Array<{
        __typename?: "CauseType";
        id?: string | null;
        key?: string | null;
        value?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type ListTransactionsQueryVariables = Exact<{
  familyId: Scalars["Int"]["input"];
  filters?: InputMaybe<TransactionFilterInputType>;
}>;

export type ListTransactionsQuery = {
  __typename?: "Query";
  listTransactions?: {
    __typename?: "ListTransactionsPaginatedType";
    page?: number | null;
    pages?: number | null;
    count?: number | null;
    objects?: Array<{
      __typename?: "AllTransactionsType";
      transactionId: string;
      amount?: number | null;
      contributor: string;
      description: string;
      status: string;
      initiatedOn: any;
      lastUpdatedOn?: any | null;
      searchDescription: string;
      source: string;
      familyId: number;
      userId: number;
      metaData: any;
      displayStatus: string;
    } | null> | null;
  } | null;
};

export type GetSecurityContributionDetailQueryVariables = Exact<{
  transactionReference: Scalars["String"]["input"];
  familyId: Scalars["Int"]["input"];
  status?: InputMaybe<Scalars["String"]["input"]>;
  pageNumber?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetSecurityContributionDetailQuery = {
  __typename?: "Query";
  securityContributionDetails?: {
    __typename?: "SecurityContributionDetailType";
    batchId?: string | null;
    submittedBy?: string | null;
    custodian?: string | null;
    initiatedOn?: any | null;
    totalValue?: number | null;
    totalCount?: number | null;
    statusCounts?: Array<{
      __typename?: "StatusCountType";
      status?: string | null;
      count?: number | null;
    } | null> | null;
    securities?: {
      __typename?: "PaginatedSecurityItemType";
      page?: number | null;
      pages?: number | null;
      count?: number | null;
      objects?: Array<{
        __typename?: "SecurityItemType";
        ticker?: string | null;
        securityName?: string | null;
        quantity?: string | null;
        amount?: number | null;
        status?: string | null;
        objectId?: string | null;
        transactionId?: string | null;
      } | null> | null;
    } | null;
  } | null;
};

export type EngagementDistributionQueryVariables = Exact<{
  ctype: CTypeEnumType;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  year?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type EngagementDistributionQuery = {
  __typename?: "Query";
  engagementDistribution?: {
    __typename?: "EngageType";
    totalGift?: number | null;
    distribution?: Array<{
      __typename: "EngageDistributionType";
      id?: string | null;
      key?: string | null;
      value?: string | null;
      gift?: number | null;
      weight?: number | null;
    } | null> | null;
  } | null;
};

export type GetRecurringGiftQueryVariables = Exact<{
  giftId: Scalars["Int"]["input"];
}>;

export type GetRecurringGiftQuery = {
  __typename?: "Query";
  recurringGift?: {
    __typename?: "RecurringGiftType";
    id: string;
    isActive: boolean;
    frequency: RecurringGiftFrequency;
    nextScheduled?: any | null;
    startDate?: any | null;
    endDate?: any | null;
    cancelledAt?: any | null;
    cancelledByName?: string | null;
    seriesDisplayStatus?: string | null;
    seriesStartedOn?: any | null;
    charityName?: string | null;
    charityId?: string | null;
    anonymous: boolean;
    totalOccurrences?: number | null;
    completedOccurrences?: number | null;
    ein?: string | null;
    note?: string | null;
    amount: any;
    companyGrant?: {
      __typename?: "CompanyGrantType";
      id: string;
      createdAt: any;
      endorsedAt?: any | null;
      createdBy: { __typename?: "UserType"; id: string; name?: string | null };
      endorsedBy?: {
        __typename?: "UserType";
        id: string;
        name?: string | null;
      } | null;
    } | null;
    charity?: {
      __typename?: "CharityType";
      id?: string | null;
      title?: string | null;
      ein?: string | null;
      name?: string | null;
      mediumImg?: string | null;
      address?: string | null;
      payment?: {
        __typename?: "CharityPaymentType";
        id?: string | null;
        paymentMethod?: string | null;
        isAch?: boolean | null;
        createdAt?: string | null;
      } | null;
    } | null;
    user: {
      __typename?: "UserType";
      firstName?: string | null;
      lastName?: string | null;
      name?: string | null;
    };
    impersonatedBy?: { __typename?: "UserType"; name?: string | null } | null;
  } | null;
};

export type ScheduledCcContributionDetailsQueryVariables = Exact<{
  scheduledCcContributionId: Scalars["Int"]["input"];
}>;

export type ScheduledCcContributionDetailsQuery = {
  __typename?: "Query";
  scheduledCcContributionDetails?: {
    __typename?: "ScheduledCCContributionDTO";
    id: string;
    chargeAmount: any;
    amount: any;
    processingFee: any;
    oneTimeFee: any;
    createdAt: any;
    firstSchedule: any;
    frequency: ScheduledCcContributionFrequency;
    isActive: boolean;
    lastTransaction?: any | null;
    nextScheduled?: any | null;
    endDate?: any | null;
    updatedAt: any;
    contributor: string;
    paymentIntentId: string;
    paymentMethodId: string;
    brand: string;
    last4: string;
    country: string;
    funding: string;
    createdBy: { __typename?: "UserType"; id: string; email: string };
    family: { __typename?: "FamilyType"; id: string; name: string };
  } | null;
};

export type ScheduledContributionDetailsQueryVariables = Exact<{
  scheduledContributionId: Scalars["Int"]["input"];
}>;

export type ScheduledContributionDetailsQuery = {
  __typename?: "Query";
  scheduledContributionDetails?: {
    __typename?: "ScheduledContributionType";
    amount?: number | null;
    contributor?: string | null;
    createdAt?: any | null;
    endDate?: string | null;
    firstSchedule?: any | null;
    frequency?: string | null;
    id?: string | null;
    institutionName?: string | null;
    isActive?: string | null;
    lastTransaction?: string | null;
    nextScheduled?: any | null;
    updatedAt?: any | null;
    account?: {
      __typename?: "BankItemAccountType";
      id: string;
      accountId?: string | null;
      mask?: string | null;
      accountName?: string | null;
      verificationStatus?: string | null;
      plaidItem?: { __typename?: "PlaidItemType"; id: string } | null;
    } | null;
    createdBy?: {
      __typename?: "UserType";
      id: string;
      firstName?: string | null;
      lastName?: string | null;
    } | null;
  } | null;
};

export type GetTransactionFiltersQueryVariables = Exact<{
  startDate: Scalars["Date"]["input"];
  endDate: Scalars["Date"]["input"];
}>;

export type GetTransactionFiltersQuery = {
  __typename?: "Query";
  getTransactionFilters?: {
    __typename?: "TransactionFiltersType";
    campaigns?: {
      __typename?: "CampaignFiltersType";
      statuses?: Array<string | null> | null;
      charities?: Array<{
        __typename?: "CharityFilterType";
        id?: string | null;
        title?: string | null;
      } | null> | null;
    } | null;
    contributions?: {
      __typename?: "ContributionFiltersType";
      displayStatuses?: Array<string | null> | null;
      statuses?: Array<string | null> | null;
      types?: Array<string | null> | null;
    } | null;
    grants?: {
      __typename?: "GrantFiltersType";
      statuses?: Array<string | null> | null;
      charities?: Array<{
        __typename?: "CharityFilterType";
        id?: string | null;
        title?: string | null;
      } | null> | null;
    } | null;
    companyGrants?: {
      __typename?: "GrantFiltersType";
      statuses?: Array<string | null> | null;
      charities?: Array<{
        __typename?: "CharityFilterType";
        id?: string | null;
        title?: string | null;
      } | null> | null;
    } | null;
    employeeGrants?: {
      __typename?: "GrantFiltersType";
      statuses?: Array<string | null> | null;
      charities?: Array<{
        __typename?: "CharityFilterType";
        id?: string | null;
        title?: string | null;
      } | null> | null;
    } | null;
    adminGrants?: {
      __typename?: "GrantFiltersType";
      statuses?: Array<string | null> | null;
      charities?: Array<{
        __typename?: "CharityFilterType";
        id?: string | null;
        title?: string | null;
      } | null> | null;
    } | null;
    myGrants?: {
      __typename?: "GrantFiltersType";
      statuses?: Array<string | null> | null;
      charities?: Array<{
        __typename?: "CharityFilterType";
        id?: string | null;
        title?: string | null;
      } | null> | null;
    } | null;
  } | null;
};

export type GetPublicSecurityBatchDetailsQueryVariables = Exact<{
  transactionReference: Scalars["String"]["input"];
  familyId: Scalars["Int"]["input"];
  status?: InputMaybe<Scalars["String"]["input"]>;
  pageNumber?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetPublicSecurityBatchDetailsQuery = {
  __typename?: "Query";
  securityContributionDetails?: {
    __typename?: "SecurityContributionDetailType";
    batchId?: string | null;
    submittedBy?: string | null;
    custodian?: string | null;
    initiatedOn?: any | null;
    totalValue?: number | null;
    totalCount?: number | null;
    statusCounts?: Array<{
      __typename?: "StatusCountType";
      status?: string | null;
      count?: number | null;
    } | null> | null;
    securities?: {
      __typename?: "PaginatedSecurityItemType";
      page?: number | null;
      pages?: number | null;
      count?: number | null;
      objects?: Array<{
        __typename?: "SecurityItemType";
        ticker?: string | null;
        securityName?: string | null;
        quantity?: string | null;
        amount?: number | null;
        status?: string | null;
        objectId?: string | null;
        transactionId?: string | null;
        statusTimeline?: Array<{
          __typename?: "ContributionStatusTimelineType";
          status?: string | null;
          statusSubtext?: string | null;
          orderOfAppearance?: number | null;
          elevateStatus?: string | null;
          completedOn?: string | null;
        } | null> | null;
      } | null> | null;
    } | null;
  } | null;
};

export type UserQueryVariables = Exact<{
  userId: Scalars["Int"]["input"];
}>;

export type UserQuery = {
  __typename?: "Query";
  user?: {
    __typename?: "UserType";
    id: string;
    email: string;
    name?: string | null;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    prefix?: UserPrefix | null;
    suffix?: UserSuffix | null;
    isStaff: boolean;
    yellowRef?: string | null;
    individualBenefit?: boolean | null;
    corporateBenefit?: boolean | null;
    roles?: any | null;
    userRoles?: any | null;
    dob?: any | null;
    address?: any | null;
    phoneNumber?: any | null;
    lastLogin?: any | null;
    relationship?: string | null;
    profilepicUrl?: string | null;
    emailPrefDafContribution?: boolean | null;
    emailPrefGifts?: boolean | null;
    emailPrefOnboarding?: boolean | null;
    subscribeNewFeatures?: boolean | null;
    subscribeGivingTrends?: boolean | null;
    externalId?: string | null;
    inviteStatus: UserInviteStatus;
    tncAcceptedTime?: any | null;
    yearlyPendingGrants?: number | null;
    mfaEnrolled?: boolean | null;
    mfaMethod?: string | null;
    signupStatus?: string | null;
    givingPrivacyPreference?: any | null;
    selfDirected?: {
      __typename?: "SelfDirectedType";
      id?: number | null;
      email?: string | null;
      inviteStatus?: string | null;
    } | null;
    yearlyFamilyUserGroupData?: {
      __typename?: "YearlyFamilyUserGroupDataType";
      allocatedAmount: any;
      contributedAmount?: number | null;
    } | null;
    userTags: Array<{
      __typename?: "UserTagType";
      id: string;
      tagCategory?: {
        __typename?: "TagCategoryType";
        id: string;
        category: string;
        tags?: Array<{
          __typename?: "TagType";
          id: string;
          tag: string;
        } | null> | null;
      } | null;
      tag?: { __typename?: "TagType"; id: string; tag: string } | null;
    }>;
    firm?: {
      __typename?: "FirmType";
      id: string;
      firmName?: string | null;
      logo?: string | null;
      logoUrl?: string | null;
      address?: any | null;
      phoneNumber?: any | null;
      website?: string | null;
      isSetupDone: boolean;
      primaryColor?: string | null;
      secondaryColor?: string | null;
      metaData?: any | null;
      isEnterprise?: boolean | null;
      parentFirm?: {
        __typename?: "FirmType";
        id: string;
        firmName?: string | null;
      } | null;
    } | null;
    family?: {
      __typename?: "FamilyType";
      advisor?: {
        __typename?: "UserType";
        id: string;
        email: string;
        firstName?: string | null;
        lastName?: string | null;
        name?: string | null;
      } | null;
    } | null;
  } | null;
};

export type ValidateEmailQueryVariables = Exact<{
  token: Scalars["String"]["input"];
}>;

export type ValidateEmailQuery = {
  __typename?: "Query";
  validateEmail?: {
    __typename?: "UserType";
    firstName?: string | null;
    lastName?: string | null;
    email: string;
    isActive: boolean;
    firm?: { __typename?: "FirmType"; id: string } | null;
  } | null;
};

export type UpdateLastLoginMutationVariables = Exact<{ [key: string]: never }>;

export type UpdateLastLoginMutation = {
  __typename?: "Mutation";
  updateLastLogin?: {
    __typename?: "UpdateLastLogin";
    ok?: boolean | null;
  } | null;
};

export type IsGiveUserQueryVariables = Exact<{ [key: string]: never }>;

export type IsGiveUserQuery = {
  __typename?: "Query";
  isGiveUser?: boolean | null;
};

export type AcceptTncMutationVariables = Exact<{ [key: string]: never }>;

export type AcceptTncMutation = {
  __typename?: "Mutation";
  acceptTnc?: { __typename?: "Accept_Tnc"; ok?: boolean | null } | null;
};

export type RegisterMemberForDonorSsoMutationVariables = Exact<{
  [key: string]: never;
}>;

export type RegisterMemberForDonorSsoMutation = {
  __typename?: "Mutation";
  registerMemberForDonorSso?: {
    __typename?: "RegisterMemberForDonorSSO";
    ok?: boolean | null;
  } | null;
};

export type SetGivingPrivacyPreferenceMutationVariables = Exact<{
  preset?: InputMaybe<Scalars["String"]["input"]>;
  fields?: InputMaybe<Scalars["GenericScalar"]["input"]>;
}>;

export type SetGivingPrivacyPreferenceMutation = {
  __typename?: "Mutation";
  setGivingPrivacyPreference?: {
    __typename?: "SetGivingPrivacyPreference";
    ok?: boolean | null;
  } | null;
};

export type AcceptAdvisorFeeAgreementMutationVariables = Exact<{
  [key: string]: never;
}>;

export type AcceptAdvisorFeeAgreementMutation = {
  __typename?: "Mutation";
  acceptAdvisorFeeAgreement?: {
    __typename?: "AcceptAdvisorFeeAgreement";
    ok?: boolean | null;
  } | null;
};

export const ActivitiesDocument = gql`
  query activities($page: Int, $pageSize: Int, $filter: ActivityFilterInput) {
    activities(page: $page, pageSize: $pageSize, filter: $filter) {
      page
      pages
      count
      objects {
        id
        type
        category
        message
        actionUrl
        actionText
        createdAt
      }
    }
  }
`;
export const GetAllGrowthActivitiesDocument = gql`
  query GetAllGrowthActivities(
    $pageSize: Int
    $page: Int
    $filter: GrowthActivityFilterInput
  ) {
    growthActivities(pageSize: $pageSize, page: $page, filter: $filter) {
      page
      pages
      count
      snoozedCount
      normalCount
      objects {
        id
        type
        category
        message
        actionUrl
        actionText
        pathToRevenue
        recommendedAction
        createdAt
        actions {
          id
          actionType
          actionAt
          actionByUser {
            id
            email
            firstName
            lastName
          }
        }
      }
    }
  }
`;
export const TodosDocument = gql`
  query todos(
    $page: Int
    $pageSize: Int
    $searchStr: String
    $filter: ActionableFilterInput
  ) {
    todos(
      page: $page
      pageSize: $pageSize
      searchStr: $searchStr
      filter: $filter
    ) {
      page
      pages
      count
      objects {
        id
        type
        category
        message
        actionUrl
        actionText
        metaData
      }
    }
  }
`;
export const AlertsDocument = gql`
  query alerts(
    $page: Int
    $pageSize: Int
    $searchStr: String
    $filter: ActionableFilterInput
  ) {
    alerts(
      page: $page
      pageSize: $pageSize
      searchStr: $searchStr
      filter: $filter
    ) {
      page
      page
      count
      objects {
        id
        type
        category
        message
        actionUrl
        actionText
      }
    }
  }
`;
export const ResendInviteDocument = gql`
  mutation resendInvite($userId: Int!) {
    resendInvite(userId: $userId) {
      ok
    }
  }
`;
export const GrowthActivityActionMutationDocument = gql`
  mutation GrowthActivityActionMutation($input: GrowthActivityActionInput!) {
    growthActivityAction(input: $input) {
      ok
      action {
        id
        actionType
        actionBy {
          id
          email
          firstName
          lastName
        }
        actionAt
        growthActivity {
          id
          type
        }
      }
      errors
    }
  }
`;
export const NewDafClientsDocument = gql`
  query newDafClients(
    $pageSize: Int
    $page: Int
    $searchStr: String
    $filters: AdvisorDafClientsFilterType
    $advisorId: Int
  ) {
    newDafClients(
      pageSize: $pageSize
      page: $page
      searchStr: $searchStr
      filters: $filters
      advisorId: $advisorId
    ) {
      count
      page
      pages
      objects {
        id
        name
        clientType
        createdAt
        isFunded
        engageFamily
        isLinkedPortfolio
        taxOptimisationSessionIds
        linkedAssets
        isIndividualDaf
        n8nLog {
          id
          eventType
          status
          envelopeId
          docusignStatus
          docusignStatusUpdatedAt
          s3Key
          isDownloaded
          createdAt
          updatedAt
        }
        familyMembers {
          id
          name
          firstName
          lastName
          familyRole
          email
          yellowRef
          inviteStatus
          profilepicUrl
          tncAcceptedTime
          phoneNumber
          linkedAssets
          yearlyFamilyUserGroupData {
            allocatedAmount
            contributedAmount
          }
          relations {
            relatedUserId
            relation
          }
          portfolioAccounts {
            id
            portfolioCode
            accountName
            totalBalance
            portfolioNameTwo
            custodianId
            totalUnrealizedGain
            appreciatedSecuritiesCount
          }
        }
        hof {
          id
          name
          firstName
          lastName
          email
          inviteStatus
          inviteSent
          yellowRef
          onboardingStage
        }
        louiseDaf {
          dafId
          fundId
          fundName
          availableBalance
          accumulatedGrants
          accumulatedContributions
          accumulatedYearlyContributions
          custodian
          custodianId
          isSingleCharityFund
          restrictedCharityId
          restrictedCharityName
          restrictedCharityEin
          ytdAdvisorFees
          totalGrantsCount
          confirmAmaAccount
          custodialVerified
          custodialVerifiedAt
          disableAllocations
          accountNumber
        }
        advisorDaf {
          fundName
          isSingleCharityFund
          restrictedCharityId
          restrictedCharityName
          restrictedCharityEin
          custodian {
            name
          }
        }
      }
    }
  }
`;
export const DafClientsByEmailDocument = gql`
  query dafClientsByEmail(
    $pageSize: Int
    $page: Int
    $searchStr: String
    $filters: AdvisorDafClientsFilterType
  ) {
    dafClients(
      pageSize: $pageSize
      page: $page
      searchStr: $searchStr
      filters: $filters
    ) {
      count
      objects {
        id
        name
        hof {
          id
          firstName
          lastName
          phoneNumber
        }
      }
    }
  }
`;
export const CreateFamilyAndMembersDocument = gql`
  mutation createFamilyAndMembers(
    $client: ClientInputType!
    $members: [MemberInputType]
    $advisorDaf: AdvisorDafInputType!
  ) {
    createFamilyAndMembers(
      client: $client
      members: $members
      advisorDaf: $advisorDaf
    ) {
      status {
        success {
          statuses {
            object
            status
            message
            __typename
          }
          total
          __typename
        }
        fail {
          statuses {
            object
            status
            message
            __typename
          }
          total
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const AdvisorNewSummaryDocument = gql`
  query advisorNewSummary {
    advisorNewSummary {
      campaigns
      totalDafAum
      clientCount
      dafInvestmentPercent
      totalGifted
      ytdSubadvisoryFee
      ytdContribution
    }
  }
`;
export const AdvisorCampaignsDocument = gql`
  query advisorCampaigns(
    $pageSize: Int
    $page: Int
    $searchStr: String
    $filters: AdvisorDafClientsFilterType
  ) {
    newDafClients(
      pageSize: $pageSize
      page: $page
      searchStr: $searchStr
      filters: $filters
    ) {
      count
      page
      pages
      objects {
        id
        name
        hof {
          id
          name
          firstName
          lastName
        }
        campaigns {
          id
          title
          publicId
          startDate
          endDate
          state
          bannerImage
          charity {
            id
            title
          }
          goal
          achieved
          donation {
            id
            contributor
            email
            amount
            createdAt
            isExternal
            status
          }
        }
      }
    }
  }
`;
export const GetAdvisorCampaignsDocument = gql`
  query GetAdvisorCampaigns(
    $pageSize: Int
    $page: Int
    $filters: CampaignFilterInputType
  ) {
    campaignsByAdvisor(pageSize: $pageSize, page: $page, filters: $filters) {
      page
      pages
      count
      objects {
        id
        title
        goal
        achieved
        message
        state
        isActive
        startDate
        endDate
        campaignImage
        bannerImage
        charity {
          id
          title
        }
        publicId
        startedBy {
          id
          name
        }
        numberOfDonations(isExternal: true)
        donation(isExternal: true) {
          id
          amount
          contributor
          email
          createdAt
          status
          isExternal
        }
      }
    }
  }
`;
export const InvestmentChangeRequestsDocument = gql`
  query investmentChangeRequests($fundId: ID!, $page: Int, $pageSize: Int) {
    investmentChangeRequests(
      fundId: $fundId
      page: $page
      pageSize: $pageSize
    ) {
      page
      pages
      objects {
        id
        initiatedOn
        status
        targets
        type
      }
    }
  }
`;
export const CancelCashMovementDocument = gql`
  mutation cancelCashMovement($fundId: ID!, $cashMovementId: ID!) {
    cancelCashMovement(fundId: $fundId, cashMovementId: $cashMovementId) {
      ok
    }
  }
`;
export const CancelReallocationRebalanceDocument = gql`
  mutation cancelReallocationRebalance(
    $fundId: ID!
    $reallocationRebalanceId: ID!
  ) {
    cancelReallocationRebalance(
      fundId: $fundId
      reallocationRebalanceId: $reallocationRebalanceId
    ) {
      ok
    }
  }
`;
export const AdvisorWeeklySummaryDocument = gql`
  query advisorWeeklySummary {
    advisorWeeklySummary {
      contributions
      grants
      pendingContributions
      pendingGrants
      __typename
    }
  }
`;
export const AdvisorClientInsightsDocument = gql`
  query advisorClientInsights {
    advisorClientInsights
  }
`;
export const AdvisorClientTransactionsDocument = gql`
  query advisorClientTransactions(
    $page: Int
    $pageSize: Int
    $filters: TransactionFilterInputType
  ) {
    advisorClientTransactions(
      page: $page
      pageSize: $pageSize
      filters: $filters
    ) {
      page
      pages
      objects {
        transactionId
        amount
        contributor
        description
        status
        displayStatus
        initiatedOn
        lastUpdatedOn
        searchDescription
        source
        familyId
        userId
      }
    }
  }
`;
export const CustodianIntegrationsDocument = gql`
  query custodianIntegrations {
    integrations {
      id
      status
      custodian {
        id
        name
        __typename
      }
      docusignUrl
      connectedOn
      masterAccount
      totalAccounts
      lastSyncedAt
      __typename
    }
  }
`;
export const LinkedAccountsDocument = gql`
  query linkedAccounts($page: Int, $pageSize: Int, $search: String) {
    linkedAccounts(page: $page, pageSize: $pageSize, search: $search) {
      page
      pages
      totalCount
      objects {
        clientName
        custodianName
        accountId
        accountNumber
        assets
        costBasis
        unrealizedGain
        appreciatedSecuritiesCount
        hasGsOwners
      }
    }
  }
`;
export const ClientsWithThirdPartyDafDocument = gql`
  query clientsWithThirdPartyDaf($page: Int, $pageSize: Int, $search: String) {
    clientsWithThirdPartyDaf(
      page: $page
      pageSize: $pageSize
      search: $search
    ) {
      page
      pages
      totalCount
      objects {
        clientName
        custodianName
        accountId
        assets
      }
    }
  }
`;
export const GetTopRecommendationsDocument = gql`
  query getTopRecommendations {
    topRecommendations {
      topDafClients {
        clientName
        portfolioCode
        portfolioValue
        costBasis
        unrealizedGain
        appreciatedSecuritiesCount
        familyId
        hofUserId
      }
      topNewClients {
        accountNumber
        clientName
        portfolioCode
        portfolioValue
        costBasis
        unrealizedGain
        appreciatedSecuritiesCount
        familyId
        hofUserId
      }
    }
  }
`;
export const GetBunchingPlanDraftDocument = gql`
  query getBunchingPlanDraft($portfolioCode: String!) {
    bunchingPlanDraft(portfolioCode: $portfolioCode) {
      id
      status
      planData
      updatedAt
    }
  }
`;
export const GetBookLevelSettingsDocument = gql`
  query getBookLevelSettings {
    bookLevelSettings {
      id
      teError
      tickerLimit
      maxContribution
      coreUser {
        id
        email
        firstName
        lastName
      }
      createdAt
      updatedAt
    }
  }
`;
export const GetClientLevelSettingsDocument = gql`
  query GetClientLevelSettings($portfolioId: String!) {
    clientLevelSettings(portfolioId: $portfolioId) {
      id
      filingStatus
      agi
      restrictedSecurities
      adventIntegratedPortfolio {
        id
        portfolioCode
        accountName
      }
      teError
      donationLimit
      targetTaxSavings
      tickerLimit
      createdAt
      updatedAt
      taxProposalScenario
    }
  }
`;
export const SaveBookLevelSettingsDocument = gql`
  mutation SaveBookLevelSettings(
    $teError: Float
    $tickerLimit: Int
    $maxContribution: Float
  ) {
    saveBookLevelSettings(
      teError: $teError
      tickerLimit: $tickerLimit
      maxContribution: $maxContribution
    ) {
      bookLevelSettings {
        id
        teError
        tickerLimit
        maxContribution
        coreUser {
          id
          email
          firstName
          lastName
        }
        createdAt
        updatedAt
      }
    }
  }
`;
export const SaveClientLevelSettingsDocument = gql`
  mutation SaveClientLevelSettings(
    $adventIntegratedPortfolioId: String!
    $filingStatus: String
    $agi: Float
    $restrictedSecurities: [String]
    $teError: Float
    $donationLimit: Float
    $targetTaxSavings: Float
    $tickerLimit: Int
    $taxProposalScenario: String
  ) {
    saveClientLevelSettings(
      adventIntegratedPortfolioId: $adventIntegratedPortfolioId
      filingStatus: $filingStatus
      agi: $agi
      restrictedSecurities: $restrictedSecurities
      teError: $teError
      donationLimit: $donationLimit
      targetTaxSavings: $targetTaxSavings
      tickerLimit: $tickerLimit
      taxProposalScenario: $taxProposalScenario
    ) {
      clientLevelSettings {
        id
        filingStatus
        agi
        restrictedSecurities
        adventIntegratedPortfolio {
          id
          portfolioCode
          accountName
        }
        teError
        donationLimit
        targetTaxSavings
        tickerLimit
        taxProposalScenario
        createdAt
        updatedAt
      }
    }
  }
`;
export const FamiliesWithPortfolioMappingsDocument = gql`
  query familiesWithPortfolioMappings($pageSize: Int, $page: Int) {
    familiesWithPortfolioMappings(pageSize: $pageSize, page: $page) {
      objects {
        id
        name
        portfolioMappings {
          portfolioCode
          accountName
          totalBalance
          createdAt
          custodianId
          masterAccountNumber
          accountType
          taxStatus
        }
      }
      page
      pages
    }
  }
`;
export const SearchAdvisorFamilyUsersDocument = gql`
  query searchAdvisorFamilyUsers(
    $advisorId: Int
    $searchStr: String
    $pageSize: Int
    $page: Int
  ) {
    searchAdvisorFamilyUsers(
      advisorId: $advisorId
      searchStr: $searchStr
      pageSize: $pageSize
      page: $page
    ) {
      page
      pages
      totalCount
      objects {
        id
        firstName
        lastName
        email
        roles
        isActive
      }
    }
  }
`;
export const RemoveUserPortfolioMappingDocument = gql`
  mutation removeUserPortfolioMapping($userId: ID!, $portfolioCode: String!) {
    removeUserPortfolioMapping(userId: $userId, portfolioCode: $portfolioCode) {
      success
      message
    }
  }
`;
export const AdvisorGroupsDocument = gql`
  query advisorGroups(
    $page: Int
    $pageSize: Int
    $searchString: String
    $excludeIds: [Int]
  ) {
    advisorGroups(
      page: $page
      pageSize: $pageSize
      searchString: $searchString
      excludeIds: $excludeIds
    ) {
      page
      pages
      totalCount
      objects {
        id
        name
        externalId
        groupType
        familyCount
        advisors {
          id
          name
          firstName
          lastName
          email
        }
      }
    }
  }
`;
export const ListFirmAdvisorsDocument = gql`
  query listFirmAdvisors(
    $firmId: Int!
    $page: Int
    $pageSize: Int
    $searchText: String
    $excludeIds: [Int]
    $userId: Int
    $isForAddClient: Boolean
  ) {
    listFirmAdvisors(
      firmId: $firmId
      page: $page
      pageSize: $pageSize
      searchText: $searchText
      excludeIds: $excludeIds
      userId: $userId
      isForAddClient: $isForAddClient
    ) {
      page
      pages
      objects {
        id
        name
        email
        aum
        clientsManaged
        clientsSupported
        dafsCount
        profileUrl
        tncAcceptedTime
        ytd
      }
    }
  }
`;
export const AdvisorGroupDocument = gql`
  query advisorGroup($groupId: Int!) {
    advisorGroup(groupId: $groupId) {
      id
      name
      externalId
      groupType
      advisors {
        id
        name
        firstName
        lastName
        email
      }
    }
  }
`;
export const ListAdvisorGroupClientsDocument = gql`
  query listAdvisorGroupClients(
    $groupId: Int!
    $page: Int
    $pageSize: Int
    $searchText: String
  ) {
    listAdvisorGroupClients(
      groupId: $groupId
      page: $page
      pageSize: $pageSize
      searchText: $searchText
    ) {
      page
      pages
      objects {
        id
        name
        primaryAdvisor
        fundName
        aum
        subAdvisorFee
        ytd
      }
    }
  }
`;
export const FundSearchDocument = gql`
  query fundSearch(
    $familyId: Int!
    $genSearchStr: String
    $filterKeys: [FilterKeyType]
    $categoryIds: [String!]
    $pageSize: Int
    $page: Int
  ) {
    fundSearch(
      familyId: $familyId
      genSearchStr: $genSearchStr
      filterKeys: $filterKeys
      categoryIds: $categoryIds
      pageSize: $pageSize
      page: $page
    ) {
      objects
      page
      pages
    }
  }
`;
export const CampaignsDocument = gql`
  query campaigns(
    $familyId: Int!
    $pageSize: Int!
    $page: Int!
    $filters: CampaignFilterInputType
  ) {
    campaigns(
      familyId: $familyId
      pageSize: $pageSize
      page: $page
      filters: $filters
    ) {
      page
      pages
      count
      objects {
        id
        title
        publicId
        startDate
        endDate
        state
        campaignType
        templateData
        bannerImage
        charity {
          id
          title
        }
        goal
        achieved
        __typename
      }
      __typename
    }
  }
`;
export const PublicCampaignDocument = gql`
  query publicCampaign($campaignId: String!) {
    publicCampaign(campaignId: $campaignId) {
      id
      goal
      message
      achieved
      title
      startDate
      endDate
      charity {
        id
        title
        fundUrl
        mission
        mediumImg
        isBlacklisted
        ein
        address
        status
        __typename
      }
      campaignImage
      bannerImage
      thirdImage
      publicId
      startedBy {
        id
        name
        firm {
          id
          firmName
          logoUrl
          primaryColor
          secondaryColor
        }
      }
      startedByFirstName
      endOnFinalDay
      endIfGoalCompleted
      state
      campaignType
      templateData
    }
  }
`;
export const FetchGuestPublicCampaignDetailsDocument = gql`
  query fetchGuestPublicCampaignDetails($campaignId: String!) {
    publicCampaign(campaignId: $campaignId) {
      id
      goal
      message
      achieved
      title
      startDate
      endDate
      charity {
        id
        title
        fundUrl
        mission
        mediumImg
        isBlacklisted
        ein
        address
        status
        __typename
      }
      campaignImage
      bannerImage
      thirdImage
      publicId
      startedBy {
        id
        name
        firm {
          id
          firmName
          logoUrl
          primaryColor
          secondaryColor
        }
      }
      startedByFirstName
      state
      campaignType
      templateData
    }
  }
`;
export const ListCampaignDonationsDocument = gql`
  query listCampaignDonations($campaignId: Int!, $page: Int, $pageSize: Int) {
    campaignDonations(
      campaignId: $campaignId
      page: $page
      pageSize: $pageSize
    ) {
      page
      pages
      objects {
        contributor
        status
        amount
        createdAt
        email
        note
      }
    }
  }
`;
export const CampaignDashboardMetricsDocument = gql`
  query campaignDashboardMetrics($familyId: Int!) {
    campaignDashboardMetrics(familyId: $familyId) {
      activeCampaigns
      pendingCampaigns
      completedCampaigns
      totalDonations
      totalDonors
      __typename
    }
  }
`;
export const GetPublicCampaignDonationsDocument = gql`
  query GetPublicCampaignDonations(
    $campaignId: Int!
    $pageSize: Int
    $page: Int
  ) {
    publicCampaignDonations(
      campaignId: $campaignId
      pageSize: $pageSize
      page: $page
    ) {
      page
      pages
      objects {
        contributor
        status
        amount
        createdAt
        email
        note
      }
    }
  }
`;
export const CampaignDraftsDocument = gql`
  query campaignDrafts($familyId: Int!) {
    campaignDrafts(familyId: $familyId) {
      id
      campaignType
      formData
      bannerImage
      campaignImage
      updatedAt
      __typename
    }
  }
`;
export const CampaignStatsDocument = gql`
  query campaignStats($campaignId: String!) {
    campaignStats(campaignId: $campaignId) {
      totalRaised
      raisedThisWeek
      contributors
      newContributorsThisWeek
      goal
      goalProgressPercent
      amountRemaining
    }
  }
`;
export const CampaignTemplateSettingsDocument = gql`
  query campaignTemplateSettings {
    campaignTemplateSettings {
      milestoneAutoCloseDays
      milestoneEventTypes
      consentWindowDays
    }
  }
`;
export const CausesDocument = gql`
  query causes($familyId: Int!) {
    causes(familyId: $familyId) {
      id
      images
      key
      value
    }
  }
`;
export const GetRestrictedCharitiesDocument = gql`
  query getRestrictedCharities($familyId: Int!) {
    getRestrictedCharities(familyId: $familyId) {
      ein
      charities
    }
  }
`;
export const CharityMatchesDocument = gql`
  query charityMatches($searchString: String!) {
    charityMatches(searchString: $searchString) {
      id
      title
      ein
      status
    }
  }
`;
export const CreateLinkTokenDocument = gql`
  query createLinkToken($familyId: Int!, $itemId: Int) {
    createLinkToken(familyId: $familyId, itemId: $itemId) {
      linkToken
      expiration
    }
  }
`;
export const ConnectAchAccountsDocument = gql`
  mutation connectAchAccounts(
    $familyId: Int!
    $publicToken: String!
    $institutionId: String!
  ) {
    connectAchAccounts(
      familyId: $familyId
      publicToken: $publicToken
      institutionId: $institutionId
    ) {
      ok
      plaidItem {
        id
        institutionId
        institutionName
        itemAccounts {
          id
          accountId
          accountName
          default
          mask
          institutionName
          balance
          verificationStatus
        }
      }
    }
  }
`;
export const FetchPlaidItemsDocument = gql`
  query fetchPlaidItems($familyId: Int!) {
    plaidItems(familyId: $familyId) {
      id
      institutionId
      institutionName
      itemAccounts {
        id
        accountId
        accountName
        default
        mask
        institutionName
        balance
        verificationStatus
      }
    }
  }
`;
export const DisconnectSavingsAccountDocument = gql`
  mutation disconnectSavingsAccount($plaidItemId: Int!) {
    disconnectSavingsAccount(plaidItemId: $plaidItemId) {
      ok
    }
  }
`;
export const SetDefaultBankAccountDocument = gql`
  mutation setDefaultBankAccount($itemAccountId: String!) {
    setDefaultBankAccount(itemAccountId: $itemAccountId) {
      ok
    }
  }
`;
export const RemoveBankAccountDocument = gql`
  mutation removeBankAccount($itemAccountId: String!) {
    removeBankAccount(itemAccountId: $itemAccountId) {
      ok
    }
  }
`;
export const GetConnectedBankAccountsDocument = gql`
  query getConnectedBankAccounts($plaidItemId: Int!) {
    connectedBankAccounts(plaidItemId: $plaidItemId) {
      id
      accountId
      accountName
      default
      mask
      institutionName
      balance
      verificationStatus
      plaidItem {
        id
      }
    }
  }
`;
export const CreateAmicusContributionDocument = gql`
  mutation createAmicusContribution(
    $familyId: Int!
    $itemAccountId: Int!
    $amount: Decimal!
    $contributionDate: DateTime!
    $contributionEndDate: DateTime
    $frequency: ContributionFrequencyChoices!
  ) {
    createAmicusContribution(
      familyId: $familyId
      itemAccountId: $itemAccountId
      amount: $amount
      contributionDate: $contributionDate
      contributionEndDate: $contributionEndDate
      frequency: $frequency
    ) {
      ok
    }
  }
`;
export const ValidateZipCodeDocument = gql`
  query validateZipCode($zipCode: String!) {
    validateZipCode(zipCode: $zipCode) {
      zipCode
      stateCode
      stateName
      city
    }
  }
`;
export const ListCompanyGrantsDocument = gql`
  query listCompanyGrants(
    $pageSize: Int!
    $page: Int!
    $status: CompanyGrantStatusChoices
    $familyId: Int
    $year: Int
    $sorters: Sorter
    $charityIds: [String]
  ) {
    listCompanyGrants(
      pageSize: $pageSize
      page: $page
      status: $status
      familyId: $familyId
      year: $year
      sorters: $sorters
      charityIds: $charityIds
    ) {
      page
      pages
      count
      objects {
        id
        charityId
        amount
        charity {
          id
          name
          isBlacklisted
          address
          ein
        }
        grantor
        frequency
        note
        startDate
        newStartDate
        endDate
        endorsedBy {
          id
          name
        }
        endorsedAt
        createdBy {
          id
          name
        }
        createdAt
        status
        anonymous
        contributions {
          id
        }
        recurringGifts {
          id
        }
      }
    }
  }
`;
export const CorporateUserSummaryDocument = gql`
  query corporateUserSummary($firmId: Int!) {
    corporateUserSummary(firmId: $firmId) {
      companySummary {
        unallocatedCount
        acceptedCount
        pendingCount
        inactiveCount
        ineligibleCount
        reservedCredits
        companyGiftsUnderApproval
      }
      participantSummary {
        pendingCount
        activeCount
        dafsOpenedCount
        dafsFundedCount
      }
    }
  }
`;
export const ListFirmTagCategoriesDocument = gql`
  query listFirmTagCategories($tagCategoryId: Int) {
    listFirmTagCategories(tagCategoryId: $tagCategoryId) {
      id
      category
      tags {
        id
        tag
        __typename
      }
      __typename
    }
  }
`;
export const GetEmployeeDetailsDocument = gql`
  query getEmployeeDetails($employeeId: Int!) {
    getEmployeeDetails(employeeId: $employeeId) {
      id
      name
      email
      yearlyFamilyUserGroupData {
        allocatedAmount
        contributedAmount
        __typename
      }
      __typename
    }
  }
`;
export const ListEmployeesDocument = gql`
  query listEmployees(
    $pageSize: Int!
    $page: Int!
    $status: EmployeeTypeEnum
    $tagIds: [Int]
    $searchString: String
    $sortOrder: SortOrderEnum
    $sortingKey: EmployeeSortingKeysEnum
    $categoryIds: [Int]
    $userType: [CorporateDafUserTypeFilterType]
    $statusList: [EmployeeTypeEnum]
  ) {
    listEmployees(
      pageSize: $pageSize
      page: $page
      status: $status
      tagIds: $tagIds
      searchString: $searchString
      sortOrder: $sortOrder
      sortingKey: $sortingKey
      categoryIds: $categoryIds
      userType: $userType
      statusList: $statusList
    ) {
      page
      pages
      count
      objects {
        id
        name
        firstName
        lastName
        createdAt
        email
        roles
        address
        inviteStatus
        isActive
        inviteSent
        corporateBenefit
        userTags {
          id
          tagCategory {
            id
            category
            tags {
              id
              tag
              __typename
            }
            __typename
          }
          tag {
            id
            tag
            __typename
          }
          __typename
        }
        yearlyUserData {
          allocatedAmount
          contributedAmount
          __typename
        }
        yearlyFamilyUserGroupData {
          allocatedAmount
          contributedAmount
          __typename
        }
        employeeStatus
        __typename
      }
      __typename
    }
  }
`;
export const ListParticipantsDocument = gql`
  query listParticipants(
    $pageSize: Int!
    $page: Int!
    $searchString: String
    $sortOrder: SortOrderEnum
    $sortingKey: EmployeeSortingKeysEnum
    $statusList: [IndividualDafStatusFilterType]
  ) {
    listParticipants(
      pageSize: $pageSize
      page: $page
      searchString: $searchString
      sortOrder: $sortOrder
      sortingKey: $sortingKey
      statusList: $statusList
    ) {
      page
      pages
      count
      objects {
        id
        name
        firstName
        lastName
        createdAt
        email
        roles
        address
        inviteStatus
        isActive
        inviteSent
        corporateBenefit
        userTags {
          id
          tagCategory {
            id
            category
            tags {
              id
              tag
              __typename
            }
            __typename
          }
          tag {
            id
            tag
            __typename
          }
          __typename
        }
        yearlyUserData {
          allocatedAmount
          contributedAmount
          __typename
        }
        yearlyFamilyUserGroupData {
          allocatedAmount
          contributedAmount
          __typename
        }
        employeeDafDetails {
          dafOpenedDate
          dafFundedDate
        }
        employeeStatus
        __typename
      }
      __typename
    }
  }
`;
export const GetCorporateDafFiltersDocument = gql`
  query getCorporateDafFilters {
    getCorporateDafFilters {
      companyDafFilters {
        type
        options {
          id
          title
          isSubType
          subTypeTitle
          subTypeOptions {
            id
            title
          }
        }
      }
      individualDafFilters {
        type
        options {
          id
          title
          isSubType
          subTypeTitle
          subTypeOptions {
            id
            title
          }
        }
      }
    }
  }
`;
export const FeaturedCharitiesDocument = gql`
  query featuredCharities($firmId: Int!) {
    featuredCharities(firmId: $firmId) {
      id
      ein
      mission
      title
      mediumImg
    }
  }
`;
export const GetAssociatedFamiliesDocument = gql`
  query getAssociatedFamilies($pageSize: Int, $page: Int, $searchStr: String) {
    associatedFamilies(
      pageSize: $pageSize
      page: $page
      searchStr: $searchStr
    ) {
      page
      pages
      objects {
        id
        name
        louiseDaf {
          fundName
          custodian
          isSingleCharityFund
          pendingContributions
          accumulatedYearlyGrants
          pendingYearlyGrants
          accumulatedContributions
          accumulatedYearlyContributions
        }
        advisorDaf {
          fundName
          isSingleCharityFund
        }
      }
    }
  }
`;
export const FirmDocument = gql`
  query firm($firmId: Int!) {
    firm(firmId: $firmId) {
      id
      firmName
      logoUrl
      metaData
      address
      phoneNumber
      website
      members
      primaryColor
      secondaryColor
      isSetupDone
      metaData
      parentFirm {
        id
        firmName
        metaData
        primaryColor
        secondaryColor
        logoUrl
      }
      isEnterprise
      companyDafLaunchDate
      individualDafLaunchDate
      taxId
      firmSummary {
        totalUsers
        totalClients
        totalDafs
        totalAum
        ytdFees
        totalAdvisors
        totalFirms
      }
      __typename
    }
  }
`;
export const ListRiaClientsDocument = gql`
  query listRiaClients(
    $firmId: Int!
    $pageSize: Int
    $page: Int!
    $searchText: String
    $isDafExists: Boolean
  ) {
    listRiaClients(
      firmId: $firmId
      pageSize: $pageSize
      page: $page
      searchText: $searchText
      isDafExists: $isDafExists
    ) {
      page
      pages
      objects {
        dafId
        dafName
        clientName
        clientId
        userId
        advisorId
        advisorName
        aum
        ytdAdminFees
        subAdvisorFee
        employeeCount
        isDafCreated
        tncAcceptedTime
        companyAdmins {
          id
          name
          email
          phoneNumber
          lastLogin
          inviteStatus
        }
        familyMembers {
          userId
          name
          email
          tncAcceptedTime
        }
        secondaryHohs {
          userId
          name
          email
          tncAcceptedTime
        }
        advisorGroup {
          id
          name
          externalId
        }
        __typename
      }
      __typename
    }
  }
`;
export const ListFirmUsersDocument = gql`
  query listFirmUsers(
    $firmId: Int!
    $pageSize: Int
    $page: Int!
    $searchText: String
    $inviteStatus: [String!]
  ) {
    listFirmUsers(
      firmId: $firmId
      pageSize: $pageSize
      page: $page
      searchText: $searchText
      inviteStatus: $inviteStatus
    ) {
      page
      pages
      objects {
        elevateUserRef
        id
        name
        email
        dafsCount
        clientsManaged
        clientsSupported
        aum
        ytd
        tncAcceptedTime
        role
        __typename
      }
      __typename
    }
  }
`;
export const SearchFirmAdvisorsDocument = gql`
  query searchFirmAdvisors(
    $firmId: Int!
    $searchText: String
    $pageSize: Int
    $page: Int
  ) {
    searchFirmAdvisors(
      firmId: $firmId
      searchText: $searchText
      pageSize: $pageSize
      page: $page
    ) {
      pages
      page
      objects {
        userId
        userName
        userEmail
        userGroupId
        userGroupName
      }
      __typename
    }
  }
`;
export const GetPoolSetRecommendationsDocument = gql`
  query getPoolSetRecommendations($custodianIds: [Int!]!) {
    getPoolSetRecommendations(custodianIds: $custodianIds) {
      custodianName
      pooledSets {
        pooledSetName
        pooledSetId
        isSmaPooledSets
        pooledSetPools {
          pooledAssetName
        }
      }
    }
  }
`;
export const GetFirmPoolsetsDocument = gql`
  query getFirmPoolsets($firmId: String!) {
    getFirmPoolsets(firmId: $firmId) {
      id
      custodianName
      isSmaPooledSets
      name
      pools {
        pooledAssetName
      }
    }
  }
`;
export const GetCustomFeesDocument = gql`
  query getCustomFees($firmId: String) {
    getCustomFees(firmId: $firmId) {
      enableFee
      enableFeeTier
      feeTier
      feeCoefficient
      lockAdvisorFeeTier
      advisorFeeTier
      enableAdvisorFeeTier
      __typename
    }
  }
`;
export const ListIndividualClientsDocument = gql`
  query listIndividualClients(
    $firmId: Int!
    $pageSize: Int
    $page: Int!
    $searchText: String
    $isDafExists: Boolean
  ) {
    listIndividualClients(
      firmId: $firmId
      pageSize: $pageSize
      page: $page
      searchText: $searchText
      isDafExists: $isDafExists
    ) {
      page
      pages
      objects {
        dafName
        email
        isDafCreated
        clientName
        userId
        clientId
        aum
        ytdAdminFees
        subAdvisorFee
        __typename
      }
      __typename
    }
  }
`;
export const ListFirmAdminsDocument = gql`
  query listFirmAdmins($firmId: Int!) {
    listFirmAdmins(firmId: $firmId) {
      id
      email
      name
      isStaff
      yearlyUserData {
        allocatedAmount
        contributedAmount
        year
        __typename
      }
      roles
      dob
      address
      phoneNumber
      relationship
      profilepicUrl
      emailPrefDafContribution
      emailPrefGifts
      tncAcceptedTime
      lastLogin
      family {
        id
        alignStatus
        mission
        name
        engageFamily
        isFunded
        advisor {
          name
          email
          __typename
        }
        louiseDaf {
          fundName
          __typename
        }
        hof {
          name
          email
          inviteStatus
          __typename
        }
        __typename
      }
      firm {
        id
        firmName
        logo
        logoUrl
        address
        phoneNumber
        website
        __typename
      }
      __typename
    }
  }
`;
export const FirmDocumentsDocument = gql`
  query firmDocuments($firmId: Int!) {
    firmDocuments(firmId: $firmId) {
      id
      documentType
      documentUrl
      source
      originalFilename
      uploadedAt
      updatedAt
    }
  }
`;
export const ContributorsDocument = gql`
  query contributors($familyId: Int!) {
    contributors(familyId: $familyId) {
      name
      isHoh
      isSelfDirected
      isCorporateAdmin
    }
  }
`;
export const SearchTickersDocument = gql`
  query searchTickers($searchString: String!) {
    searchTickers(searchString: $searchString) {
      name
      ticker
      tickerType
      __typename
    }
  }
`;
export const ValidateUploadedTickersDocument = gql`
  query validateUploadedTickers($tickerList: [String!]!) {
    validateTickerList(tickerList: $tickerList) {
      ticker
      tickerName
      isValid
      validationError
    }
  }
`;
export const ListMinimumGrantsContributionsDocument = gql`
  query listMinimumGrantsContributions($familyId: Int!) {
    listMinimumGrantsContributions(familyId: $familyId)
  }
`;
export const DafPoolsDocument = gql`
  query dafPools($dafRef: String!) {
    dafPools(dafRef: $dafRef) {
      id
      title
      approved
      assetId
      riskScore
      volatility
      returns
      assets {
        id
        ticker
        tickerName
        category
        Type
        Class
        weight
        __typename
      }
      __typename
    }
  }
`;
export const AlignDocument = gql`
  query align($familyId: Int!) {
    align(familyId: $familyId) {
      currentPortfolio {
        poolId
        poolName
        poolType
        poolValue
        poolWeight
      }
      targetPortfolio
      selectedCores {
        assetId
        assetName
        poolType
      }
      lastSubmitted
      cashModel {
        assetId
        assetName
        poolType
      }
    }
  }
`;
export const SubmitTargetRatioDocument = gql`
  mutation submitTargetRatio(
    $familyId: Int!
    $allocations: [AllocationType]!
    $returns: Float
    $riskScore: Int
    $volatility: Float
  ) {
    submitTargetRatio(
      familyId: $familyId
      allocations: $allocations
      returns: $returns
      riskScore: $riskScore
      volatility: $volatility
    ) {
      ok
    }
  }
`;
export const UpdateAdvisorFeesDocument = gql`
  mutation updateAdvisorFees($bps: Int!, $familyId: Int!) {
    updateAdvisorFees(familyId: $familyId, bps: $bps) {
      ok
    }
  }
`;
export const CreateCashMovementDocument = gql`
  mutation createCashMovement(
    $fundId: ID!
    $requestValue: Float!
    $fromPool: ID!
    $toPool: ID!
  ) {
    createCashMovement(
      fundId: $fundId
      requestValue: $requestValue
      fromPool: $fromPool
      toPool: $toPool
    ) {
      id
      ok
      fundId
      requestValue
      fromPool
      toPool
      advisorId
      dateRequested
    }
  }
`;
export const GetFundReallocationRebalanceRequestsDocument = gql`
  query getFundReallocationRebalanceRequests(
    $fundId: ID!
    $pageSize: Int
    $page: Int
  ) {
    getFundReallocationRebalanceRequests(
      fundId: $fundId
      pageSize: $pageSize
      page: $page
    ) {
      page
      pages
      objects {
        id
        daf
        dateRequested
        targets {
          assetId
          targetRatio
          targetValue
        }
        name
        status
      }
    }
  }
`;
export const LegacyDocumentsDocument = gql`
  query legacyDocuments($familyId: Int!) {
    legacyDocuments(familyId: $familyId) {
      id
      documentType
      visibility
      status
      originalFilename
      uploadedAt
      updatedAt
      documentUrl
    }
  }
`;
export const LivingLegacyPlansDocument = gql`
  query livingLegacyPlans {
    livingLegacyPlans {
      id
      familyId
      name
      founderName
      successorCount
      documentCount
      totalValue
      progress
      status
      myFamilyCompleted
      legacyPlanDefined
      impactVelocityDefined
      transitionState
      lastActivity
    }
  }
`;
export const LivingLegacyPlanDocument = gql`
  query livingLegacyPlan($familyId: Int!) {
    livingLegacyPlan(familyId: $familyId) {
      id
      familyId
      name
      founderName
      successorCount
      documentCount
      totalValue
      progress
      status
      myFamilyCompleted
      legacyPlanDefined
      impactVelocityDefined
      transitionState
      lastActivity
    }
  }
`;
export const LivingLegacyKpisDocument = gql`
  query livingLegacyKpis {
    livingLegacyKpis {
      successors
      allDafs
      legacyPlanDefined
      inTransition
      transitionCompleted
    }
  }
`;
export const SuccessionPolicyDocument = gql`
  query successionPolicy($familyId: Int!) {
    successionPolicy(familyId: $familyId) {
      id
      policyMode
      annualPayoutTarget
      sunsetTimeframeYears
      currentBalance
      accountAgeYears
      isConfigured
    }
  }
`;
export const LegacyBlueprintDocument = gql`
  query legacyBlueprint($familyId: Int!) {
    legacyBlueprint(familyId: $familyId) {
      id
      motivation
      motivationTags
      personalConnection
      coreValues
      geographicFocus
      focusAreas {
        id
        label
        weight
      }
      impactGoals {
        id
        label
        causeArea
        metricType
        targetValue
        period
        currentValue
        status
        order
      }
    }
  }
`;
export const FamilyCharityCausesDocument = gql`
  query familyCharityCauses($familyId: Int!) {
    familyCharityCauses(familyId: $familyId)
  }
`;
export const FamilyGivingGoalDocument = gql`
  query familyGivingGoal($familyId: Int!) {
    family(familyId: $familyId) {
      id
      annualGivingGoal
      annualGivingGoalAchieved
    }
  }
`;
export const SunsetCharityAllocationsDocument = gql`
  query sunsetCharityAllocations($familyId: Int!) {
    sunsetCharityAllocations(familyId: $familyId) {
      id
      charityId
      charityName
      percentage
      source
    }
  }
`;
export const FamilyFoundersMessageDocument = gql`
  query familyFoundersMessage($familyId: Int!) {
    family(familyId: $familyId) {
      id
      foundersMessage
    }
  }
`;
export const FamilyMissionDocument = gql`
  query familyMission($familyId: Int!) {
    family(familyId: $familyId) {
      id
      mission
    }
  }
`;
export const TransitionActiveCampaignsDocument = gql`
  query transitionActiveCampaigns(
    $familyId: Int!
    $pageSize: Int!
    $page: Int!
    $filters: CampaignFilterInputType
  ) {
    campaigns(
      familyId: $familyId
      pageSize: $pageSize
      page: $page
      filters: $filters
    ) {
      count
      objects {
        id
        title
        state
        unreconciledExternalCount
      }
    }
  }
`;
export const TransitionActiveItemsDocument = gql`
  query transitionActiveItems($familyId: Int!) {
    transitionActiveItems(familyId: $familyId) {
      count
      grantsCount
      contributionsCount
      grantsProcessingCount
      contributionsProcessingCount
      hasGrants
      hasContributions
      hasCampaigns
      objects {
        id
        sourceType
        charityName
        amount
        frequency
        status
      }
    }
  }
`;
export const SuccessionTransitionDocument = gql`
  query successionTransition($familyId: Int!) {
    successionTransition(familyId: $familyId) {
      id
      triggerType
      voluntaryMode
      status
      currentStep
      initiatedAt
      completedAt
      scheduledDate
      cancelledInviteCount
      step1CompletedAt
      step2CompletedAt
      step3CompletedAt
      step4CompletedAt
      step5CompletedAt
      step4NotifiedAt
      hasOpenContributions
      frozenBalance
      dafFreezeInitiatedAt
      dafFreezeConfirmedAt
      freezeConfirmationSentAt
      family {
        hof {
          firstName
          lastName
        }
      }
    }
  }
`;
export const TransitionHistoryDocument = gql`
  query transitionHistory($familyId: Int!) {
    transitionHistory(familyId: $familyId) {
      family {
        hof {
          firstName
          lastName
        }
      }
      id
      triggerType
      voluntaryMode
      status
      scheduledDate
      initiatedAt
      completedAt
      cancelledInviteCount
      step1CompletedAt
      step2CompletedAt
      step3CompletedAt
      step4CompletedAt
      step5CompletedAt
      frozenBalance
      dafFreezeInitiatedAt
      dafFreezeConfirmedAt
      freezeConfirmationSentAt
    }
  }
`;
export const PendingDeathTransitionsDocument = gql`
  query pendingDeathTransitions {
    pendingDeathTransitions {
      id
      triggerType
      status
      initiatedAt
      deathCertUrl
      family {
        id
        name
        louiseDaf {
          fundName
        }
      }
      initiatedBy {
        id
        firstName
        lastName
        email
      }
    }
  }
`;
export const ApproveDeathTransitionDocument = gql`
  mutation ApproveDeathTransition($familyId: Int!, $reviewNotes: String) {
    approveDeathTransition(familyId: $familyId, reviewNotes: $reviewNotes) {
      ok
    }
  }
`;
export const RejectDeathTransitionDocument = gql`
  mutation RejectDeathTransition($familyId: Int!, $reason: String!) {
    rejectDeathTransition(familyId: $familyId, reason: $reason) {
      ok
    }
  }
`;
export const UpdateScheduledTransitionDateDocument = gql`
  mutation UpdateScheduledTransitionDate(
    $familyId: Int!
    $scheduledDate: String!
  ) {
    updateScheduledTransitionDate(
      familyId: $familyId
      scheduledDate: $scheduledDate
    ) {
      ok
    }
  }
`;
export const TriggerSuccessionTransferNotificationDocument = gql`
  mutation TriggerSuccessionTransferNotification($familyId: Int!) {
    triggerSuccessionTransferNotification(familyId: $familyId) {
      ok
      transferCount
      message
      notifiedAt
      previouslyNotifiedAt
    }
  }
`;
export const SendSuccessionInvitesDocument = gql`
  mutation SendSuccessionInvites($familyId: Int!) {
    sendSuccessionInvites(familyId: $familyId) {
      ok
      invitesSent
      message
    }
  }
`;
export const NudgeSuccessorInviteDocument = gql`
  mutation NudgeSuccessorInvite($successorId: Int!) {
    nudgeSuccessorInvite(successorId: $successorId) {
      ok
      message
      lastNudgedAt
    }
  }
`;
export const FinalizeSuccessionTransitionDocument = gql`
  mutation FinalizeSuccessionTransition($familyId: Int!) {
    finalizeSuccessionTransition(familyId: $familyId) {
      ok
      grantsCreated
      message
    }
  }
`;
export const SuccessionReconciliationsDocument = gql`
  query SuccessionReconciliations {
    successionReconciliations {
      successorId
      successorName
      familyId
      familyName
      destinationFundName
      percentage
      frozenBalance
      expectedAmount
      receivedAmount
      variance
      contributionCount
      isReconciled
      reason
      needsReview
      varianceConfirmedAt
      varianceConfirmedBy
      freezeInitiatedAt
    }
  }
`;
export const OpsActivityDocument = gql`
  query OpsActivity($familyId: Int, $limit: Int) {
    opsActivity(familyId: $familyId, limit: $limit) {
      id
      action
      actionLabel
      actorName
      familyId
      familyName
      fundName
      transitionId
      step
      succeeded
      summary
      createdAt
    }
  }
`;
export const OpsTransitionDocument = gql`
  query OpsTransition($familyId: Int!) {
    opsTransition(familyId: $familyId) {
      transitionId
      familyId
      familyName
      fundName
      advisorName
      firmName
      initiatedByName
      hofName
      triggerType
      voluntaryMode
      status
      currentStep
      frozenBalance
      initiatedAt
      scheduledDate
      completedAt
      step1CompletedAt
      step2CompletedAt
      step3CompletedAt
      step4CompletedAt
      step5CompletedAt
      stepCompletedAt
      daysOnStep
      successorCount
      beneficiaryCount
      awaitingAction
      blockedReason
      blockedCheckedAt
    }
  }
`;
export const AdvanceSuccessionStepDocument = gql`
  mutation AdvanceSuccessionStep($familyId: Int!, $expectedStep: Int) {
    advanceSuccessionStep(familyId: $familyId, expectedStep: $expectedStep) {
      ok
      advanced
      step
      currentStep
      status
      reason
      message
    }
  }
`;
export const OpsTransitionsDocument = gql`
  query OpsTransitions($includeCompleted: Boolean) {
    opsTransitions(includeCompleted: $includeCompleted) {
      transitionId
      familyId
      familyName
      fundName
      advisorName
      firmName
      triggerType
      voluntaryMode
      status
      currentStep
      frozenBalance
      initiatedAt
      scheduledDate
      stepCompletedAt
      daysOnStep
      successorCount
      beneficiaryCount
      awaitingAction
      blockedReason
      blockedCheckedAt
    }
  }
`;
export const SuccessionTransfersDocument = gql`
  query SuccessionTransfers($familyId: Int!) {
    successionTransfers(familyId: $familyId) {
      successorId
      successorName
      destinationFundName
      percentage
      expectedAmount
      receivedAmount
      initiatedAt
      completedAt
      isReconciled
      reason
    }
  }
`;
export const ConfirmTransferVarianceDocument = gql`
  mutation ConfirmTransferVariance($successorId: Int!, $notes: String) {
    confirmTransferVariance(successorId: $successorId, notes: $notes) {
      ok
      message
    }
  }
`;
export const CloseEmptyTransitionDocument = gql`
  mutation CloseEmptyTransition($familyId: Int!) {
    closeEmptyTransition(familyId: $familyId) {
      ok
      message
    }
  }
`;
export const LivingLegacyTransitionAlertsDocument = gql`
  query LivingLegacyTransitionAlerts {
    livingLegacyTransitionAlerts {
      familyId
      familyName
      fundName
      alertType
      severity
      title
      detail
      currentStep
      scheduledDate
      daysUntil
      initiatedAt
    }
  }
`;
export const FamilyFreezeFlagsDocument = gql`
  query familyFreezeFlags($familyId: Int!) {
    family(familyId: $familyId) {
      id
      isDafFrozen
      isSuccessorFund
      successionSourceDonorName
    }
  }
`;
export const GetOverviewStatsDocument = gql`
  query getOverviewStats(
    $firmId: Int
    $programFilter: String
    $startDate: String
    $endDate: String
  ) {
    getOverviewStats(
      firmId: $firmId
      programFilter: $programFilter
      startDate: $startDate
      endDate: $endDate
    ) {
      corporateClients
      aum
      dafsOpened
      dafsFunded
      totalContributions
      totalGrants
      firmName
      launchDate
    }
  }
`;
export const GetProgramAumStatsDocument = gql`
  query getProgramAUMStats(
    $frequency: String!
    $familyId: Int
    $firmId: Int
    $programFilter: String
    $startDate: String
    $endDate: String
  ) {
    getProgramAUMStats(
      frequency: $frequency
      familyId: $familyId
      firmId: $firmId
      programFilter: $programFilter
      startDate: $startDate
      endDate: $endDate
    ) {
      aumStats {
        period
        year
        openingAumFundAsset
        closingAumFundAsset
        contributions
        grants
      }
    }
  }
`;
export const GetDistributionStatsDocument = gql`
  query getDistributionStats(
    $frequency: String!
    $firmId: Int
    $programFilter: String
    $startDate: String
    $endDate: String
  ) {
    getDistributionStats(
      frequency: $frequency
      firmId: $firmId
      programFilter: $programFilter
      startDate: $startDate
      endDate: $endDate
    ) {
      distributionStats {
        period
        year
        distribution {
          segmentName
          segmentKey
          count
          startDate
          endDate
        }
      }
    }
  }
`;
export const GetDistributionListDocument = gql`
  query getDistributionList(
    $period: String!
    $firmId: Int
    $year: Int
    $segmentKey: String
    $page: Int
    $pageSize: Int
    $isPaginated: Boolean
    $programFilter: String
    $startDate: String
    $endDate: String
  ) {
    getDistributionList(
      period: $period
      firmId: $firmId
      year: $year
      segmentKey: $segmentKey
      page: $page
      pageSize: $pageSize
      isPaginated: $isPaginated
      programFilter: $programFilter
      startDate: $startDate
      endDate: $endDate
    ) {
      distributionList {
        fundExternalId
        fundName
        balance
        participant
      }
      totalCount
      isLastPage
    }
  }
`;
export const GetCorporateClientsListDocument = gql`
  query getCorporateClientsList(
    $page: Int
    $pageSize: Int
    $isPaginated: Boolean
    $programFilter: String
    $startDate: String
    $endDate: String
  ) {
    getCorporateClientsList(
      page: $page
      pageSize: $pageSize
      isPaginated: $isPaginated
      programFilter: $programFilter
      startDate: $startDate
      endDate: $endDate
    ) {
      corporateClientsList {
        firmId
        firmGiveReferenceId
        firmName
        dafsOpened
        dafsFunded
        aum
        lois
        contributions
        grants
      }
      totalCount
      isLastPage
      page
      pageSize
    }
  }
`;
export const GetCorporateDafsListDocument = gql`
  query getCorporateDafsList(
    $firmId: Int
    $page: Int
    $pageSize: Int
    $isPaginated: Boolean
  ) {
    getCorporateDafsList(
      firmId: $firmId
      page: $page
      pageSize: $pageSize
      isPaginated: $isPaginated
    ) {
      corporateAdminsList {
        dafName
        openDate
        initialFundedDate
        latestFundedDate
        aum
        dafId
        users {
          email
          firstName
          lastName
          roles
        }
      }
      corporateParticipantsList {
        dafName
        openDate
        initialFundedDate
        latestFundedDate
        aum
        dafId
        users {
          email
          firstName
          lastName
          roles
        }
      }
      totalCount
      isLastPage
    }
  }
`;
export const GetDafStatsDocument = gql`
  query getDafStats($dafId: Int) {
    getDafStats(dafId: $dafId) {
      aum
      dafName
      dafId
      ytdContributions
      ytdGrants
      inFlightContributions
      inFlightGrants
    }
  }
`;
export const GetDafContributionsDocument = gql`
  query getDafContributions(
    $dafId: Int
    $page: Int
    $pageSize: Int
    $isPaginated: Boolean
    $filterBy: String
    $startDate: String
    $endDate: String
  ) {
    getDafContributions(
      dafId: $dafId
      page: $page
      pageSize: $pageSize
      isPaginated: $isPaginated
      filterBy: $filterBy
      startDate: $startDate
      endDate: $endDate
    ) {
      results {
        objectId
        status
        timeline {
          state
          value
        }
        amount
        contributor
        method
        initiatedDate
        contributionType
        firmName
        shares
        ticker
      }
      totalCount
      page
      pageSize
      isPaginated
      isLastPage
    }
  }
`;
export const GetDafGrantsDocument = gql`
  query getDafGrants(
    $dafId: Int
    $page: Int
    $pageSize: Int
    $isPaginated: Boolean
    $filterBy: String
    $startDate: String
    $endDate: String
  ) {
    getDafGrants(
      dafId: $dafId
      page: $page
      pageSize: $pageSize
      isPaginated: $isPaginated
      filterBy: $filterBy
      startDate: $startDate
      endDate: $endDate
    ) {
      results {
        objectId
        status
        timeline {
          state
          value
        }
        amount
        recommendedBy
        charityName
        grantNote
        method
        initiatedDate
        isAnonymous
        ein
        charityAddress {
          streetAddress
          cityStateZip
          country
        }
        firmName
      }
      totalCount
      page
      pageSize
      isPaginated
      isLastPage
    }
  }
`;
export const GetOperationsListFirmsDocument = gql`
  query getOperationsListFirms(
    $enterpriseId: Int
    $firmId: Int
    $searchText: String
    $page: Int
    $pageSize: Int
    $isPaginated: Boolean
  ) {
    getOperationsListFirms(
      enterpriseId: $enterpriseId
      firmId: $firmId
      searchText: $searchText
      page: $page
      pageSize: $pageSize
      isPaginated: $isPaginated
    ) {
      results {
        giveReferenceId
        name
        companyLaunchDate
        individualLaunchDate
        creationTime
        earliestDafCreation
      }
      totalCount
      isLastPage
    }
  }
`;
export const GetOperationsListEnterprisesDocument = gql`
  query getOperationsListEnterprises(
    $enterpriseId: Int
    $searchText: String
    $page: Int
    $pageSize: Int
    $isPaginated: Boolean
  ) {
    getOperationsListEnterprises(
      enterpriseId: $enterpriseId
      searchText: $searchText
      page: $page
      pageSize: $pageSize
      isPaginated: $isPaginated
    ) {
      results {
        giveReferenceId
        name
        creationTime
        earliestDafCreation
      }
      totalCount
      isLastPage
    }
  }
`;
export const GetOperationsContributionsKpIsDocument = gql`
  query getOperationsContributionsKPIs(
    $enterpriseId: Int
    $firmId: Int
    $filterBy: String
    $startDate: String
    $endDate: String
  ) {
    getOperationsContributionsKPIs(
      enterpriseId: $enterpriseId
      firmId: $firmId
      filterBy: $filterBy
      startDate: $startDate
      endDate: $endDate
    ) {
      achStats {
        averageCycleTimeDays
        loisToFundsAvailable
      }
      thirdPartyStats {
        averageCycleTimeDays
        loisToFundsAvailable
      }
      securityStats {
        averageCycleTimeDays
        loisToSecurityReceivedDays
        fundsAvailableDays
        liquidationDays
      }
    }
  }
`;
export const GetOperationsContributionsCountDocument = gql`
  query getOperationsContributionsCount(
    $enterpriseId: Int
    $firmId: Int
    $filterBy: String
    $startDate: String
    $endDate: String
  ) {
    getOperationsContributionsCount(
      enterpriseId: $enterpriseId
      firmId: $firmId
      filterBy: $filterBy
      startDate: $startDate
      endDate: $endDate
    ) {
      inFlightLois
      fundsReconciled
      liquidation
      fundsAvailable
      total
    }
  }
`;
export const GetOperationsContributionsStatsDocument = gql`
  query getOperationsContributionsStats(
    $enterpriseId: Int
    $firmId: Int
    $filterBy: String
    $startDate: String
    $endDate: String
    $contributionStateFilter: String
    $page: Int
    $pageSize: Int
    $isPaginated: Boolean
  ) {
    getOperationsContributionsStats(
      enterpriseId: $enterpriseId
      firmId: $firmId
      filterBy: $filterBy
      startDate: $startDate
      endDate: $endDate
      contributionStateFilter: $contributionStateFilter
      page: $page
      pageSize: $pageSize
      isPaginated: $isPaginated
    ) {
      results {
        objectId
        status
        timeline {
          state
          value
        }
        amount
        contributor
        method
        initiatedDate
        contributionType
        firmName
      }
      totalCount
      page
      pageSize
      isPaginated
      isLastPage
    }
  }
`;
export const GetOperationsStatsDocument = gql`
  query getOperationsStats(
    $enterpriseId: Int
    $dafId: Int
    $firmId: Int
    $filterBy: String
    $startDate: String
    $endDate: String
  ) {
    getOperationsStats(
      enterpriseId: $enterpriseId
      dafId: $dafId
      firmId: $firmId
      filterBy: $filterBy
      startDate: $startDate
      endDate: $endDate
    ) {
      contributions
      grants
      inFlightContributions
      inFlightGrants
    }
  }
`;
export const GetFeesStatsDocument = gql`
  query getFeesStats(
    $enterpriseId: Int
    $firmId: Int
    $advisorId: String
    $startDate: String
    $endDate: String
  ) {
    getFeesStats(
      enterpriseId: $enterpriseId
      firmId: $firmId
      advisorId: $advisorId
      startDate: $startDate
      endDate: $endDate
    ) {
      aum
      avgBps
      adminFees
      subAdvisorFees
      platformFeePct
      enterpriseFeePct
      platformShare
      enterpriseShare
    }
  }
`;
export const GetFeeTierDocument = gql`
  query getFeeTier($enterpriseId: Int, $firmId: Int, $advisorId: String) {
    getFeeTier(
      enterpriseId: $enterpriseId
      firmId: $firmId
      advisorId: $advisorId
    ) {
      feeTier
    }
  }
`;
export const GetFeesByProgramDocument = gql`
  query getFeesByProgram($page: Int, $pageSize: Int, $isPaginated: Boolean) {
    getFeesByProgram(
      page: $page
      pageSize: $pageSize
      isPaginated: $isPaginated
    ) {
      results {
        enterpriseName
        enterpriseId
        enterpriseGiveReferenceId
        aum
        avgBps
        adminFees
        subAdvisorFees
        platformFeePct
        enterpriseFeePct
        platformShare
        enterpriseShare
      }
      totalCount
      page
      pageSize
      isPaginated
      isLastPage
      isCustomFeeSplit
    }
  }
`;
export const GetFeesByEnterpriseDocument = gql`
  query getFeesByEnterprise(
    $enterpriseId: Int
    $page: Int
    $pageSize: Int
    $isPaginated: Boolean
    $startDate: String
    $endDate: String
  ) {
    getFeesByEnterprise(
      enterpriseId: $enterpriseId
      page: $page
      pageSize: $pageSize
      isPaginated: $isPaginated
      startDate: $startDate
      endDate: $endDate
    ) {
      results {
        firmName
        firmId
        firmGiveReferenceId
        aum
        avgBps
        adminFees
        subAdvisorFees
        platformFeePct
        enterpriseFeePct
        platformShare
        enterpriseShare
      }
      totalCount
      page
      pageSize
      isPaginated
      isLastPage
      isCustomFeeSplit
    }
  }
`;
export const GetFeesByFirmDocument = gql`
  query getFeesByFirm(
    $enterpriseId: Int
    $firmId: Int
    $page: Int
    $pageSize: Int
    $isPaginated: Boolean
    $startDate: String
    $endDate: String
  ) {
    getFeesByFirm(
      enterpriseId: $enterpriseId
      firmId: $firmId
      page: $page
      pageSize: $pageSize
      isPaginated: $isPaginated
      startDate: $startDate
      endDate: $endDate
    ) {
      results {
        advisorName
        advisorId
        advisorGiveReferenceId
        id
        aum
        avgBps
        adminFees
        subAdvisorFees
        platformFeePct
        enterpriseFeePct
        platformShare
        enterpriseShare
      }
      totalCount
      page
      pageSize
      isPaginated
      isLastPage
      isCustomFeeSplit
    }
  }
`;
export const GetFeesByAdvisorDocument = gql`
  query getFeesByAdvisor(
    $enterpriseId: Int
    $firmId: Int
    $advisorId: String
    $page: Int
    $pageSize: Int
    $isPaginated: Boolean
    $startDate: String
    $endDate: String
  ) {
    getFeesByAdvisor(
      enterpriseId: $enterpriseId
      firmId: $firmId
      advisorId: $advisorId
      page: $page
      pageSize: $pageSize
      isPaginated: $isPaginated
      startDate: $startDate
      endDate: $endDate
    ) {
      results {
        dafName
        dafId
        dafGiveReferenceId
        aum
        avgBps
        adminFees
        subAdvisorFees
        platformFeePct
        enterpriseFeePct
        platformShare
        enterpriseShare
      }
      totalCount
      page
      pageSize
      isPaginated
      isLastPage
      isCustomFeeSplit
    }
  }
`;
export const GetOperationsGrantsKpIsDocument = gql`
  query getOperationsGrantsKPIs(
    $enterpriseId: Int
    $firmId: Int
    $filterBy: String
    $startDate: String
    $endDate: String
  ) {
    getOperationsGrantsKPIs(
      enterpriseId: $enterpriseId
      firmId: $firmId
      filterBy: $filterBy
      startDate: $startDate
      endDate: $endDate
    ) {
      averageCycleTimeDays
      submittedToApprovedDays
      fundsMadeAvailableDays
      sentToCharityDays
      charityReceivesFundsDays
    }
  }
`;
export const GetOperationsGrantsStatsDocument = gql`
  query getOperationsGrantsStats(
    $enterpriseId: Int
    $firmId: Int
    $filterBy: String
    $startDate: String
    $endDate: String
    $page: Int
    $pageSize: Int
    $isPaginated: Boolean
    $grantsStateFilter: String
  ) {
    getOperationsGrantsStats(
      enterpriseId: $enterpriseId
      firmId: $firmId
      filterBy: $filterBy
      startDate: $startDate
      endDate: $endDate
      page: $page
      pageSize: $pageSize
      isPaginated: $isPaginated
      grantsStateFilter: $grantsStateFilter
    ) {
      results {
        objectId
        status
        timeline {
          state
          value
        }
        amount
        recommendedBy
        method
        charityName
        grantNote
        initiatedDate
        firmName
        ein
        isAnonymous
        charityAddress {
          streetAddress
          cityStateZip
          country
        }
      }
      totalCount
      page
      pageSize
      isPaginated
      isLastPage
    }
  }
`;
export const GetOperationsGrantsVolumeStatusStatsDocument = gql`
  query getOperationsGrantsVolumeStatusStats(
    $enterpriseId: Int
    $firmId: Int
    $filterBy: String
    $startDate: String
    $endDate: String
  ) {
    getOperationsGrantsVolumeStatusStats(
      enterpriseId: $enterpriseId
      firmId: $firmId
      filterBy: $filterBy
      startDate: $startDate
      endDate: $endDate
    ) {
      submittedGrants
      approvedGrants
      fundsSentGrants
      sentToCharityGrants
      completedGrants
    }
  }
`;
export const GetOperationsAumByInvestmentModelDocument = gql`
  query getOperationsAumByInvestmentModel($frequency: String) {
    getOperationsAumByInvestmentModel(frequency: $frequency) {
      models
      data
    }
  }
`;
export const GetAdoptionBannerStatsDocument = gql`
  query GetAdoptionBannerStats($firmId: Int) {
    getAdoptionBannerStats(firmId: $firmId) {
      period {
        startDate
        endDate
        totalEligibleParticipants
        openRate
        dafsOpened
        dafsFunded
        fundedRate
      }
    }
  }
`;
export const GetEngagementOverTimeDocument = gql`
  query GetEngagementOverTime($firmId: Int) {
    getEngagementOverTime(firmId: $firmId) {
      weeks {
        week
        weekStart
        signUps
        dafsOpened
        dafsFunded
      }
    }
  }
`;
export const GetEngagementFunnelDocument = gql`
  query GetEngagementFunnel($firmId: Int) {
    getEngagementFunnel(firmId: $firmId) {
      emailsSent
      emailsOpened
      emailsBounced
      signUps
      dafsOpened
      firstContribution
      firstGrant
      startDate
      endDate
    }
  }
`;
export const GetCustomerSuccessMetricsDocument = gql`
  query getCustomerSuccessMetrics($firmId: Int, $filterType: String) {
    getCustomerSuccessMetrics(firmId: $firmId, filterType: $filterType) {
      totalServiceRequests
      avgFirstResponse
      avgResolutionTime
      outstandingRequests
    }
  }
`;
export const GetServiceRequestsByChannelDocument = gql`
  query getServiceRequestsByChannel($firmId: Int, $filterType: String) {
    getServiceRequestsByChannel(firmId: $firmId, filterType: $filterType) {
      serviceRequests {
        period
        chatRequests
        emailRequests
        avgFirstResponse
        avgResolution
      }
    }
  }
`;
export const GetChannelPerformanceMetricsDocument = gql`
  query getChannelPerformanceMetrics($firmId: Int, $filterType: String) {
    getChannelPerformanceMetrics(firmId: $firmId, filterType: $filterType) {
      chat {
        requests
        avgSatisfaction
      }
      email {
        requests
        avgSatisfaction
      }
    }
  }
`;
export const GetConversationTopIssuesDocument = gql`
  query getConversationTopIssues($firmId: Int, $filterType: String) {
    getConversationTopIssues(firmId: $firmId, filterType: $filterType) {
      topIssues {
        issueType
        count
      }
    }
  }
`;
export const GetServiceRequestsByIssueTypeDocument = gql`
  query getServiceRequestsByIssueType(
    $firmId: Int
    $filterType: String
    $issueType: String
    $page: Int
    $pageSize: Int
  ) {
    getServiceRequestsByIssueType(
      firmId: $firmId
      filterType: $filterType
      issueType: $issueType
      page: $page
      pageSize: $pageSize
    ) {
      serviceRequests {
        requestId
        client
        participant
        channel
        issueType
        status
        priority
        responseTime
        issueOpened
        firstResponse
        firstClosed
        correspondence {
          name
          message
          date
        }
      }
      totalCount
      page
      pageSize
      isLastPage
    }
  }
`;
export const GetFeeStatementDocument = gql`
  mutation getFeeStatement(
    $enterpriseId: Int
    $firmId: Int
    $startDate: String!
    $endDate: String!
    $periodLabel: String!
  ) {
    getFeeStatement(
      enterpriseId: $enterpriseId
      firmId: $firmId
      startDate: $startDate
      endDate: $endDate
      periodLabel: $periodLabel
    ) {
      ok
      feeStatement
    }
  }
`;
export const GetReportsOverviewStatsDocument = gql`
  query getReportsOverviewStats(
    $enterpriseId: Int
    $firmId: Int
    $programFilter: String
    $startDate: String
    $endDate: String
  ) {
    getOverviewStats(
      enterpriseId: $enterpriseId
      firmId: $firmId
      programFilter: $programFilter
      startDate: $startDate
      endDate: $endDate
    ) {
      enterprises
      wealthClients
      advisors
      corporateClients
      aum
      dafsOpened
      dafsFunded
      totalContributions
      totalGrants
    }
  }
`;
export const GetReportsProgramAumStatsDocument = gql`
  query getReportsProgramAUMStats(
    $frequency: String!
    $enterpriseId: Int
    $familyId: Int
    $firmId: Int
  ) {
    getProgramAUMStats(
      frequency: $frequency
      enterpriseId: $enterpriseId
      familyId: $familyId
      firmId: $firmId
    ) {
      aumStats {
        period
        year
        openingAumInvestmentFundFee
        openingAumFundAsset
        closingAumInvestmentFundFee
        closingAumFundAsset
        contributions
        grants
      }
    }
  }
`;
export const GetReportsCorporateClientsListDocument = gql`
  query getReportsCorporateClientsList(
    $enterpriseId: Int
    $page: Int
    $pageSize: Int
    $isPaginated: Boolean
  ) {
    getCorporateClientsList(
      enterpriseId: $enterpriseId
      page: $page
      pageSize: $pageSize
      isPaginated: $isPaginated
    ) {
      corporateClientsList {
        firmId
        firmGiveReferenceId
        firmName
        advisorCount
        dafsOpened
        dafsFunded
        aum
        lois
        contributions
        grants
      }
      totalCount
      isLastPage
      page
      pageSize
    }
  }
`;
export const GetEnterpriseClientsListDocument = gql`
  query getEnterpriseClientsList(
    $page: Int
    $pageSize: Int
    $isPaginated: Boolean
  ) {
    getEnterpriseClientsList(
      page: $page
      pageSize: $pageSize
      isPaginated: $isPaginated
    ) {
      enterpriseClientsList {
        enterpriseId
        enterpriseGiveReferenceId
        enterpriseName
        firmCount
        dafsOpened
        dafsFunded
        aum
        lois
        contributions
        grants
      }
      totalCount
      isLastPage
      page
      pageSize
    }
  }
`;
export const MySuccessorInviteDocument = gql`
  query mySuccessorInvite($familyId: Int!) {
    mySuccessorInvite(familyId: $familyId) {
      id
      firstName
      lastName
      percentage
      isContingent
      acceptedAt
      declinedAt
      family {
        id
        name
      }
      destinationFamily {
        id
      }
    }
  }
`;
export const MySuccessorOnboardingDocument = gql`
  query mySuccessorOnboarding($familyId: Int!) {
    mySuccessorOnboarding(familyId: $familyId) {
      successorId
      isContingent
      percentage
      originatingFamilyId
      originatingFamilyName
      acceptedAt
      declinedAt
      founderMessageViewedAt
      missionReviewedAt
      acknowledgmentSignedAt
      givingHistoryViewedAt
      dafCreated
    }
  }
`;
export const SuccessorAcknowledgmentDocument = gql`
  query successorAcknowledgment($familyId: Int!) {
    successorAcknowledgment(familyId: $familyId) {
      originatingFamilyId
      originatingFamilyName
      isContingent
      percentage
      policyMode
      annualPayoutTarget
      sunsetTimeframeYears
      accountAgeYears
      yearsUntilSunset
      isPolicyConfigured
      sunsetCharityAllocations {
        id
        charityName
        percentage
      }
      alreadySignedAt
    }
  }
`;
export const SuccessorFoundersVoiceDocument = gql`
  query successorFoundersVoice($familyId: Int!) {
    successorFoundersVoice(familyId: $familyId) {
      originatingFamilyId
      originatingFamilyName
      foundersMessage
      mission
      audioUrl
      videoUrl
      hasContent
    }
  }
`;
export const SuccessorGivingHistoryDocument = gql`
  query successorGivingHistory($familyId: Int!) {
    successorGivingHistory(familyId: $familyId) {
      originatingFamilyId
      originatingFamilyName
      hasContent
      grants {
        id
        charityName
        contribution
        submittedOn
        causes
        rationale
        status
      }
    }
  }
`;
export const SuggestedForYouDocument = gql`
  query suggestedForYou($donorId: Int!, $familyId: Int!) {
    recommendedFundsDonor(donorId: $donorId, familyId: $familyId) {
      funds {
        id
        mediumImg
        mission
        nteeDesc
        ein
        restricted
        isBlacklisted
        title
        membersLiked
        campaignedBy
        contributors
        charityNavRatings
        status
        isUserFavourite
        orgSecondName
        payment {
          paymentMethod
          isAch
        }
        address
        causes {
          id
          key
          value
        }
      }
      __typename
    }
  }
`;
export const RecommendedFundsFamilyDocument = gql`
  query recommendedFundsFamily($familyId: Int!) {
    recommendedFundsFamily(familyId: $familyId) {
      funds {
        id
        ein
        charityNavRatings
        mediumImg
        mission
        nteeDesc
        title
        membersLiked
        campaignedBy
        contributors
        status
        charityNavRatings
        restricted
        isUserFavourite
        orgSecondName
        address
        causes {
          id
          key
          value
        }
      }
    }
  }
`;
export const ListTransactionsDocument = gql`
  query listTransactions(
    $familyId: Int!
    $filters: TransactionFilterInputType
  ) {
    listTransactions(familyId: $familyId, filters: $filters) {
      page
      pages
      count
      objects {
        transactionId
        amount
        contributor
        description
        status
        initiatedOn
        lastUpdatedOn
        searchDescription
        source
        familyId
        userId
        metaData
        displayStatus
      }
    }
  }
`;
export const GetSecurityContributionDetailDocument = gql`
  query getSecurityContributionDetail(
    $transactionReference: String!
    $familyId: Int!
    $status: String
    $pageNumber: Int
  ) {
    securityContributionDetails(
      transactionReference: $transactionReference
      familyId: $familyId
      status: $status
      pageNumber: $pageNumber
    ) {
      batchId
      submittedBy
      custodian
      initiatedOn
      totalValue
      totalCount
      statusCounts {
        status
        count
      }
      securities {
        page
        pages
        count
        objects {
          ticker
          securityName
          quantity
          amount
          status
          objectId
          transactionId
        }
      }
    }
  }
`;
export const EngagementDistributionDocument = gql`
  query engagementDistribution($ctype: CTypeEnumType!, $id: Int, $year: Int) {
    engagementDistribution(ctype: $ctype, id: $id, year: $year) {
      distribution {
        id
        key
        value
        gift
        weight
        __typename
      }
      totalGift
    }
  }
`;
export const GetRecurringGiftDocument = gql`
  query GetRecurringGift($giftId: Int!) {
    recurringGift(giftId: $giftId) {
      id
      companyGrant {
        id
        createdBy {
          id
          name
        }
        createdAt
        endorsedBy {
          id
          name
        }
        endorsedAt
      }
      isActive
      frequency
      nextScheduled
      startDate
      endDate
      cancelledAt
      cancelledByName
      seriesDisplayStatus
      seriesStartedOn
      charityName
      charityId
      anonymous
      totalOccurrences
      completedOccurrences
      charity {
        id
        title
        ein
        name
        mediumImg
        address
        payment {
          id
          paymentMethod
          isAch
          createdAt
        }
      }
      ein
      note
      amount
      user {
        firstName
        lastName
        name
      }
      impersonatedBy {
        name
      }
    }
  }
`;
export const ScheduledCcContributionDetailsDocument = gql`
  query scheduledCcContributionDetails($scheduledCcContributionId: Int!) {
    scheduledCcContributionDetails(
      scheduledCcContributionId: $scheduledCcContributionId
    ) {
      id
      chargeAmount
      amount
      processingFee
      oneTimeFee
      createdAt
      createdBy {
        id
        email
      }
      family {
        id
        name
      }
      firstSchedule
      frequency
      isActive
      lastTransaction
      nextScheduled
      endDate
      updatedAt
      contributor
      paymentIntentId
      paymentMethodId
      brand
      last4
      country
      funding
    }
  }
`;
export const ScheduledContributionDetailsDocument = gql`
  query scheduledContributionDetails($scheduledContributionId: Int!) {
    scheduledContributionDetails(
      scheduledContributionId: $scheduledContributionId
    ) {
      account {
        id
        accountId
        mask
        accountName
        verificationStatus
        plaidItem {
          id
        }
      }
      amount
      contributor
      createdAt
      createdBy {
        id
        firstName
        lastName
      }
      endDate
      firstSchedule
      frequency
      id
      institutionName
      isActive
      lastTransaction
      nextScheduled
      updatedAt
    }
  }
`;
export const GetTransactionFiltersDocument = gql`
  query getTransactionFilters($startDate: Date!, $endDate: Date!) {
    getTransactionFilters(startDate: $startDate, endDate: $endDate) {
      campaigns {
        charities {
          id
          title
        }
        statuses
      }
      contributions {
        displayStatuses
        statuses
        types
      }
      grants {
        charities {
          id
          title
        }
        statuses
      }
      companyGrants {
        charities {
          id
          title
        }
        statuses
      }
      employeeGrants {
        charities {
          id
          title
        }
        statuses
      }
      adminGrants {
        charities {
          id
          title
        }
        statuses
      }
      myGrants {
        charities {
          id
          title
        }
        statuses
      }
    }
  }
`;
export const GetPublicSecurityBatchDetailsDocument = gql`
  query getPublicSecurityBatchDetails(
    $transactionReference: String!
    $familyId: Int!
    $status: String
    $pageNumber: Int
  ) {
    securityContributionDetails(
      transactionReference: $transactionReference
      familyId: $familyId
      status: $status
      pageNumber: $pageNumber
    ) {
      batchId
      submittedBy
      custodian
      initiatedOn
      totalValue
      totalCount
      statusCounts {
        status
        count
      }
      securities {
        page
        pages
        count
        objects {
          ticker
          securityName
          quantity
          amount
          status
          objectId
          transactionId
          statusTimeline {
            status
            statusSubtext
            orderOfAppearance
            elevateStatus
            completedOn
          }
        }
      }
    }
  }
`;
export const UserDocument = gql`
  query user($userId: Int!) {
    user(userId: $userId) {
      id
      email
      name
      firstName
      middleName
      lastName
      prefix
      suffix
      isStaff
      yellowRef
      individualBenefit
      corporateBenefit
      selfDirected {
        id
        email
        inviteStatus
      }
      yearlyFamilyUserGroupData {
        allocatedAmount
        contributedAmount
      }
      userTags {
        id
        tagCategory {
          id
          category
          tags {
            id
            tag
          }
        }
        tag {
          id
          tag
        }
      }
      roles
      userRoles
      dob
      address
      phoneNumber
      lastLogin
      relationship
      profilepicUrl
      emailPrefDafContribution
      emailPrefGifts
      emailPrefOnboarding
      subscribeNewFeatures
      subscribeGivingTrends
      externalId
      inviteStatus
      tncAcceptedTime
      yearlyPendingGrants
      mfaEnrolled
      mfaMethod
      signupStatus
      givingPrivacyPreference
      firm {
        id
        firmName
        logo
        logoUrl
        address
        phoneNumber
        website
        isSetupDone
        primaryColor
        secondaryColor
        metaData
        isEnterprise
        parentFirm {
          id
          firmName
        }
      }
      family {
        advisor {
          id
          email
          firstName
          lastName
          name
        }
      }
    }
  }
`;
export const ValidateEmailDocument = gql`
  query validateEmail($token: String!) {
    validateEmail(token: $token) {
      firstName
      lastName
      email
      isActive
      firm {
        id
      }
    }
  }
`;
export const UpdateLastLoginDocument = gql`
  mutation updateLastLogin {
    updateLastLogin {
      ok
    }
  }
`;
export const IsGiveUserDocument = gql`
  query isGiveUser {
    isGiveUser
  }
`;
export const AcceptTncDocument = gql`
  mutation acceptTnc {
    acceptTnc {
      ok
    }
  }
`;
export const RegisterMemberForDonorSsoDocument = gql`
  mutation registerMemberForDonorSso {
    registerMemberForDonorSso {
      ok
    }
  }
`;
export const SetGivingPrivacyPreferenceDocument = gql`
  mutation setGivingPrivacyPreference($preset: String, $fields: GenericScalar) {
    setGivingPrivacyPreference(preset: $preset, fields: $fields) {
      ok
    }
  }
`;
export const AcceptAdvisorFeeAgreementDocument = gql`
  mutation acceptAdvisorFeeAgreement {
    acceptAdvisorFeeAgreement {
      ok
    }
  }
`;

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string,
  variables?: any,
) => Promise<T>;

const defaultWrapper: SdkFunctionWrapper = (
  action,
  _operationName,
  _operationType,
  _variables,
) => action();

export function getSdk(
  client: GraphQLClient,
  withWrapper: SdkFunctionWrapper = defaultWrapper,
) {
  return {
    activities(
      variables?: ActivitiesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ActivitiesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ActivitiesQuery>({
            document: ActivitiesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "activities",
        "query",
        variables,
      );
    },
    GetAllGrowthActivities(
      variables?: GetAllGrowthActivitiesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetAllGrowthActivitiesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetAllGrowthActivitiesQuery>({
            document: GetAllGrowthActivitiesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetAllGrowthActivities",
        "query",
        variables,
      );
    },
    todos(
      variables?: TodosQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<TodosQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<TodosQuery>({
            document: TodosDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "todos",
        "query",
        variables,
      );
    },
    alerts(
      variables?: AlertsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<AlertsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AlertsQuery>({
            document: AlertsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "alerts",
        "query",
        variables,
      );
    },
    resendInvite(
      variables: ResendInviteMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ResendInviteMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ResendInviteMutation>({
            document: ResendInviteDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "resendInvite",
        "mutation",
        variables,
      );
    },
    GrowthActivityActionMutation(
      variables: GrowthActivityActionMutationMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GrowthActivityActionMutationMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GrowthActivityActionMutationMutation>({
            document: GrowthActivityActionMutationDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GrowthActivityActionMutation",
        "mutation",
        variables,
      );
    },
    newDafClients(
      variables?: NewDafClientsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<NewDafClientsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<NewDafClientsQuery>({
            document: NewDafClientsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "newDafClients",
        "query",
        variables,
      );
    },
    dafClientsByEmail(
      variables?: DafClientsByEmailQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<DafClientsByEmailQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<DafClientsByEmailQuery>({
            document: DafClientsByEmailDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "dafClientsByEmail",
        "query",
        variables,
      );
    },
    createFamilyAndMembers(
      variables: CreateFamilyAndMembersMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<CreateFamilyAndMembersMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CreateFamilyAndMembersMutation>({
            document: CreateFamilyAndMembersDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "createFamilyAndMembers",
        "mutation",
        variables,
      );
    },
    advisorNewSummary(
      variables?: AdvisorNewSummaryQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<AdvisorNewSummaryQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AdvisorNewSummaryQuery>({
            document: AdvisorNewSummaryDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "advisorNewSummary",
        "query",
        variables,
      );
    },
    advisorCampaigns(
      variables?: AdvisorCampaignsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<AdvisorCampaignsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AdvisorCampaignsQuery>({
            document: AdvisorCampaignsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "advisorCampaigns",
        "query",
        variables,
      );
    },
    GetAdvisorCampaigns(
      variables?: GetAdvisorCampaignsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetAdvisorCampaignsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetAdvisorCampaignsQuery>({
            document: GetAdvisorCampaignsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetAdvisorCampaigns",
        "query",
        variables,
      );
    },
    investmentChangeRequests(
      variables: InvestmentChangeRequestsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<InvestmentChangeRequestsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<InvestmentChangeRequestsQuery>({
            document: InvestmentChangeRequestsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "investmentChangeRequests",
        "query",
        variables,
      );
    },
    cancelCashMovement(
      variables: CancelCashMovementMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<CancelCashMovementMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CancelCashMovementMutation>({
            document: CancelCashMovementDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "cancelCashMovement",
        "mutation",
        variables,
      );
    },
    cancelReallocationRebalance(
      variables: CancelReallocationRebalanceMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<CancelReallocationRebalanceMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CancelReallocationRebalanceMutation>({
            document: CancelReallocationRebalanceDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "cancelReallocationRebalance",
        "mutation",
        variables,
      );
    },
    advisorWeeklySummary(
      variables?: AdvisorWeeklySummaryQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<AdvisorWeeklySummaryQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AdvisorWeeklySummaryQuery>({
            document: AdvisorWeeklySummaryDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "advisorWeeklySummary",
        "query",
        variables,
      );
    },
    advisorClientInsights(
      variables?: AdvisorClientInsightsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<AdvisorClientInsightsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AdvisorClientInsightsQuery>({
            document: AdvisorClientInsightsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "advisorClientInsights",
        "query",
        variables,
      );
    },
    advisorClientTransactions(
      variables?: AdvisorClientTransactionsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<AdvisorClientTransactionsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AdvisorClientTransactionsQuery>({
            document: AdvisorClientTransactionsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "advisorClientTransactions",
        "query",
        variables,
      );
    },
    custodianIntegrations(
      variables?: CustodianIntegrationsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<CustodianIntegrationsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CustodianIntegrationsQuery>({
            document: CustodianIntegrationsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "custodianIntegrations",
        "query",
        variables,
      );
    },
    linkedAccounts(
      variables?: LinkedAccountsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<LinkedAccountsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<LinkedAccountsQuery>({
            document: LinkedAccountsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "linkedAccounts",
        "query",
        variables,
      );
    },
    clientsWithThirdPartyDaf(
      variables?: ClientsWithThirdPartyDafQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ClientsWithThirdPartyDafQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ClientsWithThirdPartyDafQuery>({
            document: ClientsWithThirdPartyDafDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "clientsWithThirdPartyDaf",
        "query",
        variables,
      );
    },
    getTopRecommendations(
      variables?: GetTopRecommendationsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetTopRecommendationsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetTopRecommendationsQuery>({
            document: GetTopRecommendationsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getTopRecommendations",
        "query",
        variables,
      );
    },
    getBunchingPlanDraft(
      variables: GetBunchingPlanDraftQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetBunchingPlanDraftQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetBunchingPlanDraftQuery>({
            document: GetBunchingPlanDraftDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getBunchingPlanDraft",
        "query",
        variables,
      );
    },
    getBookLevelSettings(
      variables?: GetBookLevelSettingsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetBookLevelSettingsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetBookLevelSettingsQuery>({
            document: GetBookLevelSettingsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getBookLevelSettings",
        "query",
        variables,
      );
    },
    GetClientLevelSettings(
      variables: GetClientLevelSettingsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetClientLevelSettingsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetClientLevelSettingsQuery>({
            document: GetClientLevelSettingsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetClientLevelSettings",
        "query",
        variables,
      );
    },
    SaveBookLevelSettings(
      variables?: SaveBookLevelSettingsMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<SaveBookLevelSettingsMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SaveBookLevelSettingsMutation>({
            document: SaveBookLevelSettingsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "SaveBookLevelSettings",
        "mutation",
        variables,
      );
    },
    SaveClientLevelSettings(
      variables: SaveClientLevelSettingsMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<SaveClientLevelSettingsMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SaveClientLevelSettingsMutation>({
            document: SaveClientLevelSettingsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "SaveClientLevelSettings",
        "mutation",
        variables,
      );
    },
    familiesWithPortfolioMappings(
      variables?: FamiliesWithPortfolioMappingsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<FamiliesWithPortfolioMappingsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<FamiliesWithPortfolioMappingsQuery>({
            document: FamiliesWithPortfolioMappingsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "familiesWithPortfolioMappings",
        "query",
        variables,
      );
    },
    searchAdvisorFamilyUsers(
      variables?: SearchAdvisorFamilyUsersQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<SearchAdvisorFamilyUsersQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SearchAdvisorFamilyUsersQuery>({
            document: SearchAdvisorFamilyUsersDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "searchAdvisorFamilyUsers",
        "query",
        variables,
      );
    },
    removeUserPortfolioMapping(
      variables: RemoveUserPortfolioMappingMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<RemoveUserPortfolioMappingMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RemoveUserPortfolioMappingMutation>({
            document: RemoveUserPortfolioMappingDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "removeUserPortfolioMapping",
        "mutation",
        variables,
      );
    },
    advisorGroups(
      variables?: AdvisorGroupsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<AdvisorGroupsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AdvisorGroupsQuery>({
            document: AdvisorGroupsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "advisorGroups",
        "query",
        variables,
      );
    },
    listFirmAdvisors(
      variables: ListFirmAdvisorsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ListFirmAdvisorsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ListFirmAdvisorsQuery>({
            document: ListFirmAdvisorsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "listFirmAdvisors",
        "query",
        variables,
      );
    },
    advisorGroup(
      variables: AdvisorGroupQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<AdvisorGroupQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AdvisorGroupQuery>({
            document: AdvisorGroupDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "advisorGroup",
        "query",
        variables,
      );
    },
    listAdvisorGroupClients(
      variables: ListAdvisorGroupClientsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ListAdvisorGroupClientsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ListAdvisorGroupClientsQuery>({
            document: ListAdvisorGroupClientsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "listAdvisorGroupClients",
        "query",
        variables,
      );
    },
    fundSearch(
      variables: FundSearchQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<FundSearchQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<FundSearchQuery>({
            document: FundSearchDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "fundSearch",
        "query",
        variables,
      );
    },
    campaigns(
      variables: CampaignsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<CampaignsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CampaignsQuery>({
            document: CampaignsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "campaigns",
        "query",
        variables,
      );
    },
    publicCampaign(
      variables: PublicCampaignQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<PublicCampaignQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<PublicCampaignQuery>({
            document: PublicCampaignDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "publicCampaign",
        "query",
        variables,
      );
    },
    fetchGuestPublicCampaignDetails(
      variables: FetchGuestPublicCampaignDetailsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<FetchGuestPublicCampaignDetailsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<FetchGuestPublicCampaignDetailsQuery>({
            document: FetchGuestPublicCampaignDetailsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "fetchGuestPublicCampaignDetails",
        "query",
        variables,
      );
    },
    listCampaignDonations(
      variables: ListCampaignDonationsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ListCampaignDonationsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ListCampaignDonationsQuery>({
            document: ListCampaignDonationsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "listCampaignDonations",
        "query",
        variables,
      );
    },
    campaignDashboardMetrics(
      variables: CampaignDashboardMetricsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<CampaignDashboardMetricsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CampaignDashboardMetricsQuery>({
            document: CampaignDashboardMetricsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "campaignDashboardMetrics",
        "query",
        variables,
      );
    },
    GetPublicCampaignDonations(
      variables: GetPublicCampaignDonationsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetPublicCampaignDonationsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetPublicCampaignDonationsQuery>({
            document: GetPublicCampaignDonationsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetPublicCampaignDonations",
        "query",
        variables,
      );
    },
    campaignDrafts(
      variables: CampaignDraftsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<CampaignDraftsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CampaignDraftsQuery>({
            document: CampaignDraftsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "campaignDrafts",
        "query",
        variables,
      );
    },
    campaignStats(
      variables: CampaignStatsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<CampaignStatsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CampaignStatsQuery>({
            document: CampaignStatsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "campaignStats",
        "query",
        variables,
      );
    },
    campaignTemplateSettings(
      variables?: CampaignTemplateSettingsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<CampaignTemplateSettingsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CampaignTemplateSettingsQuery>({
            document: CampaignTemplateSettingsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "campaignTemplateSettings",
        "query",
        variables,
      );
    },
    causes(
      variables: CausesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<CausesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CausesQuery>({
            document: CausesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "causes",
        "query",
        variables,
      );
    },
    getRestrictedCharities(
      variables: GetRestrictedCharitiesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetRestrictedCharitiesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetRestrictedCharitiesQuery>({
            document: GetRestrictedCharitiesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getRestrictedCharities",
        "query",
        variables,
      );
    },
    charityMatches(
      variables: CharityMatchesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<CharityMatchesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CharityMatchesQuery>({
            document: CharityMatchesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "charityMatches",
        "query",
        variables,
      );
    },
    createLinkToken(
      variables: CreateLinkTokenQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<CreateLinkTokenQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CreateLinkTokenQuery>({
            document: CreateLinkTokenDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "createLinkToken",
        "query",
        variables,
      );
    },
    connectAchAccounts(
      variables: ConnectAchAccountsMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ConnectAchAccountsMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ConnectAchAccountsMutation>({
            document: ConnectAchAccountsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "connectAchAccounts",
        "mutation",
        variables,
      );
    },
    fetchPlaidItems(
      variables: FetchPlaidItemsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<FetchPlaidItemsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<FetchPlaidItemsQuery>({
            document: FetchPlaidItemsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "fetchPlaidItems",
        "query",
        variables,
      );
    },
    disconnectSavingsAccount(
      variables: DisconnectSavingsAccountMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<DisconnectSavingsAccountMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<DisconnectSavingsAccountMutation>({
            document: DisconnectSavingsAccountDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "disconnectSavingsAccount",
        "mutation",
        variables,
      );
    },
    setDefaultBankAccount(
      variables: SetDefaultBankAccountMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<SetDefaultBankAccountMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SetDefaultBankAccountMutation>({
            document: SetDefaultBankAccountDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "setDefaultBankAccount",
        "mutation",
        variables,
      );
    },
    removeBankAccount(
      variables: RemoveBankAccountMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<RemoveBankAccountMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RemoveBankAccountMutation>({
            document: RemoveBankAccountDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "removeBankAccount",
        "mutation",
        variables,
      );
    },
    getConnectedBankAccounts(
      variables: GetConnectedBankAccountsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetConnectedBankAccountsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetConnectedBankAccountsQuery>({
            document: GetConnectedBankAccountsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getConnectedBankAccounts",
        "query",
        variables,
      );
    },
    createAmicusContribution(
      variables: CreateAmicusContributionMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<CreateAmicusContributionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CreateAmicusContributionMutation>({
            document: CreateAmicusContributionDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "createAmicusContribution",
        "mutation",
        variables,
      );
    },
    validateZipCode(
      variables: ValidateZipCodeQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ValidateZipCodeQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ValidateZipCodeQuery>({
            document: ValidateZipCodeDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "validateZipCode",
        "query",
        variables,
      );
    },
    listCompanyGrants(
      variables: ListCompanyGrantsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ListCompanyGrantsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ListCompanyGrantsQuery>({
            document: ListCompanyGrantsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "listCompanyGrants",
        "query",
        variables,
      );
    },
    corporateUserSummary(
      variables: CorporateUserSummaryQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<CorporateUserSummaryQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CorporateUserSummaryQuery>({
            document: CorporateUserSummaryDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "corporateUserSummary",
        "query",
        variables,
      );
    },
    listFirmTagCategories(
      variables?: ListFirmTagCategoriesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ListFirmTagCategoriesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ListFirmTagCategoriesQuery>({
            document: ListFirmTagCategoriesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "listFirmTagCategories",
        "query",
        variables,
      );
    },
    getEmployeeDetails(
      variables: GetEmployeeDetailsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetEmployeeDetailsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetEmployeeDetailsQuery>({
            document: GetEmployeeDetailsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getEmployeeDetails",
        "query",
        variables,
      );
    },
    listEmployees(
      variables: ListEmployeesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ListEmployeesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ListEmployeesQuery>({
            document: ListEmployeesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "listEmployees",
        "query",
        variables,
      );
    },
    listParticipants(
      variables: ListParticipantsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ListParticipantsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ListParticipantsQuery>({
            document: ListParticipantsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "listParticipants",
        "query",
        variables,
      );
    },
    getCorporateDafFilters(
      variables?: GetCorporateDafFiltersQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetCorporateDafFiltersQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetCorporateDafFiltersQuery>({
            document: GetCorporateDafFiltersDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCorporateDafFilters",
        "query",
        variables,
      );
    },
    featuredCharities(
      variables: FeaturedCharitiesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<FeaturedCharitiesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<FeaturedCharitiesQuery>({
            document: FeaturedCharitiesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "featuredCharities",
        "query",
        variables,
      );
    },
    getAssociatedFamilies(
      variables?: GetAssociatedFamiliesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetAssociatedFamiliesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetAssociatedFamiliesQuery>({
            document: GetAssociatedFamiliesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getAssociatedFamilies",
        "query",
        variables,
      );
    },
    firm(
      variables: FirmQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<FirmQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<FirmQuery>({
            document: FirmDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "firm",
        "query",
        variables,
      );
    },
    listRiaClients(
      variables: ListRiaClientsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ListRiaClientsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ListRiaClientsQuery>({
            document: ListRiaClientsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "listRiaClients",
        "query",
        variables,
      );
    },
    listFirmUsers(
      variables: ListFirmUsersQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ListFirmUsersQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ListFirmUsersQuery>({
            document: ListFirmUsersDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "listFirmUsers",
        "query",
        variables,
      );
    },
    searchFirmAdvisors(
      variables: SearchFirmAdvisorsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<SearchFirmAdvisorsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SearchFirmAdvisorsQuery>({
            document: SearchFirmAdvisorsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "searchFirmAdvisors",
        "query",
        variables,
      );
    },
    getPoolSetRecommendations(
      variables: GetPoolSetRecommendationsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetPoolSetRecommendationsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetPoolSetRecommendationsQuery>({
            document: GetPoolSetRecommendationsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getPoolSetRecommendations",
        "query",
        variables,
      );
    },
    getFirmPoolsets(
      variables: GetFirmPoolsetsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetFirmPoolsetsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetFirmPoolsetsQuery>({
            document: GetFirmPoolsetsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getFirmPoolsets",
        "query",
        variables,
      );
    },
    getCustomFees(
      variables?: GetCustomFeesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetCustomFeesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetCustomFeesQuery>({
            document: GetCustomFeesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomFees",
        "query",
        variables,
      );
    },
    listIndividualClients(
      variables: ListIndividualClientsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ListIndividualClientsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ListIndividualClientsQuery>({
            document: ListIndividualClientsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "listIndividualClients",
        "query",
        variables,
      );
    },
    listFirmAdmins(
      variables: ListFirmAdminsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ListFirmAdminsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ListFirmAdminsQuery>({
            document: ListFirmAdminsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "listFirmAdmins",
        "query",
        variables,
      );
    },
    firmDocuments(
      variables: FirmDocumentsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<FirmDocumentsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<FirmDocumentsQuery>({
            document: FirmDocumentsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "firmDocuments",
        "query",
        variables,
      );
    },
    contributors(
      variables: ContributorsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ContributorsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ContributorsQuery>({
            document: ContributorsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "contributors",
        "query",
        variables,
      );
    },
    searchTickers(
      variables: SearchTickersQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<SearchTickersQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SearchTickersQuery>({
            document: SearchTickersDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "searchTickers",
        "query",
        variables,
      );
    },
    validateUploadedTickers(
      variables: ValidateUploadedTickersQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ValidateUploadedTickersQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ValidateUploadedTickersQuery>({
            document: ValidateUploadedTickersDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "validateUploadedTickers",
        "query",
        variables,
      );
    },
    listMinimumGrantsContributions(
      variables: ListMinimumGrantsContributionsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ListMinimumGrantsContributionsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ListMinimumGrantsContributionsQuery>({
            document: ListMinimumGrantsContributionsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "listMinimumGrantsContributions",
        "query",
        variables,
      );
    },
    dafPools(
      variables: DafPoolsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<DafPoolsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<DafPoolsQuery>({
            document: DafPoolsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "dafPools",
        "query",
        variables,
      );
    },
    align(
      variables: AlignQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<AlignQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AlignQuery>({
            document: AlignDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "align",
        "query",
        variables,
      );
    },
    submitTargetRatio(
      variables: SubmitTargetRatioMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<SubmitTargetRatioMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SubmitTargetRatioMutation>({
            document: SubmitTargetRatioDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "submitTargetRatio",
        "mutation",
        variables,
      );
    },
    updateAdvisorFees(
      variables: UpdateAdvisorFeesMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<UpdateAdvisorFeesMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UpdateAdvisorFeesMutation>({
            document: UpdateAdvisorFeesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "updateAdvisorFees",
        "mutation",
        variables,
      );
    },
    createCashMovement(
      variables: CreateCashMovementMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<CreateCashMovementMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CreateCashMovementMutation>({
            document: CreateCashMovementDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "createCashMovement",
        "mutation",
        variables,
      );
    },
    getFundReallocationRebalanceRequests(
      variables: GetFundReallocationRebalanceRequestsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetFundReallocationRebalanceRequestsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetFundReallocationRebalanceRequestsQuery>({
            document: GetFundReallocationRebalanceRequestsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getFundReallocationRebalanceRequests",
        "query",
        variables,
      );
    },
    legacyDocuments(
      variables: LegacyDocumentsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<LegacyDocumentsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<LegacyDocumentsQuery>({
            document: LegacyDocumentsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "legacyDocuments",
        "query",
        variables,
      );
    },
    livingLegacyPlans(
      variables?: LivingLegacyPlansQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<LivingLegacyPlansQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<LivingLegacyPlansQuery>({
            document: LivingLegacyPlansDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "livingLegacyPlans",
        "query",
        variables,
      );
    },
    livingLegacyPlan(
      variables: LivingLegacyPlanQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<LivingLegacyPlanQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<LivingLegacyPlanQuery>({
            document: LivingLegacyPlanDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "livingLegacyPlan",
        "query",
        variables,
      );
    },
    livingLegacyKpis(
      variables?: LivingLegacyKpisQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<LivingLegacyKpisQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<LivingLegacyKpisQuery>({
            document: LivingLegacyKpisDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "livingLegacyKpis",
        "query",
        variables,
      );
    },
    successionPolicy(
      variables: SuccessionPolicyQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<SuccessionPolicyQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SuccessionPolicyQuery>({
            document: SuccessionPolicyDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "successionPolicy",
        "query",
        variables,
      );
    },
    legacyBlueprint(
      variables: LegacyBlueprintQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<LegacyBlueprintQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<LegacyBlueprintQuery>({
            document: LegacyBlueprintDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "legacyBlueprint",
        "query",
        variables,
      );
    },
    familyCharityCauses(
      variables: FamilyCharityCausesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<FamilyCharityCausesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<FamilyCharityCausesQuery>({
            document: FamilyCharityCausesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "familyCharityCauses",
        "query",
        variables,
      );
    },
    familyGivingGoal(
      variables: FamilyGivingGoalQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<FamilyGivingGoalQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<FamilyGivingGoalQuery>({
            document: FamilyGivingGoalDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "familyGivingGoal",
        "query",
        variables,
      );
    },
    sunsetCharityAllocations(
      variables: SunsetCharityAllocationsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<SunsetCharityAllocationsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SunsetCharityAllocationsQuery>({
            document: SunsetCharityAllocationsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "sunsetCharityAllocations",
        "query",
        variables,
      );
    },
    familyFoundersMessage(
      variables: FamilyFoundersMessageQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<FamilyFoundersMessageQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<FamilyFoundersMessageQuery>({
            document: FamilyFoundersMessageDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "familyFoundersMessage",
        "query",
        variables,
      );
    },
    familyMission(
      variables: FamilyMissionQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<FamilyMissionQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<FamilyMissionQuery>({
            document: FamilyMissionDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "familyMission",
        "query",
        variables,
      );
    },
    transitionActiveCampaigns(
      variables: TransitionActiveCampaignsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<TransitionActiveCampaignsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<TransitionActiveCampaignsQuery>({
            document: TransitionActiveCampaignsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "transitionActiveCampaigns",
        "query",
        variables,
      );
    },
    transitionActiveItems(
      variables: TransitionActiveItemsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<TransitionActiveItemsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<TransitionActiveItemsQuery>({
            document: TransitionActiveItemsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "transitionActiveItems",
        "query",
        variables,
      );
    },
    successionTransition(
      variables: SuccessionTransitionQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<SuccessionTransitionQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SuccessionTransitionQuery>({
            document: SuccessionTransitionDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "successionTransition",
        "query",
        variables,
      );
    },
    transitionHistory(
      variables: TransitionHistoryQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<TransitionHistoryQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<TransitionHistoryQuery>({
            document: TransitionHistoryDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "transitionHistory",
        "query",
        variables,
      );
    },
    pendingDeathTransitions(
      variables?: PendingDeathTransitionsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<PendingDeathTransitionsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<PendingDeathTransitionsQuery>({
            document: PendingDeathTransitionsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "pendingDeathTransitions",
        "query",
        variables,
      );
    },
    ApproveDeathTransition(
      variables: ApproveDeathTransitionMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ApproveDeathTransitionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ApproveDeathTransitionMutation>({
            document: ApproveDeathTransitionDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "ApproveDeathTransition",
        "mutation",
        variables,
      );
    },
    RejectDeathTransition(
      variables: RejectDeathTransitionMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<RejectDeathTransitionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RejectDeathTransitionMutation>({
            document: RejectDeathTransitionDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "RejectDeathTransition",
        "mutation",
        variables,
      );
    },
    UpdateScheduledTransitionDate(
      variables: UpdateScheduledTransitionDateMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<UpdateScheduledTransitionDateMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UpdateScheduledTransitionDateMutation>({
            document: UpdateScheduledTransitionDateDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "UpdateScheduledTransitionDate",
        "mutation",
        variables,
      );
    },
    TriggerSuccessionTransferNotification(
      variables: TriggerSuccessionTransferNotificationMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<TriggerSuccessionTransferNotificationMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<TriggerSuccessionTransferNotificationMutation>({
            document: TriggerSuccessionTransferNotificationDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "TriggerSuccessionTransferNotification",
        "mutation",
        variables,
      );
    },
    SendSuccessionInvites(
      variables: SendSuccessionInvitesMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<SendSuccessionInvitesMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SendSuccessionInvitesMutation>({
            document: SendSuccessionInvitesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "SendSuccessionInvites",
        "mutation",
        variables,
      );
    },
    NudgeSuccessorInvite(
      variables: NudgeSuccessorInviteMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<NudgeSuccessorInviteMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<NudgeSuccessorInviteMutation>({
            document: NudgeSuccessorInviteDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "NudgeSuccessorInvite",
        "mutation",
        variables,
      );
    },
    FinalizeSuccessionTransition(
      variables: FinalizeSuccessionTransitionMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<FinalizeSuccessionTransitionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<FinalizeSuccessionTransitionMutation>({
            document: FinalizeSuccessionTransitionDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "FinalizeSuccessionTransition",
        "mutation",
        variables,
      );
    },
    SuccessionReconciliations(
      variables?: SuccessionReconciliationsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<SuccessionReconciliationsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SuccessionReconciliationsQuery>({
            document: SuccessionReconciliationsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "SuccessionReconciliations",
        "query",
        variables,
      );
    },
    OpsActivity(
      variables?: OpsActivityQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<OpsActivityQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OpsActivityQuery>({
            document: OpsActivityDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "OpsActivity",
        "query",
        variables,
      );
    },
    OpsTransition(
      variables: OpsTransitionQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<OpsTransitionQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OpsTransitionQuery>({
            document: OpsTransitionDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "OpsTransition",
        "query",
        variables,
      );
    },
    AdvanceSuccessionStep(
      variables: AdvanceSuccessionStepMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<AdvanceSuccessionStepMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AdvanceSuccessionStepMutation>({
            document: AdvanceSuccessionStepDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "AdvanceSuccessionStep",
        "mutation",
        variables,
      );
    },
    OpsTransitions(
      variables?: OpsTransitionsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<OpsTransitionsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OpsTransitionsQuery>({
            document: OpsTransitionsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "OpsTransitions",
        "query",
        variables,
      );
    },
    SuccessionTransfers(
      variables: SuccessionTransfersQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<SuccessionTransfersQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SuccessionTransfersQuery>({
            document: SuccessionTransfersDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "SuccessionTransfers",
        "query",
        variables,
      );
    },
    ConfirmTransferVariance(
      variables: ConfirmTransferVarianceMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ConfirmTransferVarianceMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ConfirmTransferVarianceMutation>({
            document: ConfirmTransferVarianceDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "ConfirmTransferVariance",
        "mutation",
        variables,
      );
    },
    CloseEmptyTransition(
      variables: CloseEmptyTransitionMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<CloseEmptyTransitionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CloseEmptyTransitionMutation>({
            document: CloseEmptyTransitionDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "CloseEmptyTransition",
        "mutation",
        variables,
      );
    },
    LivingLegacyTransitionAlerts(
      variables?: LivingLegacyTransitionAlertsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<LivingLegacyTransitionAlertsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<LivingLegacyTransitionAlertsQuery>({
            document: LivingLegacyTransitionAlertsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "LivingLegacyTransitionAlerts",
        "query",
        variables,
      );
    },
    familyFreezeFlags(
      variables: FamilyFreezeFlagsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<FamilyFreezeFlagsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<FamilyFreezeFlagsQuery>({
            document: FamilyFreezeFlagsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "familyFreezeFlags",
        "query",
        variables,
      );
    },
    getOverviewStats(
      variables?: GetOverviewStatsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetOverviewStatsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetOverviewStatsQuery>({
            document: GetOverviewStatsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getOverviewStats",
        "query",
        variables,
      );
    },
    getProgramAUMStats(
      variables: GetProgramAumStatsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetProgramAumStatsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetProgramAumStatsQuery>({
            document: GetProgramAumStatsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getProgramAUMStats",
        "query",
        variables,
      );
    },
    getDistributionStats(
      variables: GetDistributionStatsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetDistributionStatsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetDistributionStatsQuery>({
            document: GetDistributionStatsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getDistributionStats",
        "query",
        variables,
      );
    },
    getDistributionList(
      variables: GetDistributionListQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetDistributionListQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetDistributionListQuery>({
            document: GetDistributionListDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getDistributionList",
        "query",
        variables,
      );
    },
    getCorporateClientsList(
      variables?: GetCorporateClientsListQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetCorporateClientsListQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetCorporateClientsListQuery>({
            document: GetCorporateClientsListDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCorporateClientsList",
        "query",
        variables,
      );
    },
    getCorporateDafsList(
      variables?: GetCorporateDafsListQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetCorporateDafsListQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetCorporateDafsListQuery>({
            document: GetCorporateDafsListDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCorporateDafsList",
        "query",
        variables,
      );
    },
    getDafStats(
      variables?: GetDafStatsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetDafStatsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetDafStatsQuery>({
            document: GetDafStatsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getDafStats",
        "query",
        variables,
      );
    },
    getDafContributions(
      variables?: GetDafContributionsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetDafContributionsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetDafContributionsQuery>({
            document: GetDafContributionsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getDafContributions",
        "query",
        variables,
      );
    },
    getDafGrants(
      variables?: GetDafGrantsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetDafGrantsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetDafGrantsQuery>({
            document: GetDafGrantsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getDafGrants",
        "query",
        variables,
      );
    },
    getOperationsListFirms(
      variables?: GetOperationsListFirmsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetOperationsListFirmsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetOperationsListFirmsQuery>({
            document: GetOperationsListFirmsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getOperationsListFirms",
        "query",
        variables,
      );
    },
    getOperationsListEnterprises(
      variables?: GetOperationsListEnterprisesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetOperationsListEnterprisesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetOperationsListEnterprisesQuery>({
            document: GetOperationsListEnterprisesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getOperationsListEnterprises",
        "query",
        variables,
      );
    },
    getOperationsContributionsKPIs(
      variables?: GetOperationsContributionsKpIsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetOperationsContributionsKpIsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetOperationsContributionsKpIsQuery>({
            document: GetOperationsContributionsKpIsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getOperationsContributionsKPIs",
        "query",
        variables,
      );
    },
    getOperationsContributionsCount(
      variables?: GetOperationsContributionsCountQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetOperationsContributionsCountQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetOperationsContributionsCountQuery>({
            document: GetOperationsContributionsCountDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getOperationsContributionsCount",
        "query",
        variables,
      );
    },
    getOperationsContributionsStats(
      variables?: GetOperationsContributionsStatsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetOperationsContributionsStatsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetOperationsContributionsStatsQuery>({
            document: GetOperationsContributionsStatsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getOperationsContributionsStats",
        "query",
        variables,
      );
    },
    getOperationsStats(
      variables?: GetOperationsStatsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetOperationsStatsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetOperationsStatsQuery>({
            document: GetOperationsStatsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getOperationsStats",
        "query",
        variables,
      );
    },
    getFeesStats(
      variables?: GetFeesStatsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetFeesStatsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetFeesStatsQuery>({
            document: GetFeesStatsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getFeesStats",
        "query",
        variables,
      );
    },
    getFeeTier(
      variables?: GetFeeTierQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetFeeTierQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetFeeTierQuery>({
            document: GetFeeTierDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getFeeTier",
        "query",
        variables,
      );
    },
    getFeesByProgram(
      variables?: GetFeesByProgramQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetFeesByProgramQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetFeesByProgramQuery>({
            document: GetFeesByProgramDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getFeesByProgram",
        "query",
        variables,
      );
    },
    getFeesByEnterprise(
      variables?: GetFeesByEnterpriseQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetFeesByEnterpriseQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetFeesByEnterpriseQuery>({
            document: GetFeesByEnterpriseDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getFeesByEnterprise",
        "query",
        variables,
      );
    },
    getFeesByFirm(
      variables?: GetFeesByFirmQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetFeesByFirmQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetFeesByFirmQuery>({
            document: GetFeesByFirmDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getFeesByFirm",
        "query",
        variables,
      );
    },
    getFeesByAdvisor(
      variables?: GetFeesByAdvisorQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetFeesByAdvisorQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetFeesByAdvisorQuery>({
            document: GetFeesByAdvisorDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getFeesByAdvisor",
        "query",
        variables,
      );
    },
    getOperationsGrantsKPIs(
      variables?: GetOperationsGrantsKpIsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetOperationsGrantsKpIsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetOperationsGrantsKpIsQuery>({
            document: GetOperationsGrantsKpIsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getOperationsGrantsKPIs",
        "query",
        variables,
      );
    },
    getOperationsGrantsStats(
      variables?: GetOperationsGrantsStatsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetOperationsGrantsStatsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetOperationsGrantsStatsQuery>({
            document: GetOperationsGrantsStatsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getOperationsGrantsStats",
        "query",
        variables,
      );
    },
    getOperationsGrantsVolumeStatusStats(
      variables?: GetOperationsGrantsVolumeStatusStatsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetOperationsGrantsVolumeStatusStatsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetOperationsGrantsVolumeStatusStatsQuery>({
            document: GetOperationsGrantsVolumeStatusStatsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getOperationsGrantsVolumeStatusStats",
        "query",
        variables,
      );
    },
    getOperationsAumByInvestmentModel(
      variables?: GetOperationsAumByInvestmentModelQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetOperationsAumByInvestmentModelQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetOperationsAumByInvestmentModelQuery>({
            document: GetOperationsAumByInvestmentModelDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getOperationsAumByInvestmentModel",
        "query",
        variables,
      );
    },
    GetAdoptionBannerStats(
      variables?: GetAdoptionBannerStatsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetAdoptionBannerStatsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetAdoptionBannerStatsQuery>({
            document: GetAdoptionBannerStatsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetAdoptionBannerStats",
        "query",
        variables,
      );
    },
    GetEngagementOverTime(
      variables?: GetEngagementOverTimeQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetEngagementOverTimeQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetEngagementOverTimeQuery>({
            document: GetEngagementOverTimeDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetEngagementOverTime",
        "query",
        variables,
      );
    },
    GetEngagementFunnel(
      variables?: GetEngagementFunnelQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetEngagementFunnelQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetEngagementFunnelQuery>({
            document: GetEngagementFunnelDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetEngagementFunnel",
        "query",
        variables,
      );
    },
    getCustomerSuccessMetrics(
      variables?: GetCustomerSuccessMetricsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetCustomerSuccessMetricsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetCustomerSuccessMetricsQuery>({
            document: GetCustomerSuccessMetricsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getCustomerSuccessMetrics",
        "query",
        variables,
      );
    },
    getServiceRequestsByChannel(
      variables?: GetServiceRequestsByChannelQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetServiceRequestsByChannelQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetServiceRequestsByChannelQuery>({
            document: GetServiceRequestsByChannelDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getServiceRequestsByChannel",
        "query",
        variables,
      );
    },
    getChannelPerformanceMetrics(
      variables?: GetChannelPerformanceMetricsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetChannelPerformanceMetricsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetChannelPerformanceMetricsQuery>({
            document: GetChannelPerformanceMetricsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getChannelPerformanceMetrics",
        "query",
        variables,
      );
    },
    getConversationTopIssues(
      variables?: GetConversationTopIssuesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetConversationTopIssuesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetConversationTopIssuesQuery>({
            document: GetConversationTopIssuesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getConversationTopIssues",
        "query",
        variables,
      );
    },
    getServiceRequestsByIssueType(
      variables?: GetServiceRequestsByIssueTypeQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetServiceRequestsByIssueTypeQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetServiceRequestsByIssueTypeQuery>({
            document: GetServiceRequestsByIssueTypeDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getServiceRequestsByIssueType",
        "query",
        variables,
      );
    },
    getFeeStatement(
      variables: GetFeeStatementMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetFeeStatementMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetFeeStatementMutation>({
            document: GetFeeStatementDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getFeeStatement",
        "mutation",
        variables,
      );
    },
    getReportsOverviewStats(
      variables?: GetReportsOverviewStatsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetReportsOverviewStatsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetReportsOverviewStatsQuery>({
            document: GetReportsOverviewStatsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getReportsOverviewStats",
        "query",
        variables,
      );
    },
    getReportsProgramAUMStats(
      variables: GetReportsProgramAumStatsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetReportsProgramAumStatsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetReportsProgramAumStatsQuery>({
            document: GetReportsProgramAumStatsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getReportsProgramAUMStats",
        "query",
        variables,
      );
    },
    getReportsCorporateClientsList(
      variables?: GetReportsCorporateClientsListQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetReportsCorporateClientsListQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetReportsCorporateClientsListQuery>({
            document: GetReportsCorporateClientsListDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getReportsCorporateClientsList",
        "query",
        variables,
      );
    },
    getEnterpriseClientsList(
      variables?: GetEnterpriseClientsListQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetEnterpriseClientsListQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetEnterpriseClientsListQuery>({
            document: GetEnterpriseClientsListDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getEnterpriseClientsList",
        "query",
        variables,
      );
    },
    mySuccessorInvite(
      variables: MySuccessorInviteQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<MySuccessorInviteQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<MySuccessorInviteQuery>({
            document: MySuccessorInviteDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "mySuccessorInvite",
        "query",
        variables,
      );
    },
    mySuccessorOnboarding(
      variables: MySuccessorOnboardingQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<MySuccessorOnboardingQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<MySuccessorOnboardingQuery>({
            document: MySuccessorOnboardingDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "mySuccessorOnboarding",
        "query",
        variables,
      );
    },
    successorAcknowledgment(
      variables: SuccessorAcknowledgmentQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<SuccessorAcknowledgmentQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SuccessorAcknowledgmentQuery>({
            document: SuccessorAcknowledgmentDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "successorAcknowledgment",
        "query",
        variables,
      );
    },
    successorFoundersVoice(
      variables: SuccessorFoundersVoiceQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<SuccessorFoundersVoiceQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SuccessorFoundersVoiceQuery>({
            document: SuccessorFoundersVoiceDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "successorFoundersVoice",
        "query",
        variables,
      );
    },
    successorGivingHistory(
      variables: SuccessorGivingHistoryQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<SuccessorGivingHistoryQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SuccessorGivingHistoryQuery>({
            document: SuccessorGivingHistoryDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "successorGivingHistory",
        "query",
        variables,
      );
    },
    suggestedForYou(
      variables: SuggestedForYouQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<SuggestedForYouQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SuggestedForYouQuery>({
            document: SuggestedForYouDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "suggestedForYou",
        "query",
        variables,
      );
    },
    recommendedFundsFamily(
      variables: RecommendedFundsFamilyQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<RecommendedFundsFamilyQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RecommendedFundsFamilyQuery>({
            document: RecommendedFundsFamilyDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "recommendedFundsFamily",
        "query",
        variables,
      );
    },
    listTransactions(
      variables: ListTransactionsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ListTransactionsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ListTransactionsQuery>({
            document: ListTransactionsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "listTransactions",
        "query",
        variables,
      );
    },
    getSecurityContributionDetail(
      variables: GetSecurityContributionDetailQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetSecurityContributionDetailQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetSecurityContributionDetailQuery>({
            document: GetSecurityContributionDetailDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getSecurityContributionDetail",
        "query",
        variables,
      );
    },
    engagementDistribution(
      variables: EngagementDistributionQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<EngagementDistributionQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<EngagementDistributionQuery>({
            document: EngagementDistributionDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "engagementDistribution",
        "query",
        variables,
      );
    },
    GetRecurringGift(
      variables: GetRecurringGiftQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetRecurringGiftQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetRecurringGiftQuery>({
            document: GetRecurringGiftDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "GetRecurringGift",
        "query",
        variables,
      );
    },
    scheduledCcContributionDetails(
      variables: ScheduledCcContributionDetailsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ScheduledCcContributionDetailsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ScheduledCcContributionDetailsQuery>({
            document: ScheduledCcContributionDetailsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "scheduledCcContributionDetails",
        "query",
        variables,
      );
    },
    scheduledContributionDetails(
      variables: ScheduledContributionDetailsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ScheduledContributionDetailsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ScheduledContributionDetailsQuery>({
            document: ScheduledContributionDetailsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "scheduledContributionDetails",
        "query",
        variables,
      );
    },
    getTransactionFilters(
      variables: GetTransactionFiltersQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetTransactionFiltersQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetTransactionFiltersQuery>({
            document: GetTransactionFiltersDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getTransactionFilters",
        "query",
        variables,
      );
    },
    getPublicSecurityBatchDetails(
      variables: GetPublicSecurityBatchDetailsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetPublicSecurityBatchDetailsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetPublicSecurityBatchDetailsQuery>({
            document: GetPublicSecurityBatchDetailsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getPublicSecurityBatchDetails",
        "query",
        variables,
      );
    },
    user(
      variables: UserQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<UserQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UserQuery>({
            document: UserDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "user",
        "query",
        variables,
      );
    },
    validateEmail(
      variables: ValidateEmailQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ValidateEmailQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ValidateEmailQuery>({
            document: ValidateEmailDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "validateEmail",
        "query",
        variables,
      );
    },
    updateLastLogin(
      variables?: UpdateLastLoginMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<UpdateLastLoginMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UpdateLastLoginMutation>({
            document: UpdateLastLoginDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "updateLastLogin",
        "mutation",
        variables,
      );
    },
    isGiveUser(
      variables?: IsGiveUserQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<IsGiveUserQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<IsGiveUserQuery>({
            document: IsGiveUserDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "isGiveUser",
        "query",
        variables,
      );
    },
    acceptTnc(
      variables?: AcceptTncMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<AcceptTncMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AcceptTncMutation>({
            document: AcceptTncDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "acceptTnc",
        "mutation",
        variables,
      );
    },
    registerMemberForDonorSso(
      variables?: RegisterMemberForDonorSsoMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<RegisterMemberForDonorSsoMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RegisterMemberForDonorSsoMutation>({
            document: RegisterMemberForDonorSsoDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "registerMemberForDonorSso",
        "mutation",
        variables,
      );
    },
    setGivingPrivacyPreference(
      variables?: SetGivingPrivacyPreferenceMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<SetGivingPrivacyPreferenceMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<SetGivingPrivacyPreferenceMutation>({
            document: SetGivingPrivacyPreferenceDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "setGivingPrivacyPreference",
        "mutation",
        variables,
      );
    },
    acceptAdvisorFeeAgreement(
      variables?: AcceptAdvisorFeeAgreementMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<AcceptAdvisorFeeAgreementMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AcceptAdvisorFeeAgreementMutation>({
            document: AcceptAdvisorFeeAgreementDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "acceptAdvisorFeeAgreement",
        "mutation",
        variables,
      );
    },
  };
}
export type Sdk = ReturnType<typeof getSdk>;
